webpackJsonp([68],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return util; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crypto_js__);







var _util;



/*========本地存储===========*/
var STORE_PREFIX = "_MX_";
var storage = {
  getPrefix: function getPrefix() {
    return STORE_PREFIX;
  },
  cookies: {
    get: function get(sKey) {
      if (!sKey) return null;
      sKey = STORE_PREFIX + sKey;
      return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    set: function set(sKey, sValue) {
      var vEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1800;
      var sPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "/";
      var sDomain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
      var bSecure = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) return false;

      sKey = STORE_PREFIX + sKey;
      var sExpires = "";
      if (vEnd) {
        switch (vEnd.constructor) {
          case Number:
            // 单位秒
            sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
            break;
          case String:
            sExpires = "; expires=" + vEnd;
            break;
          case Date:
            sExpires = "; expires=" + vEnd.toUTCString();
            break;
        }
      }
      document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
      return true;
    },
    remove: function remove(sKey) {
      var sPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var sDomain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      if (!this.has(sKey)) return false;

      sKey = STORE_PREFIX + sKey;
      document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
      return true;
    },
    has: function has(sKey) {
      if (!sKey) return false;
      return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
    },
    keys: function keys() {
      var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
      for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
        aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
      }
      return aKeys;
    }
  },
  session: {
    set: function set(key, value) {
      if (!key) return false;
      window.sessionStorage.setItem(STORE_PREFIX + key, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(value || {}));
    },
    get: function get(key) {
      if (!key) return null;
      return JSON.parse(window.sessionStorage.getItem(STORE_PREFIX + key));
    },
    remove: function remove(key) {
      window.sessionStorage.removeItem(STORE_PREFIX + key);
    },
    removeAll: function removeAll() {
      window.sessionStorage.clear();
    }
  },
  local: {
    getUsedSize: function getUsedSize() {
      return unescape(encodeURIComponent(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(localStorage))).length;
    },
    getFreeSize: function getFreeSize() {
      //5M
      return 1024 * 1024 * 5 - this.getUsedSize();
    },
    set: function set(key, value) {
      var ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000 * 3600 * 24 * 365;

      if (!key) return false;

      key = STORE_PREFIX + key;
      var newValue = {
        value: value,
        expires: ms,
        time: new Date().getTime()
      };
      window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(newValue));
    },
    get: function get(key) {
      if (!key) return null;
      key = STORE_PREFIX + key;

      var value = JSON.parse(window.localStorage.getItem(key));
      if (value && new Date().getTime() - value.time < value.expires) {
        value = value.value;
      } else {
        value = null;
      }
      return value;
    },
    remove: function remove(key) {
      window.localStorage.removeItem(STORE_PREFIX + key);
    },
    removeAll: function removeAll() {
      window.localStorage.clear();
    }
  }
};

var util = (_util = {
  //本地存储
  storage: storage,

  //上传图片
  /**
   * 上传图片
   * @param  {string}   url          服务器上传请求地址
   * @param  {obj}      data         图片文件信息
   * @param  {string}   field        字段名
   * @param  {function} uploadingFn  上传中回调函数
   * @param  {function} successFn    上传成功回调函数
   * @param  {function} failerFn     上传失败回调函数
   * @return {Promise}
   */
  uploadImg: function uploadImg(url, data, field, uploadingFn, successFn, failerFn) {
    field = field || "file";
    var fmData = new FormData();
    fmData.append(field, data); //将文件转成二进制形式

    // 监听进度回调
    var uploadProgress = function uploadProgress(event) {
      if (event.lengthComputable) {
        var progress = 100 * Math.round(event.loaded) / event.total;
        console.log("上传进度：", progress);
        uploadingFn && uploadingFn(progress);
      }
    };

    // 上传文件
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var client = new XMLHttpRequest();
      client.open("POST", url, true);
      client.onreadystatechange = function () {
        if (this.readyState !== 4) {
          return;
        }
        if (this.status === 200 || this.status === 201) {
          resolve(JSON.parse(this.responseText));
        } else {
          reject(this.status);
        }
      };

      client.upload.addEventListener("progress", uploadProgress, false); //监听进度

      // 设置header
      if ((typeof headers === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(headers)) == "object" && headers) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(headers).forEach(function (k) {
          client.setRequestHeader(k, headers[k]);
        });
      }

      client.send(fmData);
    }).then(
    // 上传成功
    function (resData) {
      console.log("上传成功：", resData);
      successFn && successFn(resData);
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(resData);
    },
    // 上传失败
    function (sts) {
      console.log("上传失败：", sts);
      failerFn && failerFn(sts);
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(resData);
    });
  },


  //图片压缩
  imgScale: function imgScale(imgUrl, fileList, quality) {
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var img = new Image();
      var _this = this;
      var canvas = document.createElement("canvas");
      var cxt = canvas.getContext("2d");
      var base64 = null;
      img.src = imgUrl;
      img.onload = function () {
        if (fileList.size / 1024 / 1024 > 1) {
          //缩放后图片的宽高
          var width = img.naturalWidth / quality;
          var height = img.naturalHeight / quality;
          canvas.width = width;
          canvas.height = height;
          cxt.drawImage(this, 0, 0, width, height);
          base64 = canvas.toDataURL("image/jpeg");
          resolve(base64);
        } else {
          var expectWidth = img.naturalWidth;
          var expectHeight = img.naturalHeight;
          if (img.naturalWidth > img.naturalHeight && img.naturalWidth > 800) {
            expectWidth = 800;
            expectHeight = expectWidth * img.naturalHeight / img.naturalWidth;
          } else if (img.naturalHeight > img.naturalWidth && img.naturalHeight > 1200) {
            expectHeight = 1200;
            expectWidth = expectHeight * img.naturalWidth / img.naturalHeight;
          }
          canvas.width = expectWidth;
          canvas.height = expectHeight;
          cxt.drawImage(img, 0, 0, expectWidth, expectHeight);
          base64 = canvas.toDataURL("image/jpeg", 0.8);
          resolve(base64);
        }
      };
    });
  },
  canvasUpload: function canvasUpload(url, data, rawFile, type, uploadingFn, successFn, failerFn) {
    console.log("rawFile>>>>>>>>>", rawFile);
    var text = window.atob(data.split(",")[1]);
    var buffer = new ArrayBuffer(text.length);
    var ubuffer = new Uint8Array(buffer);
    var pecent = 0,
        loop = null;

    for (var i = 0; i < text.length; i++) {
      ubuffer[i] = text.charCodeAt(i);
    }

    var Builder = window.WebKitBlobBuilder || window.MozBlobBuilder;
    var blob;

    if (Builder) {
      var builder = new Builder();
      builder.append(buffer);
      blob = builder.getBlob(type);
    } else {
      blob = new window.Blob([buffer], { type: type });
    }

    var fmData = new FormData();
    fmData.append("imagefile", blob, rawFile.name);

    // 监听进度回调
    var uploadProgress = function uploadProgress(event) {
      if (event.lengthComputable) {
        var progress = 100 * Math.round(event.loaded) / event.total;
        console.log("上传进度：", progress);
        uploadingFn && uploadingFn(progress);
      }
    };

    // 上传文件
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var client = new XMLHttpRequest();
      client.open("POST", url, true);
      client.onreadystatechange = function () {
        if (this.readyState !== 4) {
          return;
        }
        if (this.status === 200 || this.status === 201) {
          resolve(JSON.parse(this.responseText));
        } else {
          reject(this.status);
        }
      };

      client.upload.addEventListener("progress", uploadProgress, false); //监听进度

      // 设置header
      if ((typeof headers === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(headers)) == "object" && headers) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(headers).forEach(function (k) {
          client.setRequestHeader(k, headers[k]);
        });
      }

      client.send(fmData);
    }).then(
    // 上传成功
    function (resData) {
      successFn && successFn(resData);
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(resData);
    },
    // 上传失败
    function (sts) {
      failerFn && failerFn(sts);
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(sts);
    });
  },


  //获取url查询字符串
  getQuery: function getQuery(url) {
    url = decodeURIComponent(url);
    var theRequest = {};
    if (url.indexOf("?") !== -1) {
      var strs = url.substr(1).split("&");
      for (var i = 0, len = strs.length; i < len; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  },


  //设置url查询字符串
  setQuery: function setQuery(params) {
    if (Object.prototype.toString.call(params) !== "[object Object]") {
      return "";
    }
    var url = "?";
    for (var i in params) {
      url += i + "=" + params[i] + "&";
    }
    url = url.replace(/\&$/g, "").replace(/^\?$/g, "");
    return url;
  },

  /**
   * 解析字符串
   *
   * @param      {string}  str     要解析的字符串
   * @param      {string}  places  分隔符
   * @param      {string}  query   查找参数
   */
  parseString: function parseString(str, places, query) {
    places = places || "&";
    if (!str || !str.length) {
      return "";
    }

    str = decodeURIComponent(str);

    var res = {};
    str.split(places).forEach(function (item) {
      var itemArr = item.split("=");
      res[itemArr[0]] = itemArr[1];
    });

    if (query) {
      return res[query];
    }

    return res;
  },


  isTel: function isTel(phone) {
    var reg = /^1\d{10}$|^(?:0\d{2,3}-?)?[2-9]\d{6,7}$/g;
    return reg.test(phone) ? true : false;
  },
  isAuthCode: function isAuthCode(authCode) {
    var reg = /^\d{4,6}$/g;
    return reg.test(authCode) ? true : false;
  },
  isNumber: function isNumber(dinnerNum) {
    var reg = /^\d{1,3}$/g;
    return reg.test(dinnerNum) ? true : false;
  },
  isNum: function isNum(dinnerNum) {
    var reg = /^\d$/g;
    return reg.test(dinnerNum) ? true : false;
  },
  isEmail: function isEmail(email) {
    var reg = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
    return reg.test(email) ? true : false;
  },
  isMoney: function isMoney(mon) {
    var reg = /^(?:0|[1-9]\d*)\.\d{1,2}$|^[1-9]\d*$|^0$/g;

    return reg.test(mon) ? true : false;
  },
  isObject: function isObject(obj) {
    return obj !== null && (typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj)) === "object";
  },
  //检测是否是微信浏览器
  isWeiXin: function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/microMessenger/i) == "micromessenger") {
      return true;
    }
    return false;
  },
  //检测是否是支付宝内置浏览器
  isAlipay: function isAlipay() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/alipay/i) == "alipay") return true;
    return false;
  },
  // encryptPwd: function(key, value) {
  //   let raw = Crypto.enc.Base64.stringify(Crypto.MD5(value, { asBytes: true }));
  //   raw = this.replaceAll(raw, "\\", "_");
  //   raw = this.replaceAll(raw, "/", "-");
  //   raw = this.replaceAll(raw, "+", "]");
  //   let enc = Crypto.HmacMD5(raw, key) + "";
  //   return enc.toUpperCase();

  // },
  encryptPwdF: function encryptPwdF(value) {
    var raw = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.enc.Base64.stringify(__WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.MD5(value, { asBytes: true }));
    raw = this.replaceAll(raw, "\\", "_");
    raw = this.replaceAll(raw, "/", "-");
    raw = this.replaceAll(raw, "+", "]");
    return raw;
  },
  encryptPwd: function encryptPwd(raw, key) {
    var enc = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.HmacMD5(raw, key) + "";
    return enc.toUpperCase();
  },
  encryptEnc: function encryptEnc(pwd) {
    return "RAW_" + pwd;
  },
  replaceAll: function replaceAll(str, match, ment) {
    while (true) {
      var pos = str.indexOf(match);
      if (pos >= 0) {
        str = str.replace(match, ment);
      } else {
        break;
      }
    }
    return str;
  },

  /*doSign: function(data) {
        let sign = "";
      for (let p in data) {
          sign += `${p}=${data[p]}&`;
      }
      sign = sign.replace(/\&$/g, "").split("&").filter((item, index) => /^p\d\=/g.test(item)).join("&");
        sign += storage.local.get('signKey') || "";
      sign = Crypto.enc.Utf8.parse(sign);
      sign = Crypto.MD5(sign, { asBytes: true });
      sign = Crypto.enc.Hex.stringify(sign);
      return sign;
  },*/
  format: function format(date, fmt) {
    date = new Date(date);
    var o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return fmt;
  },

  /**
   * 时间 转 时间戳
   * @param  {[type]} stringTime [时间]
   * @return {[type]}            [时间戳]
   */
  formatTimeStamp: function formatTimeStamp(stringTime) {
    var timestamp = stringTime ? new Date(stringTime).getTime() : "";
    return timestamp;
  },


  /**
   * 深拷贝
   *
   * @param {*} obj
   * @param {Array<Object>} cache
   * @return {*}
   */
  deepCopy: function deepCopy(obj) {
    var _this2 = this;

    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (obj === null || (typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(obj)) !== "object") {
      return obj;
    }

    var hit = this.find(cache, function (c) {
      return c.original === obj;
    });
    if (hit) {
      return hit.copy;
    }

    var copy = Array.isArray(obj) ? [] : {};

    cache.push({
      original: obj,
      copy: copy
    });

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
      copy[key] = _this2.deepCopy(obj[key], cache);
    });

    return copy;
  },
  find: function find(list, f) {
    return list.filter(f)[0];
  },


  /**
   * forEach for object
   */
  forEachValue: function forEachValue(obj, fn) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
      return fn(obj[key], key);
    });
  },


  //URL包含
  urlExclude: function urlExclude(url) {
    var excludeFns = ["hydsite.printerHandler.availablePrinter", //打印机上报
    "hydsite.printHandler.getReceiptPrintData"];

    var query = util.getQuery(url);
    if (query && query["p0"]) {
      return excludeFns.includes(query["p0"]);
    }

    return false;
  },

  //跳过网络检测
  skipCheckNet: function skipCheckNet(url) {
    var excludeFns = ["hydsite.localServiceHandler.getLocalServiceId", //获取本地服务ID
    "hydsite.printHandler.getReceiptPrintData", //打印任务处理
    "hydsite.printerHandler.availablePrinter"];

    var query = util.getQuery(url);
    if (query && query["p0"]) {
      return excludeFns.includes(query["p0"]);
    }

    return false;
  },


  //检查请求参数
  checkParams: function checkParams(_ref) {
    var fn = _ref.fn,
        param = _ref.param,
        fullresult = _ref.fullresult;

    if (!fn || !fn.length) {
      console.error("请求方法(fn)必须传入！");
      return false;
    }

    if (!Array.isArray(param)) {
      console.error("请求参数(param)必须是数组！");
      return false;
    }

    return true;
  },

  //组合httpURL
  combHttpURL: function combHttpURL(baseURL, data) {
    var httpURL = baseURL.toString();
    if (!httpURL.includes("?")) {
      httpURL += "?";
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        httpURL += key + "=" + data[key] + "&";
      }

      //没有内容
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (httpURL.endsWith("?")) {
      httpURL = httpURL.substring(0, httpURL.length - 1);
    }

    if (httpURL.endsWith("&")) {
      httpURL = httpURL.substring(0, httpURL.length - 1);
    }

    return httpURL;
  },

  //input自动获取焦点
  autoFocus: function autoFocus(ref, isFocus, isSelect) {
    if (isFocus) {
      ref.$el.children[0].focus();
    }
    if (isSelect) {
      ref.inputSelect();
    }
  }

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_util, "combHttpURL", function combHttpURL(baseURL, data) {
  var httpURL = baseURL.toString();
  if (!httpURL.includes("?")) {
    httpURL += "?";
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      httpURL += key + "=" + data[key] + "&";
    }

    //没有内容
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  if (httpURL.endsWith("?")) {
    httpURL = httpURL.substring(0, httpURL.length - 1);
  }

  if (httpURL.endsWith("&")) {
    httpURL = httpURL.substring(0, httpURL.length - 1);
  }

  return httpURL;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_util, "getResultErrMsg", function getResultErrMsg(result) {
  return result && (result.message || result.target && result.target.message) || "获取数据失败";
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_util, "setTextSize", function setTextSize(text) {
  var isIPhone = window.navigator.appVersion.match(/iphone/gi);
  var devicePixelRatio = window.devicePixelRatio;
  var arr = text.replace(/font-size: /g, "font-size:").split("font-size:");
  var dpr = 1;
  if (isIPhone) {
    // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
    if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
      dpr = 3;
    } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
      dpr = 2;
    } else {
      dpr = 1;
    }
  } else {
    // 其他设备下，仍旧使用1倍的方案
    dpr = 1;
  }

  var array = arr && arr.length && arr.reduce(function (curr, next, index) {
    var obj = {};
    if (index == 0) {
      obj = next;
    } else {
      obj = next.replace(next.substring(0, next.indexOf("px")), "font-size:" + Number(next.substring(0, next.indexOf("px"))) * 2);
    }
    curr.push(obj);
    return curr;
  }, []);
  return array.join("");
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_util, "debounce", function debounce(fn, delay) {
  var timer = null;
  return function () {
    var _this3 = this,
        _arguments = arguments;

    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      fn.apply(_this3, _arguments);
    }, delay);
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_util, "throttle", function throttle(fn, delay) {
  var startTime = 0;
  return function () {
    var currentTime = new Date().getTime();
    if (currentTime - startTime > delay) {
      fn.apply(this, arguments);
      startTime = currentTime;
    }
  };
}), _util);

/* harmony default export */ __webpack_exports__["c"] = (util);

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = window.Vuex;

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export env */
/* unused harmony export wx */
// 静态值定义： 【应用配置】

/**
 * [api 后端接口相关，自动根据打包命令加载对应环境接口地址]
 * @type {Object}
 */
var env = {
  HOST_IP: "https://m.meixin.com",
  OA_HOST_IP: __webpack_require__.i({"NODE_ENV":"production","HOST_IP":"https://m.meixin.com","COMMENT_HOST_IP":"https://m.meixin.com","CALL_PATH":"mxmall-call","INVOKE_PATH":"jsoncall/directCall/invoke","CONTEXT_PATH":"mxmall-weixin"}).OA_HOST_IP,
  COMMENT_HOST_IP: "https://m.meixin.com",
  CALL_PATH: "mxmall-call",
  INVOKE_PATH: "jsoncall/directCall/invoke",
  CONTEXT_PATH: "mxmall-weixin",
  ENV_MODE: "production", //环境模式
  STORE_LOG_SWITCH: true, //打印VUEX日志 (仅限开发环境有效)
  PRINT_DEBUG_URL: true //打印HTTP请求URL (仅限开发环境有效)
};

var wx = {
  APP_ID: 'wx5afd32ac14c76152',
  TEST_OPENID: '0C83B5471E4448BC86F52F5F9FADE9FAC14CB5AA3247D475B14BB818E719F468'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  env: env,
  apiBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + "/" + env.INVOKE_PATH,
  authBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + '/jsoncall/loginCall/getLoginToken',
  loginReqUrl: env.HOST_IP + "/" + env.CALL_PATH + "/jsoncall/loginCall/login",
  logoutBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + '/jsoncall/loginCall/logout',
  imgBaseUrl: env.HOST_IP + "/" + env.CALL_PATH,
  tokenCallUrl: env.HOST_IP,
  oaTokenCallUrl: env.OA_HOST_IP,
  commentTokenCallUrl: env.COMMENT_HOST_IP,
  uploadBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + "/f-ul",
  downloadBaseUrl: env.HOST_IP + "/" + env.CALL_PATH + "/dlfile",
  onlinePreviewUrl: env.HOST_IP + '/mxoa/onlinePreview',
  wx: wx,
  versionNo: '1.0.0', //客户端版本号
  defaultVal: {
    qrcode: wx.QR_CODE
  },
  errorMsg: {
    "AccessPermissionDeny": '服务请求被拒绝，检查是否未登陆！',
    "InvalidSign": '鉴权失败，服务请求被拒绝！',
    "java.lang.IllegalStateException": '服务请求失败，请稍后再试！',
    "RuntimeException": '服务请求失败，请稍后再试！',
    "IllegalStateException": '服务请求失败，请稍后再试！',
    "InvalidService": '服务请求失败，请稍后再试！',
    "NoExporterException": '服务请求失败，请稍后再试！'
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(347)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(404),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(415),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Constant__ = __webpack_require__(5);









/* harmony default export */ __webpack_exports__["a"] = ({
  context: {
    isloading: false
  },

  // HTTP POST
  post: function post(_ref, config, success, error) {
    var fn = _ref.fn,
        param = _ref.param,
        fullresult = _ref.fullresult;

    var _this = this;

    var userAttrId = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].session.get('userAttrId');
    var signKey = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.get('signKey');
    var signFlag = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.get('signFlag');
    fullresult = fullresult || (fullresult = true);
    config = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["b" /* util */].deepCopy(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */]), config);

    if (!userAttrId || signFlag === null || signFlag && !signKey) {
      console.log('>>>>>>>>>>>>>>');
      return this.getSignKey().then(function () {
        return _this.request('POST', { fn: fn, param: param, fullresult: fullresult }, config, success, error);
      }).catch(function (err) {
        console.error(err);
      });
    } else {
      return this.request('POST', { fn: fn, param: param, fullresult: fullresult }, config, success, error).catch(function (err) {
        console.error(err);
      });
    }
  },

  // HTTP GET
  get: function get(_ref2, config, success, error) {
    var fn = _ref2.fn,
        param = _ref2.param,
        fullresult = _ref2.fullresult;

    var _this2 = this;

    var userAttrId = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].session.get('userAttrId');
    var signKey = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.get('signKey');
    var signFlag = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.get('signFlag');

    if (!userAttrId || signFlag === null || signFlag && !signKey) {
      return this.getSignKey().then(function () {
        return _this2.request('GET', { fn: fn, param: param, fullresult: fullresult }, config, success, error);
      }).catch(function (err) {
        console.error(err);
      });
    } else {
      return this.request('GET', { fn: fn, param: param, fullresult: fullresult }, config, success, error).catch(function (err) {
        console.error(err);
      });
    }
  },

  // HTTP REQUEST
  request: function request(method, _ref3, config, success, error) {
    var fn = _ref3.fn,
        param = _ref3.param,
        fullresult = _ref3.fullresult;

    method = method || 'post';

    // 参数校验
    if (!__WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["b" /* util */].checkParams({ fn: fn, param: param, fullresult: fullresult })) {
      return;
    };

    // 打包数据
    var data = {
      p0: fn,
      p1: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(param),
      userAttrId: __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].session.get('userAttrId'),
      fullresult: fullresult === true
    };

    // API签名
    var signFlag = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.get('signFlag');
    if (signFlag) {
      data.sign = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["b" /* util */].doSign(data);
    }

    config.method = method;
    if (config.method.toLowerCase() == "get") {
      config.params = data;
    } else {
      config.data = data;
    }

    /*Indicator.open({
      //text: '努力加载中...',
      spinnerType: 'snake'
    });*/

    // 开发环境，打印调试URL
    if (__WEBPACK_IMPORTED_MODULE_7__Constant__["a" /* default */].env.ENV_MODE == 'development' && __WEBPACK_IMPORTED_MODULE_7__Constant__["a" /* default */].env.PRINT_DEBUG_URL) {
      var httpURL = __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["b" /* util */].combHttpURL(config.baseURL, data);
      console.log('请求URL: ', httpURL);
    }

    // HTTP请求
    return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].request(config).then(function (res) {
      /*Indicator.close();*/

      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject("请求服务异常！");
      }

      var result = typeof res.data == 'string' ? JSON.parse(res.data) : res.data;
      if (result.success === true) {
        success && success(result);
        __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].session.set('userAttrId', result.userAttrId);

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
      } else {
        error && error(res.data);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.data);
      }
    }).catch(function (errors) {
      /*Indicator.close();*/

      error && error(errors.toString());
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errors.toString());
    });
  },

  // API sign key
  getSignKey: function (_getSignKey) {
    function getSignKey() {
      return _getSignKey.apply(this, arguments);
    }

    getSignKey.toString = function () {
      return _getSignKey.toString();
    };

    return getSignKey;
  }(function () {
    var _this3 = this;

    var data = {
      p0: '',
      userAttrId: __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].session.get('userAttrId') || ""
    };

    var config = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */]);
    config.baseURL = __WEBPACK_IMPORTED_MODULE_7__Constant__["a" /* default */].authBaseUrl;
    config.params = data;

    return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].request(config).then(function (res) {
      console.log('get signKey:', res);
      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject("请求服务异常！");
      }

      var result = typeof res.data == 'string' ? JSON.parse(res.data) : res.data;

      if (result.success === true) {
        var userAttrId = result.userAttrId;
        var signFlag = result.target && result.target.target && result.target.target.signFlag;
        var signKey = result.target && result.target.target && result.target.target.signKey;

        __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.set('signKey', signKey);
        __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.set('signFlag', signFlag);
        __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].session.set('userAttrId', userAttrId);

        if (signFlag && !signKey) {
          return _this3.logout().then(function () {
            return getSignKey();
          }).catch(function (err) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
          });
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result);
      }
    }).catch(function (errors) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errors);
    });
  }),

  // logout for new signKey
  logout: function logout() {
    var data = {
      p0: '',
      userAttrId: __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].session.get('userAttrId') || ""
    };

    var config = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */]);
    config.baseURL = __WEBPACK_IMPORTED_MODULE_7__Constant__["a" /* default */].logoutBaseUrl;
    config.params = data;

    return __WEBPACK_IMPORTED_MODULE_3__axios__["a" /* default */].request(config).then(function (res) {
      console.log('get signKey:', res);
      if (!res || res.status != 200 || !res.data) {
        error && error("请求服务异常！");
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject("请求服务异常！");
      }

      var result = typeof res.data == 'string' ? JSON.parse(res.data) : res.data;

      if (result.success === true) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result);
      }
    }).catch(function (errors) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errors);
    });
  }

});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TITLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_USER_ATTR_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_USER; });
/* unused harmony export LOGIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return IS_LOGINDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEARCH_KEYWORD_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LASTTEST_SEARCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLEAR_LASTTEST_SEARCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CUSTOMER_SHREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SHARE_GOODS_LISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGENO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LASTPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ORDER_MSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ORDER_MATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TREE_DATA; });
// frame 框架相关
var TITLE = 'TITLE';

// globel 全局
var USER_INFO = 'USER_INFO'; //用户信息
var UPDATE_USER_ATTR_ID = 'UPDATE_USER_ATTR_ID';
var SET_USER = 'SET_USER'; //设置用户信息

// login 登陆相关
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var IS_LOGINDE = 'IS_LOGINDE'; //是否登录


//搜索相关
var SEARCH_KEYWORD_LIST = 'SEARCH_KEYWORD_LIST'; //随机获取的搜索关键词列表
var LASTTEST_SEARCH_LIST = 'LASTTEST_SEARCH_LIST'; //最近搜索
var CLEAR_LASTTEST_SEARCH_LIST = 'CLEAR_LASTTEST_SEARCH_LIST'; //清除最近搜索

//客服部分
var CUSTOMER_SHREF = "CUSTOMER_SHREF"; //客服链接

//晒家分享相关
var SHARE_GOODS_LISTS = "SHARE_GOODS_LISTS"; //商品列表
var PAGENO = "PAGENO";
var LASTPAGE = "LASTPAGE";

// 客户订单
var ORDER_MSG = "ORDER_MSG";
var ORDER_MATE = "ORDER_MATE";
var TREE_DATA = "TREE_DATA";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(398),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(360)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(418),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return restCall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tokenCall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_axios__ = __webpack_require__(75);



/**
 * HTTP adapter
 */






function jsonCall(_ref, option, success, error) {
  var fn = _ref.fn,
      param = _ref.param,
      fullresult = _ref.fullresult,
      method = _ref.method;

  method = method || "post";
  var axiosConfig = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].deepCopy(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */]), option);
  if (method.toString().toLowerCase() === "post") {
    return __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].post({ fn: fn, param: param, fullresult: fullresult }, axiosConfig, success, error);
  } else {
    return __WEBPACK_IMPORTED_MODULE_4__http__["a" /* default */].get({ fn: fn, param: param, fullresult: fullresult }, axiosConfig, success, error);
  }
}

/**
 * 常规RESTfull接口调用
 *
 * @param      {String}    url      请求URL地址
 * @param      {Object}    data     请求数据
 * @param      {Function}  success  请求成功回调
 * @param      {Function}  error    请求失败回调
 */
var restCall = function restCall(url, data, type, success, error) {
  if (!data.userAttrId) {
    data.userAttrId = __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].storage.session.get("userAttrId");
  }

  var axiosConfig = __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].deepCopy(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */]);
  axiosConfig.baseURL = url;
  axiosConfig.data = data;
  axiosConfig.method = type || "POST";

  // 非生产环境，打印调试URL
  if (__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].env.NODE_ENV != "production" && __WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].env.PRINT_DEBUG_URL) {
    var httpURL = __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].combHttpURL(axiosConfig.baseURL, data);
    console.log("请求URL: ", httpURL);
  }

  return __WEBPACK_IMPORTED_MODULE_7__service_axios__["a" /* default */].request(axiosConfig).then(function (res) {
    if (!res || res.status != 200 || !res.data) {
      error && error("请求服务异常！");
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject("请求服务异常！");
    }

    var result = typeof res.data == "string" ? JSON.parse(res.data) : res.data;
    if (result["success"] === true) {
      success && success(result);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
    } else {
      error && error(result);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result);
    }
  }).catch(function (errors) {
    if (__WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].isObject(errors)) {
      error && error(errors.message || errors.target && errors.target.message || "网络请求异常,请稍后再试!");
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errors.message || errors.target && errors.target.message || "网络请求异常,请稍后再试!");
    } else {
      error && error(errors);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errors);
    }
  });
};

/**
 * 常规RESTfull接口调用
 *
 * @param      {String}    url      请求URL地址
 * @param      {Object}    data     请求数据
 * @param      {Function}  success  请求成功回调
 * @param      {Function}  error    请求失败回调
 */
var tokenCall = function tokenCall(url, data, type, token, success, error) {
  var axiosConfig = __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].deepCopy(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */]);
  axiosConfig.method = type || "POST";
  axiosConfig.baseURL = url.startsWith('http://') || url.startsWith('https://') ? url : __WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + url;
  if (axiosConfig.method.toLowerCase().trim() == "get") {
    axiosConfig.params = data;
  } else {
    axiosConfig.data = data;
  }
  //判断属于哪个模块登录customerService：售后登录
  var belong = __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].storage.local.get("belong");
  var _token = "";
  switch (belong) {
    case "fitting":
      _token = token || __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].storage.local.get("fittingToken");
      break;
    default:
      _token = token || __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].storage.local.get("token");
      break;
  }
  axiosConfig.headers.token = _token;
  // axiosConfig.headers.token = token || util.storage.local.get("token");
  axiosConfig.headers["Content-Type"] = "application/json;charset=UTF-8";
  axiosConfig.transformRequest = [function (data) {
    // console.log('transformRequest<--------------------',data,typeof data,JSON.stringify(data))
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
  }];

  // console.log('===============', axiosConfig)

  return __WEBPACK_IMPORTED_MODULE_7__service_axios__["a" /* default */].request(axiosConfig).then(function (res) {
    console.log("tokenCall >>>>>>>>>>>>>>>", res);
    if (!res || res.status != 200 || !res.data) {
      error && error("请求服务异常！");
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject("请求服务异常！");
    }

    var result = typeof res.data == "string" ? JSON.parse(res.data) : res.data;

    if (result["code"] === 200) {
      console.log(result);
      success && success(result);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
    } else {
      error && error(result);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result);
    }
  }).catch(function (errors) {
    if (__WEBPACK_IMPORTED_MODULE_6__common_utils_util__["b" /* util */].isObject(errors)) {
      error && error(errors.message || errors.target || "网络请求异常,请稍后再试!");
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errors.message || errors.target || "网络请求异常,请稍后再试!");
    } else {
      error && error(errors);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errors);
    }
  });
};

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = window.Vue;

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(324)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(381),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(353)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_login_index__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_home_index__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_cart_index__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_classify_index__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_personal_index__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_physicalStores_index__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_agency_index__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_agency_agencyCom__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_customOrder_index__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_questions_index__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_customerService_index__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_afterSaleComment_index__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_diy_index__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_fitting_index__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_install_study_index__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_prod_intro_index__ = __webpack_require__(239);





/*import createLogger from '../plugins/logger'*/


//modules













 //diy部分内容




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);
var debug = "production" !== "production" && __WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].env.STORE_LOG_SWITCH;

//公共数据
var state = {
  userAttrId: "", //用户sessionId
  userInfo: null, //用户信息
  customerLink: null //客服链接
};

//导出STORE
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
  state: state,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {
    login: __WEBPACK_IMPORTED_MODULE_6__modules_login_index__["a" /* default */],
    home: __WEBPACK_IMPORTED_MODULE_7__modules_home_index__["a" /* default */],
    cart: __WEBPACK_IMPORTED_MODULE_8__modules_cart_index__["a" /* default */],
    classify: __WEBPACK_IMPORTED_MODULE_9__modules_classify_index__["a" /* default */],
    personal: __WEBPACK_IMPORTED_MODULE_10__modules_personal_index__["a" /* default */],
    plysicalStores: __WEBPACK_IMPORTED_MODULE_11__modules_physicalStores_index__["a" /* default */],
    agency: __WEBPACK_IMPORTED_MODULE_12__modules_agency_index__["a" /* default */],
    agencyCom: __WEBPACK_IMPORTED_MODULE_13__modules_agency_agencyCom__["a" /* default */],
    customOrder: __WEBPACK_IMPORTED_MODULE_14__modules_customOrder_index__["a" /* default */],
    questions: __WEBPACK_IMPORTED_MODULE_15__modules_questions_index__["a" /* default */],
    customerService: __WEBPACK_IMPORTED_MODULE_16__modules_customerService_index__["a" /* default */],
    afterSaleComment: __WEBPACK_IMPORTED_MODULE_17__modules_afterSaleComment_index__["a" /* default */],
    fitting: __WEBPACK_IMPORTED_MODULE_19__modules_fitting_index__["a" /* default */],
    diy: __WEBPACK_IMPORTED_MODULE_18__modules_diy_index__["a" /* default */],
    installStudy: __WEBPACK_IMPORTED_MODULE_20__modules_install_study_index__["a" /* default */],
    prodIntro: __WEBPACK_IMPORTED_MODULE_21__modules_prod_intro_index__["a" /* default */]
  },
  strict: debug
  /*plugins: debug ? [createLogger()] : []*/
}));

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initWxShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    Vue.prototype.linkFn = function (linkType, linkTarget) {
      //给自定义方法起个名  
      var ENV = __WEBPACK_IMPORTED_MODULE_0__Constant__["a" /* default */].assetBaseUrl;
      switch (linkType) {
        case '1':
          window.location.href = '/main/search?linkTarget=' + linkTarget + '&linkType=' + linkType; //商品搜索页
          break;
        case '2':
          window.location.href = '/main/brandHome?linkTarget=' + linkTarget + '&linkType=' + linkType; //店铺首页
          break;
        case '3':
          window.location.href = '/main/search?linkTarget=' + linkTarget + '&linkType=' + linkType; //店铺分类列表页
          break;
        case '4':
          window.location.href = '/main/goodsDetail?linkTarget=' + linkTarget + '&linkType=' + linkType; //商品详情
          break;
        case '5':
          //to do
          break;
        case '6':
          //to do
          break;
        case '93':
          //to do
          break;
        case '94':
          //to do
          break;
        case '95':
          window.location.href = '/main/physicalStores?linkTarget=' + linkTarget + '&linkType=' + linkType; //店铺门店页
          break;
        case '96':
          window.location.href = '/main/physicalStores?linkTarget=' + linkTarget + '&linkType=' + linkType; //实体门店页
          break;
        case '97':
          //diy页面
          break;
        case '98':
          if (linkTarget.indexOf('http://') < 0) {
            linkTarget = "http://" + linkTarget;
          }
          window.location.href = linkTarget;
          break;
        case '99':
          //to do
          break;
        case 'project':
          window.location.href = 'http://www.cqmxjt.cn/index.php?m=content&c=index&a=lists&catid=80';
          break;
        case 'fitting':
          window.location.href = '/fitting/role';
          break;
        case 'oa':
          window.location.href = 'http://oa.mexingroup.com:9999';
        default:
          break;
      }
    };
  }
});

/**
 * 微信分享初始化
 */
var initWxShare = function initWxShare(url) {
  //--------微信分享初始化
  __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */]._actions.getWxJsSdkConfig[0]([url]).then(function (wxTarget) {
    wxTarget.debug = false;
    //微信配置
    var wxconfig = {
      appId: wxTarget.appId,
      debug: wxTarget.debug,
      nonceStr: wxTarget.nonceStr,
      signature: wxTarget.signature,
      timestamp: wxTarget.timestamp,
      jsApiList: wxTarget.jsApiList
    };
    __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.config(wxTarget);
  }).then(function () {

    var shareTitle = document.title;
    var shareUrl = location.href;
    var shareDesc = location.href;
    var shareImgUrl = 'http://' + location.host + '/static/images/meixin_logo.jpg';
    __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.ready(function () {
      //分享到朋友圈
      __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareTimeline({
        title: shareTitle, // 分享标题
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function success() {}
      });
      //分享给朋友
      __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareAppMessage({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function success() {}
      });
      /*分享到qq*/
      __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareQQ({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function success() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
        }
      });
      //分享到腾讯微博
      __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareWeibo({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function success() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
        }
      });
      //分享到qq空间
      __WEBPACK_IMPORTED_MODULE_1_weixin_js_sdk___default.a.onMenuShareQZone({
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareUrl, // 分享链接
        imgUrl: shareImgUrl, // 分享图标
        success: function success() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function cancel() {
          // 用户取消分享后执行的回调函数
        }
      });
    });
  });
  //----微信分享初始化结束
};

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constant__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
    baseURL: __WEBPACK_IMPORTED_MODULE_1__Constant__["a" /* default */].apiBaseUrl,
    method: 'GET',
    transformRequest: [function (data) {
        data = __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data);
        // data = JSON.stringify(data);
        return data;
    }],

    transformResponse: [function (data) {
        return data;
    }],

    headers: {
        'Accept': 'application/json,text/html',
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        /* 'Content-Type': 'application/json;charset=UTF-8'*/
    },

    params: {},
    paramsSerializer: function paramsSerializer(params) {
        return __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(params);
    },

    timeout: 60000,
    withCredentials: false, // default
    responseType: 'json', // default

    //防止跨域状态下发起option请求
    // onUploadProgress: function(progressEvent) {
    //  // Do whatever you want with the native progress event
    // },
    // onDownloadProgress: function(progressEvent) {
    //  // Do whatever you want with the native progress event
    // },

    maxContentLength: 2000,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 500; // default
    },
    maxRedirects: 5 // default
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(9);



/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(param, success, error) {
    __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(param, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].logout();
  },

  loginHanlder: {
    checkLogin: function checkLogin(param, success, error) {
      var option = {
        fn: "mallmem.memLoginHandler.isLogined",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },
  wxHandler: {
    //8.1.获取首页头部导航栏
    getWxJsSdkConfig: function getWxJsSdkConfig(param, success, error) {
      var option = {
        fn: "mallsale.wxHandler.getWxJsSdkConfig",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },
  /*
  * 获取首页头部导航栏
  * @type {Object}
  */
  navBarHandler: {
    //8.1.获取首页头部导航栏
    getHomeHeaderNavs: function getHomeHeaderNavs(param, success, error) {
      var option = {
        fn: "mallsale.navBarHandler.getHomeHeaderNavs",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },

  /*
  * 17.商品查询（列表）API
  * @type {Object}
  */
  goodsSearchHandler: {
    //17.1.获取排序列表
    goodsSearchHandler: function goodsSearchHandler(param, success, error) {
      var option = {
        fn: "mallsale.goodsSearchHandler.getGoodsSearchSort",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //17.2.商品分页查询
    pageGoods: function pageGoods(param, success, error) {
      var option = {
        fn: "mallsale.goodsSearchHandler.pageGoods",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },

  /*
  *购物车API
  * @type {Object}
   */
  cartHandler: {
    //13.1.获取购物车信息
    getCartInfo: function getCartInfo(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.getCartInfo",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //13.4.增加购物车商品数量
    incrMemCartNum: function incrMemCartNum(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.incrMemCartNum",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //13.5.修改购物车商品数量
    changeMemCartNum: function changeMemCartNum(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.changeMemCartNum",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //13.6.减少购物车商品数量
    decrMemCartNum: function decrMemCartNum(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.decrMemCartNum",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //13.7.从购物车中删除商品
    removeMemCart: function removeMemCart(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.removeMemCart",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //13.8.从购物车中批量删除商品
    removeMemCarts: function removeMemCarts(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.removeMemCarts",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //13.12.从购物车加入收藏夹
    addMemFavFormCart: function addMemFavFormCart(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.addMemFavFormCart",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //13.13.从购物车加入收藏夹-批量
    addMemFavBatchFormCart: function addMemFavBatchFormCart(param, success, error) {
      var option = {
        fn: "mallsale.cartHandler.addMemFavBatchFormCart",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },

  /*
  *结算API
  * @type {Object}
  */
  settleHandler: {
    //15.1.从购物车结算
    getOrderSettleMsgFromCart: function getOrderSettleMsgFromCart(param, success, error) {
      var option = {
        fn: "mallsale.settleHandler.getOrderSettleMsgFromCart",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //15.4.提交订单
    createOrder: function createOrder(param, success, error) {
      var option = {
        fn: "mallsale.settleHandler.createOrder",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },

  /*
  *发票API
  * @type {Object}
  */
  invoiceHandler: {
    //14.1.分页查询会员发票信息
    pageMemOrderInvoice: function pageMemOrderInvoice(param, success, error) {
      var option = {
        fn: "mallsale.invoiceHandler.pageMemOrderInvoice",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //14.2.获取发票类型列表
    listInvoiceType: function listInvoiceType(param, success, error) {
      var option = {
        fn: "mallsale.invoiceHandler.listInvoiceType",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //14.3.获取发票内容列表
    listInvoiceContent: function listInvoiceContent(param, success, error) {
      var option = {
        fn: "mallsale.invoiceHandler.listInvoiceContent",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //14.4.获取会员单位发票列表
    listMemInvoiceMsg: function listMemInvoiceMsg(param, success, error) {
      var option = {
        fn: "mallsale.invoiceHandler.listMemInvoiceMsg",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //14.5.保存会员单位发票
    saveMemInvoice: function saveMemInvoice(param, success, error) {
      var option = {
        fn: "mallsale.invoiceHandler.saveMemInvoice",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //14.6.删除会员单位发票
    removeMemInvoice: function removeMemInvoice(param, success, error) {
      var option = {
        fn: "mallsale.invoiceHandler.removeMemInvoice",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },

  /*
  *地址API
  * @type {Object}
  */
  addressHandler: {
    //7.6.列出收货地址
    listAddress: function listAddress(param, success, error) {
      var option = {
        fn: "mallmem.addressHandler.listAddress",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  },

  /*
  *12.优惠券、红包相关API
  * @type {Object}
  */
  couponHandler: {
    //12.1.分页查询会员优惠券
    pageMemCoupon: function pageMemCoupon(param, success, error) {
      var option = {
        fn: "mallsale.couponHandler.pageMemCoupon",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //12.2.删除会员优惠券、红包
    delMemCoupon: function delMemCoupon(param, success, error) {
      var option = {
        fn: "mallsale.couponHandler.delMemCoupon",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    },

    //12.3.分页查询会员红包
    pageMemRedpacket: function pageMemRedpacket(param, success, error) {
      var option = {
        fn: "mallsale.couponHandler.pageMemRedpacket",
        param: param
      };
      return __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */].post(option, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */], success, error);
    }
  }

});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);








// http request 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].state.token) {
    config.headers.Authorization = 'token ' + __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].state.token;
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// http response 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  console.log('axios response >>>', response);
  if (response.data && response.data.errCode) {
    var errmsg = __WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].errorMsg[response.data.errCode] || response.data.message;
    if (response.data.errCode == "AccessPermissionDeny") {
      location.href = '/main/auth?redirect=' + location.href;
      return;
    }
  }
  // tokenCall  401 token失效，重新登录
  if (response.data && response.data.code) {
    console.log('response.data', response.data);
    if (response.data.code == 401) {
      //判断属于哪个模块登录customerService：售后登录
      var belong = __WEBPACK_IMPORTED_MODULE_5__common_utils_util__["a" /* storage */].local.get('belong');
      var redirect = '';
      switch (belong) {
        case "customerService":
          redirect = encodeURIComponent(location.pathname + location.search);
          location.href = '/main/customerLogin?redirect=' + redirect;
          break;
        case "fitting":
          redirect = encodeURIComponent(location.pathname + location.search);
          location.href = '/fitting/role?redirect=' + redirect;
          break;
        default:
          location.href = '/main/agencyLogin?redirect=' + location.href;
          break;
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.message);
    }
  }

  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        __WEBPACK_IMPORTED_MODULE_2__store_index__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* LOGOUT */]);
        location.href = '/main/auth?redirect=' + location.href;
    }
  }

  if (error.toString().indexOf('Network') > 0) {
    /* MessageBox.alert("网络异常！");*/
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(376),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(383),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(390),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(375),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(321)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(378),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(373),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(419),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(406),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(403),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(377),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(379),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(380),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(399),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(395),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(391),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(413),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(412),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73ac8fb2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(396),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(372),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(387),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(384),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(401),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(420),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(382),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(386),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(389),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(408),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(359)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(417),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(400),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(388),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(411),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(405),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(392),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(394),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(407),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(397),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports) {

;(function (win, lib) {
    var doc = win.document;
    var docEl = doc.documentElement;
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        // console.warn('将根据已有的meta标签来设置缩放比例');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // 其他设备下，仍旧使用1倍的方案
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    if (!metaEl) {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
            width = 540 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    win.addEventListener('resize', function () {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 12 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function (e) {
            doc.body.style.fontSize = 12 * dpr + 'px';
        }, false);
    }

    refreshRem();

    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    };
    flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    };
})(window, window['lib'] || (window['lib'] = {}));

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(1);



function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
        util: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_1__util_js__["c" /* default */];
            }
        }
    });
}
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "discount", function() { return discount; });
/* harmony export (immutable) */ __webpack_exports__["dateFormat"] = dateFormat;
/**
 * HTML编译输出过滤器
 */

// 折扣展示
var discount = function discount(value) {
  var discount = value.split('.')[0];
  if (discount % 10 == 0) {
    return discount.substr(0, 1);
  } else {
    return discount;
  }
};

/**
 * 日期格式化
 * @param timeSpan
 * @param format
 * @returns {*}
 */
function dateFormat(timeSpan, format) {
  if (!timeSpan) return;

  //兼容IE8低版本处理
  var timestr = timeSpan.replace(/-/g, '/').replace(/T|Z/g, ' ').trim();

  var date = new Date(timestr);
  var o = {
    "M+": date.getMonth() + 1, //month
    "d+": date.getDate(), //day
    "h+": date.getHours(), //hour
    "m+": date.getMinutes(), //minute
    "s+": date.getSeconds(), //second
    "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
    "S": date.getMilliseconds() //millisecond
  };

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }

  return format;
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_main__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_index__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classify_index__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cart_index__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__personal_index__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__physicalStores_index__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__agency_index__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__customOrder_index__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__login_index__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__error_index__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__questions_index__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__afterSaleComment_index__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__customerService_index__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__install_study_index__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__prod_intro_index__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fitting_index__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__400_index__ = __webpack_require__(207);





















__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var mainRouter = [{
  path: "/",
  redirect: "/main/home"
}, {
  path: "/main",
  // component: main,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(51)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: []
}, {
  path: "/fitting",
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(51)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: []
}, {
  path: "/400",
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(51)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: []
}];

var configRouter = function configRouter() {
  var _mainRouter$1$childre, _mainRouter$1$childre2, _mainRouter$1$childre3, _mainRouter$1$childre4, _mainRouter$1$childre5, _mainRouter$1$childre6, _mainRouter$1$childre7, _mainRouter$1$childre8, _mainRouter$1$childre9, _mainRouter$1$childre10, _mainRouter$1$childre11, _mainRouter$1$childre12, _mainRouter$1$childre13, _mainRouter$2$childre, _mainRouter$3$childre, _mainRouter$1$childre14;

  (_mainRouter$1$childre = mainRouter[1].children).push.apply(_mainRouter$1$childre, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__home_index__["a" /* default */]));
  (_mainRouter$1$childre2 = mainRouter[1].children).push.apply(_mainRouter$1$childre2, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__classify_index__["a" /* default */]));
  (_mainRouter$1$childre3 = mainRouter[1].children).push.apply(_mainRouter$1$childre3, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__cart_index__["a" /* default */]));
  (_mainRouter$1$childre4 = mainRouter[1].children).push.apply(_mainRouter$1$childre4, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__personal_index__["a" /* default */]));
  (_mainRouter$1$childre5 = mainRouter[1].children).push.apply(_mainRouter$1$childre5, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__physicalStores_index__["a" /* default */]));
  (_mainRouter$1$childre6 = mainRouter[1].children).push.apply(_mainRouter$1$childre6, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__agency_index__["a" /* default */]));
  (_mainRouter$1$childre7 = mainRouter[1].children).push.apply(_mainRouter$1$childre7, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__customOrder_index__["a" /* default */]));
  (_mainRouter$1$childre8 = mainRouter[1].children).push.apply(_mainRouter$1$childre8, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__login_index__["a" /* default */]));
  (_mainRouter$1$childre9 = mainRouter[1].children).push.apply(_mainRouter$1$childre9, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__questions_index__["a" /* default */]));
  (_mainRouter$1$childre10 = mainRouter[1].children).push.apply(_mainRouter$1$childre10, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__afterSaleComment_index__["a" /* default */]));
  (_mainRouter$1$childre11 = mainRouter[1].children).push.apply(_mainRouter$1$childre11, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__customerService_index__["a" /* default */]));
  (_mainRouter$1$childre12 = mainRouter[1].children).push.apply(_mainRouter$1$childre12, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__install_study_index__["a" /* default */]));
  (_mainRouter$1$childre13 = mainRouter[1].children).push.apply(_mainRouter$1$childre13, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__prod_intro_index__["a" /* default */]));
  (_mainRouter$2$childre = mainRouter[2].children).push.apply(_mainRouter$2$childre, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_19__fitting_index__["a" /* default */]));
  (_mainRouter$3$childre = mainRouter[3].children).push.apply(_mainRouter$3$childre, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__400_index__["a" /* default */]));

  //注意：错误页面路由,必须放最后
  (_mainRouter$1$childre14 = mainRouter[1].children).push.apply(_mainRouter$1$childre14, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__error_index__["a" /* default */]));
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(mainRouter);
};

/* harmony default export */ __webpack_exports__["a"] = (configRouter);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(74);

/**
 * 注册到vue全局方法，直接在vue组件里面调用this.api;
 */


function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
        api: {
            get: function get() {
                return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */];
            }
        }
    });
}
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(385),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(99);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },


  methods: {},
  components: {},
  created: function created() {}
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    imgpath: String, //图片路径
    emptytext: String, //文字提示
    btntext: [String, Boolean], //按钮文字
    btnurl: String //按钮跳转链接
  },
  data: function data() {
    return {};
  },

  computed: {},
  methods: {
    doUrl: function doUrl(url) {
      location.href = url;
      // this.$router.push({
      // 		path: url
      // 	})
    }
  },
  created: function created() {
    //console.log(this.btntext)
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constant__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isLeftRight: Boolean, //是否是左右结构
    imagePath: String, //图片路径
    defaultPath: String, //默认图片路径
    titleText: [String, Boolean], //title
    moneyText: [String, Boolean], //money
    outSideBox: Boolean, //外边框阴影
    isNewProduct: Boolean, //是否是新品
    onlyImage: Boolean, //是否需要懒加载
    orginalCost: String, //原价
    width: Number,
    height: Number,
    imgStyle: Object,
    eventparam: Object
  },
  data: function data() {
    return {
      isOverflow: false
    };
  },

  computed: {
    imgPath: function imgPath() {
      if (this.imagePath) {
        var src = this.imagePath;
        if (this.width && this.height) {
          var strArr = this.imagePath.split(".");
          strArr[0] = strArr[0] + "-" + this.width + "-" + this.height;
          src = strArr.join(".");
        } else if (this.width) {
          var _strArr = this.imagePath.split(".");
          _strArr[0] = _strArr[0] + "-" + this.width;
          src = _strArr.join(".");
        } else if (!this.width || !this.height) {
          src = this.imagePath;
        }
        return __WEBPACK_IMPORTED_MODULE_0__Constant__["a" /* default */].imgBaseUrl + "/" + src;
      } else {
        return this.defaultPath;
      }
    }
  },
  methods: {
    onImgClick: function onImgClick() {
      this.$emit("eventclick", this.eventparam);
    }
  },
  created: function created() {
    //console.log(Constant.imgBaseUrl + '/' + this.imagePath)
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			/*bottomNav: '1'*/
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		bottomNav: function bottomNav() {
			return this.$route.meta.id ? this.$route.meta.id : '1';
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
		cartGoodsNum: 'cartGoodsNum' //购物车商品数量
	})),
	mounted: function mounted() {
		this.getCartNum();
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
		getCartGoodsNum: 'getCartGoodsNum' //获取购物车商品数量
	}), {
		handleChange: function handleChange(val) {
			switch (val) {
				case '1':
					this.$router.push({ path: '/main/home' });
					break;
				case '2':
					this.$router.push({ path: '/main/classify' });
					break;
				case '3':
					this.$router.push({ path: '/main/cart' });
					break;
				case '4':
					this.$router.push({ path: '/main/personal' });
					break;
			}
		},

		//13.9.获取购物车商品数量
		getCartNum: function getCartNum() {
			this.getCartGoodsNum([]).then(function (res) {
				//this.cartGoodsNum = res;
			});
		}
	})
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_image_image__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isDIY: false, //是否是div商品
    cartitem: "",
    selvalue: "",
    isCheckBox: false, //是否有复选框
    isRightTriggle: false, //是否有向右的箭头
    width: [Number, String],
    height: [Number, String]
  },
  data: function data() {
    return {
      value: this.selvalue
    };
  },

  methods: {
    clickItem: function clickItem(goodid, skuId) {
      if (skuId == undefined) {
        skuId = 0;
      }
      location.href = '/main/goodsDetail?goodsId=' + goodid + '&skuId=' + skuId || 0;

      //this.$emit('clickItem', index);
    }

  },
  components: {
    imgs: __WEBPACK_IMPORTED_MODULE_0__components_image_image___default.a
  },
  watch: {
    selvalue: function selvalue(val) {
      this.value = val;
    },
    value: function value(val) {
      this.$emit("on-result-change", val);
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		goHome: function goHome() {
			this.$router.push({
				path: '/main/home'
			});
		}
	}
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        index: [Number, String]
    },
    data: function data() {
        return {
            startX: 0, //触摸位置
            moveX: 0, //滑动时的位置
            disX: 0, //移动距离
            txtStyle: '',
            delWidth: 150,
            top: '',
            zIndex: 'z-index:-1'
        };
    },

    methods: {
        _touchStart: function _touchStart(ev) {
            ev = ev || event;
            if (ev.touches.length == 1) {
                // 手指按下的时候记录按下的位置
                this.startX = ev.touches[0].clientX;
                //console.log(this.startX)
            }
        },
        _touchMove: function _touchMove(ev) {
            ev = ev || event;
            if (ev.touches.length == 1) {
                // 滑动过程中的实时位置
                this.moveX = ev.touches[0].clientX;
                // 滑动过程中实时计算滑动距离
                this.disX = this.startX - this.moveX;
                //console.log('disX==>',this.disX)
                // 如果是向右滑动或者只是点击，不改变滑动位置
                if (this.disX < 0 || this.disX == 0) {
                    // console.log('没有移动');
                    this.txtStyle = "transform:translateX(0rem)";
                    this.zIndex = "z-index:" + -1 + ";width:" + 0 + "rem";
                } else if (this.disX > 50) {
                    //如果是向左滑动，则实时给这个根元素一个向左的偏移-left，当偏移量到达固定值delWidth时，固定元素的偏移量为 delWidth
                    this.txtStyle = "transform:translateX(-" + this.disX / 100 + "rem)";
                    this.zIndex = "z-index:" + 10 + ";width:" + this.disX / 100 + "rem";
                    // if (this.disX  >= this.delWidth/2) {
                    //     this.txtStyle = "transform:translateX(-" + this.delWidth/100 + "rem)";
                    //     this.zIndex = "z-index:" + 10 + ";width:" + this.delWidth/100 + "rem";
                    // }
                }
            }
        },
        _touchEnd: function _touchEnd(ev) {
            if (event.changedTouches.length == 1) {
                // 手指移动结束后的水平位置
                var endX = event.changedTouches[0].clientX;
                // 触摸开始与结束,手指移动的距离
                this.disX = this.startX - endX;
                //如果距离小于删除按钮的1/2，不显示删除按钮
                //console.log("=>",this.disX )
                //滑动结束，判断当前的滑动距离大于或等于时 偏移
                if (this.disX >= this.delWidth / 2) {
                    this.txtStyle = "transform:translateX(-" + this.delWidth / 100 + "rem)";
                    this.zIndex = "z-index:" + 10 + ";width:" + this.delWidth / 100 + "rem";
                } else {
                    this.txtStyle = "transform:translateX(-" + 0 + "rem)";
                    this.zIndex = "z-index:" + -1 + ";width:" + 0 + "rem";
                }
            }
        },
        deleteItem: function deleteItem(index) {
            this.$emit('deleteItem', index);
        }
    }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_touchDelete_touchDelete__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_touchDelete_touchDelete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_touchDelete_touchDelete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Vuex__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      all: false,
      headimgPopup: false,
      id: "",
      isEdit: false, //编辑状态
      isDelete: false, //单个删除弹框
      isDeletes: false, //批量删除弹框
      cartInfoList: [], //购物车商品列表
      totalGoodsPrice: 0, //总价
      totalGoodsNum: 0, //购物车商品数量
      goodsNumber: 0,
      settleDatas: [], //结算店铺列表
      OrderSettleMsg: {}, //订单信息
      couponAmounts: [], //选中的优惠券
      redpacketAmounts: [], //选中的优惠券
      deleteid: null,
      toast: {
        toast: false,
        messageTip: ""
      },
      //以下为优惠券
      couponPopup: false, //优惠券弹框
      couponsList: [], //优惠券列表
      tempStoreId: "" //店铺id
    };
  },

  watch: {
    //深度 watcher
  },
  created: function created() {
    this.cartInfo();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_Vuex__["a" /* mapActions */])({
    getOrderSettleMsgFromCart: "getOrderSettleMsgFromCart", //购物车结算
    getCartGoodsNum: "getCartGoodsNum", //获取购物车商品数量
    getListStoreCoupons: "getListStoreCoupons", //获取优惠券列表
    receiveCoupon: "receiveCoupon" //领取优惠券
  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this2 = this;

      this.toast.toast = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this2.toast.toast = false;
      }, 1500);
    },

    //获取优惠券列表
    getListStoreCoupon: function getListStoreCoupon(storeId) {
      var _this3 = this;

      this.tempStoreId = storeId;
      this.getListStoreCoupons(storeId).then(function (res) {
        _this3.couponsList = res;
      });
    },

    //领取优惠券
    getCoupon: function getCoupon(couponId, couponType, isGet) {
      var _this4 = this;

      if (isGet == 1) {
        return;
      }
      this.receiveCoupon([couponId, couponType]).then(function (res) {
        if (res.success) {
          _this4.showTipMessage(true, res.message || "领取成功！");
          _this4.getListStoreCoupon(_this4.tempStoreId);
        } else {
          _this4.showTipMessage(true, res.message || "领取失败，请稍后重试！");
        }
      }).catch(function (error) {
        _this4.showTipMessage(true, error);
      });
    },
    gotoBrandHome: function gotoBrandHome(storeid) {
      this.$router.push({
        path: "/main/brandHome?linkTarget=" + storeid + "&linkType=2"
      });
    },
    gotoDetail: function gotoDetail(storeid, goodid, skuId) {
      this.$router.push({
        path: "/main/goodsDetail?goodsId=" + goodid + "&storeId=" + storeid + "&skuId=" + skuId
      });
    },
    cartInfo: function cartInfo() {
      var _this5 = this;

      this.getCartNum();
      var _this = this;
      //this.cartInfoList = [];
      this.api.cartHandler.getCartInfo([], function (res) {
        var data = res.target.target;
        _this5.load = false;
        if (data != null) {
          //判断store是否勾选
          var storenum = 0; //选中的店铺数量
          data.cartGoodsItems.forEach(function (item) {
            //  _this.getListStoreCoupons(item.storeId).then(res =>{
            //    item.couponsList = res;
            // })
            var count = 0; //计数器
            item.cartGoodses.forEach(function (sub, index) {
              if (sub.cartSelected) count++;
            });
            item.Selected = count == item.cartGoodses.length ? true : false; //勾选的数量  和 当前商店的商品数量 一致  该商店勾选
            if (item.Selected == true) storenum++;
          });
          _this5.all = storenum == data.cartGoodsItems.length ? true : false;
          console.log("data", data);
          _this5.cartInfoList = data.cartGoodsItems;
          _this5.totalGoodsPrice = data.totalGoodsPrice;
          _this5.totalGoodsNum = data.totalGoodsNum;
        } else {
          _this5.cartInfoList = [];
          _this5.totalGoodsPrice = 0;
          _this5.totalGoodsNum = 0;
        }
      });
    },

    //13.9.获取购物车商品数量
    getCartNum: function getCartNum() {
      var _this6 = this;

      this.getCartGoodsNum([]).then(function (res) {
        _this6.CartGoodsNum = res;
      });
    },

    //选中某品牌   =>该品牌下的DIY和商品勾选
    storeAll: function storeAll(checked, index) {
      //当前店铺的所有商品列表
      var goods = this.cartInfoList[index].cartGoodses;
      // 检查是否勾选 index 的店铺
      var isStoreAll = checked ? true : false;
      //如果店铺选中，所属商品全部选中   反之亦然
      for (var i = 0; i <= goods.length - 1; i++) {
        goods[i].cartSelected = isStoreAll;
      }
      this.changeCheckbox();
    },

    //复选框改变事件
    changeSelect: function changeSelect(checked, storeIndex, goodsIndex) {
      this.cartInfoList[storeIndex].cartGoodses[goodsIndex].cartSelected = checked;
      this.changeCheckbox();
    },

    //勾选事件
    changeCheckbox: function changeCheckbox() {
      var sum = 0; //金钱
      var storenum = 0; //选中的店铺数量
      this.cartInfoList.forEach(function (item) {
        var count = 0; //商品数量
        item.cartGoodses.forEach(function (sub, index) {
          if (sub.cartSelected == true) {
            count++;
            sum += sub.goodsNum * sub.salePrice;
          }
        });
        item.Selected = count == item.cartGoodses.length ? true : false;
        if (item.Selected == true) storenum++;
      });
      this.all = storenum == this.cartInfoList.length ? true : false;
      this.totalGoodsPrice = sum.toFixed(2);
    },

    //全选
    handleCheckAllChange: function handleCheckAllChange(checked) {
      //全选按钮状态
      var isAll = checked ? true : false;
      this.all = isAll;
      //根据全选按钮 标记其他复选框
      this.cartInfoList.forEach(function (item) {
        item.Selected = isAll;
        item.cartGoodses.forEach(function (sub, index) {
          sub.cartSelected = isAll;
        });
      });
      this.changeCheckbox();
      //console.log(this.all,checked);
    },

    //商品数量修改
    changeNum: function changeNum(action, id, num) {
      var _this7 = this;

      if (action == "reduce") {
        if (num <= 1) return;
        this.api.cartHandler.decrMemCartNum([id], function (res) {
          //console.log(res)
          _this7.cartInfo();
        });
      } else if (action == "add") {
        this.api.cartHandler.incrMemCartNum([id], function (res) {
          _this7.cartInfo();
        });
      }
      this.toast.toast = true;
      this.toast.messageTip = "商品数量修改成功";
      setTimeout(function () {
        _this7.toast.toast = false;
      }, 1500);
    },

    // 删除
    deleteItem: function deleteItem(id) {
      this.deleteid = id;
      this.isDelete = true;
    },

    //单个删除
    removeCart: function removeCart() {
      var _this8 = this;

      this.api.cartHandler.removeMemCart([this.deleteid], function (res) {
        //this.cartInfoList = [];
        _this8.cartInfo();
        _this8.toast.toast = true;
        _this8.toast.messageTip = "删除成功";
        setTimeout(function () {
          _this8.toast.toast = false;
        }, 1500);
      }).catch(function (err) {
        _this8.toast.toast = true;
        _this8.toast.messageTip = "删除失败";
        setTimeout(function () {
          _this8.toast.toast = false;
        }, 1500);
      });
      this.isDelete = false;
    },

    //批量删除
    removeCarts: function removeCarts() {
      var _this9 = this;

      var _this = this;
      var delCartIds = [];
      this.cartInfoList.forEach(function (item) {
        item.cartGoodses.forEach(function (sub, index) {
          if (sub.cartSelected) {
            delCartIds.push(sub.instSkuId);
          }
        });
      });
      this.api.cartHandler.removeMemCarts([delCartIds], function (res) {
        //this.cartInfoList = [];
        _this9.cartInfo();
        _this9.toast.toast = true;
        _this9.toast.messageTip = "删除成功";
        setTimeout(function () {
          _this9.toast.toast = false;
        }, 1500);
      }).catch(function (err) {
        _this9.toast.toast = true;
        _this9.toast.messageTip = "删除失败";
        setTimeout(function () {
          _this9.toast.toast = false;
        }, 1500);
      });
      this.isDeletes = false;
    },

    //商品加减
    goodsNum: function goodsNum(action) {
      var _this10 = this;

      if (action == "add") {
        this.goodsNumber += 1;
        this.api.cartHandler.incrMemCartNum([], function (res) {
          console.log(res);
        });
      } else if (action == "reduce") {
        if (this.goodsNumber == 0) return;
        this.goodsNumber -= 1;
      }
      this.toast.toast = true;
      this.toast.messageTip = "商品数量修改成功";
      setTimeout(function () {
        _this10.toast.toast = false;
      }, 1500);
    },

    // 批量加入收藏夹
    addCollect: function addCollect() {
      var _this11 = this;

      var delCartIds = [];
      this.cartInfoList.forEach(function (item) {
        item.cartGoodses.forEach(function (sub, index) {
          if (sub.cartSelected) {
            delCartIds.push(sub.instSkuId);
          }
        });
      });
      this.api.cartHandler.addMemFavBatchFormCart([delCartIds], function (res) {
        //console.log(res);
        //this.cartInfo();
        _this11.toast.toast = true;
        _this11.toast.messageTip = "收藏成功";
        setTimeout(function () {
          _this11.toast.toast = false;
        }, 1500);
      }).catch(function (err) {
        _this11.toast.toast = true;
        _this11.toast.messageTip = "收藏失败";
        setTimeout(function () {
          _this11.toast.toast = false;
        }, 1500);
      });
    },

    //点击全选
    selectAll: function selectAll(checked) {
      var _this = this;
      if (checked) {
        //实现反选
        _this.value = [];
        _this.cartData.forEach(function (item) {
          _this.value.push(item.id);
        });
      } else {
        //实现全选
        _this.value = [];
      }
    },

    // 初始化店铺结算信息
    initSettleDatas: function initSettleDatas(OrderSettleMsg) {
      var _this = this;
      var settleDatas = [];
      var couponAmounts = [];
      var redpacketAmounts = [];
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用优惠券",
            couponAmount: 0
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用红包",
            couponAmount: 0
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        var instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function (sub) {
          //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });

        settleDatas.push({
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId: "0",
          remark: "",
          dealerCode: ""
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0);
        redpacketAmounts.push(0);
      });
      var orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      __WEBPACK_IMPORTED_MODULE_5__common_utils_util_js__["a" /* storage */].local.set("orderData", orderData);
    },
    goOrderPay: function goOrderPay() {
      var _this12 = this;

      var selectCartIds = [];
      var _this = this;
      this.cartInfoList.forEach(function (item) {
        item.cartGoodses.forEach(function (sub) {
          if (sub.cartSelected) {
            selectCartIds.push(sub.instSkuId);
          }
        });
      });
      if (selectCartIds.length < 1) {
        //this.$message.warning("请选择要结算的商品!");
        return false;
      }
      this.getOrderSettleMsgFromCart([selectCartIds]).then(function (res) {
        _this12.initSettleDatas(res); // 初始化店铺结算信息

        _this12.$router.push({
          path: "/main/firmorder"
        });
      }).catch(function (err) {
        _this12.toast.toast = true;
        _this12.toast.messageTip = "结算失败，等会再试试吧~";
        setTimeout(function () {
          _this12.toast.toast = false;
        }, 1500);
      });
    }
  }),
  components: {
    menus: __WEBPACK_IMPORTED_MODULE_2__components_menus_menus___default.a,
    emptyCart: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a,
    touchDelete: __WEBPACK_IMPORTED_MODULE_1__components_touchDelete_touchDelete___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_4__components_image_image___default.a
  },
  mounted: function mounted() {}
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_touchDelete_touchDelete__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_touchDelete_touchDelete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_touchDelete_touchDelete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      value: [], //选中的id
      allChecked: false, //全选状态
      couponPopup: false, //优惠券弹框
      redpackagePopup: false, //红包弹框
      id: "",
      goodsNumber: 0, //加减框  数量
      isEdit: false, //编辑状态
      scrolled: 0, //监听滚动事件
      addressInfo: [], //地址列表
      selectAddressIndex: 0, //选中的地址  下标
      addInfo: {}, //用户新增的发票抬头
      invoiceTypeList: [], //获取发票类型列表
      invoiceContentList: [], //获取发票内容列表
      memInvoiceMsgList: [], //获取会员单位发票列表
      settleDatas: [], //结算店铺列表
      OrderSettleMsg: {}, //订单信息
      couponAmounts: [], //选中的优惠券
      // 发票信息
      invoiceData: {},
      invoinceInfo: "不开发票", //发票信息
      currentCoupon: -1, //当前选中的优惠券
      orderData: {}, //订单信息（包含店铺结算信息  店铺优惠金额）
      createOrderData: {}, //订单提交结果
      toast: {
        isShow: false,
        messageTip: ""
      },
      pay: {
        loading: false,
        message: "提交订单···"
      }
    };
  },

  watch: {
    //深度 watcher
  },
  computed: {
    isShowFirmBox: function isShowFirmBox() {
      return this.$route.query.isShowFirmBox == "1" ? true : false;
    }
  },

  created: function created() {
    //获取地址信息
    this.getListAddress();
    //获取订单数据
    this.getOrderSettle(this.$route.query.ids);
    //获取发票信息
    if (__WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.get("invoiceData") != null) {
      this.invoiceData = __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.get("invoiceData");
      if (this.invoiceData.invoiceTypeName && this.invoiceData.invoiceHead && this.invoiceData.invoiceContentName != "不开发票") {
        this.invoinceInfo = this.invoiceData.invoiceTypeName + " " + this.invoiceData.invoiceHead + "  " + this.invoiceData.invoiceContentName;
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])({
    getOrderSettleMsgFromCart: "getOrderSettleMsgFromCart", //购物车结算
    createOrder: "createOrder", //提交订单
    createOrderWithOrder: "createOrderWithOrder", //15.6.提交订单（带订单号）
    listAddress: "listAddress", //获取地址列表
    getWxJsSdkConfig: "getWxJsSdkConfig", //获取微信js配置config
    doWxMpPay: "doWxMpPay", //微信公众号支付
    doWxH5Pay: "doWxH5Pay", //微信H5支付
    doUnionWapConsumePay: "doUnionWapConsumePay" //银联手机网页支付
  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this2 = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this2.toast.isShow = false;
      }, 1500);
    },
    gotoBrandHome: function gotoBrandHome(storeid) {
      this.$router.push({
        path: "/main/brandHome?linkTarget=" + storeid + "&linkType=2"
      });
    },
    getOrderSettle: function getOrderSettle(ids) {
      if (__WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.get("orderData")) {
        this.orderData = __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.get("orderData");
        this.OrderSettleMsg = this.orderData.OrderSettleMsg;
        this.settleDatas = this.orderData.settleDatas;
        this.couponAmounts = this.orderData.couponAmounts;
        this.redpacketAmounts = this.orderData.redpacketAmounts;
        this.load = false;
      } else {
        location.href = "/main/cart";
      }
    },


    //选择优惠券  type  1 优惠券  2  红包    instId位当前选中的优惠券InstId
    selCoupon: function selCoupon(type, instId) {
      var _this = this;
      var index = this.currentCoupon;
      if (type == "1") {
        this.settleDatas[this.currentCoupon].couponInstId = instId;
        this.OrderSettleMsg.storeOrderSettleMsgs[index].couponMsgs.forEach(function (item) {
          if (item.couponInstId == instId) {
            if (item.couponCate == 3) {
              _this.couponAmounts[index] = item;
            } else {
              _this.couponAmounts[index] = item.couponAmount; //改变后优惠券金额
            }
          }
        });
        this.couponPopup = false;
      } else if (type == "2") {
        this.settleDatas[index].redpacketInstId = instId;
        this.OrderSettleMsg.storeOrderSettleMsgs[index].redpacketMsgs.forEach(function (item) {
          if (item.couponInstId == instId) {
            _this.redpacketAmounts[index] = item.couponAmount; //改变后红包金额
          }
        });
        this.redpackagePopup = false;
      }
      var tempcoupon = this.couponAmounts[index]; //优惠券金额
      var tempredpacket = this.redpacketAmounts[index]; //优惠券金额
      if (_this.couponAmounts[index].couponCate == 3) {
        //当前店铺总金额 = bk当前店铺商品总金额 * 折扣  - 红包金额
        _this.OrderSettleMsg.storeOrderSettleMsgs[index].finalPrice = (Number(_this.OrderSettleMsg.storeOrderSettleMsgs[index].totalGoodsPrice) * _this.couponAmounts[index].couponDiscount / 100 - Number(tempredpacket)).toFixed(2);
      } else {
        //当前店铺总金额 = 当前店铺商品总金额 - 优惠券金额 - 红包金额
        _this.OrderSettleMsg.storeOrderSettleMsgs[index].finalPrice = (Number(_this.OrderSettleMsg.storeOrderSettleMsgs[index].totalGoodsPrice) - Number(tempcoupon) - Number(tempredpacket)).toFixed(2);
      }
      var finalPrice = 0;
      var discountPrice = 0;
      this.OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        finalPrice += Number(item.finalPrice);
        discountPrice += Number(item.totalGoodsPrice - item.finalPrice);
      });
      this.OrderSettleMsg.finalPrice = finalPrice.toFixed(2);
      this.OrderSettleMsg.discountPrice = discountPrice.toFixed(2);
    },


    // 获取地址列表
    getListAddress: function getListAddress() {
      var _this3 = this;

      this.listAddress().then(function (res) {
        _this3.addressInfo = res;
        var _this = _this3;
        if (_this3.$route.query.selectAddressId) {
          var addressId = _this.$route.query.selectAddressId;
          _this.addressInfo.forEach(function (item, index) {
            if (item.addressId == addressId) _this.selectAddressIndex = index;
          });
        } else {
          //获取默认地址  并默认选中
          _this.addressInfo.forEach(function (item, index) {
            if (item.isDefault == "1") _this.selectAddressIndex = index;
          });
        }
      });
    },
    openinvoice: function openinvoice() {
      //选择地址  存储当前订单所有信息
      __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.set("orderData", this.orderData);
      this.$router.push({
        path: "/main/writeinvoice"
      });
    },
    openaddr: function openaddr() {
      //选择地址  存储当前订单所有信息
      __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.set("orderData", this.orderData);
      if (this.$route.query.orderId == undefined) {
        this.$router.push({
          path: "/main/selectaddress?selectAddressId=" + this.addressInfo[this.selectAddressIndex].addressId
        });
      } else {
        this.$router.push({
          path: "/main/selectaddress?orderId=" + this.$route.query.orderId + "&selectAddressId=" + this.addressInfo[this.selectAddressIndex].addressId
        });
      }
      // this.$router.push({
      //   path: '/main/selectaddress?selectAddressId=' + this.addressInfo[this.selectAddressIndex].addressId
      // })
    },

    //新增地址
    addaddr: function addaddr() {
      this.$router.push({
        path: "/main/writeaddress"
      });
    },
    submitOrder_bk: function submitOrder_bk() {
      var _this4 = this;

      var url = "/main/firmorder";

      // 检查数据
      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      //this.load = true;
      var addressId = this.addressInfo[this.selectAddressIndex].addressId;

      //alert("当前页面URL: " + location.href);

      //微信内置浏览器
      if (this.util.isWeiXin()) {
        var _url = "/main/firmorder";
        // 1.微信配置
        this.getWxJsSdkConfig([_url]).then(function (wxTarget) {
          //wx.config(wxTarget);
        }).then(function () {
          // 2.创建订单
          return _this4.createOrder([1, addressId, _this4.settleDatas, _this4.invoiceData]);
        }).then(function (res) {
          _this4.createOrderData = res;
          //alert(" 生成订单结果（订单号）: " + this.createOrderData.orderId);
          //3. 发起微信请求
          return _this4.callOldWxPay(_this4.createOrderData.orderId);
          //return this.callNewWxPay();
        }).catch(function (err) {
          _this4.showTipMessage(true, err);
        });
      } else {
        this.createOrder([1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
          _this4.createOrderData = res;
          //3. 发起H5微信请求
          _this4.callH5WxPay(_this4.createOrderData.orderId);
        });
      }
    },
    onCreatOrder: function onCreatOrder() {
      var _this5 = this;

      // 检查数据
      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      //this.load = true;
      var addressId = this.addressInfo[this.selectAddressIndex].addressId;

      this.createOrder([1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
        _this5.createOrderData = res;
        location.href = "/main/firmpay?orderId=" + _this5.createOrderData.orderId;
      }).catch(function (err) {
        _this5.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
      });
    },
    submitOrder: function submitOrder() {
      var _this6 = this;

      // 检查数据
      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      //this.load = true;
      var addressId = this.addressInfo[this.selectAddressIndex].addressId;

      //微信内置浏览器
      if (this.util.isWeiXin()) {
        if (this.createOrderData.orderId == null && this.$route.query.orderId == null) {
          //判断当前url是否有orderId或订单已生成
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrder([1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
            _this6.pay.loading = true;
            _this6.pay.message = "等待支付···";
            _this6.createOrderData = res;
            return _this6.callOldWxPay(_this6.createOrderData.orderId);
            //return this.callNewWxPay();
          }).catch(function (err) {
            _this6.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
          });
        } else {
          var orderId = this.createOrderData.orderId || this.$route.query.orderId;
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrderWithOrder([orderId, 1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
            _this6.pay.loading = true;
            _this6.pay.message = "等待支付···";
            return _this6.callOldWxPay(orderId);
            //return this.callNewWxPay();
          }).catch(function (err) {
            _this6.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
          });
        }
      } else {
        if (this.createOrderData.orderId == null && this.$route.query.orderId == null) {
          //判断当前url是否有orderId或订单已生成
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrder([1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
            _this6.createOrderData = res;
            _this6.pay.loading = true;
            _this6.pay.message = "等待支付···";
            //3. 发起H5微信请求
            return _this6.callH5WxPay(_this6.createOrderData.orderId);
          }).catch(function (err) {
            _this6.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
          });
        } else {
          var _orderId = this.createOrderData.orderId || this.$route.query.orderId;
          this.pay.loading = true;
          this.pay.message = "订单提交中···";
          return this.createOrderWithOrder([_orderId, 1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
            _this6.pay.loading = true;
            _this6.pay.message = "等待支付···";
            return _this6.callH5WxPay(_orderId);
            //return this.callNewWxPay();
          }).catch(function (err) {
            _this6.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
          });
        }
      }
    },


    //银联支付
    submitUnionOrder: function submitUnionOrder() {
      var _this7 = this;

      if (this.selectAddressIndex == null) {
        this.showTipMessage(true, "请选择地址！");
        return;
      }
      var addressId = this.addressInfo[this.selectAddressIndex].addressId;
      //创建订单
      if (this.createOrderData.orderId == null && this.$route.query.orderId == null) {
        //判断当前url是否有orderId或订单已生成
        this.creatCartOrder(addressId);
      } else {
        var orderId = this.createOrderData.orderId || this.$route.query.orderId;
        this.pay.loading = true;
        this.pay.message = "订单提交中···";
        return this.createOrderWithOrder([orderId, 1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
          _this7.pay.loading = true;
          _this7.pay.message = "等待支付···";
          _this7.callUnionPay(_this7.createOrderData.orderId || _this7.$route.query.orderId);
        }).catch(function (err) {
          _this7.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
        });
      }
    },

    //创建订单
    creatCartOrder: function creatCartOrder(addressId) {
      var _this8 = this;

      // 检查数据

      this.pay.loading = true;
      this.pay.message = "订单提交中···";
      this.createOrder([1, addressId, this.settleDatas, this.invoiceData]).then(function (res) {
        _this8.createOrderData = res;
        _this8.pay.loading = true;
        _this8.pay.message = "等待支付···";
        _this8.callUnionPay(_this8.createOrderData.orderId);
      }).catch(function (err) {
        _this8.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
      });
    },

    // 银联wap网关支付
    callUnionPay: function callUnionPay(orderNo) {
      this.doUnionWapConsumePay([orderNo]).then(function (res) {
        var boxId = "_mxmall_unionpay_box_";
        var div = document.createElement("div");
        div.id = boxId;
        div.innerHTML = res;
        document.body.appendChild(div);
        document.querySelector("#" + boxId + " > form").submit();
      }).catch(function (err) {
        console.error(err);
      });
    },


    //微信H5支付
    callH5WxPay: function callH5WxPay(orderId) {
      var _this = this;
      this.doWxH5Pay([orderId || _this.createOrderData.orderId || _this.$route.query.orderId]).then(function (res) {
        if (res.success && res.errCode == "ORDERPAID") {
          _this.showTipMessage(true, "该订单已支付成功");
          location.href = "/main/paysuccess?orderId=" + orderId || _this.createOrderData.orderId || _this.$route.query.orderId;
          return;
        }
        var url = res.target.target;
        //重定向
        location.replace(url);
        //TODO
      }).catch(function (err) {
        //alert(err)
      });
    },

    //旧版微信支付
    callOldWxPay: function callOldWxPay(orderId) {
      var _this = this;

      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        return this.doWxMpPay([orderId || this.createOrderData.orderId]).then(function (resWxPay) {
          //alert("调用服务端doWxMpPay,返回结果resWxPay："+JSON.stringify(resWxPay));
          if (!resWxPay || !resWxPay.success || !resWxPay.target || !resWxPay.target.success) {
            _this.showTipMessage(true, resWxPay && resWxPay.message || resWxPay && resWxPay.target && resWxPay.target.message || "抱歉，支付失败！");
            //防止重复提交
            location.href = "/main/myorders";
            return;
          }

          WeixinJSBridge.invoke("getBrandWCPayRequest", {
            appId: resWxPay.target.target.appId, //公众号名称，由商户传入
            timeStamp: resWxPay.target.target.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: resWxPay.target.target.nonceStr, //随机串
            package: resWxPay.target.target.package,
            signType: resWxPay.target.target.signType, //微信签名方式：
            paySign: resWxPay.target.target.paySign //微信签名
          }, function (res) {
            //alert("STEP 4 微信服务器返回结果: " + JSON.stringify(res));
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回   ok，但并不保证它绝对可靠。
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              _this.showTipMessage(true, "支付成功");
              location.href = "/main/paysuccess?orderId=" + _this.createOrderData.orderId || _this.$route.query.orderId;
            } else if (res.err_msg == "get_brand_wcpay_request:fail") {
              _this.showTipMessage(true, "支付失败");
              location.href = "/main/myorders?type=2";
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              _this.showTipMessage(true, "已取消支付");
              location.href = "/main/myorders?type=2";
            }
          });
        }).catch(function (err) {
          _this.showTipMessage(true, err || "支付失败!");
          location.href = "/main/myorders?type=2";
        });
      }
    },


    //新版微信支付
    callNewWxPay: function callNewWxPay() {
      var _this = this;
      this.doWxMpPay([this.createOrderData.orderId]).then(function (resWxPay) {
        //alert("STEP 3 微信公众号支付  doWxMpPay  --: " +  JSON.stringify(resWxPay));

        if (resWxPay.success == true && resWxPay.errCode == "ORDERPAID") {
          //已经支付成功   ->   支付成功页面
          location.href = "/main/myorders";
        }

        __WEBPACK_IMPORTED_MODULE_8_weixin_js_sdk___default.a.chooseWXPay({
          timestamp: resWxPay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写
          nonceStr: resWxPay.nonceStr, // 支付签名随机串，不长于 32 位
          package: resWxPay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: resWxPay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: resWxPay.paySign, // 支付签名
          success: function success(res) {
            //alert(" 微信支付: " + res);
            if (res.errMsg == "chooseWXPay:ok") {
              _this.showTipMessage(true, "支付成功");
            }
          },
          cancel: function cancel(res) {
            //alert("STEP 4 您取消了支付！");
            _this.showTipMessage(true, "已取消支付");
          },
          fail: function fail(err) {
            //alert("FAIL:" + JSON.stringify(err));
            _this.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
          }
        });
      });
    },
    finishPay: function finishPay() {
      this.isShowFirmBox = false;

      //H5重定向回来的ORDERID
      var orderId = this.createOrderData.orderId || this.$route.query.orderId;
      if (!orderId) {
        this.showTipMessage(true, "订单不存在");
        return;
      }

      location.href = "/main/paysuccess?orderId=" + orderId;
    },
    onScroll: function onScroll() {
      this.scrolled = document.querySelectorAll(".firmorderWrapper")[0].scrollTop;
    }
  }),
  components: {
    menus: __WEBPACK_IMPORTED_MODULE_3__components_menus_menus___default.a,
    touchDelete: __WEBPACK_IMPORTED_MODULE_2__components_touchDelete_touchDelete___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_5__components_myOrdersItem_myOrdersItem___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_4__components_image_image___default.a
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      document.querySelectorAll(".firmorderWrapper")[0].addEventListener("scroll", this.onScroll);
    });
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      orderNO: this.$route.query.orderId,
      payResult: {} //订单信息
    };
  },

  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    getOrderPayResult: 'getOrderPayResult' //获取支付结果
  }), {
    //跳转订单详情
    gotoOrderDetail: function gotoOrderDetail() {
      this.$router.push({ path: '/main/orderdetail?stOrderId=' + this.payResult.orderNo + '&orderState=1' });
      return;
    },

    //跳转订单
    gotoOrder: function gotoOrder() {
      this.$router.push({ path: '/main/myorders?type=3' });
      return;
    },
    getPayResult: function getPayResult() {
      var _this = this;

      this.getOrderPayResult([this.orderNO]).then(function (res) {
        _this.payResult = res;
        _this.load = false;
        __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__["a" /* storage */].local.remove('createOrderData');
      }).catch(function (error) {
        _this.$message.error(error);
      });
    },
    goScanmore: function goScanmore() {
      this.$router.push({ path: '/' });
    }
  }),
  created: function created() {},

  components: {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__["a" /* storage */].local.remove('invoiceData');
    __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__["a" /* storage */].local.remove('orderData');
    this.getPayResult();
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			load: true,
			addressInfo: [], //地址列表
			selectAddressId: this.$route.query.selectAddressId //选中的地址id

		};
	},

	watch: {//深度 watcher

	},
	created: function created() {
		//获取地址信息
		this.getListAddress();
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
		listAddress: 'listAddress' //获取地址列表
	}), {
		// 获取地址列表
		getListAddress: function getListAddress() {
			var _this = this;

			this.listAddress().then(function (res) {
				_this.addressInfo = res;
				_this.load = false;
			});
		},

		//选中后直接返回订单提交页面
		selectAddr: function selectAddr(id) {
			if (this.$route.query.orderId == undefined) {
				this.$router.push({
					path: '/main/firmorder?selectAddressId=' + id
				});
			} else {
				this.$router.push({
					path: '/main/firmorder?orderId=' + this.$route.query.orderId + '&selectAddressId=' + id
				});
			}
			// this.$router.push({
			//  		path: '/main/firmorder?selectAddressId='+id
			//  	})
		},

		//修改地址
		editAddress: function editAddress(id) {
			this.$router.push({
				path: '/main/writeaddress?addressId=' + id
			});
		},

		//新增地址
		add: function add() {
			this.$router.push({
				path: '/main/writeaddress'
			});
		}
	}),
	components: {}
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      seltype: null, //选中的发票类型
      invoiceTitle: '', //发票抬头   个人？单位
      selectedCompanyid: null, //选中的单位
      selCompany: {},
      deleteheadId: null,
      isEditState: false, //编辑状态
      isAddState: false, //新增状态
      deleteDialog: false, //删除弹框
      editDialog: false, //编辑弹框
      addInfo: {}, //用户新增的发票抬头
      invoiceTypeList: [], //获取发票类型列表
      invoiceContentList: [], //获取发票内容列表
      memInvoiceMsgList: [], //获取会员单位发票列表
      // 发票信息
      invoiceData: {
        invoiceType: null, //类型
        invoiceTypeName: null,
        invoiceContent: null, //内容
        invoiceContentName: null,
        invoiceHead: null, //抬头
        uniformCode: null
      },
      toast: {
        toast: false,
        messageTip: ''
      }

    };
  },

  watch: {},
  created: function created() {
    this.getInvoiceType();
    this.getInvoiceContent();
    this.getMemInvoiceMsg();
    if (__WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__["a" /* storage */].local.get('invoiceData') != null) {
      this.invoiceData = __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__["a" /* storage */].local.get('invoiceData');
      if (this.invoiceData.uniformCode) {
        this.selectedCompanyid = this.invoiceData.invoiceHead;
        this.invoiceTitle = 'company';
      } else {
        this.invoiceTitle = 'person';
        this.invoiceData.invoiceHead = '个人';
      }
    }
    this.load = false;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    listInvoiceType: 'listInvoiceType', //获取发票类型列表
    listInvoiceContent: 'listInvoiceContent', //获取发票内容列表
    listMemInvoiceMsg: 'listMemInvoiceMsg', //获取会员单位发票列表
    removeMemInvoice: 'removeMemInvoice', //删除会员单位发票
    saveMemInvoice: 'saveMemInvoice' //保存会员单位发票列表
  }), {
    //点击单位  选中
    selcompanycheckbox: function selcompanycheckbox(index) {
      this.invoiceData.invoiceHead = this.memInvoiceMsgList[index].invoiceHead;
      this.invoiceData.uniformCode = this.memInvoiceMsgList[index].uniformCode;
      this.selectedCompanyid = this.memInvoiceMsgList[index].invoiceHead;
    },

    //获取发票类型列表
    getInvoiceType: function getInvoiceType() {
      var _this = this;

      this.listInvoiceType([]).then(function (res) {
        _this.invoiceTypeList = res;
      });
    },

    //获取发票内容列表
    getInvoiceContent: function getInvoiceContent() {
      var _this2 = this;

      this.listInvoiceContent([]).then(function (res) {
        _this2.invoiceContentList = res;
      });
    },

    //获取会员单位发票列表
    getMemInvoiceMsg: function getMemInvoiceMsg() {
      var _this3 = this;

      this.listMemInvoiceMsg([]).then(function (res) {
        _this3.memInvoiceMsgList = res;
      });
    },

    //编辑
    write: function write(action, index) {
      var _this4 = this;

      if (action == 'edit') {
        //编辑状态  显示编辑删除按钮
        this.isEditState = true;
      } else if (action == 'add') {
        //添加状态 填写
        this.isAddState = true;
      } else if (action == 'finish') {
        //完成状态 
        this.isEditState = false;
      } else if (action == 'modify') {
        //修改状态  修改弹框打开
        this.selCompany = this.memInvoiceMsgList[index];
        this.editDialog = true;
      } else if (action == 'delete') {
        //删除状态    删除弹框
        this.deleteheadId = this.memInvoiceMsgList[index].invoiceId;
        this.deleteDialog = true;
      } else if (action == 'quit') {
        //新增   --- 取消
        this.isAddState = false;
      } else if (action == 'save') {
        //新增   --- 保存
        if (this.addInfo.invoiceHead == null || this.addInfo.uniformCode == null) {
          this.toast.messageTip = '请认真填写发票抬头！';
          this.toast.toast = true;
          setTimeout(function () {
            _this4.toast.toast = false;
          }, 1500);
          return;
        }

        this.saveInvoicehead(0, this.addInfo.invoiceHead, this.addInfo.uniformCode);
        this.isAddState = false;
      }
    },

    //删除发票抬头
    deleteHead: function deleteHead() {
      var _this5 = this;

      this.removeMemInvoice([this.deleteheadId]).then(function (res) {
        _this5.deleteDialog = false;
        _this5.getMemInvoiceMsg();
        _this5.toast.messageTip = '删除成功';
        _this5.toast.toast = true;
        setTimeout(function () {
          _this5.toast.toast = false;
        }, 1500);
      }).catch(function (err) {
        _this5.toast.messageTip = '删除失败';
        _this5.toast.toast = true;
        setTimeout(function () {
          _this5.toast.toast = false;
        }, 1500);
      });
    },

    //保存发票抬头
    saveInvoicehead: function saveInvoicehead(id, invoiceHead, uniformCode) {
      var _this6 = this;

      this.saveMemInvoice([id, invoiceHead, uniformCode]).then(function (res) {
        _this6.getMemInvoiceMsg();
        _this6.addInfo = {};
        _this6.toast.messageTip = id == 0 ? '新增成功' : '修改成功';
        _this6.toast.toast = true;
        setTimeout(function () {
          _this6.toast.toast = false;
        }, 1500);
      });
    },

    //保存编辑
    saveEdit: function saveEdit() {
      this.saveInvoicehead(this.selCompany.invoiceId, this.selCompany.invoiceHead, this.selCompany.uniformCode);
      this.editDialog = false;
    },

    //将选中的信息存储   路由跳转
    submit: function submit() {
      var _this7 = this;

      console.log(this.invoiceData);
      if (this.invoiceData.invoiceTypeName == null) {
        this.toast.messageTip = '请选择发票类型！';
        this.toast.toast = true;
        setTimeout(function () {
          _this7.toast.toast = false;
        }, 1500);
        return;
      } else if (this.invoiceData.invoiceContentName == null) {
        this.toast.messageTip = '请选择发票内容！';
        this.toast.toast = true;
        setTimeout(function () {
          _this7.toast.toast = false;
        }, 1500);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__["a" /* storage */].local.set("invoiceData", this.invoiceData);
      history.go(-1);
    }
  }),
  components: {}
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			load: true,
			tabIndex: 'essence', //左侧选中，默认精品
			brandCates: [], //品牌分类
			keyWord: '',
			adverbrand: {}, //随机品牌广告
			adverstore: {}, //随机商城广告
			boutiques: [], //精品推荐
			isTabIndex: true
		};
	},
	updated: function updated() {
		if (this.isTabIndex && (this.$route.meta.tabIndex >= 0 || this.$route.meta.tabIndex == "essence")) {
			console.log(this.$route.meta.tabIndex);
			this.$nextTick(function () {
				var _this = this;

				this.tabIndex = this.$route.meta.tabIndex || "essence";
				setTimeout(function () {
					_this.$route.meta.tabIndex = -1;
				}, 500);
			});
		}
		if (!this.$route.meta.savePosition) {
			return;
		}
		this.$nextTick(function () {
			var _this2 = this;

			// alert(this.tabIndex)
			this.$refs.brandContent.scrollTop = this.$route.meta.savePosition;
			setTimeout(function () {
				_this2.$route.meta.savePosition = 0;
				_this2.$route.meta.tabIndex = "";
			}, 500);
		});
	},
	created: function created() {
		var _this3 = this;

		this.getBrand();
		this.getGroomGoods();
		this.randomAdver([1, 4]).then(function (res) {
			_this3.adverstore = res[0];
		});
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
		getBrandCates: 'getBrandCates',
		randomStoreAdverts: 'randomStoreAdverts', //获取随机广告
		getBoutiqueGoods: 'getBoutiqueGoods',
		randomAdver: 'randomAdver' //24.1.随便获取商城N条广告
	}), {
		selTab: function selTab(index) {
			var _this4 = this;

			this.tabIndex = index;
			this.isTabIndex = false;
			var storeId = this.brandCates[this.tabIndex].cates.linkTarget;
			this.randomStoreAdverts([storeId, 1, 4]).then(function (res) {
				console.log(res);
				_this4.adverbrand = res[0];
			});
		},

		//8.3.获取首页品牌分类
		getBrand: function getBrand() {
			var _this5 = this;

			this.getBrandCates([1]).then(function (res) {
				_this5.brandCates = res;
				console.log("ceshi");
				//this.load = false;
			});
		},

		//获取为您未见商品
		getGroomGoods: function getGroomGoods() {
			var _this6 = this;

			//  6.精品推荐
			this.getBoutiqueGoods().then(function (res) {
				_this6.boutiques = res;
				_this6.load = false;
			});
		},
		searchgoods: function searchgoods() {
			if (this.tabIndex != 'essence') {
				this.$router.push({
					path: '/main/search?linkTarget=' + this.brandCates[this.tabIndex].cates.linkTarget + '&linkType=' + this.brandCates[this.tabIndex].cates.linkType + '&keyWord=' + this.keyWord || null
				});
			} else {
				this.$router.push({
					path: '/main/search?keyWord=' + this.keyWord || null
				});
			}
		},
		scanDetail: function scanDetail(storeid, goodid, skuId) {
			this.$route.meta.savePosition = this.$refs.brandContent.scrollTop;
			this.$route.meta.tabIndex = this.tabIndex;
			this.$router.push({
				path: '/main/goodsDetail?goodsId=' + goodid + '&storeId=' + storeid + '&skuId=' + skuId
			});
		}
	}),
	components: {
		menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
		topLink: __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default.a,
		imgs: __WEBPACK_IMPORTED_MODULE_3__components_image_image___default.a
	}
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
				data: function data() {
								return {
												load: true,
												GoodsDetail: '',
												goodsId: this.$route.query.goodsId || this.$route.query.linkTarget, //商品id
												storeId: this.$route.query.storeId || '', //商品id
												skuId: this.$route.query.skuId || 0, //商品id

												tip: '继续拖动，查看参数',
												startY: 0, //触摸位置
												moveY: 0, //滑动时的位置
												disY: 0, //移动距离
												txtStyle: '',
												height: 0,
												startScrollH: 0 //开始滑动  记录当前滚动的位置
								};
				},

				computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
								scrollHeight: 'scrollHeight'
				})),
				mounted: function mounted() {
								var _this = this;

								var count = 0;
								this.yzInterval = setInterval(function () {
												count++;
												if (_this.load == false) {
																clearInterval(_this.yzInterval);
																var cHeight = _this.$refs.wrap.clientHeight; //元素的高度
																var oHeight = _this.$refs.content.clientHeight; //内容的高度
																_this.height = oHeight - cHeight; //可滑动的最大值
												}
								}, 1000);
				},

				methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
								getGoodsDetail: 'getGoodsDetail', //商品详情
								savescrollHeight: 'savescrollHeight' //存储页面滚动高度
				}), {
								//18.2.获取商品详情
								getDetail: function getDetail(id) {
												var _this2 = this;

												this.getGoodsDetail([id]).then(function (res) {
																_this2.GoodsDetail = res;
																_this2.load = false;
												});
								},

								_touchStart: function _touchStart(ev) {
												ev = ev || event;
												if (ev.touches.length == 1) {
																// 手指按下的时候记录按下的位置
																this.startY = ev.touches[0].clientY;
																//记录手指按下时滚动的高度
																this.startScrollH = this.scrollHeight.scrollHeight;
												}
								},
								_touchMove: function _touchMove(ev) {
												ev = ev || event;
												if (ev.touches.length == 1) {
																// 滑动过程中的实时位置
																this.moveY = ev.touches[0].clientY;
																// 滑动过程中实时计算滑动距离
																this.disY = this.startY - this.moveY;
																//console.log('disY==>', this.disY,this.height, this.startScrollH)
																//鼠标按下时的滑动距离大于可滑动的最大距离  
																if (this.startScrollH / this.height >= 0.98) {
																				if (this.disY > 100) {
																								//滑动距离大于100
																								// this.txtStyle = "transform:translateY(-" + this.disY + "px)";
																								this.txtStyle = "margin-bottom:" + this.disY + "px";
																								document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight + this.disY;
																								this.tip = '释放切换到参数';
																				} else if (this.disY > 0 && this.disY < 100) {
																								this.txtStyle = "margin-bottom:" + this.disY + "px";
																								document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight + this.disY;
																								this.tip = '上拉切换到参数';
																								//this.tip = '继续拖动，查看详情'
																				}
																} else {
																				this.tip = '继续拖动，查看参数';
																}
												}
								},
								_touchEnd: function _touchEnd(ev) {
												if (event.changedTouches.length == 1) {
																// 手指移动结束后的水平位置
																var endX = event.changedTouches[0].clientY;
																// 触摸开始与结束,手指移动的距离
																//this.disY = this.startY - endX;
																//如果距离小于100，页面不跳转，否则跳转至对应页面
																//console.log("=>",this.disY,this.height, this.startScrollH)
																//滑动结束，判断当前的滑动距离大于或等于时 偏移
																if (this.disY > 100 && this.startScrollH / this.height >= 0.98) {
																				this.$router.push({ path: '/main/goodsDetail/parameter?goodsId=' + this.goodsId + '&storeId=' + (this.storeId || '') + '&skuId=' + this.skuId });
																} else {
																				this.txtStyle = "margin-bottom:" + 0 + "px";
																				document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight;
																				this.tip = '继续拖动，查看参数';
																}
												}
								}
				}),
				components: {
								imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a,
								empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
				},
				created: function created() {
								this.load = true;
								this.getDetail(this.$route.query.goodsId);
				}
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			load: true,
			GoodsComm: {},
			GoodsCommList: {},
			goodsId: this.$route.query.goodsId, //商品id
			pageNo: 1,
			pageSize: 10,
			total: 0
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
		pageGoodsCommMsg: 'pageGoodsCommMsg',
		getGoodsCommMsg: 'getGoodsCommMsg'
	}), {
		//11.7.获取商品评价总览
		getGoodsCommtag: function getGoodsCommtag() {
			var _this = this;

			this.getGoodsCommMsg([this.goodsId]).then(function (res) {
				_this.GoodsComm = res;
			});
		},

		//11.8.分页查询商品评价
		getGoodsCommContent: function getGoodsCommContent() {
			var _this2 = this;

			this.pageGoodsCommMsg([this.goodsId, this.pageNo, this.pageSize]).then(function (res) {
				_this2.GoodsCommList = res.result;
				_this2.total = Number(res.totalCount);
				_this2.load = false;
			});
		}
	}),
	components: {
		imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a,
		empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
	},
	created: function created() {
		this.getGoodsCommtag();
		this.getGoodsCommContent();
	}
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_amap__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_amap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
		data: function data() {
				return {
						tip: '继续拖动，查看详情',
						startY: 0, //触摸位置
						moveY: 0, //滑动时的位置
						disY: 0, //移动距离
						txtStyle: '',
						height: 0,
						startScrollH: 0, //开始滑动  记录当前滚动的位置

						currentAddress: {
								provinceId: '',
								province: '',
								cityId: '',
								city: '',
								areaId: '',
								area: '',
								townId: '',
								town: '',
								address: '',
								postCode: '',
								consignee: '',
								mobile: '',
								isDefault: 0
						}, //当前地址信息
						addressMsgShow: '请选择地区', //页面展示的值
						addressProvince: '', //展示省份
						addressCity: '', //展示城市
						chooseCityId: '', //选中城市id
						chooseAreaId: '', //选中的区域id
						chooseStreetId: '', //获取的街道id
						arealistMsg: [], //当前获取到的省份信息
						cityListShow: [], //获取到的城市信息
						areaAddressMsg: [], //获取到城镇信息
						chooseBox: true, //选择地址弹框
						shoWOr: 1, //初始展示省份一级
						errorShow: 0, //错误信息提示
						toast2: false, //手机号码验证
						messageShow: '', //提示信息
						cityNameShow: '', //城市展示
						areaNameShow: '', //区域名
						getStreetMsgList: '', //最后街道信息
						streetNameShow: '', //街道信息
						addressCode: 0,
						addressPopup: false,
						isAddress: false, //是否是选择地区


						load: true,
						bottomPopup: false,
						swiperOption: {
								//是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
								/*notNextTick: true,  */
								pagination: '.swiper-pagination',
								autoplay: 5000,
								paginationType: 'fraction',
								autoplayDisableOnInteraction: false
						},
						goodsNum: 1,
						goodsSkuMsg: "", //商品sku信息
						goodsDetail: [], //商品详情
						skuImages: [], //商品套图
						imgIndex: 0, //商品展示图和高清图
						settleDatas: [], //结算店铺列表
						OrderSettleMsg: {}, //订单信息
						couponAmounts: [], //选中的优惠券

						GoodsComm: {},
						GoodsCommList: {},
						/*以下为地图板块*/
						amap: null,
						lat: null,
						lng: null,

						//以下为优惠券
						couponPopup: false, //优惠券弹框
						couponsList: [], //优惠券列表

						toast: {
								isShow: false,
								messageTip: ''
						}

				};
		},

		computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
				goodData: 'goodData', //产品信息
				isSelSku: 'isSelSku', //商品选择框
				scrollHeight: 'scrollHeight'
		}), {
				brandId: function brandId() {
						return '';
				},
				cateId: function cateId() {
						return '';
				}
		}),
		mounted: function mounted() {
				var _this2 = this;

				var count = 0;
				this.yzInterval = setInterval(function () {
						count++;
						if (_this2.load == false) {
								clearInterval(_this2.yzInterval);
								var cHeight = _this2.$refs.wrap.clientHeight; //元素的高度
								var oHeight = _this2.$refs.content.clientHeight; //内容的高度
								_this2.height = oHeight - cHeight; //可滑动的最大值
						}
				}, 1000);
		},

		watch: {
				goodData: function goodData(val) {
						this.goodsSkuMsg = this.goodData.goodsSkuMsg;
						this.goodsNum = this.goodData.goodsNum;
				}
		},
		methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
				listAreaMsg: 'listAreaMsg', //获取地域列表
				getGoodsDetail: 'getGoodsDetail', //获取商品详情
				getCartGoodsNum: 'getCartGoodsNum', //获取购物车商品数量
				getGoodsSkuMsg: 'getGoodsSkuMsg', //获取商品SKU信息
				getGoodsSku: 'getGoodsSku', //通过选择属性 获取 商品单品信息
				addMemCart: 'addMemCart', //加入购物车
				getOrderSettleMsg: 'getOrderSettleMsg', //直接购买
				saveGoodsData: 'saveGoodsData', //保存购买的商品信息
				saveSelectSku: 'saveSelectSku',
				getGoodsCommMsg: 'getGoodsCommMsg',
				pageGoodsCommMsg: 'pageGoodsCommMsg',
				pageDealerStore: 'pageDealerStore', //分页获取实体门店信息
				getListStoreCoupons: 'getListStoreCoupons', //获取优惠券列表
				receiveCoupon: 'receiveCoupon', //领取优惠券
				savescrollHeight: 'savescrollHeight' //存储页面滚动高度
		}), {
				_touchStart: function _touchStart(ev) {
						ev = ev || event;
						if (ev.touches.length == 1) {
								// 手指按下的时候记录按下的位置
								this.startY = ev.touches[0].clientY;
								//记录手指按下时滚动的高度
								this.startScrollH = this.scrollHeight.scrollHeight;
						}
				},
				_touchMove: function _touchMove(ev) {
						ev = ev || event;
						if (ev.touches.length == 1) {
								// 滑动过程中的实时位置
								this.moveY = ev.touches[0].clientY;
								// 滑动过程中实时计算滑动距离
								this.disY = this.startY - this.moveY;
								//console.log('disY==>', this.disY,this.height, this.startScrollH)
								//鼠标按下时的滑动距离大于可滑动的最大距离
								if (this.startScrollH / this.height >= 0.98) {
										if (this.disY > 100) {
												//滑动距离大于100
												// this.txtStyle = "transform:translateY(-" + this.disY + "px)";
												this.txtStyle = "margin-bottom:" + this.disY + "px";
												document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight + this.disY;
												this.tip = '释放切换到详情';
										} else if (this.disY > 0 && this.disY < 100) {
												this.txtStyle = "margin-bottom:" + this.disY + "px";
												document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight + this.disY;
												this.tip = '上拉切换到详情';
												//this.tip = '继续拖动，查看详情'
										}
								} else {
										this.tip = '继续拖动，查看详情';
								}
						}
				},
				_touchEnd: function _touchEnd(ev) {
						if (event.changedTouches.length == 1) {
								// 手指移动结束后的水平位置
								var endX = event.changedTouches[0].clientY;
								// 触摸开始与结束,手指移动的距离
								//this.disY = this.startY - endX;
								//如果距离小于100，页面不跳转，否则跳转至对应页面
								//console.log("=>",this.disY,this.height, this.startScrollH)
								//滑动结束，判断当前的滑动距离大于或等于时 偏移
								if (this.disY > 100 && this.startScrollH / this.height >= 0.98) {
										this.$router.push({ path: '/main/goodsDetail/detail?goodsId=' + this.goodsId + '&storeId=' + (this.storeId || '') + '&skuId=' + this.skuId });
								} else {
										this.txtStyle = "margin-bottom:" + 0 + "px";
										document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight;
										this.tip = '继续拖动，查看详情';
								}
						}
				},

				showTipMessage: function showTipMessage(isShow, msg) {
						var _this3 = this;

						this.toast.isShow = isShow;
						this.toast.messageTip = msg;
						setTimeout(function () {
								_this3.toast.isShow = false;
						}, 1500);
				},

				//领取优惠券
				getCoupon: function getCoupon(couponId, couponType, isGet) {
						var _this4 = this;

						if (isGet == 1) {
								return;
						}
						this.receiveCoupon([couponId, couponType]).then(function (res) {
								if (res.success) {
										_this4.showTipMessage(true, res.message || '领取成功！');
										_this4.getSkuMsg();
								} else {
										_this4.showTipMessage(true, '领取失败，请稍后重试！');
								}
						}).catch(function (error) {
								console.log(error);
								_this4.showTipMessage(true, '领取失败');
						});
				},

				//获取地图内容
				getAmapContent: function getAmapContent() {
						var vm = this;
						var amap = {
								resizeEnable: true,
								zoom: 15,
								center: [121.59996, 31.197646],
								markers: [],
								events: {
										init: function init(map) {
												AMapUI.loadUI(['misc/MarkerList', 'overlay/SimpleMarker', 'overlay/SimpleInfoWindow'], function (MarkerList, SimpleMarker, SimpleInfoWindow) {
														var $ = MarkerList.utils.$;

														/*var defaultIconStyle = 'red'; //默认的图标样式*/
														vm.markerList = new MarkerList({
																map: map,
																//ListElement对应的父节点或者ID
																//listContainer: "myList", //document.getElementById("myList"),
																//选中后显示

																//从数据中读取位置, 返回lngLat
																getPosition: function getPosition(item) {
																		return [item.longitude, item.latitude];
																},
																//数据ID，如果不提供，默认使用数组索引，即index
																getDataId: function getDataId(item, index) {
																		return item.id;
																},
																getCityCode: function getCityCode(item) {
																		return item.cityCode;
																},
																getInfoWindow: function getInfoWindow(data, context, recycledInfoWindow) {
																		console.log(data);
																		var innerHTML = MarkerList.utils.template('<div class="info-title"><%- data.storeName %></div>' + '<div class="info-content">' + '<% if(data.relaPhone ){ %>' + '        <p class="info-item phone"><%- data.relaPhone %></p>' + '<% } %>' + '<p class="info-item address"><%- data.address %></p>' + '</div>' + '<a class="info-goHere" href="http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:' + data.latitude + ',' + data.longitude + ';title:' + data.address + ';addr:' + data.address + '&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp"></a>', {
																				data: data
																		});

																		var infowindow = new AMap.InfoWindow({
																				placeSearch: true,
																				asOrigin: true,
																				asDestination: true,
																				content: innerHTML,
																				offset: new AMap.Pixel(0, -30)
																		});
																		return infowindow;
																},
																//构造marker用的options对象, content和title支持模板，也可以是函数，返回marker实例，或者返回options对象
																getMarker: function getMarker(data, context, recycledMarker) {
																		var label = 1;
																		label += context.index;
																		if (recycledMarker) {
																				recycledMarker.setIconLabel(label);
																				return;
																		}

																		return new SimpleMarker({
																				containerClassNames: 'my-marker',
																				iconStyle: vm.defaultIconStyle,
																				iconLabel: label
																		});
																},
																//构造列表元素，与getMarker类似，可以是函数，返回一个dom元素，或者模板 html string
																getListElement: function getListElement(data, context, recycledListElement) {
																		var label = 1;
																		label += context.index;
																		//使用模板创建
																		var innerHTML = MarkerList.utils.template('<span class="poibox-label"><%- label %></span>' + '<div class="poi-info-left">' + '    <h3 class="poi-title">' + '        <%- data.storeName %>' + '    </h3>' + '    <div class="poi-info">' + '        <p class="poi-addr">地址：<%- data.address %></p>' + '<% if(data.relaPhone ){ %>' + '        <p class="poi-addr">电话：<%- data.relaPhone %></p>' + '<% } %>' + '    </div>' + '</div>' + '<div class="clear"></div>', {
																				data: data,
																				label: label
																		});

																		if (recycledListElement) {
																				recycledListElement.innerHTML = innerHTML;
																				return recycledListElement;
																		}

																		return '<li class="poibox">' + innerHTML + '</li>';
																},
																//列表节点上监听的事件
																listElementEvents: ['click', 'mouseenter', 'mouseleave'],
																//marker上监听的事件
																markerEvents: ['click', 'mouseover', 'mouseout'],
																//makeSelectedEvents:false,
																selectedClassNames: 'selected',
																autoSetFitView: true
														});

														//加载地图，调用浏览器定位服务
														var geolocation;
														map.plugin('AMap.Geolocation', function () {
																geolocation = new AMap.Geolocation({
																		enableHighAccuracy: true, //是否使用高精度定位，默认:true
																		timeout: 10000, //超过10秒后停止定位，默认：无穷大
																		buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
																		zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
																		buttonPosition: 'RB'
																});
																map.addControl(geolocation);
																geolocation.getCurrentPosition();
																AMap.event.addListener(geolocation, 'complete', onComplete); //返回定位信息
																AMap.event.addListener(geolocation, 'error', onError); //返回定位出错信息
														});

														//解析定位结果
														function onComplete(data) {
																console.log("lng", data.position.getLng());
																var positionLists = [];
																var positionList = {
																		longitude: data.position.getLng(),
																		latitude: data.position.getLat()
																};

																vm.lng = data.position.getLng();
																vm.lat = data.position.getLat();
																//地图显示当前城市
																var params = {
																		mapType: 2,
																		longitude: vm.currentAddress.provinceId ? "" : data.position.getLng(),
																		latitude: vm.currentAddress.cityId ? "" : data.position.getLat(),
																		provinceCode: '',
																		cityCode: '',
																		areaCode: '',
																		brandId: '',
																		storeId: vm.storeId || '',
																		goodsId: vm.goodsId || '',
																		provinceId: vm.currentAddress.provinceId || "",
																		cityId: vm.currentAddress.cityId || "",
																		areaId: vm.currentAddress.areaId || ""
																};
																vm.pageDealerStore([params, 1, 20]).then(function (res) {
																		vm.markerList.render(res.result);
																});

																// positionLists.push(positionList);
																// vm.markerList.render(positionLists);
														}
														//解析定位错误信息
														function onError(data) {
																//实例化城市查询类
																var citysearch = new AMap.CitySearch();
																// var city = "重庆"
																//自动获取用户IP，返回当前城市
																citysearch.getLocalCity(function (status, result) {
																		if (status === 'complete' && result.info === 'OK') {
																				if (result && result.city && result.bounds) {
																						vm.lng = result.bounds.eb.lng;
																						vm.lat = result.bounds.eb.lat;
																						//地图显示当前城市
																						var params = {
																								mapType: 2,
																								longitude: vm.currentAddress.provinceId ? "" : result.bounds.eb.lng,
																								latitude: vm.currentAddress.cityId ? "" : result.bounds.eb.lat,
																								provinceCode: '',
																								cityCode: '',
																								areaCode: '',
																								brandId: '',
																								storeId: vm.storeId || '',
																								goodsId: vm.goodsId || '',
																								provinceId: vm.currentAddress.provinceId || "",
																								cityId: vm.currentAddress.cityId || "",
																								areaId: vm.currentAddress.areaId || ""
																						};
																						vm.pageDealerStore([params, 1, 20]).then(function (res) {
																								vm.markerList.render(res.result);
																						});
																				}
																		}
																});
														}
												});
										}
								}
						};
						this.amap = amap;
				},

				//获取实体门店数据
				getPageDealerStore: function getPageDealerStore(lat, lng) {
						var _this5 = this;

						var params = {
								mapType: 2,
								longitude: this.lng || "",
								latitude: this.lat || "",
								provinceCode: '',
								cityCode: '',
								areaCode: '',
								brandId: '',
								storeId: this.storeId || '',
								goodsId: this.goodsId || '',
								provinceId: this.currentAddress.provinceId || "",
								cityId: this.currentAddress.cityId || "",
								areaId: this.currentAddress.areaId || ""
						};
						this.pageDealerStore([params, 1, 20]).then(function (res) {
								_this5.markerList.render(res.result);
						});
				},

				//地址出现弹框
				clickProvince: function clickProvince(areaId) {
						this.addressMsgShow = '请选择区域';
						this.addressProvince = '';
						this.cityNameShow = '';
						this.currentAddress.province = '';
						this.currentAddress.provinceId = '';
						this.currentAddress.city = '';
						this.currentAddress.cityId = '';
						this.currentAddress.areaId = '';
						this.currentAddress.area = '';
						this.currentAddress.townId = '';
						this.currentAddress.town = '';
						this.shoWOr = 1;
				},

				// 点击省出现下级
				shooseProvince: function shooseProvince(provinceId, provinceName) {
						//this.clickProvince();
						this.shoWOr = 2;
						this.getCityListShow(provinceId); //获取城市列表
						this.currentAddress.provinceId = provinceId; //保存id
						this.currentAddress.province = provinceName; //保存名字
						this.addressProvince = provinceName; //名字在页面展示
						this.addressMsgShow = provinceName; //选择框展示
				},

				//点击城市出现下级
				shooseCity: function shooseCity(cityId, cityName) {
						var _this6 = this;

						this.getTownMsg(cityId); //获取城镇信息
						//setTimeout(this.getTownMsg(cityId), 1); //获取城镇信息
						//this.addressMsgShow = this.addressProvince + cityName; //选择框展示城市名字
						this.currentAddress.city = cityName; //保存城市名字
						this.cityNameShow = cityName; //展示城市名字
						this.currentAddress.cityId = cityId; //保存城市id
						this.chooseCityId = cityId; //选中城市的id
						this.addressMsgShow = this.addressProvince + '/' + this.cityNameShow;
						this.listAreaMsg(cityId).then(function (res) {
								_this6.areaAddressMsg = res.target;
								if (_this6.areaAddressMsg.length == 0) {
										_this6.addressMsgShow = _this6.addressProvince + '/' + _this6.cityNameShow; //选择框展示城市名字
										_this6.shoWOr = 2; //关闭地址选择框
										return;
								} else if (_this6.areaAddressMsg.length != 0) {
										_this6.shoWOr = 3;
								}
						});
				},

				//点击区域出现下一级
				shooseArea: function shooseArea(areaId, areaName) {
						var _this7 = this;

						this.currentAddress.areaId = areaId; //保存的区域id
						this.chooseAreaId = areaId; //保存的id
						this.currentAddress.area = areaName; //保存地址名称
						this.areaNameShow = areaName; //展示的街道
						this.addressMsgShow = this.addressProvince + '/' + this.cityNameShow + '/' + this.areaNameShow;
						//this.chooseBox = false; //关闭地址框
						this.listAreaMsg(areaId).then(function (res) {
								_this7.getStreetMsgList = res.target;
								if (_this7.getStreetMsgList.length == 0) {
										_this7.shoWOr = 3;
								} else {
										_this7.shoWOr = 4;
								}
						});
				},

				//点击街道出现下一级
				shooseStreet: function shooseStreet(areaId, areaName) {
						var _this8 = this;

						this.currentAddress.townId = areaId; //保存的区域id
						this.chooseStreetId = areaId; //保存街道id
						this.currentAddress.town = areaName; //保存地址名称
						this.streetNameShow = areaName; //展示的街道
						//this.chooseBox = false; //关闭地址框
						this.addressMsgShow = this.addressProvince + '/' + this.cityNameShow + '/' + this.areaNameShow + '/' + this.streetNameShow;
						this.listAreaMsg(areaId).then(function (res) {
								_this8.lastMsg = res.target;
						});
				},

				//获取区域的列表api
				getAreaMsg: function getAreaMsg(areaId) {
						var _this9 = this;

						this.listAreaMsg(areaId).then(function (res) {
								_this9.getStreetMsgList = res.target;
						});
				},

				//获取城镇信息api
				getTownMsg: function getTownMsg(cityId) {
						var _this10 = this;

						this.listAreaMsg(cityId).then(function (res) {
								_this10.areaAddressMsg = res.target;
						});
				},

				//获取城市的列表api
				getCityListShow: function getCityListShow(provinceId) {
						var _this11 = this;

						this.listAreaMsg(provinceId).then(function (result) {
								_this11.cityListShow = result.target;
						});
				},

				//获取省份列表api
				getListAreaMsg: function getListAreaMsg(addressCode) {
						var _this12 = this;

						this.listAreaMsg(addressCode).then(function (result) {
								_this12.arealistMsg = result.target;
						}).catch(function (error) {});
				},

				//地址看确认
				adressFirm: function adressFirm() {
						this.addressPopup = false;
						//this.getAmapContent();
						this.getPageDealerStore();
				},

				//11.7.获取商品评价总览
				getGoodsComm: function getGoodsComm() {
						var _this13 = this;

						this.getGoodsCommMsg([this.goodsId]).then(function (res) {
								_this13.GoodsComm = res;
						});
				},

				//11.8.分页查询商品评价
				getGoodsCommContent: function getGoodsCommContent() {
						var _this14 = this;

						this.pageGoodsCommMsg([this.goodsId, 1, 3]).then(function (res) {
								_this14.GoodsCommList = res.result;
						});
				},

				//18.2.获取商品SKU信息
				getSkuMsg: function getSkuMsg() {
						var _this15 = this;

						if (this.goodsSkuMsg) {
								this.goodsSkuMsg.fields.forEach(function (field) {
										field.values.forEach(function (item, index) {
												if (item.isChecked == 1 && item.isImage == 1) {
														_this15.skuImages = item.showImages;
														_this15.imgIndex = index;
												}
										});
								});
								this.load = false;
						} else {
								this.getGoodsSkuMsg([this.goodsId, this.skuId]).then(function (res) {
										_this15.goodsSkuMsg = res;
										_this15.goodsSkuMsg.fields.forEach(function (field) {
												field.values.forEach(function (item, index) {
														if (item.isChecked == 1 && item.isImage == 1) {
																_this15.skuImages = item.showImages;
																_this15.imgIndex = index;
														}
												});
										});
										_this15.saveGoodForBuy(); //将需要购买的商品信息存储
										_this15.load = false;
								});
						}
				},

				//保存要购买的商品的信息
				saveGoodForBuy: function saveGoodForBuy() {
						var _this = this;
						this.saveGoodsData({
								goodsSkuMsg: _this.goodsSkuMsg,
								goodsNum: _this.goodsNum
								//skuImages: _this.skuImages,
						});
				},

				//选择商品属性
				selectSku: function selectSku(fieldId, valueId) {
						var _this16 = this;

						this.saveSelectSku({
								fieldId: fieldId,
								valueId: valueId
						});
						//获取商品单品信息
						var values = [];
						this.goodData.goodsSkuMsg.fields.forEach(function (field) {
								field.values.forEach(function (item) {
										if (item.isChecked == 1) {
												if (item.isImage == 1) {
														_this16.skuImages = item.showImages;
												}
												var value = {
														fieldId: item.fieldId,
														valueId: item.valueId
												};
												values.push(value);
										}
								});
						});
						this.getGoodsSku([this.goodsId, values]).then(function (res) {});
				},

				//商品加减
				changegoodsNum: function changegoodsNum(action) {
						if (action == 'add') {
								this.goodsNum += 1;
						} else if (action == 'reduce') {
								if (this.goodsNum == 1) return;
								this.goodsNum -= 1;
						}
						this.saveGoodForBuy(); //将需要购买的商品信息存储
				},
				gotoEvalute: function gotoEvalute() {
						this.$router.push({ path: '/main/goodsDetail/evaluate?goodsId=' + this.goodsId + '&storeId=' + this.storeId + '&skuId=' + this.skuId });
				},
				gotoDIY: function gotoDIY() {
						this.$router.push({
								path: '/main/diyPage?brandId=' + this.goodsSkuMsg.brandId + '&cateId=' + this.goodsSkuMsg.cateId
						});
				}
		}),
		components: {
				imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a,
				emptyCart: __WEBPACK_IMPORTED_MODULE_2__components_empty_empty___default.a
		},
		created: function created() {
				this.load = true;
				this.goodsId = this.$route.query.goodsId || this.$route.query.linkTarget;
				this.skuId = this.$route.query.skuId || 0;
				this.storeId = this.$route.query.storeId;
				this.getAmapContent();
				this.getGoodsComm();
				this.getGoodsCommContent();
				this.getSkuMsg();
				//获取地域列表
				this.getListAreaMsg(this.addressCode);
		}
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util_js__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // 滚动定位所需数据
      scrollY: 0,
      load: true,
      menuData: [{
        value: "商品"
      }, {
        value: "详情"
      }, {
        value: "参数"
      }, {
        value: "评价"
      }],
      bottomPopup: false,
      id: 1,
      showDialog: false,
      goodsId: "", //商品id
      storeId: "", //商品id
      skuId: "", //商品id
      CartGoodsNum: 0, //购物车商品数量
      goodsSkuMsg: "", //商品sku信息
      skuImages: [], //商品套图
      imgIndex: 0, //商品展示图和高清图
      goodsNum: 1, //商品数量

      diyId: null, //diyId
      skuIds: [], //选中的单品id
      selectDIYinfo: [], //选中的DIY信息

      settleDatas: [], //结算店铺列表
      OrderSettleMsg: {}, //订单信息
      couponAmounts: [], //选中的优惠券

      BuyOrAddCart: true, //true -buy     false -addCart
      toast: {
        toast: false,
        messageTip: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentIndex: function currentIndex() {
      return this.$route.meta.id;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    goodData: "goodData", //产品信息
    diyGoodData: "diyGoodData", //DIY产品信息
    cartGoodsNum: "cartGoodsNum", //购物车商品数量
    customerLink: "customerLink" //客服链接
  }), {
    btnDisabled: function btnDisabled() {
      if (this.goodsSkuMsg && this.goodsSkuMsg.sku && this.goodsSkuMsg.sku.goodsPrice > 0) {
        return false;
      } else {
        return true;
      }
    }
  }),
  mounted: function mounted() {
    this.$nextTick(function () {
      // console.log(this.$refs)
      /*document.querySelectorAll('.homeWrapper')[0].addEventListener('scroll', this.onScroll)*/
      this.$refs.dishesWrapper.addEventListener("scroll", this.onScroll);
    });
  },

  watch: {
    // 对路由变化作出响应...
    $route: function $route(to, from) {
      document.getElementById("dishesWrapper").scrollTop = 0;
    },
    goodData: function goodData(val) {
      this.goodsSkuMsg = this.goodData.goodsSkuMsg;
      this.goodsNum = this.goodData.goodsNum;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    getCartGoodsNum: "getCartGoodsNum", //获取购物车商品数量
    getGoodsSkuMsg: "getGoodsSkuMsg", //获取商品SKU信息
    getGoodsSku: "getGoodsSku", //通过选择属性 获取 商品单品信息
    saveGoodsData: "saveGoodsData", //保存购买的商品信息
    savescrollHeight: "savescrollHeight", //存储页面滚动高度
    saveIsSelSku: "saveIsSelSku", //属性选择弹框

    addGoodsFav: "addGoodsFav", //商品添加收藏

    addMemCart: "addMemCart", //加入购物车
    getOrderSettleMsg: "getOrderSettleMsg", //直接购买
    saveSelectSku: "saveSelectSku",

    getOrderSettleMsgForDiy: "getOrderSettleMsgForDiy", //直接购买-DIY商品
    addMemCartForDiy: "addMemCartForDiy", //加入DIY商品到购物车
    getCustomerLink: "getCustomerLink" //获取客服链接
  }), {
    onScroll: function onScroll() {
      /*this.scrolled = document.querySelectorAll('.homeWrapper')[0].scrollTop;*/
      var scrolled = this.$refs.dishesWrapper.scrollTop;
      this.savescrollHeight({
        scrollHeight: scrolled
      });
    },

    //保存要购买的商品的信息
    saveGoodForBuy: function saveGoodForBuy() {
      var _this = this;
      this.saveGoodsData({
        goodsSkuMsg: _this.goodsSkuMsg,
        goodsNum: _this.goodsNum
      });
    },

    //13.9.获取购物车商品数量
    getCartNum: function getCartNum() {
      var _this2 = this;

      this.getCartGoodsNum([]).then(function (res) {
        _this2.CartGoodsNum = res;
      });
    },

    //上方菜单
    selectMenu: function selectMenu(index) {
      if (index == this.currentIndex) {
        return;
      }
      switch (index) {
        case 0:
          this.$router.push({
            path: "/main/goodsDetail?goodsId=" + this.goodsId + "&storeId=" + (this.storeId || "") + "&skuId=" + this.skuId
          });
          break;
        case 1:
          this.$router.push({
            path: "/main/goodsDetail/detail?goodsId=" + this.goodsId + "&storeId=" + (this.storeId || "") + "&skuId=" + this.skuId
          });
          break;
        case 2:
          this.$router.push({
            path: "/main/goodsDetail/parameter?goodsId=" + this.goodsId + "&storeId=" + (this.storeId || "") + "&skuId=" + this.skuId
          });
          break;
        case 3:
          this.$router.push({
            path: "/main/goodsDetail/evaluate?goodsId=" + this.goodsId + "&storeId=" + (this.storeId || "") + "&skuId=" + this.skuId
          });
          break;
      }
    },

    //18.2.获取商品SKU信息
    getSkuMsg: function getSkuMsg() {
      var _this3 = this;

      if (this.goodsSkuMsg) {
        this.goodsSkuMsg.fields.forEach(function (field) {
          field.values.forEach(function (item, index) {
            if (item.isChecked == 1 && item.isImage == 1) {
              _this3.skuImages = item.showImages;
              _this3.imgIndex = index;
            }
          });
        });
        this.load = false;
      } else {
        this.getGoodsSkuMsg([this.goodsId, this.skuId || 0]).then(function (res) {
          _this3.goodsSkuMsg = res;
          _this3.goodsSkuMsg.fields.forEach(function (field) {
            field.values.forEach(function (item, index) {
              if (item.isChecked == 1 && item.isImage == 1) {
                _this3.skuImages = item.showImages;
                _this3.imgIndex = index;
              }
            });
          });
          //如果storeid不存在
          _this3.storeId = _this3.goodsSkuMsg.sku.storeId;
          _this3.saveGoodForBuy(); //将需要购买的商品信息存储
          _this3.load = false;

          _this3.getCustomerLink(_this3.goodsSkuMsg.sku.storeId);
        });
      }
    },

    //选择商品属性
    selectSku: function selectSku(fieldId, valueId) {
      var _this4 = this;

      this.saveSelectSku({
        fieldId: fieldId,
        valueId: valueId
      });
      //获取商品单品信息
      var values = [];
      this.goodData.goodsSkuMsg.fields.forEach(function (field) {
        field.values.forEach(function (item) {
          if (item.isChecked == 1) {
            if (item.isImage == 1) {
              _this4.skuImages = item.showImages;
            }
            var value = {
              fieldId: item.fieldId,
              valueId: item.valueId
            };
            values.push(value);
          }
        });
      });
      this.getGoodsSku([this.goodsId, values]).then(function (res) {});
    },

    //商品加减
    changegoodsNum: function changegoodsNum(action) {
      if (action == "add") {
        this.goodsNum += 1;
      } else if (action == "reduce") {
        if (this.goodsNum == 1) return;
        this.goodsNum -= 1;
      }
      this.saveGoodForBuy(); //将需要购买的商品信息存储
    },

    //打开QQ聊天
    openCustomServer: function openCustomServer() {
      var tel = 4008322777;
      /*window.location.href = 'tel://' + tel;*/
      window.location.href = this.customerLink;
      // let qq ='4008322777';
      // window.location.href = 'http://wpa.qq.com/msgrd?v=3&uin='+ qq +'&site=qq&menu=yes';
    },

    //商品加入收藏
    addGoodFav: function addGoodFav() {
      var _this5 = this;

      this.addGoodsFav(this.goodsId).then(function (res) {
        if (res.success) {
          _this5.toast.toast = true;
          _this5.toast.messageTip = "收藏成功";
          setTimeout(function () {
            _this5.toast.toast = false;
          }, 1500);
          //this.collectShow = true;
          //this.collectCondition = "收藏成功";
        } else {
          _this5.toast.toast = true;
          _this5.toast.messageTip = "收藏失败";
          setTimeout(function () {
            _this5.toast.toast = false;
          }, 1500);
        }
      }).catch(function (error) {
        //alert(error);
      });
    },

    // 立即购买
    buyNow: function buyNow() {
      this.BuyOrAddCart = true;
      if (this.currentIndex >= 0) {
        this.bottomPopup = true;
        //this.saveIsSelSku({isSelSku:true });
        this.goodsSkuMsg = this.goodData.goodsSkuMsg;
        this.goodsNum = this.goodData.goodsNum;
      } else {
        this.showDialog = true;
        this.selectDIYinfo = this.diyGoodData.selectDIYinfo; //选中的DIY配件信息
        this.diyId = this.diyGoodData.diyId;
        this.skuIds = this.diyGoodData.skuIds;
        this.goodsNum = this.diyGoodData.goodsNum;
      }
    },

    // 加入购物车
    joinCart: function joinCart() {
      this.BuyOrAddCart = false;
      if (this.currentIndex >= 0) {
        this.bottomPopup = true;
        // this.saveIsSelSku({isSelSku:true });
        this.goodsSkuMsg = this.goodData.goodsSkuMsg;
        this.goodsNum = this.goodData.goodsNum;
      } else {
        this.showDialog = true;
        this.selectDIYinfo = this.diyGoodData.selectDIYinfo; //选中的DIY配件信息
        this.diyId = this.diyGoodData.diyId;
        this.skuIds = this.diyGoodData.skuIds;
        this.goodsNum = this.diyGoodData.goodsNum;
      }
    },
    addCart: function addCart() {
      var _this6 = this;

      this.addMemCart([this.goodsId, this.goodsSkuMsg.sku.skuId, this.goodsNum]).then(function (res) {
        if (res) {
          _this6.bottomPopup = false;
          _this6.getCartNum();
          _this6.toast.toast = true;
          _this6.toast.messageTip = "加入购物车成功";
          setTimeout(function () {
            _this6.toast.toast = false;
          }, 1500);
        }
      }).catch(function (err) {
        _this6.toast.toast = true;
        _this6.toast.messageTip = err || "请求失败，等会再试试吧~";
        setTimeout(function () {
          _this6.toast.toast = false;
        }, 1500);
      });
    },

    //添加DIY商品到购物车
    addCartDiy: function addCartDiy() {
      var _this7 = this;

      this.addMemCartForDiy([this.diyId, this.skuIds, this.goodsNum]).then(function (res) {
        if (res) {
          _this7.getCartNum();
          _this7.showDialog = false;
          _this7.toast.toast = true;
          _this7.toast.messageTip = "加入购物车成功";
          setTimeout(function () {
            _this7.toast.toast = false;
          }, 1500);
        }
      }).catch(function (err) {
        _this7.toast.toast = true;
        _this7.toast.messageTip = err || "请求失败，等会再试试吧~";
        setTimeout(function () {
          _this7.toast.toast = false;
        }, 1500);
      });
    },
    getOrderSettle: function getOrderSettle() {
      var _this8 = this;

      this.getOrderSettleMsg([this.goodsId, this.goodsSkuMsg.sku.skuId, this.goodsNum]).then(function (res) {
        _this8.initSettleDatas(res); // 初始化店铺结算信息
        _this8.$router.push({
          path: "/main/firmorder"
        });
      }).catch(function (err) {
        _this8.toast.toast = true;
        _this8.toast.messageTip = err || "请求失败，等会再试试吧~";
        setTimeout(function () {
          _this8.toast.toast = false;
        }, 1500);
      });
    },

    //直接购买DIY商品
    getOrderSettleMsgDIY: function getOrderSettleMsgDIY() {
      var _this9 = this;

      this.getOrderSettleMsgForDiy([this.diyId, this.skuIds, this.goodsNum]).then(function (res) {
        _this9.initSettleDatas(res); // 初始化店铺结算信息
        _this9.$router.push({
          path: "/main/firmorder"
        });
      }).catch(function (err) {
        _this9.toast.toast = true;
        _this9.toast.messageTip = err || "请求失败，等会再试试吧~";
        setTimeout(function () {
          _this9.toast.toast = false;
        }, 1500);
      });
    },

    // 初始化店铺结算信息
    initSettleDatas: function initSettleDatas(OrderSettleMsg) {
      var _this = this;
      var settleDatas = [];
      var couponAmounts = [];
      var redpacketAmounts = []; //console.log(this.OrderSettleMsg.storeOrderSettleMsgs)
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用优惠券",
            couponAmount: 0
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用红包",
            couponAmount: 0
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        var instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function (sub) {
          //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });

        settleDatas.push({
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId: "0",
          remark: "",
          dealerCode: ""
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0);
        redpacketAmounts.push(0);
      });
      var orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      __WEBPACK_IMPORTED_MODULE_3__common_utils_util_js__["a" /* storage */].local.set("orderData", orderData);
    },
    submitDIY: function submitDIY() {
      if (this.BuyOrAddCart) {
        this.getOrderSettleMsgDIY();
      } else {
        this.addCartDiy();
      }
    },
    submit: function submit() {
      if (this.BuyOrAddCart) {
        this.getOrderSettle();
      } else {
        this.addCart();
      }
    },
    gotoCart: function gotoCart() {
      this.$router.push({ path: "/main/cart" });
    }
  }),
  components: {
    imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a
  },
  created: function created() {
    this.goodsId = this.$route.query.goodsId || this.$route.query.linkTarget;
    this.skuId = this.$route.query.skuId || 0;
    this.storeId = this.$route.query.storeId;
    this.getCartNum();
    this.getSkuMsg();
    this.load = false;
    this.savescrollHeight({
      scrollHeight: 0
    });
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constant__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      typeId: 0,
      goodsNum: 1, //商品数量
      totalPrice: 0, //商品总价
      goodsId: this.$route.query.goodsId, //商品id
      storeId: this.$route.query.storeId, //商品id
      diyInfos: [], //diy信息列表
      diyPropertys: null, //diy选中属性
      diyImages: [], //选中的内容
      skuInfo: null, //选中属性总的内容
      values: [], //选中的商品sku
      diyId: null, //diyId
      skuIds: [], //选中的单品id
      selectDIYinfo: [] //选中的DIY信息
    };
  },

  watch: {
    diyPropertys: function diyPropertys() {
      var _this2 = this;

      var diyPropertys = [];
      if (this.diyPropertys && this.diyPropertys.diyId) {
        diyPropertys = this.diyPropertys.items.filter(function (item) {
          return item.itemType == 1;
        });
      }
      diyPropertys.forEach(function (item) {
        //默认选中的图片信息
        var image = {
          imageIndex: item.imageIndex,
          sku: item.itemInfo.sku
        };

        item.itemInfo.fields.forEach(function (field) {
          field.values.forEach(function (item) {
            //初始化values信息
            var value = {};
            _this2.values = _this2.values.filter(function (it) {
              return item.valueId != it.valueId;
            });

            if (item.isChecked == 1) {
              value = {
                fieldId: item.fieldId,
                valueId: item.valueId
              };

              _this2.values.push(value);
            }
          });
        });
        _this2.getImages(image);
      });
    },
    diyImages: function diyImages() {
      var _this3 = this;

      if (this.diyImages && this.diyImages.length) {
        this.skuInfo = {
          goodsPrice: 0,
          unitPrice: 0,
          selectGood: ''
        };
        this.diyImages.forEach(function (item) {
          _this3.skuInfo.goodsPrice = Number(_this3.skuInfo.goodsPrice) + Number(item.sku.goodsPrice);
          _this3.totalPrice = _this3.skuInfo.goodsPrice * _this3.goodsNum;
          _this3.skuInfo.unitPrice += Number(item.sku.unitPrice);
          _this3.skuInfo.selectGood = _this3.skuInfo.selectGood ? _this3.skuInfo.selectGood + ',' + item.sku.skuFields : item.sku.skuFields;
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    diyGoodData: 'diyGoodData' //产品信息
  }), {
    currentIndex: function currentIndex() {
      return this.$route.meta.id;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    getOrderSettleMsgForDiy: 'getOrderSettleMsgForDiy', //直接购买-DIY商品
    getDiyInfo: 'getDiyInfo', //获取商品SKU信息
    getDiySku: 'getDiySku', //通过选择属性 获取 商品单品信息
    saveDiyData: 'saveDiyData' //保存购买的商品信息
  }), {

    //保存要购买的商品的信息
    saveDiyForBuy: function saveDiyForBuy() {
      var skuIds = [];
      this.diyImages.forEach(function (item) {
        if (item.sku.skuId) {
          skuIds.push(item.sku.skuId);
        }
      });
      var _this = this;
      this.saveDiyData({
        diyId: _this.diyId,
        skuIds: skuIds,
        goodsNum: _this.goodsNum,
        selectDIYinfo: _this.selectDIYinfo
      });
    },

    //商品加减
    changegoodsNum: function changegoodsNum(action) {
      if (action == 'add') {
        this.goodsNum += 1;
      } else if (action == 'reduce') {
        if (this.goodsNum == 1) return;
        this.goodsNum -= 1;
      }
      this.totalPrice = this.skuInfo.goodsPrice * this.goodsNum;
      this.saveDiyForBuy(); //将需要购买的商品信息存储
    },

    //图片路径
    imagePath: function imagePath(_imagePath) {
      return __WEBPACK_IMPORTED_MODULE_3__Constant__["a" /* default */].imgBaseUrl + '/' + _imagePath;
    },


    //获取diy信息
    getDiyInfos: function getDiyInfos() {
      var _this4 = this;

      this.getDiyInfo([this.storeId, this.goodsId]).then(function (res) {
        console.log('res', res);
        _this4.diyInfos = res;
        _this4.load = false;
        if (res == null) return;
        _this4.diyPropertys = _this4.diyInfos.find(function (item) {
          _this4.diyId = item.diyId;
          //筛选选中的各配件信息
          if (item.items[0].itemInfo && item.items[0].itemInfo.fields && item.items[0].itemInfo.fields.length > 0) {
            item.items[0].itemInfo.fields.forEach(function (sub, index) {
              sub.values.find(function (field) {
                _this4.selectDIYinfo = _this4.selectDIYinfo.filter(function (t) {
                  return t.fieldName != field.fieldName;
                });
                _this4.selectDIYinfo.push({
                  fieldName: field.fieldName,
                  valueName: field.valueName
                });
                return field.isChecked == 1;
              });
            });
          }

          _this4.saveDiyForBuy(); //将需要购买的商品信息存储

          return item.isChecked == 1;
        });
      }).catch(function (error) {
        _this4.$message.error(error);
      });
    },


    //获取diy单品信息
    getDiySkus: function getDiySkus(goodsId, imageIndex) {
      var _this5 = this;

      this.getDiySku([goodsId, this.values]).then(function (res) {
        _this5.diyImages.forEach(function (item, index) {
          if (imageIndex == item.imageIndex) {
            var image = {
              imageIndex: item.imageIndex,
              sku: res
            };

            _this5.$set(_this5.diyImages, index, image);
          }
        });
        _this5.saveDiyForBuy(); //将需要购买的商品信息存储
      });
    },


    //获取组合展示门数据
    getImages: function getImages(item) {
      if (this.diyImages && this.diyImages.length) {
        this.diyImages = this.diyImages.filter(function (diy) {
          return diy.imageIndex != item.imageIndex;
        });
      }
      this.diyImages.push(item);
    },


    //选择diy单品属性
    selectDiyGood: function selectDiyGood(index, goodsId, fieldId, valueId, imageIndex) {
      var _this6 = this;

      var itemInfo = this.diyPropertys.items[index].itemInfo.fields.find(function (item) {
        return item.fieldId == fieldId;
      });

      itemInfo.values.forEach(function (item) {
        if (item.valueId == valueId) {
          item.isChecked = 1;
          var value = {};
          if (_this6.values && _this6.values.length) {
            _this6.values = _this6.values.filter(function (it) {
              return it.fieldId != fieldId;
            });
          }
          value.valueId = item.valueId;
          value.fieldId = item.fieldId;
          _this6.values.push(value);
          _this6.selectDIYinfo = _this6.selectDIYinfo.filter(function (t) {
            return t.fieldName != item.fieldName;
          });
          _this6.selectDIYinfo.push({
            fieldName: item.fieldName,
            valueName: item.valueName
          });
        } else {
          item.isChecked = 0;
        }
      });

      //获取diy单品信息
      this.getDiySkus(goodsId, imageIndex);
    },


    //选择diy单品
    selectDiyProperty: function selectDiyProperty(index, skuId) {
      var _this7 = this;

      var itemInfo = this.diyPropertys.items[index];
      var image = {
        imageIndex: itemInfo.imageIndex
      };
      itemInfo.itemInfo.forEach(function (item) {
        if (item.skuId == skuId) {
          item.isChecked = 1;
          _this7.selectDIYinfo = _this7.selectDIYinfo.filter(function (t) {
            return t.fieldName != itemInfo.itemName;
          });
          _this7.selectDIYinfo.push({
            fieldName: itemInfo.itemName,
            valueName: item.values[0].valueName
          });
          image.sku = item;
          _this7.getImages(image);
        } else {
          item.isChecked = 0;
        }
      });
      this.saveDiyForBuy(); //将需要购买的商品信息存储
    },


    //diy系列选择
    shooseSeries: function shooseSeries(id) {
      if (this.diyId == id) {
        return;
      }

      this.diyId = id;
      this.diyImages = [];
      this.values = [];
      this.diyInfos.forEach(function (item) {
        if (item.diyId == id) {
          item.isChecked = 1;
        } else {
          item.isChecked = 0;
        }
      });

      this.diyPropertys = this.diyInfos.find(function (item) {
        return item.isChecked == 1;
      });
    }
  }),
  components: {
    imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a
  },
  created: function created() {
    this.getDiyInfos();
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_empty_empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tip: '继续拖动，查看评价',
      startY: 0, //触摸位置
      moveY: 0, //滑动时的位置
      disY: 0, //移动距离
      txtStyle: '',
      height: 0,
      startScrollH: 0, //开始滑动  记录当前滚动的位置


      goodsId: this.$route.query.goodsId || this.$route.query.linkTarget, //商品id
      storeId: this.$route.query.storeId || '', //商品id
      skuId: this.$route.query.skuId || 0, //商品id


      load: true,
      GoodsKindValue: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    var count = 0;
    this.yzInterval = setInterval(function () {
      count++;
      if (_this.load == false) {
        clearInterval(_this.yzInterval);
        var cHeight = _this.$refs.wrap.clientHeight; //元素的高度
        var oHeight = _this.$refs.content.clientHeight; //内容的高度
        _this.height = oHeight - cHeight; //可滑动的最大值
      }
    }, 1000);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    scrollHeight: 'scrollHeight'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    getGoodsKindValue: 'getGoodsKindValue' //获取商品SKU信息
  }), {
    //18.2.获取商品详情
    getGoodsKind: function getGoodsKind(id) {
      var _this2 = this;

      this.getGoodsKindValue([id]).then(function (res) {
        _this2.GoodsKindValue = res;
        _this2.load = false;
      });
    },

    _touchStart: function _touchStart(ev) {
      ev = ev || event;
      if (ev.touches.length == 1) {
        // 手指按下的时候记录按下的位置
        this.startY = ev.touches[0].clientY;
        //记录手指按下时滚动的高度
        this.startScrollH = this.scrollHeight.scrollHeight;
      }
    },
    _touchMove: function _touchMove(ev) {
      ev = ev || event;
      if (ev.touches.length == 1) {
        // 滑动过程中的实时位置
        this.moveY = ev.touches[0].clientY;
        // 滑动过程中实时计算滑动距离
        this.disY = this.startY - this.moveY;
        //console.log('disY==>', this.disY,this.height, this.startScrollH)
        //鼠标按下时的滑动距离大于可滑动的最大距离  
        if (this.startScrollH / this.height >= 0.98) {
          if (this.disY > 100) {
            //滑动距离大于100
            // this.txtStyle = "transform:translateY(-" + this.disY + "px)";
            this.txtStyle = "margin-bottom:" + this.disY + "px";
            document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight + this.disY;
            this.tip = '释放切换到评价';
          } else if (this.disY > 0 && this.disY < 100) {
            this.txtStyle = "margin-bottom:" + this.disY + "px";
            document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight + this.disY;
            this.tip = '上拉切换到评价';
            //this.tip = '继续拖动，查看详情'
          }
        } else {
          this.tip = '继续拖动，查看评价';
        }
      }
    },
    _touchEnd: function _touchEnd(ev) {
      if (event.changedTouches.length == 1) {
        // 手指移动结束后的水平位置
        var endX = event.changedTouches[0].clientY;
        // 触摸开始与结束,手指移动的距离
        //this.disY = this.startY - endX;
        //如果距离小于100，页面不跳转，否则跳转至对应页面
        //console.log("=>",this.disY,this.height, this.startScrollH)
        //滑动结束，判断当前的滑动距离大于或等于时 偏移
        if (this.disY > 100 && this.startScrollH / this.height >= 0.98) {
          this.$router.push({ path: '/main/goodsDetail/evaluate?goodsId=' + this.goodsId + '&storeId=' + (this.storeId || '') + '&skuId=' + this.skuId });
        } else {
          this.txtStyle = "margin-bottom:" + 0 + "px";
          document.getElementById('dishesWrapper').scrollTop = this.scrollHeight.scrollHeight;
          this.tip = '继续拖动，查看评价';
        }
      }
    }
  }),
  components: {
    empty: __WEBPACK_IMPORTED_MODULE_2__components_empty_empty___default.a
  },
  created: function created() {
    this.load = true;
    this.getGoodsKind(this.$route.query.goodsId);
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_empty_empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      asc: "", //1表示升序排列，2表示降序排列
      isColligate: false,
      rightPopup: false,
      eq: 2, //默认展示条数
      nextId: null,
      GoodsPropertieTags: [], //18.6.获取商品 属性标签
      checkedTag: [], //选中的商品属性
      goodsList: [], //商品列表
      pageNo: 1, //当前页码
      pageSize: 10, //每次加载条数
      total: 0, //z总数量
      currentPage: 1, //当前页
      lastPageNo: 1, //总共页面数量
      loading: false,
      scroller: null,
      keyWord: this.$route.query.keyWord || null,
      linkTarget: this.$route.query.linkTarget,
      linkType: this.$route.query.linkType,
      seo: true, //综合
      sorts: [],
      brands: [],
      adver: {}, //随机广告
      toast: {
        toast: false,
        messageTip: ""
      }
    };
  },
  updated: function updated() {
    var vm = this;
    var savePosition = vm.$route.meta.savePosition;
    var keyWord = vm.$route.meta.keyWord;
    if (keyWord && savePosition >= 0) {
      vm.keyWord = keyWord;
    }
    if (savePosition <= 0) {
      vm.$route.meta.savePosition = -1;
      return;
    }

    vm.$nextTick(function () {
      vm.$refs.listBox.scrollTop = savePosition;
      setTimeout(function () {
        vm.$route.meta.savePosition = -1;
        vm.$route.meta.keyWord = "";
      }, 500);
    });
  },
  created: function created() {
    var _this = this;

    this.nextId = this.eq;
    this.getGoodsPropertieTag().then(function (res) {
      _this.GoodsPropertieTags = res.tags;
    }).then(function (res) {
      _this.getBrands().then(function (res) {
        res.unshift({
          linkName: "全部",
          linkType: "8",
          sort: "-1"
        });
        var brandstags = {
          linkName: "品牌",
          subs: res
        };
        _this.GoodsPropertieTags.unshift(brandstags);
        _this.checkedTag = [];
        if (_this.GoodsPropertieTags && _this.GoodsPropertieTags.length) {
          _this.GoodsPropertieTags.forEach(function (item) {
            var tag = {
              tagId: item.linkTarget,
              linkInfo: ""
            };
            _this.checkedTag.push(tag);
          });
        }
        if (_this.linkTarget && _this.linkType) {
          _this.checkedTag[0].linkInfo = {
            linkTarget: _this.linkTarget,
            linkType: _this.linkType
          };
        }
        //console.log(">>>>",this.checkedTag)
        _this.pageGoods();
      });
    });

    this.randomAdver([1, 4]).then(function (res) {
      _this.adver = res[0];
    });
  },
  mounted: function mounted() {
    this.scroller = document.querySelectorAll(".box")[0];
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    shareGoodsLists: "goodsLists",
    statePageNo: "pageNo",
    lastPage: "lastPage"
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    getGoodsSearchSort: "getGoodsSearchSort", //获取排序列表
    getPageGoods: "getPageGoods", //分页查询商品数据
    getGoodsPropertieTag: "getGoodsPropertieTag", //获取搜索页面属性标签
    getBrands: "getBrands", //获取品牌
    randomAdver: "randomAdver" //24.1.随便获取商城N条广告
  }), {
    focusinput: function focusinput() {
      this.loading = false;
    },

    // 加载更多
    loadMore: function loadMore() {
      var _this2 = this;

      this.$route.meta.savePosition = -1;
      this.$route.meta.keyWord = "";
      if (this.lastPageNo <= this.pageNo) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.pageGoods();
        setTimeout(function () {
          _this2.loading = false;
        }, 2000);
      }
    },
    select: function select() {
      //this.asc='asc';
      this.isColligate = true;
    },
    gotoAdverDetail: function gotoAdverDetail() {
      switch (this.adver.linkType) {
        case "1":
          break;
        default:
          break;
      }
    },
    toggleNexted: function toggleNexted(id) {
      if (id < this.eq) {
        return;
      }
      if (id == this.nextId) {
        this.nextId = null;
        return;
      }
      this.nextId = id;
    },

    //选择商品属性标签
    selectTag: function selectTag(index, item) {
      this.checkedTag[index].linkInfo = item;
    },

    //商品分页查询
    pageGoods: function pageGoods() {
      var _this3 = this;

      var links = [];
      if (this.checkedTag && this.checkedTag.length) {
        this.checkedTag.forEach(function (item) {
          var link = {};
          if (item.linkInfo && item.linkInfo.linkTarget) {
            link.linkType = item.linkInfo.linkType;
            link.linkTarget = item.linkInfo.linkTarget;
            links.push(link);
          }
        });
      }
      // //如当前
      // if(this.linkTarget && this.linkType){
      // 	links.push({
      // 		linkTarget:this.linkTarget,
      // 		linkType:this.linkType
      // 	})
      // }

      var keyWord = this.keyWord;
      var params = {
        links: links,
        keyWord: keyWord,
        sorts: this.sorts
      };

      if (this.$route.meta.savePosition > 0) {
        this.pageNo = this.statePageNo;
        this.goodsList = this.shareGoodsLists;
        this.lastPageNo = this.lastPage;
        this.load = false;
        return;
      }

      this.getPageGoods([params, this.pageNo, this.pageSize]).then(function (res) {
        res.result.forEach(function (item) {
          _this3.goodsList.push(item);
        });
        _this3.lastPageNo = Number(res.lastPageNo);
        _this3.total = Number(res.totalCount);
        _this3.currentPage = Number(res.currentPageNo);
        _this3.load = false;
      });
    },
    scanDetail: function scanDetail(storeid, goodid, skuId) {
      this.$route.meta.savePosition = this.$refs.listBox.scrollTop;
      this.$route.meta.keyWord = this.keyWord;
      this.$router.push({
        path: "/main/goodsDetail?goodsId=" + goodid + "&storeId=" + storeid + "&skuId=" + skuId
      });
    },
    reset: function reset() {
      var _this4 = this;

      this.keyWord = "";
      this.nextId = this.eq;
      this.getGoodsPropertieTag().then(function (res) {
        _this4.GoodsPropertieTags = res.tags;
      }).then(function (res) {
        _this4.getBrands().then(function (res) {
          res.unshift({
            linkName: "全部",
            linkType: "8",
            sort: "-1"
          });
          var brandstags = {
            linkName: "品牌",
            subs: res
          };
          _this4.GoodsPropertieTags.unshift(brandstags);
          _this4.checkedTag = [];
          if (_this4.GoodsPropertieTags && _this4.GoodsPropertieTags.length) {
            _this4.GoodsPropertieTags.forEach(function (item) {
              var tag = {
                tagId: item.linkTarget,
                linkInfo: ""
              };
              _this4.checkedTag.push(tag);
            });
          }
          if (_this4.linkTarget && _this4.linkType) {
            _this4.checkedTag[0].linkInfo = {
              linkTarget: _this4.linkTarget,
              linkType: _this4.linkType
            };
          }
          //console.log(">>>>",this.checkedTag)
          _this4.pageGoods();
        });
      });
      //this.checkedTag = [];
    },
    seoRanking: function seoRanking() {
      if (this.seo) {
        this.seo = false;
      } else {
        this.asc = "";
        this.sorts = [];
        this.seo = true;
      }
      this.filter();
    },
    sale: function sale(action) {
      this.seo = false;
      var sort = {
        sortType: "1",
        sort: action
      };
      this.asc = action;
      this.sorts.push(sort);
      this.filter();
    },
    filter: function filter() {
      this.pageNo = 1;
      this.load = true;
      this.isColligate = false;
      this.rightPopup = false;
      this.goodsList = [];
      this.$refs.listBox.scrollTop = 0;
      this.pageGoods();
    }
  }),
  components: {
    topLink: __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default.a
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			isDialog: false,
			searchKey: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
		searchKeywordList: 'searchKeywordList', //随机搜索词列表
		lastSearchList: 'lastSearchList' //最近搜索关键词
	})),
	created: function created() {
		this._initView();
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
		getHotSearch: 'getHotSearch', //随机获取一组关键词
		addLastSearch: 'addLastSearch', //添加最近搜索关键词
		clearLastSearch: 'clearLastSearch' //清空最近搜索关键词
	}), {
		_initView: function _initView() {
			//随机获取搜索词列表
			if (!this.searchKeywordList || !this.searchKeywordList.length) {
				this.getHotSearch();
			}
		},

		//换一批关键词
		batchKeyword: function batchKeyword() {
			this.getHotSearch();
		},


		//搜索商品
		searchGoods: function searchGoods(keyword) {
			if (!keyword || !keyword.trim()) {
				return;
			}
			this.addLastSearch(keyword);
			this.$router.push({
				path: '/main/search',
				query: {
					keyWord: keyword
				}
			});
		},


		//清空最近搜索
		clearSearch: function clearSearch() {
			this.isDialog = false;
			this.clearLastSearch();
		}
	}),
	components: {
		topLink: __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default.a,
		imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a
	}
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_topLink_topLink__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_topLink_topLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_topLink_topLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        /*notNextTick: true, */
        pagination: ".swiper-pagination",
        autoplay: 5000,
        autoplayDisableOnInteraction: false
      },
      scrolled: 0, //滚动距离
      isFixed: false,
      linkTarget: null, //店铺id
      shopDetail: {}, //存放店铺详情
      bannerDeatilList: [], //获取到的banner图
      promotionsShopList33: [], //获取促销列表
      promotionsShopList44: [], //获取促销列表
      promotionsShopListBanner: [], //获取促销列表
      promotionsShopList66: [], //获取促销列表
      floorMsg: [], //获取到的楼层信息
      comSwiperOption: {
        slidesPerView: 2.5,
        slidesPerGroup: 2,
        autoplay: 10000,
        loop: false,
        autoplayDisableOnInteraction: false
      },
      couponsList: [], //优惠券和红包列表
      toast: {
        toast: false,
        messageTip: ""
      },
      backgroundImage: "/static/images/get_coupon_bg@3x.png"
      // linkTarget: this.$route.query.linkTarget, //跳转搜索
      //linkType: this.$route.query.linkType, //跳转搜素需要的
    };
  },
  updated: function updated() {
    if (!__WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.get("savePosition")) {
      return;
    }
    this.$nextTick(function () {
      this.$refs.homeWrapper.scrollTop = __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.get("savePosition");
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.remove("savePosition");
      }, 500);
    });
  },

  watch: {
    scrolled: function scrolled() {
      if (this.scrolled > 0) {
        this.isFixed = true;
        return;
      }

      this.isFixed = false;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])({
    getStoreBaseInfo: "getStoreBaseInfo", //获取店铺详细信息
    getStoreBanner: "getStoreBanner", //获取店铺Banner图
    getStorePromotions: "getStorePromotions", //获取促销广告
    getStoreFloorInfo: "getStoreFloorInfo", //获取楼层数据
    getListStoreCoupons: "getListStoreCoupons", //获取优惠券和红包列表
    receiveCoupon: "receiveCoupon" //领取优惠券或者红包
  }), {
    goPage: function goPage(linkType, linkTarget) {
      __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.set("savePosition", this.$refs.homeWrapper.scrollTop);
      this.linkFn(linkType, linkTarget);
    },

    //获取优惠券和红包列表
    getListStoreCoupon: function getListStoreCoupon() {
      var _this = this;

      this.getListStoreCoupons(this.linkTarget).then(function (res) {
        _this.couponsList = res;
      }).catch(function (error) {
        console.log(error);
      });
    },

    //领取优惠券
    receiveCouponFn: function receiveCouponFn(couponId, couponType, isGet) {
      var _this2 = this;

      if (isGet == 1) {
        return;
      }
      this.receiveCoupon([couponId, couponType]).then(function (res) {
        console.log(res);
        if (res.success) {
          _this2.toast.toast = true;
          _this2.toast.messageTip = res.message || "领取成功";
          setTimeout(function () {
            _this2.toast.toast = false;
          }, 1500);
          _this2.getListStoreCoupon();
        } else {
          _this2.toast.toast = true;
          _this2.toast.messageTip = res.message || "领取失败，请稍后重试";
          setTimeout(function () {
            _this2.toast.toast = false;
          }, 1500);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    //搜索跳转
    jumpSearch: function jumpSearch() {
      var linkTargetMsg = this.$route.query.linkTarget;
      var linkTypeMsg = this.$route.query.linkType;
      __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.set("savePosition", this.$refs.homeWrapper.scrollTop);
      this.$router.push({
        path: "/main/search?linkTarget=" + linkTargetMsg + "&linkType=" + linkTypeMsg + "&keyWord="
      });
    },

    //获取滚动的距离
    onScroll: function onScroll() {
      this.scrolled = document.querySelectorAll(".homeWrapper")[0].scrollTop;
    },

    //调用店铺详情api
    getStoreBaseInfoMsg: function getStoreBaseInfoMsg(linkTarget) {
      var _this3 = this;

      this.getStoreBaseInfo(linkTarget).then(function (res) {
        _this3.shopDetail = res;
      });
    },

    //获取店铺Banner图;
    getStoreBannerMsg: function getStoreBannerMsg(linkTarget) {
      var _this4 = this;

      this.getStoreBanner([linkTarget, 4]).then(function (res) {
        _this4.bannerDeatilList = res;
      });
    },

    //获取促销广告1-4条
    getStorePromotionsMsg: function getStorePromotionsMsg(linkTarget, promType) {
      var _this5 = this;

      this.getStorePromotions([linkTarget, promType, 4]).then(function (res) {
        if (promType == 3) {
          _this5.promotionsShopList33 = res;
        } else if (promType == 4) {
          _this5.promotionsShopList44 = res;
        } else if (promType == 5) {
          _this5.promotionsShopListBanner = res;
        } else if (promType == 6) {
          _this5.promotionsShopList66 = res;
        } else if (promType == 8) {
          if (res && res[0] && res[0].imagePath && res[0].imagePath.imagePath) {
            _this5.backgroundImage = __WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].imgBaseUrl + "/" + (res && res[0] && res[0].imagePath && res[0].imagePath.imagePath);
          }
        }
      });
    },

    //获取店铺楼层信息
    getStoreFloorInfoMsg: function getStoreFloorInfoMsg(linkTarget, appType) {
      var _this6 = this;

      this.getStoreFloorInfo([linkTarget, appType]).then(function (res) {
        _this6.floorMsg = res;
        //console.log("结果", res);
      });
    },

    //浏览商品详情
    viewGoodsDetail: function viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.set("savePosition", this.$refs.homeWrapper.scrollTop);
        this.$router.push({
          path: "/main/goodsDetail?goodsId=" + goods.goodsId
        });
      }
    }
  }),
  mounted: function mounted() {
    this.$nextTick(function () {
      /* console.log(this.$refs);*/
      document.querySelectorAll(".homeWrapper")[0].addEventListener("scroll", this.onScroll);
    });

    this.getListStoreCoupon();
  },
  created: function created() {
    this.linkTarget = this.$route.query.linkTarget; //获取店铺ID
    this.getStoreBaseInfoMsg(this.linkTarget); //获取点店铺详细
    this.getStoreBannerMsg(this.linkTarget); //获取店铺banner图
    this.getStorePromotionsMsg(this.linkTarget, 3); //获取店铺促销商品
    this.getStorePromotionsMsg(this.linkTarget, 4); //获取店铺促销商品
    this.getStorePromotionsMsg(this.linkTarget, 5); //获取店铺促销商品
    this.getStorePromotionsMsg(this.linkTarget, 6); //获取店铺促销商品
    this.getStoreFloorInfoMsg(this.linkTarget, 4); //获取到的楼层信息
    this.getStorePromotionsMsg(this.linkTarget, 8); //获取到的楼层信息
  },

  components: {
    topLink: __WEBPACK_IMPORTED_MODULE_1__components_topLink_topLink___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_2__components_image_image___default.a,
    swiper: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_swiper__["swiperSlide"],
    "v-image": __WEBPACK_IMPORTED_MODULE_2__components_image_image___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default.a
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_topLink_topLink__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_topLink_topLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_topLink_topLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      defaultBanner: __WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].defaultVal.defaultBanner,
      slides: [], //焦点幻灯banner
      brandCates: [], //品牌分类
      boutiques: [], //精品推荐
      floors: [],
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        /*notNextTick: true,  */
        pagination: ".swiper-pagination",
        autoplay: 10000,
        autoplayDisableOnInteraction: false
      },
      comSwiperOption: {
        slidesPerView: 2.5,
        slidesPerGroup: 2,
        autoplay: 10000,
        loop: false,
        autoplayDisableOnInteraction: false
      },
      newsSwiperOption: {
        direction: "vertical",
        autoplay: 10000,
        loop: true,
        autoplayDisableOnInteraction: false
      },
      scrolled: 0, //监听滚动事件
      load: true,
      ShareGoods: [] //晒家分享列表
    };
  },
  updated: function updated() {
    if (!this.$route.meta.savePosition) {
      return;
    }
    this.$nextTick(function () {
      var _this = this;

      this.$refs.homeWrapper.scrollTop = this.$route.meta.savePosition;
      setTimeout(function () {
        _this.$route.meta.savePosition = 0;
      }, 500);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])({
    getHomeSlide: "getHomeSlide",
    getBrandCates: "getBrandCates",
    getAdBanners: "getAdBanners",
    getRecomGoods: "getRecomGoods",
    getVrBanner: "getVrBanner",
    getBoutiqueGoods: "getBoutiqueGoods",
    getNewMessages: "getNewMessages",
    getHomeFloorInfos: "getHomeFloorInfos",
    getMainShareGoods: "getMainShareGoods"
  }), {
    onScroll: function onScroll() {
      /*this.scrolled = document.querySelectorAll('.homeWrapper')[0].scrollTop;*/
      this.scrolled = this.$refs.homeWrapper.scrollTop;
    },
    gotosunhomeList: function gotosunhomeList() {
      this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
      this.$router.push({ path: "/main/sunhomelist" });
    },
    gotoSunhomeDetail: function gotoSunhomeDetail(shareId) {
      this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
      this.$router.push({ path: "/main/sunhomedetail?shareId=" + shareId });
    },
    goDeatil: function goDeatil() {
      alert(1);
      this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
    },

    //搜索商品
    searchGood: function searchGood() {
      this.$router.push({ path: "/main/allSearch" });
    },
    _initView: function _initView() {
      var _this2 = this;

      //  1.焦点幻灯
      this.getHomeSlide().then(function (res) {
        console.log("getHomeSlide", res);
        _this2.slides = res;
      });

      //  2.品牌分类
      this.getBrandCates([4]).then(function (res) {
        console.log("getBrandCates", res);
        _this2.brandCates = res;
      });

      //  3.广告banner
      /*this.getAdBanners().then(res=>{
                    console.log('getAdBanners',res);
                    this.navBanners = res;
                  });*/

      //  4.系列推荐
      /*this.getRecomGoods().then(res=>{
                    console.log('getRecomGoods',res);
                    this.navBanners = res;
                  });*/

      //  5.VR展示广告
      /*this.getVrBanner().then(res=>{
                    console.log('getVrBanner',res);
                    this.navBanners = res;
                  });*/

      //  6.精品推荐
      this.getBoutiqueGoods().then(function (res) {
        console.log("getBoutiqueGoods", res);
        _this2.boutiques = res;
      });

      //  7.最新消息
      /*this.getNewMessages().then(res=>{
                    console.log('getNewMessages',res);
                    this.navBanners = res;
                  });*/
      //  8.商品楼层(暂用WEB)
      this.getHomeFloorInfos(4).then(function (res) {
        console.log("getHomeFloorInfos", res);
        _this2.floors = res;
        _this2.load = false;
      });
      //  9.晒家分享
      this.getMainShareGoods().then(function (res) {
        _this2.ShareGoods = res;
      });
    },


    //浏览商品详情
    viewGoodsDetail: function viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        this.$route.meta.savePosition = this.$refs.homeWrapper.scrollTop;
        this.$router.push({
          path: "/main/goodsDetail?goodsId=" + goods.goodsId + "&skuId=" + (goods.skuId || 0) + "&storeId=" + goods.storeId
        });
      }
    }
  }),
  computed: {
    /*goodsFloors(){
                  return this.floors.filter(item => {
                    return item.itemType == 1;
                  });
                },*/
    /*adFloors(){
                  return this.floors.filter(item => {
                    return item.itemType == 99;
                  });
                }*/
  },
  watch: {},
  mounted: function mounted() {
    this.$nextTick(function () {
      console.log(this.$refs);
      /*document.querySelectorAll('.homeWrapper')[0].addEventListener('scroll', this.onScroll)*/
      this.$refs.homeWrapper.addEventListener("scroll", this.onScroll);
    });
  },
  created: function created() {
    this._initView();

    console.log(this.defaultBanner);
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_2__components_menus_menus___default.a,
    topLink: __WEBPACK_IMPORTED_MODULE_3__components_topLink_topLink___default.a,
    "v-image": __WEBPACK_IMPORTED_MODULE_4__components_image_image___default.a,
    swiper: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__["swiperSlide"]
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true  
        /*notNextTick: true,  */
        pagination: '.swiper-pagination',
        autoplay: 10000,
        autoplayDisableOnInteraction: false
      },
      shareId: this.$route.query.shareId, //shareId
      ShareInfoContent: {}
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    getShareInfoContent: 'getShareInfoContent'
  }), {
    //浏览商品详情
    viewGoodsDetail: function viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        this.$router.push({
          path: '/main/goodsDetail?goodsId=' + goods.goodsId + '&skuId=' + (goods.skuId || 0) + '&storeId=' + goods.storeId
        });
      }
    }
  }),
  components: {
    'v-image': __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a
  },
  created: function created() {
    var _this = this;

    //  1.获取详情
    this.getShareInfoContent([this.shareId]).then(function (res) {
      _this.load = false;
      console.log('getShareInfoContent', res);
      _this.ShareInfoContent = res;
    });
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_empty_empty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      load: true,
      asc: '', //1表示升序排列，2表示降序排列
      isColligate: false,
      rightPopup: false,
      eq: 2, //默认展示条数
      nextId: null,
      GoodsPropertieTags: [], //18.6.获取商品 属性标签
      checkedTag: [], //选中的商品属性
      goodsList: [], //商品列表
      pageNo: 1, //当前页码
      pageSize: 10, //每次加载条数
      total: 0, //z总数量
      currentPage: 1, //当前页
      lastPageNo: 1, //总共页面数量
      loading: false,
      isSavePosition: true,
      scroller: null,
      keyWord: this.$route.query.keyWord || null,
      linkTarget: this.$route.query.linkTarget,
      linkType: this.$route.query.linkType,
      seo: true, //综合
      sorts: [],
      brands: [],
      adver: {}, //随机广告
      toast: {
        toast: false,
        messageTip: ''
      },
      isfocu: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    shareGoodsLists: 'shareGoodsLists',
    statePageNo: 'pageNo',
    lastPage: 'lastPage'
  })),
  updated: function updated() {
    if (!this.$route.meta.savePosition) {
      return;
    }
    this.$nextTick(function () {
      this.$refs.listBox.scrollTop = this.$route.meta.savePosition;
    });
  },
  created: function created() {
    var _this = this;

    this.nextId = this.eq;
    this.getGoodsPropertieTag().then(function (res) {
      _this.GoodsPropertieTags = res.tags;
    }).then(function (res) {

      _this.getBrands().then(function (res) {
        res.unshift({
          linkName: "全部",
          linkType: '8',
          sort: '-1'
        });
        var brandstags = {
          linkName: "品牌",
          subs: res
        };
        _this.GoodsPropertieTags.unshift(brandstags);
        _this.checkedTag = [];
        if (_this.GoodsPropertieTags && _this.GoodsPropertieTags.length) {
          _this.GoodsPropertieTags.forEach(function (item) {
            var tag = {
              tagId: item.linkTarget,
              linkInfo: ""
            };
            _this.checkedTag.push(tag);
          });
        }
        if (_this.linkTarget && _this.linkType) {
          _this.checkedTag[0].linkInfo = {
            linkTarget: _this.linkTarget,
            linkType: _this.linkType
          };
        }
        //console.log(">>>>",this.checkedTag)
        _this.pageGoods();
      });
    });

    this.randomAdver([1, 4]).then(function (res) {
      _this.adver = res[0];
    });
  },
  mounted: function mounted() {

    this.scroller = document.querySelectorAll('.box')[0];
  },

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    getGoodsSearchSort: 'getGoodsSearchSort', //获取排序列表
    pageShareGoods: 'pageShareGoods', //分页查询商品数据
    getGoodsPropertieTag: 'getGoodsPropertieTag', //获取搜索页面属性标签
    getBrands: 'getBrands', //获取品牌
    randomAdver: 'randomAdver', //24.1.随便获取商城N条广告
    savePosition: "savePosition"
  }), {
    gotoSunhomeDetail: function gotoSunhomeDetail(shareId) {
      this.$route.meta.savePosition = this.$refs.listBox.scrollTop;
      this.$router.push({ path: '/main/sunhomedetail?shareId=' + shareId });
    },

    // 加载更多
    loadMore: function loadMore() {
      var _this2 = this;

      this.loading = true;
      this.$route.meta.savePosition = "";
      if (this.lastPageNo == this.pageNo) {
        this.loading = false;
        // this.toast.toast = true;
        //  this.toast.messageTip = '没有更多数据啦~'
        //  setTimeout(() => { this.toast.toast = false }, 1500)
      } else {
        setTimeout(function () {
          _this2.pageNo++;
          _this2.pageGoods();
          _this2.loading = false;
        }, 2000);
      }
    },
    select: function select() {
      //this.asc='asc';
      this.isColligate = true;
    },
    blurinput: function blurinput() {
      setTimeout(this.isfocu = false, 15000);
    },
    focusinput: function focusinput() {
      if (this.keyWord != null) {
        this.isfocu = true;
      } else {
        this.isfocu = true;
      }
    },
    gotoAdverDetail: function gotoAdverDetail() {
      switch (this.adver.linkType) {
        case '1':
          break;
        default:
          break;
      }
    },
    toggleNexted: function toggleNexted(id) {
      if (id < this.eq) {
        return;
      }
      if (id == this.nextId) {
        this.nextId = null;
        return;
      }
      this.nextId = id;
    },

    //选择商品属性标签
    selectTag: function selectTag(index, item) {
      this.checkedTag[index].linkInfo = item;
    },

    //商品分页查询
    pageGoods: function pageGoods() {
      var _this3 = this;

      var links = [];
      if (this.checkedTag && this.checkedTag.length) {
        this.checkedTag.forEach(function (item) {
          var link = {};
          if (item.linkInfo && item.linkInfo.linkTarget) {
            link.linkType = item.linkInfo.linkType;
            link.linkTarget = item.linkInfo.linkTarget;
            links.push(link);
          }
        });
      }
      // //如当前
      // if(this.linkTarget && this.linkType){
      //  links.push({
      //    linkTarget:this.linkTarget,
      //    linkType:this.linkType
      //  })
      // }

      var keyWord = this.keyWord;
      var params = {
        links: links,
        keyWord: keyWord,
        sorts: this.sorts
      };

      if (this.$route.meta.savePosition) {
        this.pageNo = this.statePageNo;
        this.goodsList = this.shareGoodsLists;
        this.lastPageNo = this.lastPage;
        this.load = false;
        return;
      }

      this.pageShareGoods([params, this.pageNo, this.pageSize]).then(function (res) {
        res.result.forEach(function (item) {
          _this3.goodsList.push(item);
        });
        _this3.lastPageNo = Number(res.lastPageNo);
        _this3.total = Number(res.totalCount);
        _this3.currentPage = Number(res.currentPageNo);
        _this3.load = false;
      });
    },
    scanDetail: function scanDetail(storeid, goodid, skuId) {
      this.$router.push({
        path: '/main/goodsDetail?goodsId=' + goodid + '&storeId=' + storeid + '&skuId=' + skuId
      });
    },
    reset: function reset() {
      this.checkedTag = [];
    },
    seoRanking: function seoRanking() {
      if (this.seo) {
        this.seo = false;
      } else {
        this.asc = '';
        this.sorts = [];
        this.seo = true;
      }
      this.filter();
    },
    sale: function sale(action) {
      this.seo = false;
      var sort = {
        sortType: "1",
        sort: action
      };
      this.asc = action;
      this.sorts.push(sort);
      this.filter();
    },
    filter: function filter() {
      this.pageNo = 1;
      this.load = true;
      this.isColligate = false;
      this.rightPopup = false;
      this.goodsList = [];
      this.pageGoods();
    }
  }),
  components: {
    topLink: __WEBPACK_IMPORTED_MODULE_2__components_topLink_topLink___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default.a
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Vuex__ = __webpack_require__(45);

//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            load: true
        };
    },
    created: function created() {
        this.login();
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_Vuex__["a" /* mapActions */])({
        saveWxLogin: 'saveWxLogin',
        doLogin: 'doLogin',
        connectOauth2Authorize: 'connectOauth2Authorize', //5.2.生成微信网页授URL-用户同意授权获取code
        doWxMpLogin: 'doWxMpLogin',
        updateMemCartForUserLogin: 'updateMemCartForUserLogin'
    }), {
        login: function login() {
            var code = this.$route.query['code'] || __WEBPACK_IMPORTED_MODULE_2__common_utils_util_js__["c" /* default */].parseString(location.href, '&', 'code');
            //alert('CODE：'+code);
            //微信浏览器内，必须获取到CODE   && Constant.env.ENV_MODE == 'production'
            if (!code && this.util.isWeiXin()) {
                //alert('您是微信浏览器，必须获取CODE，将跳转至微信服务器...');
                return this.doWxOauth2AutoLogin();
            }

            this.toLoginPage(code);
        },
        toLoginPage: function toLoginPage(code) {
            var redirect = this.$route.query.redirect;
            var isQuestionLogin = this.$route.query.isQuestionLogin;
            //当前是大区问卷调查时跳转到wxLogin界面，否则跳转商城登录界面
            var pathUrl = isQuestionLogin == 'true' ? '/main/questionLogin' : '/main/login';
            this.$router.push({
                path: pathUrl,
                query: {
                    'redirect': redirect,
                    'code': code
                }
            });
        },


        // 请求微信授权登陆
        doWxOauth2AutoLogin: function doWxOauth2AutoLogin() {
            var redirectURL = this.$route.query.redirect || "";
            var prevFix = redirectURL.includes("?") ? "&autologin=true" : "?autologin=true";
            redirectURL += prevFix;

            this.connectOauth2Authorize([redirectURL]).then(function (res) {
                //alert('微信授权结果： doWxAutoLogin- '+JSON.stringify(res.target));
                if (res.target) {
                    // 重定向至微信
                    var url = res.target;

                    //alert('oauth2 授权后的URL >>> ' + url);
                    location.replace(url);
                }
            });
        },


        // 微信CODE登陆
        wxMemLoginByCode: function wxMemLoginByCode(code) {
            var _this = this;

            //alert("code:"+code)
            this.doWxMpLogin([code]).then(function (res) {
                //alert("doWxMpLogin-"+ JSON.stringify(res));
                if (res.success && res.target && res.target.success) {
                    var memData = res.target.target;
                    //alert("memData-"+ JSON.stringify(memData));

                    //调用loginCall/login方法，注册用户登录状态
                    _this.doLogin({
                        openId: memData.openId,
                        clientType: 'WEIXIN',
                        authToken: memData.authToken
                    }).then(function (res) {
                        //alert("调用loginCall-"+res)
                        var redirect = decodeURIComponent(_this.$route.query.redirect || '/');
                        _this.updateMemCartForUserLogin();
                        //完整URL
                        if (redirect.startsWith('http')) {
                            location.href = redirect;
                        } else {
                            _this.$router.push({
                                path: redirect
                            });
                        }
                    });
                } else {
                    //alert('微信CODE登录失败： '+(res && (res.message || res.target.message))|| "微信自动登录失败");
                    _this.toLoginPage();
                }
            }).catch(function (err) {
                //alert('微信CODE登录失败： '+JSON.stringify(err));
                _this.toLoginPage();
            });
        }
    })
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      mobile: null,
      authCode: null,
      getauthCodeTip: "获取验证码", //获取验证码按钮内容
      isGetauthCode: false, //是否点击获取二维码按钮
      tip: "",
      load: true,
      toast: {
        isShow: false,
        messageTip: ""
      },
      randomCodePath: "",
      randomCode: ""
    };
  },
  created: function created() {
    var _this = this;

    this.getLoginToken({
      p0: ""
    }).then(function (res) {
      _this.userAttrId = __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__["a" /* storage */].session.get("userAttrId");
      _this.randomCodePath = __WEBPACK_IMPORTED_MODULE_3__Constant__["a" /* default */].imgBaseUrl + "/random?v=" + Math.random() + "&userAttrId=" + _this.userAttrId;
    });

    this.load = false;
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      window.addEventListener("popstate", function (e) {
        // window.history.go(-2);//页面回退两次   ps:-> auth -> 之前页面
      }, false);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    sendAuthCodeSms: "sendAuthCodeSms",
    getLoginToken: "getLoginToken", //获取token
    quickLogin: "quickLogin",
    quickLoginWithCode: "quickLoginWithCode",
    doWxMpLogin: "doWxMpLogin",
    doLogin: "doLogin",
    saveWxLogin: "saveWxLogin",
    saveUserInfo: "saveUserInfo",
    logout: "logout",
    connectOauth2Authorize: "connectOauth2Authorize", //5.2.生成微信网页授URL-用户同意授权获取code
    updateMemCartForUserLogin: "updateMemCartForUserLogin"
  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this2 = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this2.toast.isShow = false;
      }, 1500);
    },

    //刷新图片验证码
    refreshImgCode: function refreshImgCode() {
      this.userAttrId = __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__["a" /* storage */].session.get("userAttrId");
      this.randomCodePath = __WEBPACK_IMPORTED_MODULE_3__Constant__["a" /* default */].imgBaseUrl + "/random?v=" + Math.random() + "&userAttrId=" + this.userAttrId;
    },
    goback: function goback() {
      window.history.go(-2);
    },
    loginOut: function loginOut() {
      this.logout([]).then(function (res) {
        //alert("退出成功")
        __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__["a" /* storage */].local.remove("userInfo");
        console.log("res", res);
      });
    },


    //表单填写有效
    isFormValid: function isFormValid() {
      return this.authCode && /^[0-9]{4,6}$/.test(this.authCode) && this.mobile && /^1\d{10}$/.test(this.mobile);
    },


    //是否微信浏览器
    isWxBrowser: function isWxBrowser() {
      return this.util.isWeiXin();
    },


    //获取验证码
    getValidateCode: function getValidateCode() {
      var _this3 = this;

      if (!/^1\d{10}$/.test(this.mobile)) {
        this.showTipMessage(true, "请输入正确的手机号码");
        return;
      }

      if (!this.randomCode) {
        this.showTipMessage(true, "请输入图片验证码");
        return;
      }

      this.sendAuthCodeSms([this.mobile, this.randomCode]).then(function (res) {
        _this3.intervalyz();
      });
      return;
    },

    // 开启验证码倒计时
    intervalyz: function intervalyz() {
      var _this4 = this;

      this.isGetauthCode = true;
      var conunt = 60;
      this.getauthCodeTip = conunt + "s后重新获取";
      this.yzInterval = setInterval(function () {
        conunt--;
        _this4.getauthCodeTip = conunt + "s后重新获取";
        if (conunt == 0) {
          _this4.getauthCodeTip = "重新获取验证码";
          clearInterval(_this4.yzInterval);
          _this4.isGetauthCode = false;
        }
      }, 1000);
    },
    checkMobile: function checkMobile() {
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.showTipMessage(true, "请输入正确的手机号码");
        // this.tip='请输入正确的手机号码'
        return;
      }
    },
    checkAuthCode: function checkAuthCode() {
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.showTipMessage(true, "请输入正确的手机号码");
        // this.tip='请输入正确的手机号码'
        return;
      }
      if (!/^[0-9]{4,6}$/.test(this.authCode)) {
        this.showTipMessage(true, "请输入正确的验证码");
        // this.tip='请输入正确的验证码'
        return;
      } else {
        this.tip = "";
      }
    },

    //登录
    login: function login() {
      //alert('当前地址：'+location.href);
      var wxCode = this.$route.query["code"] || this.util.parseString(location.href, "&", "code");

      //alert('mobile:'+this.mobile + ',authCode:' + this.authCode +',wxCode:'+wxCode)
      //this.quickLogin([this.mobile,this.authCode,'WEIXIN'])
      if (wxCode) {
        this.doLoginWithWxCode(wxCode);
      } else {
        this.doLoginWithUnWxCode();
      }
    },
    doLoginWithWxCode: function doLoginWithWxCode(wxCode) {
      var _this5 = this;

      this.quickLoginWithCode([this.mobile, this.authCode, wxCode]).then(function (res) {
        //alert('quickLoginWithCode:' + JSON.stringify(res))
        return _this5.doLogin({
          openId: res.openId,
          clientType: "WEIXIN",
          authToken: res.authToken
        });
      }).then(function (res) {
        _this5.showTipMessage(true, "登录成功");
        _this5.updateMemCartForUserLogin();
        var redirect = decodeURIComponent(_this5.$route.query.redirect || "/");
        //完整URL
        if (redirect.startsWith("http")) {
          location.href = redirect;
        } else {
          _this5.$router.push({
            path: redirect
          });
        }
      }).catch(function (err) {
        _this5.showTipMessage(true, err || "登录失败");
      });
    },
    doLoginWithUnWxCode: function doLoginWithUnWxCode() {
      var _this6 = this;

      this.quickLogin([this.mobile, this.authCode, "WEIXIN"]).then(function (res) {
        // alert('quickLogin:' + JSON.stringify(res))
        return _this6.doLogin({
          openId: res.openId,
          clientType: "WEIXIN",
          authToken: res.authToken
        });
      }).then(function (res) {
        console.log(res);
        _this6.showTipMessage(true, "登录成功");
        _this6.updateMemCartForUserLogin();
        var redirect = decodeURIComponent(_this6.$route.query.redirect || "/");
        //完整URL
        if (redirect.startsWith("http")) {
          location.href = redirect;
        } else {
          _this6.$router.push({
            path: redirect
          });
        }
      }).catch(function (err) {
        _this6.showTipMessage(true, err || "登录失败");
      });
    },


    //微信授权登录
    loginForWx: function loginForWx() {
      //获取授权
      this.doWxAutoLogin();
    },
    doWxAutoLogin: function doWxAutoLogin() {
      var _this7 = this;

      var wxCode = this.$route.query.code;
      //alert("doWxAutoLogin code:"+wxCode);

      this.doWxMpLogin([wxCode]).then(function (res) {
        //alert("doWxMpLogin-"+ JSON.stringify(res));
        if (res.success && res.target && res.target.success) {
          var memData = res.target.target;
          //alert("memData-"+ JSON.stringify(memData));

          //调用loginCall/login方法，注册用户登录状态
          _this7.doLogin({
            openId: memData.openId,
            clientType: "WEIXIN",
            authToken: memData.authToken
          }).then(function (res) {
            //alert("调用loginCall-"+res)
            var redirect = decodeURIComponent(_this7.$route.query.redirect || "/");
            _this7.updateMemCartForUserLogin();
            //完整URL
            if (redirect.startsWith("http")) {
              location.href = redirect;
            } else {
              _this7.$router.push({
                path: redirect
              });
            }
          });
        } else {
          //alert('微信CODE登录失败： '+(res && (res.message || res.target.message))|| "微信自动登录失败");
          _this7.toLoginPage();
        }
      }).catch(function (err) {
        //alert('微信CODE登录失败： '+JSON.stringify(err));
        _this7.toLoginPage();
      });
    },
    doWxAutoLoginbk: function doWxAutoLoginbk() {
      var redirectURL = this.$route.query.redirect || "";
      var prevFix = redirectURL.includes("?") ? "&autologin=true" : "?autologin=true";
      redirectURL += prevFix;

      this.connectOauth2Authorize([redirectURL]).then(function (res) {
        //alert('微信授权结果： doWxAutoLogin- '+JSON.stringify(res.target));
        if (res.target) {
          // 重定向至微信
          var url = res.target;

          //alert('oauth2 授权后的URL >>> ' + url);
          location.replace(url);
        }
      });
    },


    // 感谢语
    tQHandler: function tQHandler() {
      alert("美心商城欢迎您！竭诚为您服务！");
    }
  }),
  components: {
    imgs: __WEBPACK_IMPORTED_MODULE_1__components_image_image___default.a
  }
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      nickName: '',
      toast: false, //提示文字为空
      successMsg: false //修改成功
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    doSetNickName: 'doSetNickName' //设置会员昵称api
  }), {
    save: function save() {
      var _this = this;

      if (this.nickName == '' || this.nickName == null) {
        this.nickName = '';
        this.toast = true;
        setTimeout(function () {
          _this.toast = false;
        }, 1500);
      } else {
        this.itDoSetNickName(this.nickName);
        this.$router.push({
          path: '/main/userinfo'
        });
      }
    },

    //设置会员昵称api
    itDoSetNickName: function itDoSetNickName(nickName) {
      var _this2 = this;

      this.doSetNickName(nickName).then(function (res) {
        _this2.successMsg = true;
        setTimeout(function () {
          _this2.successMsg = false;
        }, 1500);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a
  },
  created: function created() {
    if (this.$route.query.nickName == 'null') {
      this.nickName = '';
      return;
    } else if (this.$route.query.nickName != 'null') {
      this.nickName = this.$route.query.nickName;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadShow: true,
      evaluation: false, //生产中、已发货  联系客服
      tags: [{ name: "大品牌，值得信赖", id: 1 }, { name: "服务好", id: 2 }, { name: "质量真", id: 3 }, { name: "赞", id: 9 }, { name: "货真价实", id: 4 }, { name: "外观漂亮大方", id: 5 }, { name: "物美价廉", id: 6 }, { name: "款式独特", id: 7 }, { name: "做工精细", id: 8 }],
      seltags: [],
      cartData: [{
        id: '1',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1
      }],
      comment: "",
      remnant: 200,
      serveStar: 0, //服务星数量
      priceStar: 0, //价格星数量
      goodsStar: 0, //商品星数量
      commId: this.$route.query.commId ? this.$route.query.commId : null, //查询商品评价详情需传值;
      stOrderId: this.$route.query.stOrderId, //获取还为评价需传值;
      orderId: this.$route.query.orderId,
      notCommentGoodsListMsg: [], //获取还未平列表
      getGoodsCommentEditShow: {} //获取当前评价信息
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapActions"])({
    getNotCommentGoods: 'getNotCommentGoods', //获取还未评价的商品
    getGoodsComment: 'getGoodsComment', //获取当前商品评价详情
    modGoodsComment: 'modGoodsComment', //修改商品评价
    addGoodsComment: 'addGoodsComment' //新增商品评价
  }), {
    //点击新增星星
    starAddBtn: function starAddBtn(starAdd, index, starIndex) {
      var obj = this.notCommentGoodsListMsg[index];
      obj.commentStars[starIndex].starScore = starAdd;
      this.$set(this.notCommentGoodsListMsg, index, obj);
    },

    //点击修改星星
    starEditBtn: function starEditBtn(starEdit, starEditIndex) {
      this.getGoodsCommentEditShow.commentStars[starEditIndex].starScore = starEdit;
    },

    //新增选择标签
    selectTag: function selectTag(tagIndex, index) {
      var obj = this.notCommentGoodsListMsg[index];
      if (obj.commentTags[tagIndex].selected == 1) {
        obj.commentTags[tagIndex].selected = 0;
      } else {
        obj.commentTags[tagIndex].selected = 1;
      }
      this.$set(this.notCommentGoodsListMsg, index, obj);
    },

    //修改选择标签
    selectEditTag: function selectEditTag(tagEditIndex) {
      if (this.getGoodsCommentEditShow.commentTags[tagEditIndex].selected == 1) {
        this.getGoodsCommentEditShow.commentTags[tagEditIndex].selected = 0;
      } else {
        this.getGoodsCommentEditShow.commentTags[tagEditIndex].selected = 1;
      }
    },

    //评论输入是检测字数
    commentInput: function commentInput() {
      var txtVal = this.getGoodsCommentEditShow.commDesc.length;
      this.remnant = 200 - txtVal;
    },
    notcommentInput: function notcommentInput(index) {
      var txtVal = this.notCommentGoodsListMsg[index].commDesc.length;
      this.remnant = 200 - txtVal;
    },
    closeEvaluation: function closeEvaluation() {
      this.evaluation = false;
      this.$router.push({
        path: '/main/mycomments'
      });
    },

    //提交评判断(新增或者修改)
    goEvaluation: function goEvaluation(id) {
      if (this.commId == null) {
        var upMsg = []; //提交表单的值
        this.notCommentGoodsListMsg.forEach(function (item, index) {
          var commentTagsAdd = [];
          item.commentTags.forEach(function (selectAdd) {
            var changeAdd = {
              tagId: selectAdd.selected == 1 ? selectAdd.tagId : null
            };
            commentTagsAdd.push(changeAdd);
          });
          var msgAllLiset = {
            instSkuId: item.instSkuId,
            goodsId: item.goodsId,
            skuId: item.skuId,
            commentStars: item.commentStars,
            commentTags: commentTagsAdd,
            commentDesc: item.commDesc
          };
          upMsg.push(msgAllLiset);
          return upMsg;
        });
        this.getAddGoodsComment(this.stOrderId, this.orderId, upMsg);
      } else if (this.commId != null) {
        this.getGoodsCommentEditShow;
        var commentTagsEdit = [];
        this.getGoodsCommentEditShow.commentTags.forEach(function (selectItem, selectindex) {
          var changeTags = {
            tagId: selectItem.selected == 1 ? selectItem.tagId : null
          };
          commentTagsEdit.push(changeTags);
          return commentTagsEdit;
        });
        var editMsg = {
          instSkuId: this.getGoodsCommentEditShow.instSkuId,
          goodsId: this.getGoodsCommentEditShow.goodsId,
          skuId: this.getGoodsCommentEditShow.skuId,
          commentStars: this.getGoodsCommentEditShow.commentStars,
          commentTags: commentTagsEdit,
          commentDesc: this.getGoodsCommentEditShow.commDesc
        };
        this.getModGoodsComment(this.commId, editMsg);
      }
    },

    //修改评价......
    getModGoodsComment: function getModGoodsComment(commId, getGoodsCommentEditShow) {
      var _this = this;

      this.modGoodsComment([commId, getGoodsCommentEditShow]).then(function (res) {
        //console.log
        "修改商品评价成功", res;
        _this.evaluation = true;
      }).catch(function (error) {});
    },

    //获取还未评价的商品
    getNotCommentGoodsList: function getNotCommentGoodsList(stOrderId) {
      var _this2 = this;

      this.getNotCommentGoods(stOrderId).then(function (res) {
        _this2.loadShow = false; //关闭加载
        _this2.notCommentGoodsListMsg = res; //保存为评价列表
        _this2.notCommentGoodsListMsg.forEach(function (item) {
          item.instSkuId = item.instSkuId ? item.instSkuId : null;
          item.goodsId = item.goodsId ? item.goodsId : null;
          item.skuId = item.skuId ? item.skuId : null;
          item.commentTags = item.commentTags ? item.commentTags : [];
          item.commentStars = item.commentStars ? item.commentStars : [];
          item.commentDesc = item.commentDesc ? item.commentDesc : null;
        });
      });
    },

    //获取当前商品评价详情
    getGoodsCommentMsg: function getGoodsCommentMsg(commId) {
      var _this3 = this;

      this.getGoodsComment(this.commId).then(function (res) {
        _this3.loadShow = false;
        _this3.getGoodsCommentEditShow = res.target;
        _this3.commentInput();
      });
    },

    //新增当前商品详情
    getAddGoodsComment: function getAddGoodsComment(stOrderId, orderId, upMsg) {
      var _this4 = this;

      this.addGoodsComment([stOrderId, orderId, upMsg]).then(function (res) {
        _this4.evaluation = true;
      });
    }
  }),
  watch: {},
  created: function created() {
    this.getNotCommentGoodsList(this.stOrderId); //获取还为评价的商品
    if (this.commId) {
      this.getGoodsCommentMsg(this.commId); //获取当前商品详情
    }
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadShow: true,
      loading: false,
      scroller: null,
      pageNo: 1,
      pageSize: 10,
      total: 0, //z总数量
      currentPage: 0,
      lastPageNo: 1, //总共页面数量
      invoiceList: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    pageMemOrderInvoice: 'pageMemOrderInvoice' //获取发票信息
  }), {
    // 加载更多
    loadMore: function loadMore() {
      var _this2 = this;

      if (this.lastPageNo == this.pageNo) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.getpageMemOrderInvoice();
        setTimeout(function () {
          _this2.loading = false;
        }, 2000);
      }
    },
    getpageMemOrderInvoice: function getpageMemOrderInvoice() {
      var _this3 = this;

      this.pageMemOrderInvoice([this.pageNo, this.pageSize]).then(function (res) {
        _this3.loadShow = false;
        var _this = _this3;
        res.result.forEach(function (item) {
          _this.invoiceList.push(item);
        });
        // this.invoiceList = res.result;
        _this3.lastPageNo = Number(res.lastPageNo);
        _this3.currentPage = Number(res.currentPageNo);
        _this3.total = Number(res.totalCount);
      }).catch(function (error) {
        console.log(error);
        // this.$message.error(error);
      });
    }
  }),
  watch: {},
  mounted: function mounted() {
    this.scroller = document.querySelectorAll('.orders-list')[0];
    console.log(this.scroller);
    this.getpageMemOrderInvoice();
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_empty_empty__);
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {};
	},

	methods: {},
	watch: {},
	components: {
		menus: __WEBPACK_IMPORTED_MODULE_0__components_menus_menus___default.a,
		myOrdersItem: __WEBPACK_IMPORTED_MODULE_1__components_myOrdersItem_myOrdersItem___default.a,
		empty: __WEBPACK_IMPORTED_MODULE_2__components_empty_empty___default.a
	}
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadShow: true,
      defaultAddress: "",
      isDelete: false, //删除弹框
      listAddressMsg: [], //所有收货地址
      addressId: '', //获取当前选中的地址
      toast1: false, //提示设置信息
      toast2: false //删除成功提示
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    removeAddress: 'removeAddress', //删除收货地址
    addAddress: 'addAddress', //新增收货地址
    editAddress: 'editAddress', //修改收货地址
    listAreaMsg: 'listAreaMsg', //获取地域列表
    getAddress: 'getAddress', //获取地址列表
    listAddress: 'listAddress', //直接列出收货地址列表
    doSetDefaultAddress: 'doSetDefaultAddress' //设置为默认地址
  }), {
    //修改地址
    editAddress: function editAddress(addressId, memId) {
      this.$router.push({
        path: '/main/writeaddress?addressId=' + addressId + '&memId=' + memId
      });
    },

    //删除地址
    deleteAddress: function deleteAddress(addressId) {
      this.addressId = addressId; //当前需要删除的Id
      this.isDelete = true;
    },

    //调用删除api 并关闭事件
    closedeleteAddress: function closedeleteAddress() {
      this.getRemoveAddress(this.addressId);
    },

    //设置默认地址按钮
    changeCheck: function changeCheck(addressId, isDefault) {
      if (isDefault == 0) {
        console.log("状态:", addressId + "获取的地址" + isDefault);
        this.getDoSetDefaultAddress(addressId, 1);
      } else if (isDefault == 1) {
        return;
      }
    },

    //addAddress跳转新增地址
    addAddress: function addAddress() {
      this.$router.push({
        path: '/main/writeaddress'
      });
    },

    //设置默认地址api
    getDoSetDefaultAddress: function getDoSetDefaultAddress(addressId, isDefault) {
      var _this2 = this;

      this.doSetDefaultAddress([addressId, isDefault]).then(function (res) {
        _this2.getlistAddress(); //重新获取页面
        _this2.toast1 = true;
        setTimeout(function () {
          _this2.toast1 = false;
        }, 1500);
      });
    },

    //删除收货地址api
    getRemoveAddress: function getRemoveAddress(addressId) {
      var _this3 = this;

      this.removeAddress(addressId).then(function (res) {
        _this3.isDelete = false;
        _this3.getlistAddress(); //重新加载页面
        _this3.toast2 = true;
        setTimeout(function () {
          _this3.toast2 = false;
        }, 1500);
      }).catch(function (error) {});
    },
    getlistAddress: function getlistAddress() {
      var _this4 = this;

      var _this = this;
      //直接列出收货地址列表
      this.listAddress().then(function (res) {
        _this4.loadShow = false;
        _this4.listAddressMsg = res;
        _this4.listAddressMsg.forEach(function (item, index) {
          if (item.isDefault == 1) {
            _this.defaultAddress = item.addressId;
          }
        });
      }).catch(function (error) {});
    }
  }),
  watch: {},
  mounted: function mounted() {
    this.getlistAddress();
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var cartData = [];
    for (var i = 0; i < 11; i++) {
      cartData.push({
        id: '1',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: i
      });
    }
    return {
      loadShow: true,
      Height: document.body.clientHeight - 40,
      cartData: cartData,
      checkboxsel: [], //选中的favId
      allChecked: false, //全选状态
      editstate: false, //编辑状态
      isDelete: false, //删除弹框
      toast1: false, //没有选中提示框
      toast2: false, //删除成功提示框
      num: 10,
      loading: false, //加载
      scroller: null,
      refreshing: false,
      trigger: null,
      listPageGoodsFav: [], //获取我的收藏
      pageNo: 1,
      pageSize: 10,
      currentPage: 1, //当前页
      lastPageNo: 1, //总共页面数量
      size: null, //当前收藏条数
      goodsName: '' //商品名称
    };
  },

  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    pageGoodsFav: 'pageGoodsFav', //获取收藏信息
    delGoodsFavBatch: 'delGoodsFavBatch', //批量删除我的收藏
    delGoodsFav: 'delGoodsFav' //删除我的收藏
  }), {
    // 加载更多
    loadMore: function loadMore() {
      var _this2 = this;

      if (this.lastPageNo == this.pageNo) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.getPageGoodsFav();
        setTimeout(function () {
          _this2.loading = false;
        }, 2000);
      }
    },
    refresh: function refresh() {
      var _this3 = this;

      this.refreshing = true;
      setTimeout(function () {
        var list = [];
        for (var i = _this3.num; i < _this3.num + 10; i++) {
          list.push({
            id: '1',
            title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
            img: "/static/images/headImg.jpg",
            describe: "油漆门特权订金（特价门型不可用）",
            price: i
          });
        }
        _this3.listPageGoodsFav = list;
        _this3.num += 10;
        _this3.refreshing = false;
      }, 2000);
    },

    //子组件传数据   判断并勾选
    onResultChange: function onResultChange(val) {
      this.checkboxsel = val;
      if (this.checkboxsel.length === this.listPageGoodsFav.length) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
      //console.log("需要修改的数据", this.checkboxsel)
    },

    //点击数据列表时间
    clickItem: function clickItem(id) {
      if (this.editstate) {
        //编辑状态，勾选
        // 编辑状态 点击列表
        // 如未勾选   勾选对应的
        // 已勾选   则取消勾选
        var isSel = false;
        var _this = this;
        for (var i = 0; i < _this.checkboxsel.length; i++) {
          if (_this.checkboxsel[i] == id) {
            _this.checkboxsel.splice(i, 1);
            isSel = true;
          }
        }
        if (!isSel) {
          this.checkboxsel.push(id);
        }
      } else {
        //进入产品详情页
        this.$router.push({
          path: '/main/myredpack'
        });
      }
    },
    //取消收藏
    deleteItem: function deleteItem() {
      var _this4 = this;

      if (this.checkboxsel.length > 0) {
        this.isDelete = true;
      } else {
        this.toast1 = true;
        if (this.toast1Timer) clearTimeout(this.toast1Timer);
        this.toast1Timer = setTimeout(function () {
          _this4.toast1 = false;
        }, 1500);
      }
    },

    //关闭弹框  判断是批量删除还是单个删除
    closedeleteAddress: function closedeleteAddress() {
      if (this.checkboxsel.length <= 1) {
        this.getDelGoodsFav(this.checkboxsel[0]);
      } else if (this.checkboxsel.length >= 2) {
        this.getDelGoodsFavBatch(this.checkboxsel);
      }
    },

    //选择全部
    selectAll: function selectAll(checked) {
      var _this = this;
      if (checked) {
        //实现反选
        _this.checkboxsel = [];
        _this.listPageGoodsFav.forEach(function (item) {
          _this.checkboxsel.push(item.favId);
        });
      } else {
        //实现全选
        _this.checkboxsel = [];
      }
    },

    //批量删除api
    getDelGoodsFavBatch: function getDelGoodsFavBatch(favId) {
      var _this5 = this;

      this.delGoodsFavBatch(favId).then(function (res) {
        _this5.isDelete = false;
        _this5.toast2 = true;
        setTimeout(function () {
          _this5.toast2 = false;
        }, 1500);
        _this5.getPageGoodsFav(_this5.goodsName, _this5.pageNo, _this5.pageSize);
      }).catch(function (error) {});
    },

    //删除我的收藏
    getDelGoodsFav: function getDelGoodsFav(favId) {
      var _this6 = this;

      this.delGoodsFav(favId).then(function (res) {
        _this6.isDelete = false;
        _this6.toast2 = true;
        setTimeout(function () {
          _this6.toast2 = false;
        }, 1500);
        _this6.getPageGoodsFav(_this6.goodsName, _this6.pageNo, _this6.pageSize);
      });
    },

    //获取我的收藏列表
    getPageGoodsFav: function getPageGoodsFav() {
      var _this7 = this;

      this.pageGoodsFav([this.goodsName, this.pageNo, this.pageSize]).then(function (res) {
        _this7.loadShow = false;
        res.target.result.forEach(function (item) {
          _this7.listPageGoodsFav.push(item);
        });
        // this.listPageGoodsFav = res.target.result;
        _this7.size = res.target.totalCount;
        _this7.lastPageNo = Number(res.target.lastPageNo);
        _this7.currentPage = Number(res.target.currentPageNo);
      });
    }
  }),
  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
  },
  mounted: function mounted() {
    this.scroller = document.querySelectorAll('.collection-list')[0];
    console.log(this.scroller);
    // this.scroller = this.$el;
    this.trigger = this.$el;
  },
  created: function created() {
    //获取我的收藏列表
    this.getPageGoodsFav([this.goodsName, this.pageNo, this.pageSize]);
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loadShow: true,
      isDelete: false, //删除弹框
      cartData: [{
        id: '1',
        title: "防火防盗",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1
      }],
      num: 10,
      loading: false,
      scroller: null,
      pageNo: 1, //页码
      pageSize: 5, //页量
      total: 0, //z总数量
      lastPageNo: 1, //总共页面数量
      currentPage: 0,
      commId: '', //订单号
      getGoodsCommentList: [] //获取评价列表
    };
  },
  mounted: function mounted() {
    this.scroller = document.querySelectorAll('.orders-list')[0];
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    pageGoodsComment: 'pageGoodsComment', //获取分页商品评价
    delGoodsComment: 'delGoodsComment' //删除我的商品评价
  }), {
    // 加载更多
    loadMore: function loadMore() {
      var _this2 = this;

      if (this.lastPageNo == this.pageNo) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.getpageGoodsComment();
        setTimeout(function () {
          _this2.loading = false;
        }, 2000);
      }
    },

    //修改评价evaluation
    editAddress: function editAddress(commId) {
      this.$router.push({
        path: '/main/evaluation?commId=' + commId
      });
    },

    //打开当前删除的弹框
    deleteAddress: function deleteAddress(commId) {
      this.commId = commId;
      this.isDelete = true;
    },

    //关闭弹框
    closedeleteAddress: function closedeleteAddress() {
      this.getDelGoodsComment(this.commId);
      this.isDelete = false;
    },

    //删除地址api调用
    getDelGoodsComment: function getDelGoodsComment(commId) {
      var _this3 = this;

      this.delGoodsComment(commId).then(function (res) {
        _this3.pageGoodsComment(_this3.pageNo, _this3.pageSize);
      });
    },
    getpageGoodsComment: function getpageGoodsComment() {
      var _this4 = this;

      var _this = this;
      //获取我的评价列表
      this.pageGoodsComment([this.pageNo, this.pageSize]).then(function (result) {
        result.result.forEach(function (item) {
          _this.getGoodsCommentList.push(item);
        });
        // this.getGoodsCommentList = result.result;
        _this4.lastPageNo = Number(result.lastPageNo);
        _this4.currentPage = Number(result.currentPageNo);
        _this4.total = Number(result.totalCount);
        _this4.loadShow = false;
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  }),
  watch: {},
  created: function created() {
    this.getpageGoodsComment();
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Vuex__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      delCoupon: false, //删除确认弹框
      temp: 0, //临时存储id
      activeTab: 'tab1',
      scandetailid: [],
      loadShow: true, //加载
      num: 10,
      loading: false,
      scroller: null,
      pageNo: 1,
      pageSize: 10,
      total: 0, //z总数量
      lastPageNo: 1, //总共页面数量
      currentPage: 0,
      memCouponMsg: [], //获取我的优惠券列表有效
      memCouponMsgExpireList: [], //无效优惠券
      toast1: false //删除提示信息
    };
  },
  mounted: function mounted() {
    this.scroller = document.querySelectorAll('.coupon-list')[0];
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_Vuex__["a" /* mapActions */])({
    pageMemCoupon: 'pageMemCoupon', //获取我的优惠券
    delMemCoupon: 'delMemCoupon' //删除优惠券
  }), {
    // 加载更多
    loadMore: function loadMore() {
      var _this = this;

      var type = 0;
      if (this.activeTab == 'tab1') {
        type = 0;
      } else if (this.activeTab == 'tab2') {
        type = 2;
      }
      if (this.lastPageNo == this.currentPage) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.getPageMemCoupon(type, this.pageNo, this.pageSize);
        setTimeout(function () {
          _this.loading = false;
        }, 2000);
      }
    },
    tabHeaderOne: function tabHeaderOne(type) {
      if (this.activeTab == 'tab1') {
        return;
      }
      this.loadShow = true; //加载
      this.activeTab = 'tab1';
      // 数据列表清空
      this.pageNo = 1;
      this.memCouponMsg = [];
      this.getPageMemCoupon(type, this.pageNo, this.pageSize);
    },

    //打开已经失效的优惠券
    tabHeaderTwo: function tabHeaderTwo(type) {
      if (this.activeTab == 'tab2') {
        return;
      }
      this.loadShow = true; //加载
      this.activeTab = 'tab2';
      // 数据列表清空
      this.pageNo = 1;
      this.memCouponMsg = [];
      this.getPageMemCoupon(type, this.pageNo, this.pageSize);
    },

    //检查详情是否打开
    check: function check(index) {
      for (var i = 0; i < this.scandetailid.length; i++) {
        if (this.scandetailid[i] == index) return true;
      }
    },

    //打开详情
    scandetail: function scandetail(index) {
      if (this.check(index)) {
        //检查标签已经选中
        for (var i = 0; i < this.scandetailid.length; i++) {
          if (this.scandetailid[i] == index) this.scandetailid.splice(i, 1);
        }
      } else {
        this.scandetailid.push(index);
      }
    },

    //删除我的优惠券按钮
    deleteitem: function deleteitem(couponInstId) {
      this.delCoupon = true;
      this.temp = couponInstId;
      // this.getDelMemCoupon(couponInstId);
    },

    //进入订单详情
    gouse: function gouse(storeId, useType) {
      this.$router.push({
        path: '/main/brandHome?linkTarget=' + storeId + '&linkType=' + useType
      });
    },

    //获取我的优惠券列表api
    getPageMemCoupon: function getPageMemCoupon(couponState, pageNo, pageSize) {
      var _this2 = this;

      this.pageMemCoupon([couponState, pageNo, pageSize]).then(function (res) {
        // this.memCouponMsg = res.result; //未使用的
        res.result.forEach(function (item) {
          _this2.memCouponMsg.push(item);
        });
        _this2.lastPageNo = Number(res.lastPageNo);
        _this2.currentPage = Number(res.currentPageNo);
        _this2.total = Number(res.totalCount);
        _this2.loadShow = false; //加载结束
      }).catch(function (error) {});
    },

    //删除当签优惠券api
    getDelMemCoupon: function getDelMemCoupon(couponInstId) {
      var _this3 = this;

      this.delMemCoupon(couponInstId).then(function (res) {
        _this3.delCoupon = false;
        _this3.toast1 = true;
        setTimeout(function () {
          _this3.toast1 = false;
        }, 1500);
        _this3.getPageMemCoupon(0, _this3.pageNo, _this3.pageSize);
      }).catch(function (error) {});
    }
  }),
  created: function created() {

    //获取我的优惠券列表
    this.getPageMemCoupon(0, this.pageNo, this.pageSize);

    //this.getDelMemCoupon(32132132);
  },

  watch: {},
  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      type: this.$route.query.type || 1, //订单类别
      loadShow: true, //加载
      loadorderCount: true, //加载订单数量
      quitOrder: false, //取消订单
      chargeBack: false, //申请退单
      contactService: false, //生产中、已发货  联系客服
      activeTab: "tab1",
      value: [], //选中的id
      scrolled: 0, //监听滚动事件
      num: 3,
      loading: false,
      scroller: null,
      pageMemOrderList: [], //获取列表
      pageNo: 1, //页码
      pageSize: 10, //页量
      total: 0, //z总数量
      lastPageNo: 1, //总共页面数量
      currentPage: 0,
      orderTab: this.$route.query.type ? this.$route.query.type : 1, //查询条件
      queryText: "",
      countNumber: {},
      allMemOrderCount: null,
      memOrderDetailMsg: [],
      settleDatas: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "settleDatas", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "OrderSettleMsg", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "toast", {
      isShow: false,
      messageTip: ""
    }), _ref;
  },
  mounted: function mounted() {
    this.scroller = document.querySelectorAll(".orders-list")[0];
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapActions"])({
    getMemOrderCount: "getMemOrderCount", //查询各个订单数
    pageMemOrder: "pageMemOrder", //分页查询订单
    cancelMemOrder: "cancelMemOrder", //取消订单
    applyBackOrder: "applyBackOrder", //申请退单
    getOrderSettleMsgForOrder: "getOrderSettleMsgForOrder" //重新购买
  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this2 = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this2.toast.isShow = false;
      }, 500);
    },

    //搜索订单
    searchOrder: function searchOrder() {
      if (this.queryText == "") {
        return;
      }
      this.orderTab = 1;
      this.getPageMemOrder(this.queryText, this.orderTab, this.pageNo, this.pageSize);
    },

    //判断是取消订单还是申请退单还是线下操作
    cancelOrder: function cancelOrder(stated, stOrderId) {
      this.stOrderId = stOrderId;
      if (stated == 0) {
        this.quitOrder = true;
      } else if (stated == 4 || stated == 1 || stated == 3) {
        this.chargeBack = true;
      } else {
        this.contactService = true;
      }
    },
    jumpSearchBelowOrders: function jumpSearchBelowOrders() {
      this.$router.push({ path: "/main/searchbeloworders" });
    },
    shareJump: function shareJump(stOrderId, orderId) {
      this.$router.push({
        path: "/main/publishsunhome?stOrderId=" + stOrderId + "&orderId=" + orderId
      });
    },

    //跳转去评价
    evaluateJump: function evaluateJump(stOrderId, orderId) {
      this.$router.push({
        path: "/main/evaluation?stOrderId=" + stOrderId + "&orderId=" + orderId
      });
      //this.$router.push({ path: '/main/quitsuccess' });
    },

    // 初始化店铺结算信息
    initSettleDatas: function initSettleDatas(stOrderId, OrderSettleMsg) {
      var _this = this;
      var settleDatas = [];
      var couponAmounts = [];
      var redpacketAmounts = [];
      console.log(OrderSettleMsg);
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用优惠券",
            couponAmount: 0
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: "0",
            couponName: "不使用红包",
            couponAmount: 0
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        var instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function (sub) {
          //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });
        settleDatas.push({
          stOrderId: stOrderId,
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId: "0",
          remark: "",
          dealerCode: ""
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0);
        redpacketAmounts.push(0);
      });
      var orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.set("orderData", orderData);
    },

    //立即支付
    orderSubmit: function orderSubmit(id, stOrderId, orderId) {
      var _this3 = this;

      var _this = this;
      this.getOrderSettleMsgForOrder(stOrderId).then(function (res) {
        _this3.OrderSettleMsg = res.target.target;
        _this3.initSettleDatas(stOrderId, res.target.target); // 初始化店铺结算信息
        _this3.$router.push({
          path: "/main/firmorder?orderId=" + orderId
        });
      });
    },

    //立即购买
    buyNow: function buyNow(stOrderId, orderId) {
      var _this4 = this;

      var _this = this;
      this.getOrderSettleMsgForOrder(stOrderId).then(function (res) {
        _this4.initSettleDatas(stOrderId, res.target.target); // 初始化店铺结算信息
        _this4.$router.push({
          path: "/main/firmorder"
        });
      });
    },

    //不同状态的订单;
    stateClick: function stateClick(upNo) {
      if (this.activeTab == "tab" + upNo) {
        return false;
      }
      this.loadShow = true; //加载
      this.orderTab = upNo;
      this.activeTab = "tab" + upNo;
      // 数据列表清空
      this.pageNo = 1;
      this.pageMemOrderList = [];
      this.getPageMemOrder(this.queryText, this.orderTab, this.pageNo, this.pageSize);
      this.getMemOrderCountWay();
    },

    //跳转订单详情
    gotoOrderDetail: function gotoOrderDetail(stOrderId, orderState, commonFinished) {
      // console.log('去评价', commonFinished);
      this.$router.push({
        path: "/main/orderdetail?stOrderId=" + stOrderId + "&orderState=" + orderState + "&commonFinished= " + commonFinished
      });
      return;
    },

    // 加载更多
    loadMore: function loadMore() {
      var _this5 = this;

      if (this.lastPageNo == this.pageNo) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.getPageMemOrder(this.queryText, this.orderTab, this.pageNo, this.pageSize);
        setTimeout(function () {
          _this5.loading = false;
        }, 2000);
      }
    },

    //状态栏切换
    handleTabChange: function handleTabChange(val) {
      this.activeTab = val;
    },

    //取消订单
    doQuitOrder: function doQuitOrder(id) {
      this.getCancelMemOrder(this.stOrderId);
    },

    //关闭取消订单弹框
    closeQuitOrder: function closeQuitOrder() {
      this.quitOrder = false;
    },

    //关闭联系客服
    closeContactService: function closeContactService() {
      this.contactService = false;
    },

    //拨打电话
    phoneCall: function phoneCall(tel) {
      this.contactService = false;
      window.location.href = "tel://" + tel;
    },

    //申请退单
    doChargeBack: function doChargeBack() {
      this.getApplyBackOrder(this.stOrderId);
      this.chargeBack = false;
    },

    //关闭申请退单弹框
    closeChargeBack: function closeChargeBack() {
      this.chargeBack = false;
    },

    //立即支付
    goPay: function goPay(id) {
      console.log("支付" + id);
    },

    //进入订单详情
    orderdetail: function orderdetail() {
      this.$router.push({
        path: "/main/orderdetail"
      });
    },

    //获取订单列表详情api
    getPageMemOrder: function getPageMemOrder(queryText, orderTab, pageNo, pageSize) {
      var _this6 = this;

      this.pageMemOrder([queryText, orderTab, pageNo, pageSize]).then(function (res) {
        _this6.loadShow = false; //加载关闭
        // this.pageMemOrderList = res.result;
        res.result.forEach(function (item) {
          _this6.pageMemOrderList.push(item);
        });
        _this6.lastPageNo = Number(res.lastPageNo);
        _this6.currentPage = Number(res.currentPageNo);
        _this6.total = Number(res.totalCount);
      }).catch(function (error) {
        _this6.showTipMessage(true, error || "获取数据失败,请稍后重试");
      });
    },

    //取消订单api
    getCancelMemOrder: function getCancelMemOrder(stOrderId) {
      var _this7 = this;

      this.cancelMemOrder(stOrderId).then(function (res) {
        _this7.showTipMessage(true, "已成功取消订单");
        _this7.quitOrder = false;
        // 数据列表清空
        _this7.pageNo = 1;
        _this7.pageMemOrderList = [];
        _this7.getPageMemOrder(_this7.queryText, _this7.orderTab, _this7.pageNo, _this7.pageSize);
        _this7.getMemOrderCountWay();
      }).catch(function (error) {
        _this7.showTipMessage(true, error || "取消失败,请稍后重试");
      });
    },
    //申请退单api
    getApplyBackOrder: function getApplyBackOrder(stOrderId) {
      var _this8 = this;

      this.applyBackOrder([stOrderId, "mobile"]).then(function (res) {
        _this8.showTipMessage(true, "退单申请已提交");
        _this8.getMemOrderCountWay();
        // 数据列表清空
        _this8.pageNo = 1;
        _this8.pageMemOrderList = [];
        _this8.getPageMemOrder(_this8.queryText, _this8.orderTab, _this8.pageNo, _this8.pageSize);
      }).catch(function (error) {
        _this8.showTipMessage(true, error || "退单失败,请稍后重试");
      });
    },

    //查询各自订单数
    getMemOrderCountWay: function getMemOrderCountWay() {
      var _this9 = this;

      this.getMemOrderCount().then(function (res) {
        _this9.countNumber = res;
        _this9.allMemOrderCount = parseInt(_this9.countNumber.waitPayNum) + parseInt(_this9.countNumber.payedNum) + parseInt(_this9.countNumber.productNum) + parseInt(_this9.countNumber.shippedNum) + parseInt(_this9.countNumber.installedNum) + parseInt(_this9.countNumber.canceledNum) + parseInt(_this9.countNumber.backedNum) + parseInt(_this9.countNumber.commentedNum);
        _this9.loadorderCount = false;
      });
    }
  }),
  watch: {},
  created: function created() {
    this.getMemOrderCountWay(); //订单数量
    this.getPageMemOrder(this.queryText, this.orderTab, this.pageNo, this.pageSize); //分页查询我的订单
    this.activeTab = "tab" + this.$route.query.type || "1";
  },

  components: {
    imgs: __WEBPACK_IMPORTED_MODULE_2__components_image_image___default.a,
    menus: __WEBPACK_IMPORTED_MODULE_3__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_5__components_empty_empty___default.a
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Vuex__ = __webpack_require__(45);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      delCoupon: false, //删除确认弹框
      temp: 0, //临时存储id
      activeTab: 'tab1',
      scandetailid: [],
      loadShow: true, //加载
      // 下拉加载相关
      loading: false,
      scroller: null,
      pageNo: 1,
      pageSize: 10,
      total: 0, //z总数量
      lastPageNo: 1, //总共页面数量
      currentPage: 0,

      memCouponMsg: [], //获取我的优惠券列表有效
      memCouponMsgExpireList: [], //无效优惠券
      toast1: false //删除提示信息
    };
  },
  mounted: function mounted() {
    this.scroller = document.querySelectorAll('.' + this.activeTab)[0];
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_Vuex__["a" /* mapActions */])({
    pageMemRedpacket: 'pageMemRedpacket', //获取我的优惠券
    delMemCoupon: 'delMemCoupon' //删除优惠券
  }), {
    // 加载更多
    loadMore: function loadMore() {
      var _this = this;

      var type = 0;
      if (this.activeTab == 'tab1') {
        type = 0;
      } else if (this.activeTab == 'tab2') {
        type = 2;
      }
      if (this.lastPageNo == this.currentPage) {
        this.loading = false;
      } else {
        this.loading = true;
        this.pageNo++;
        this.getPageMemRedPacket(type, this.pageNo, this.pageSize);
        setTimeout(function () {
          _this.loading = false;
        }, 2000);
      }
    },
    tabHeaderOne: function tabHeaderOne(type) {
      if (this.activeTab == 'tab1') {
        return;
      }
      this.loadShow = true; //加载
      this.activeTab = 'tab1';
      // 数据列表清空
      this.pageNo = 1;
      this.memCouponMsg = [];
      this.getPageMemRedPacket(type, this.pageNo, this.pageSize);
    },

    //打开已经失效的优惠券
    tabHeaderTwo: function tabHeaderTwo(type) {
      if (this.activeTab == 'tab2') {
        return;
      }
      this.loadShow = true; //加载
      this.activeTab = 'tab2';
      // 数据列表清空
      this.pageNo = 1;
      this.memCouponMsg = [];
      this.getPageMemRedPacket(type, this.pageNo, this.pageSize);
    },

    //检查详情是否打开
    check: function check(index) {
      for (var i = 0; i < this.scandetailid.length; i++) {
        if (this.scandetailid[i] == index) return true;
      }
    },

    //打开详情
    scandetail: function scandetail(index) {
      if (this.check(index)) {
        //检查标签已经选中
        for (var i = 0; i < this.scandetailid.length; i++) {
          if (this.scandetailid[i] == index) this.scandetailid.splice(i, 1);
        }
      } else {
        this.scandetailid.push(index);
      }
    },

    //删除我的优惠券按钮
    deleteitem: function deleteitem(couponInstId) {
      this.delCoupon = true;
      this.temp = couponInstId;
      // this.getDelMemCoupon(couponInstId);
    },

    //进入订单详情
    gouse: function gouse(storeId, useType) {
      this.$router.push({
        path: '/main/home'
      });
    },

    //获取我的优惠券列表api
    getPageMemRedPacket: function getPageMemRedPacket(couponState, pageNo, pageSize) {
      var _this2 = this;

      this.pageMemRedpacket([couponState, pageNo, pageSize]).then(function (res) {
        res.result.forEach(function (item) {
          _this2.memCouponMsg.push(item);
        });
        _this2.lastPageNo = Number(res.lastPageNo);
        _this2.currentPage = Number(res.currentPageNo);
        _this2.total = Number(res.totalCount);
        _this2.loadShow = false; //加载结束
        _this2.loadShow = false; //加载结束
      }).catch(function (error) {});
    },

    //删除当签优惠券api
    getDelMemCoupon: function getDelMemCoupon(couponInstId) {
      var _this3 = this;

      this.delMemCoupon(couponInstId).then(function (res) {
        _this3.delCoupon = false;
        _this3.toast1 = true;
        setTimeout(function () {
          _this3.toast1 = false;
        }, 1500);
        _this3.getPageMemRedPacket(0, _this3.pageNo, _this3.pageSize);
      }).catch(function (error) {});
    }
  }),
  created: function created() {

    //获取我的优惠券列表
    this.getPageMemRedPacket(0, this.pageNo, this.pageSize);

    //this.getDelMemCoupon(32132132);
  },

  watch: {},
  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_3__components_empty_empty___default.a
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _ref;

    return _ref = {

      settleDatas: [],
      OrderSettleMsg: '',
      loadShow: true, //加载
      quitOrder: false, //取消订单
      chargeBack: false, //申请退单
      contactService: false, //生产中、已发货  联系客服
      cartData: [{
        id: '1',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1
      }, {
        id: '2',
        title: "这个周末一起吃饭么?这个周末一起吃饭么?这个周末一起起吃饭么?这个周末一起吃饭么?",
        img: "/static/images/headImg.jpg",
        describe: "油漆门特权订金（特价门型不可用）",
        price: 99999,
        count: 1
      }],
      value: [], //选中的id
      memOrderDetailMsg: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'settleDatas', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'stOrderId', this.$route.query.stOrderId), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'orderStateType', this.$route.query.orderState), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commonFinished', this.$route.query.commonFinished ? this.$route.query.commonFinished : null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'toast', {
      isShow: false,
      messageTip: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'pay', {
      loading: false,
      message: '提交订单···'
    }), _ref;
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])({
    getMemOrderDetail: 'getMemOrderDetail', //获取会员订单详情
    applyBackOrder: 'applyBackOrder', //申请退单
    cancelMemOrder: 'cancelMemOrder', //取消订单
    getOrderSettleMsgForOrder: 'getOrderSettleMsgForOrder', //重新购买
    getOrderSettleMsgFromCart: 'getOrderSettleMsgFromCart', //购物车


    doWxMpPay: 'doWxMpPay', //微信公众号支付
    doWxH5Pay: 'doWxH5Pay', //微信H5支付
    doUnionWapConsumePay: 'doUnionWapConsumePay' //银联手机网页支付

  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this2 = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this2.toast.isShow = false;
      }, 1500);
    },

    //取消订单
    doQuitOrder: function doQuitOrder(id) {
      this.getCancelMemOrder(this.stOrderId);
      this.$router.push({
        path: '/main/quitsuccess'
      });
    },

    //执行 申请退单
    doChargeBack: function doChargeBack() {
      this.getApplyBackOrder(this.stOrderId);
    },

    //拨打电话
    phoneCall: function phoneCall(tel) {},

    //立即购买
    // 初始化店铺结算信息
    initSettleDatas: function initSettleDatas(stOrderId, OrderSettleMsg) {
      var _this = this;
      var settleDatas = [];
      var couponAmounts = [];
      var redpacketAmounts = []; //console.log(this.OrderSettleMsg.storeOrderSettleMsgs)
      OrderSettleMsg.storeOrderSettleMsgs.forEach(function (item) {
        if (item.couponMsgs == null || item.couponMsgs.length == 0) {
          item.couponMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.couponMsgs.unshift({
            couponInstId: '0',
            couponName: '不使用优惠券',
            couponAmount: 0
          });
        }
        if (item.redpacketMsgs == null || item.redpacketMsgs.length == 0) {
          item.redpacketMsgs = [];
        } else {
          // 优惠券列表中加入  不使用选项
          item.redpacketMsgs.unshift({
            couponInstId: '0',
            couponName: '不使用红包',
            couponAmount: 0
          });
        }
        // 记录结算数据  店铺id 商品id  优惠券默认为0  红包默认0  备注默认为空
        var instSkuIds = [];
        item.settleGoodsMsg.cartGoodses.forEach(function (sub) {
          //每个店铺下的商品实例id
          instSkuIds.push(sub.instSkuId);
        });

        settleDatas.push({
          stOrderId: stOrderId,
          storeId: item.settleGoodsMsg.storeId,
          instSkuIds: instSkuIds,
          couponInstId: "0",
          redpacketInstId: '0',
          remark: '',
          dealerCode: ''
        });
        //店铺优惠券优惠金额列表
        couponAmounts.push(0);
        redpacketAmounts.push(0);
      });
      var orderData = {};
      orderData.OrderSettleMsg = OrderSettleMsg; //订单信息
      orderData.settleDatas = settleDatas; //店铺结算信息
      orderData.couponAmounts = couponAmounts; //优惠券优惠金额
      orderData.redpacketAmounts = redpacketAmounts;
      __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.set('orderData', orderData);
    },

    //立即支付
    orderSubmit: function orderSubmit(id) {
      var _this3 = this;

      var stOrderId = '';
      var _this = this;
      stOrderId = this.memOrderDetailMsg.stOrderId;
      this.getOrderSettleMsgForOrder(stOrderId).then(function (res) {
        _this3.OrderSettleMsg = res.target.target;
        _this3.initSettleDatas(stOrderId, res.target.target); // 初始化店铺结算信息
        _this3.$router.push({
          path: '/main/firmorder?orderId=' + _this.memOrderDetailMsg.orderId
        });
      });
    },

    //立即购买
    buyNow: function buyNow() {
      var _this4 = this;

      var stOrderId = '';
      var _this = this;
      stOrderId = this.memOrderDetailMsg.stOrderId;
      this.getOrderSettleMsgForOrder(stOrderId).then(function (res) {
        _this4.OrderSettleMsg = res.target.target;
        _this4.initSettleDatas(stOrderId, res.target.target); // 初始化店铺结算信息
        _this4.$router.push({
          path: '/main/firmorder'
        });
      });
    },

    //判断是取消订单还是申请退单还是线下操作
    cancelOrder: function cancelOrder(stated, stOrderId) {
      this.stOrderId = stOrderId;
      if (stated == 0) {
        this.quitOrder = true;
      } else if (stated == 4 || stated == 1 || stated == 3 || stated == 12 || stated == 13) {
        this.chargeBack = true;
      } else {
        this.contactService = true;
      }
    },


    //跳转去评价
    evaluateJump: function evaluateJump(stOrderId, orderId) {
      //this.$router.push({path: '/personal/evaluateAll?stOrderId=' + stOrderId + '&orderId=' + orderId})
    },

    //取消订单api
    getCancelMemOrder: function getCancelMemOrder(stOrderId) {
      var _this5 = this;

      this.cancelMemOrder(stOrderId).then(function (res) {
        _this5.showTipMessage(true, '已成功取消订单');

        _this5.$router.push({ path: '/main/myorders' });
      }).catch(function (error) {
        _this5.showTipMessage(true, error || '退单失败,请稍后重试');
      });
    },
    //申请退单api
    getApplyBackOrder: function getApplyBackOrder(stOrderId) {
      var _this6 = this;

      this.applyBackOrder([stOrderId, 'mobile']).then(function (res) {
        _this6.showTipMessage(true, '退单申请已提交');
        _this6.$router.push({
          path: '/main/quitsuccess'
        });
      }).catch(function (error) {
        _this6.showTipMessage(true, error || '退单失败,请稍后重试');
      });
    },


    // 微信支付
    submitOrder: function submitOrder() {
      var orderId = this.memOrderDetailMsg.orderId;
      //微信内置浏览器
      if (this.util.isWeiXin()) {
        this.pay.loading = true;
        this.pay.message = '等待支付···';
        this.callOldWxPay(orderId);
      } else {
        this.pay.loading = true;
        this.pay.message = '等待支付···';
        //3. 发起H5微信请求
        this.callH5WxPay(orderId);
      }
    },

    //银联支付
    submitUnionOrder: function submitUnionOrder() {
      this.pay.loading = true;
      this.pay.message = '等待支付···';

      this.callUnionPay(this.memOrderDetailMsg.orderId);
    },


    // 银联wap网关支付
    callUnionPay: function callUnionPay(orderNo) {
      var _this7 = this;

      this.doUnionWapConsumePay([orderNo]).then(function (res) {
        var boxId = "_mxmall_unionpay_box_";
        var div = document.createElement('div');
        div.id = boxId;
        div.innerHTML = res;
        document.body.appendChild(div);
        document.querySelector("#" + boxId + " > form").submit();
      }).catch(function (err) {
        _this7.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
      });
    },


    //微信H5支付
    callH5WxPay: function callH5WxPay(orderId) {
      var _this8 = this;

      var _this = this;
      this.doWxH5Pay([orderId || _this.memOrderDetailMsg.orderId]).then(function (res) {
        if (res.success && res.errCode == 'ORDERPAID') {
          _this.showTipMessage(true, "该订单已支付成功");
          location.href = '/main/paysuccess?orderId=' + orderId || _this.memOrderDetailMsg.orderId;
          return;
        }
        var url = res.target.target;
        //重定向
        location.replace(url);
        //TODO
      }).catch(function (err) {
        _this8.showTipMessage(true, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
      });
    },

    //旧版微信支付
    callOldWxPay: function callOldWxPay(orderId) {
      var _this = this;

      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
        }
      } else {
        return this.doWxMpPay([orderId || this.memOrderDetailMsg.orderId]).then(function (resWxPay) {
          //alert("调用服务端doWxMpPay,返回结果resWxPay："+JSON.stringify(resWxPay));  
          if (!resWxPay || !resWxPay.success || !resWxPay.target || !resWxPay.target.success) {
            _this.showTipMessage(true, resWxPay && resWxPay.message || resWxPay && resWxPay.target && resWxPay.target.message || '抱歉，支付失败！');
            //防止重复提交
            location.href = '/main/myorders';
            return;
          }

          WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": resWxPay.target.target.appId, //公众号名称，由商户传入     
            "timeStamp": resWxPay.target.target.timeStamp, //时间戳，自1970年以来的秒数     
            "nonceStr": resWxPay.target.target.nonceStr, //随机串     
            "package": resWxPay.target.target.package,
            "signType": resWxPay.target.target.signType, //微信签名方式：     
            "paySign": resWxPay.target.target.paySign //微信签名 
          }, function (res) {
            //alert("STEP 4 微信服务器返回结果: " + JSON.stringify(res));
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回   ok，但并不保证它绝对可靠。    
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              _this.showTipMessage(true, '支付成功');
              location.href = '/main/paysuccess?orderId=' + _this.memOrderDetailMsg.orderId || _this.$route.query.orderId;
            } else if (res.err_msg == "get_brand_wcpay_request:fail") {
              _this.showTipMessage(true, '支付失败');
              location.href = '/main/myorders?type=2';
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              _this.showTipMessage(true, '已取消支付');
              location.href = '/main/myorders?type=2';
            }
          });
        }).catch(function (err) {
          _this.showTipMessage(true, err || '支付失败!');
          location.href = '/main/myorders?type=2';
        });
      }
    }
  }),
  watch: {},
  mounted: function mounted() {
    var _this9 = this;

    //当前店铺订单详情
    this.getMemOrderDetail(this.stOrderId).then(function (res) {
      _this9.memOrderDetailMsg = res;
      _this9.loadShow = false;
    }).catch(function (error) {
      console.log(error);
    });
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_3__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_4__components_myOrdersItem_myOrdersItem___default.a
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loading: true,
      listMemDetailInfo: [], //获取会员详细信息
      listMemAccountMsg: [], //获取账户信息
      listMemOrderCount: [], //获取会员订单数量
      toast: {
        isShow: false,
        messageTip: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    getMemDetailInfo: 'getMemDetailInfo', //获取会员详细信息
    getMemAccountMsg: 'getMemAccountMsg', //获取账户信息
    getMemOrderCount: 'getMemOrderCount', //获取会员订单数
    logout: 'logout', //退出登录
    doLogout: 'doLogout' //执行退出登录
  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this.toast.isShow = false;
      }, 1500);
    },
    loginOut: function loginOut() {
      var _this2 = this;

      this.logout().then(function (res) {
        // alert(JSON.stringify(res))
        _this2.doLogout().then(function (res) {
          _this2.showTipMessage(true, '退出成功');
          __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__["a" /* storage */].local.remove('userInfo');
          __WEBPACK_IMPORTED_MODULE_4__common_utils_util_js__["a" /* storage */].local.remove('invoiceData');
          setTimeout(function () {
            _this2.$router.push({ path: '/' });
          }, 500);
        });
      }).catch(function (err) {
        _this2.showTipMessage(true, err || '退出失败');
      });
    },

    //打开个人信息页面
    openUserInfo: function openUserInfo() {
      this.$router.push({
        path: '/main/userinfo'
      });
    },

    //打开我的订单页面
    openMyOrders: function openMyOrders(type) {
      this.$router.push({
        path: '/main/myorders?type=' + type
      });
    },

    //打开我的账户
    openMyAccount: function openMyAccount() {
      this.$router.push({
        path: '/main/myaccount'
      });
    },

    //打开我的红包
    openMyRedpack: function openMyRedpack() {
      this.$router.push({
        path: '/main/myredpack'
      });
    },

    //我的优惠券
    openMyCoupon: function openMyCoupon() {
      this.$router.push({
        path: '/main/mycoupon'
      });
    },

    //打开收货地址
    openAddress: function openAddress() {
      this.$router.push({
        path: '/main/myaddress'
      });
    },

    //打开发票信息
    openInvoiceInfo: function openInvoiceInfo() {
      this.$router.push({
        path: '/main/invoiceinfo'
      });
    },

    //打开我的评论
    openMyComments: function openMyComments() {
      this.$router.push({
        path: '/main/mycomments'
      });
    },
    openMyCollection: function openMyCollection() {
      this.$router.push({
        path: '/main/mycollection'
      });
    }
  }),
  watch: {},
  created: function created() {
    var _this3 = this;

    //获取会员信息
    this.getMemDetailInfo().then(function (res) {
      _this3.listMemDetailInfo = res;
    });
    //获取账户信息
    this.getMemAccountMsg().then(function (res) {
      _this3.listMemAccountMsg = res.target;
    });
    this.getMemOrderCount().then(function (res) {
      _this3.listMemOrderCount = res;
      _this3.loading = false;
    });
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_3__components_image_image___default.a
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Constant__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      actionUrl: __WEBPACK_IMPORTED_MODULE_7__Constant__["a" /* default */].uploadBaseUrl + "/apps", //提交URL
      loadShow: true, //加载
      toast: {
        isShow: false,
        messageTip: ''
      },
      stOrderId: this.$route.query.stOrderId, //店铺订单id
      orderId: this.$route.query.orderId, //店铺订单id
      commDesc: '',
      file: [],
      comSwiperOption: {
        slidesPerView: 3.5,
        slidesPerGroup: 2,
        autoplay: 10000,
        loop: false,
        autoplayDisableOnInteraction: false
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    getMemOrderDetail: 'getMemOrderDetail', //获取会员订单详情
    listOrderGoodsMsgByOrderId: 'listOrderGoodsMsgByOrderId',
    submitShareData: 'submitShareData'

  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this2 = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this2.toast.isShow = false;
      }, 1500);
    },
    submit: function submit() {
      var _this3 = this;

      if (this.commDesc == '') {
        this.showTipMessage(true, '请填写分享内容');
        return;
      } else if (this.file.length < 1) {
        this.showTipMessage(true, '请选择分享的图片');
        return;
      } else {
        var picIds = [];

        this.file.forEach(function (item, index) {
          picIds.push(item.fileId);
        });
        this.submitShareData([this.orderId, this.commDesc, picIds]).then(function (res) {
          _this3.showTipMessage(true, '分享成功啦');
          setTimeout(function () {
            _this3.$router.push({ path: '/' });
          }, 500);
        }).catch(function (err) {
          _this3.showTipMessage(true, err || '分享失败啦，待会试试吧！');
        });
      }
    },

    //浏览商品详情
    viewGoodsDetail: function viewGoodsDetail(goods) {
      if (goods && goods.goodsId) {
        this.$router.push({
          path: '/main/goodsDetail?goodsId=' + goods.goodsId + '&skuId=' + (goods.skuId || 0)
        });
      }
    },

    // 选择图片
    selimg: function selimg(action) {
      var _this4 = this;

      var filetarget = '';
      var _this = this;
      filetarget = this.$refs.albumImg.files[0];
      if (!filetarget) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_6__common_utils_util__["c" /* default */].uploadImg(this.actionUrl, filetarget, 'avatar').then(function (res) {
        if (!res.returnTargets[0].fileId) {
          return;
        }
        res.returnTargets[0].fileName = __WEBPACK_IMPORTED_MODULE_7__Constant__["a" /* default */].imgBaseUrl + '/image/' + res.returnTargets[0].fileName;
        //存储上传的文件
        _this.file.push(res.returnTargets[0]);
      }).catch(function (err) {
        _this4.showTipMessage(true, err);
      });
    },

    //删除图片
    deletefile: function deletefile(id) {
      var _this = this;
      _this.file.forEach(function (item, index) {
        if (item.fileId == id) _this.file.splice(item, 1);
      });
    }
  }),
  watch: {},
  mounted: function mounted() {
    var _this5 = this;

    //当前店铺订单详情
    this.listOrderGoodsMsgByOrderId(this.orderId).then(function (res) {
      _this5.memOrderDetailMsg = res;console.log(res);
      _this5.loadShow = false;
    }).catch(function (error) {
      console.log(error);
    });
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_2__components_myOrdersItem_myOrdersItem___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_3__components_image_image___default.a
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_menus_menus__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    save: function save() {
      this.$router.push({
        path: '/main/myorders'
      });
    }
  },
  components: {
    menus: __WEBPACK_IMPORTED_MODULE_0__components_menus_menus___default.a
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_image_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_myOrdersItem_myOrdersItem__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_myOrdersItem_myOrdersItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_myOrdersItem_myOrdersItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_empty_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      queryText: "",
      orderContent: [],
      isEmpty: false,
      loadShow: false,
      toast: {
        isShow: false,
        messageTip: ""
      },
      orderNumObj: {
        orderNumFour: null,
        orderNumFive: null
      }
    };
  },
  mounted: function mounted() {},

  watch: {
    orderContent: function orderContent() {
      if (this.orderContent && this.orderContent.length > 0) {
        this.isEmpty = false;
        return;
      }
      this.isEmpty = true;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapActions"])({
    queryOrder: "queryOrder" //线下订单查询
  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this.toast.isShow = false;
      }, 500);
    },
    searchOrder: function searchOrder() {
      var _this2 = this;

      if (!this.orderNumObj.orderNumFive && !this.orderNumObj.orderNumFour) {
        this.showTipMessage(true, "请输入关键字");
        return;
      }
      this.queryText = "CP-" + (this.orderNumObj.orderNumFour || "") + "-" + (this.orderNumObj.orderNumFive || "");
      // if (this.queryText == '') {
      //   this.showTipMessage(true,'请输入关键字');
      //   return
      // }
      this.loadShow = true;
      this.queryOrder(this.queryText).then(function (res) {
        _this2.orderContent = res.recs;
        _this2.loadShow = false;
      }).catch(function (error) {
        _this2.showTipMessage(true, error || "搜索失败,请稍后重试");
      });
    },
    checkNum: function checkNum(e, name) {
      if (!__WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["c" /* default */].isNum(e.key)) {
        var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.orderNumObj);
        var str = obj[name].replace(e.key, "");
        this.orderNumObj[name] = str;
      }
    }
  }),
  created: function created() {},

  components: {
    imgs: __WEBPACK_IMPORTED_MODULE_2__components_image_image___default.a,
    myOrdersItem: __WEBPACK_IMPORTED_MODULE_3__components_myOrdersItem_myOrdersItem___default.a,
    empty: __WEBPACK_IMPORTED_MODULE_4__components_empty_empty___default.a
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_image_image__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_image_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_image_image__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      actionUrl: __WEBPACK_IMPORTED_MODULE_4__Constant__["a" /* default */].uploadBaseUrl + "/apps", //提交URL
      loadShow: true,
      loadingTip: '拼命加载中',
      shooseSex: '', //选择性别
      headimgPopup: false,
      sexPopup: false,
      brithPopup: false,
      sex: [{
        id: 2,
        name: '女'
      }, {
        id: 1,
        name: '男'
      }, {
        id: 0,
        name: '保密'
      }],
      listMemDetailInfo: [], //获取会员详细信息
      successMsg: false, //修改成功
      valBirthDay: '', //出生日期
      nowTime: '',
      toast: {
        isShow: false,
        messageTip: ''
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    doSetBirthDay: 'doSetBirthDay', //设置出生日期
    doSetMemImage: 'doSetMemImage', //设置会员头像
    doSetNickName: 'doSetNickName', //设会员昵称
    doSetSex: 'doSetSex', //设置会员性别
    getMemDetailInfo: 'getMemDetailInfo', //获取会员详细信息
    uploadPic: 'uploadPic'
  }), {
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this.toast.isShow = false;
      }, 1500);
    },
    open: function open(position) {
      this[position + 'Popup'] = true;
    },
    close: function close(position) {
      this[position + 'Popup'] = false;
    },
    editNickname: function editNickname(nickName) {
      this.$router.push({
        path: '/main/editnickname?nickName=' + nickName
      });
    },

    //chenge 事件监听日期变化
    birthDayChange: function birthDayChange(valueDay) {
      var valueDay = new Date(valueDay).getTime();
      this.itDoSetBirthDay(valueDay); //调用方法修改
    },

    //选择生日信息
    selsex: function selsex(index) {
      this.shooseSex = this.sex[index].id;
      this.itDoSetSex(this.shooseSex); //修改性别   
      this.close('sex');
    },


    // 选择图片
    selimg: function selimg(action) {
      var _this2 = this;

      var filetarget = '';
      if (action == 1) {
        filetarget = this.$refs.cameraImg.files[0];
        // this.imgPreview(this.$refs.cameraImg.files[0]);
      } else if (action == 2) {
        filetarget = this.$refs.albumImg.files[0];
        // this.imgPreview(this.$refs.albumImg.files[0]);
      }
      if (!filetarget) {
        return;
      }
      this.loadShow = true; //开始加载
      this.loadingTip = '正在上传头像~';
      __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].uploadImg(this.actionUrl, filetarget, 'avatar').then(function (res) {
        //console.log('page result1',res.returnTargets[0].fileId) 
        if (!res.returnTargets[0].fileId) {
          return;
        }
        //this.listMemDetailInfo.avatarImage.imagePath ='/image/'+fileName
        _this2.itDoSetMemImage(res.returnTargets[0].fileId);
      }).catch(function (err) {
        //console.log('page result2',err)
      });
      this.close('headimg');
    },


    // 预览
    imgPreview: function imgPreview(file) {
      var self = this;

      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        var reader = new FileReader();
        // 将图片将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          self.listMemDetailInfo.avatarImage.imagePath = this.result;
          console.log("结果是?>>>", this);
        };
      }
    },

    //设置生日api
    itDoSetBirthDay: function itDoSetBirthDay(birthdayValue) {
      var _this3 = this;

      this.doSetBirthDay(birthdayValue).then(function (res) {
        _this3.showTipMessage(true, "修改成功！");
        _this3.getMemDetailInfoList(); //重新调取api获取信息
      }).catch(function (error) {});
    },

    //设置会员头像api
    itDoSetMemImage: function itDoSetMemImage(memImageId) {
      var _this4 = this;

      this.doSetMemImage(memImageId).then(function (res) {
        _this4.showTipMessage(true, "上传成功！");
        _this4.getMemDetailInfoList(); //重新调取api获取信息
      }).catch(function (error) {});
    },

    //修改性别
    itDoSetSex: function itDoSetSex(sex) {
      var _this5 = this;

      this.doSetSex(sex).then(function (res) {
        _this5.showTipMessage(true, "修改成功！");
        _this5.getMemDetailInfoList(); //重新调取api获取信息
      }).catch(function (error) {});
    },

    //调去会员详细信息
    getMemDetailInfoList: function getMemDetailInfoList() {
      var _this6 = this;

      this.getMemDetailInfo().then(function (res) {
        _this6.listMemDetailInfo = res; //获取到的信息
        // this.listMemDetailInfo.avatarImage.imagePath = Constant.imgBaseUrl + '/' + res.avatarImage.imagePath;
        // console.log(">>>>>>>>>>>>>>>",this.listMemDetailInfo.avatarImage.imagePath)
        _this6.loadShow = false; //关闭加载
        _this6.nowTime = __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].format(new Date(new Date()), 'yyyy-MM-dd'); //当前的时间
        if (_this6.listMemDetailInfo.birthDay != null) {
          var getDay = parseInt(_this6.listMemDetailInfo.birthDay, 10); //转换为整型
          _this6.valBirthDay = __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].format(new Date(getDay), 'yyyy-MM-dd'); //展示的时间
        } else if (_this6.listMemDetailInfo.birthDay == null) {
          _this6.valBirthDay = ''; //当前的时间
          return;
        }
      }).catch(function (error) {});
    }
  }),
  created: function created() {
    //获取会员详细信息
    this.getMemDetailInfoList();
    //this.itDoSetMemImage(); //设置头像
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a,
    imgs: __WEBPACK_IMPORTED_MODULE_5__components_image_image___default.a
  },
  computed: {
    imgPath: function imgPath() {
      if (this.imagePath) {
        return __WEBPACK_IMPORTED_MODULE_4__Constant__["a" /* default */].imgBaseUrl + '/' + src;
      } else {
        return this.defaultPath;
      }
    }
  },
  watch: {}
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_menus_menus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      addressPopup: false, //位置选择弹框
      addressCode: 0, //获取地址需要传的值
      addressId: this.$route.query.addressId ? this.$route.query.addressId : null, //查询地址详细信息需要的id
      memId: this.$route.query.memId, //会员id
      currentAddress: {
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        area: '',
        townId: '',
        town: '',
        address: '',
        postCode: '',
        consignee: '',
        mobile: '',
        isDefault: 0
      }, //当前地址信息
      addressMsgShow: '', //页面展示的值
      addressProvince: '', //展示省份
      addressCity: '', //展示城市
      chooseCityId: '', //选中城市id
      chooseAreaId: '', //选中的区域id
      chooseStreetId: '', //获取的街道id
      arealistMsg: [], //当前获取到的省份信息
      cityListShow: [], //获取到的城市信息
      areaAddressMsg: [], //获取到城镇信息
      bottomPopup: false, //选择地址弹框
      chooseBox: true, //选择地址弹框
      shoWOr: 1, //初始展示省份一级
      errorShow: 0, //错误信息提示
      toast2: false, //手机号码验证
      messageShow: '', //提示信息
      cityNameShow: '', //城市展示
      areaNameShow: '', //区域名
      getStreetMsgList: '', //最后街道信息
      streetNameShow: '', //街道信息
      lastMsg: '' //最后选中的信息
    };
  },

  watch: {
    topPopup: function topPopup(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.topPopup = false;
        }, 2000);
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])({
    doSetDefaultAddress: 'doSetDefaultAddress', //设置默认地址
    addAddress: 'addAddress', //新增收货地址
    editAddress: 'editAddress', //修改收货地址
    listAreaMsg: 'listAreaMsg', //获取地域列表
    getAddress: 'getAddress' //获取发地址列表
  }), {
    //地址出现弹框
    clickProvince: function clickProvince(areaId) {
      this.addressMsgShow = '';
      this.addressProvince = '';
      this.cityNameShow = '';
      this.currentAddress.province = '';
      this.currentAddress.provinceId = '';
      this.currentAddress.city = '';
      this.currentAddress.areaId = '';
      this.currentAddress.area = '';
      this.currentAddress.townId = '';
      this.currentAddress.town = '';
      this.shoWOr = 1;
    },

    // 点击省出现下级
    shooseProvince: function shooseProvince(provinceId, provinceName) {
      this.shoWOr = 2;
      this.getCityListShow(provinceId); //获取城市列表
      this.currentAddress.provinceId = provinceId; //保存id
      this.currentAddress.province = provinceName; //保存名字
      this.addressProvince = provinceName; //名字在页面展示
      this.addressMsgShow = provinceName; //选择框展示
    },

    //点击城市出现下级
    shooseCity: function shooseCity(cityId, cityName) {
      var _this2 = this;

      this.getTownMsg(cityId); //获取城镇信息
      //setTimeout(this.getTownMsg(cityId), 1); //获取城镇信息
      //this.addressMsgShow = this.addressProvince + cityName; //选择框展示城市名字
      this.currentAddress.city = cityName; //保存城市名字
      this.cityNameShow = cityName; //展示城市名字
      this.currentAddress.cityId = cityId; //保存城市id
      this.chooseCityId = cityId; //选中城市的id
      this.addressMsgShow = this.addressProvince + this.cityNameShow;
      this.listAreaMsg(cityId).then(function (res) {
        _this2.areaAddressMsg = res.target;
        if (_this2.areaAddressMsg.length == 0) {
          _this2.addressMsgShow = _this2.addressProvince + _this2.cityNameShow; //选择框展示城市名字
          _this2.shoWOr = 2; //关闭地址选择框
          return;
        } else if (_this2.areaAddressMsg.length != 0) {
          _this2.shoWOr = 3;
        }
      });
    },

    //点击区域出现下一级
    shooseArea: function shooseArea(areaId, areaName) {
      var _this3 = this;

      this.currentAddress.areaId = areaId; //保存的区域id
      this.chooseAreaId = areaId; //保存的id
      this.currentAddress.area = areaName; //保存地址名称
      this.areaNameShow = areaName; //展示的街道
      this.addressMsgShow = this.addressProvince + this.cityNameShow + this.areaNameShow;
      //this.chooseBox = false; //关闭地址框
      this.listAreaMsg(areaId).then(function (res) {
        _this3.getStreetMsgList = res.target;
        if (_this3.getStreetMsgList.length == 0) {
          _this3.shoWOr = 3;
        } else {
          _this3.shoWOr = 4;
        }
      });
    },

    //点击街道出现下一级
    shooseStreet: function shooseStreet(areaId, areaName) {
      var _this4 = this;

      this.currentAddress.townId = areaId; //保存的区域id
      this.chooseStreetId = areaId; //保存街道id
      this.currentAddress.town = areaName; //保存地址名称
      this.streetNameShow = areaName; //展示的街道
      //this.chooseBox = false; //关闭地址框
      this.addressMsgShow = this.addressProvince + this.cityNameShow + this.areaNameShow + this.streetNameShow;
      this.listAreaMsg(areaId).then(function (res) {
        _this4.lastMsg = res.target;
      });
    },

    //获取区域的列表api
    getAreaMsg: function getAreaMsg(areaId) {
      var _this5 = this;

      this.listAreaMsg(areaId).then(function (res) {
        _this5.getStreetMsgList = res.target;
      });
    },

    //获取城镇信息api
    getTownMsg: function getTownMsg(cityId) {
      var _this6 = this;

      this.listAreaMsg(cityId).then(function (res) {
        _this6.areaAddressMsg = res.target;
      });
    },

    //获取城市的列表api
    getCityListShow: function getCityListShow(provinceId) {
      var _this7 = this;

      this.listAreaMsg(provinceId).then(function (result) {
        _this7.cityListShow = result.target;
      });
    },

    //获取省份列表api
    getListAreaMsg: function getListAreaMsg(addressCode) {
      var _this8 = this;

      this.listAreaMsg(addressCode).then(function (result) {
        _this8.arealistMsg = result.target;
      }).catch(function (error) {});
    },

    //获取收货地址详细信息api
    getAddressMsg: function getAddressMsg(addressId) {
      var _this9 = this;

      this.getAddress(addressId).then(function (res) {
        _this9.currentAddress = res;
        _this9.currentAddress.address = _this9.currentAddress.address ? _this9.currentAddress.address : null;
        _this9.currentAddress.consignee = _this9.currentAddress.consignee ? _this9.currentAddress.consignee : null;
        _this9.currentAddress.mobile = _this9.currentAddress.mobile ? _this9.currentAddress.mobile : null;
        _this9.currentAddress.province = _this9.currentAddress.province ? _this9.currentAddress.province : null;
        _this9.currentAddress.provinceId = _this9.currentAddress.provinceId ? _this9.currentAddress.provinceId : null;
        _this9.currentAddress.city = _this9.currentAddress.city ? _this9.currentAddress.city : null;
        _this9.currentAddress.areaId = _this9.currentAddress.areaId ? _this9.currentAddress.areaId : null;
        _this9.currentAddress.area = _this9.currentAddress.area ? _this9.currentAddress.area : null;
        _this9.currentAddress.townId = _this9.currentAddress.townId ? _this9.currentAddress.townId : null;
        _this9.currentAddress.town = _this9.currentAddress.town ? _this9.currentAddress.town : null;
        _this9.currentAddress.postCode = _this9.currentAddress.postCode ? _this9.currentAddress.postCode : null;
        if (_this9.currentAddress.area == null) {
          _this9.addressMsgShow = _this9.currentAddress.city ? _this9.currentAddress.province + _this9.currentAddress.city : _this9.currentAddress.province;
        } else {
          _this9.addressMsgShow = _this9.currentAddress.city ? _this9.currentAddress.province + _this9.currentAddress.city + _this9.currentAddress.area : _this9.currentAddress.province; //当前位置展示的信息
        }
      }).catch(function (error) {});
    },
    isCellPhone: function isCellPhone(telephone) {
      var reg = /^1\d{10}$/; ///^1[3578]\d{9}$|^(?:0\d{2,3}-?)?[2-9]\d{6,7}$/g;
      var res = reg.test(telephone);
      return res;
    },

    //保存我的地址判断是新增还是修改地址  //验证输入的数字是否正确
    save: function save() {
      var _this10 = this;

      var valuechange = this.isCellPhone(this.currentAddress.mobile);
      if (this.currentAddress.consignee == '') {
        this.messageShow = "请输入姓名!";
        this.toast2 = true;
        setTimeout(function () {
          _this10.toast2 = false;
        }, 1500);
      } else if (this.currentAddress.mobile == '' || valuechange == false) {
        this.messageShow = "请验证手机号码!";
        this.toast2 = true;
        setTimeout(function () {
          _this10.toast2 = false;
        }, 1500);
      } else if (this.currentAddress.province == '') {
        this.messageShow = "请选择省份!";
        this.toast2 = true;
        setTimeout(function () {
          _this10.toast2 = false;
        }, 1500);
      } else if (this.currentAddress.city == '') {
        this.messageShow = "请选择城市!";
        this.toast2 = true;
        setTimeout(function () {
          _this10.toast2 = false;
        }, 1500);
      } else if (this.currentAddress.address == '') {
        this.messageShow = "请输入地址!";
        this.toast2 = true;
        setTimeout(function () {
          _this10.toast2 = false;
        }, 1500);
      } else {
        if (this.addressId == null) {
          //alert('新增')
          this.addAddressMsg(this.currentAddress); //新增
        } else {
          //alert('修改')
          this.getEditAddress(this.currentAddress); //修改
        }
      }
    },

    //修改我的地址
    getEditAddress: function getEditAddress(editMsg) {
      var _this11 = this;

      this.editAddress([editMsg]).then(function (res) {
        _this11.$router.go(-1);
      }).catch(function (error) {});
    },

    //新增我的地址
    addAddressMsg: function addAddressMsg(upMsg) {
      var _this12 = this;

      this.addAddress(upMsg).then(function (res) {
        _this12.$router.go(-1);
      }).catch(function (error) {});
    }
  }),
  mounted: function mounted() {
    //获取地域列表
    this.getListAreaMsg(this.addressCode);
    //获取当前地址详情
    if (this.addressId != null) {
      this.getAddressMsg(this.addressId);
    } else {
      return;
    }
  },

  components: {
    menus: __WEBPACK_IMPORTED_MODULE_1__components_menus_menus___default.a
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_amap__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_amap__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var address = {
  '北京': ['东城区', '海淀区'],
  '广东': ['广州', '深圳', '珠海', '汕头', '韶关', '佛山', '江门', '湛江'],
  '上海': ['上海'],
  '天津': ['天津'],
  '重庆': ['重庆', '渝北']
};
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentAddress: {
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        area: '',
        townId: '',
        town: '',
        address: '',
        postCode: '',
        consignee: '',
        mobile: '',
        isDefault: 0
      }, //当前地址信息
      addressMsgShow: '请选择地区', //页面展示的值
      addressProvince: '', //展示省份
      addressCity: '', //展示城市
      chooseCityId: '', //选中城市id
      chooseAreaId: '', //选中的区域id
      chooseStreetId: '', //获取的街道id
      arealistMsg: [], //当前获取到的省份信息
      cityListShow: [], //获取到的城市信息
      areaAddressMsg: [], //获取到城镇信息
      bottomPopup: false, //选择地址弹框
      chooseBox: true, //选择地址弹框
      shoWOr: 1, //初始展示省份一级
      errorShow: 0, //错误信息提示
      toast2: false, //手机号码验证
      messageShow: '', //提示信息
      cityNameShow: '', //城市展示
      areaNameShow: '', //区域名
      getStreetMsgList: '', //最后街道信息
      streetNameShow: '', //街道信息
      addressCode: 0,
      addressPopup: false,
      isAddress: false, //是否是选择地区
      /*以下为地图板块*/
      amap: null,
      lat: null,
      lng: null,

      //品牌
      Brands: [], //品牌列表
      brandId: '', //选中的品牌id
      brandName: '全部品牌', //品牌名称
      temp: {} //临时变量
    };
  },
  created: function created() {
    var _this = this;

    this.getBrands().then(function (res) {
      res.forEach(function (item) {
        item.selected = false;
      });
      _this.Brands = res;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({
    listAreaMsg: 'listAreaMsg', //获取地域列表
    pageDealerStore: 'pageDealerStore', //分页获取实体门店信息
    getBrands: 'getBrands'
  }), {
    selBrand: function selBrand(event, index) {
      //全部置为  未选中状态
      this.Brands.forEach(function (item) {
        item.selected = false;
      });
      //当前为选中，记录品牌id
      if (event) {
        this.brandId = this.Brands[index].linkTarget;
        this.brandName = this.Brands[index].linkName;
      } else {
        this.brandId = '';
        this.brandName = '全部品牌';
      }
      this.Brands[index].selected = event;
    },

    //获取地图内容
    getAmapContent: function getAmapContent() {
      var vm = this;
      var amap = {
        resizeEnable: true,
        zoom: 1,
        center: [121.59996, 31.197646],
        markers: [],
        events: {
          init: function init(map) {
            AMapUI.loadUI(['misc/MarkerList', 'overlay/SimpleMarker', 'overlay/SimpleInfoWindow'], function (MarkerList, SimpleMarker, SimpleInfoWindow) {
              var $ = MarkerList.utils.$;

              /*var defaultIconStyle = 'red'; //默认的图标样式*/

              vm.markerList = new MarkerList({
                map: map,
                //ListElement对应的父节点或者ID
                //listContainer: "myList", //document.getElementById("myList"),
                //选中后显示

                //从数据中读取位置, 返回lngLat
                getPosition: function getPosition(item) {
                  return [item.longitude, item.latitude];
                },
                //数据ID，如果不提供，默认使用数组索引，即index
                getDataId: function getDataId(item, index) {
                  return item.id;
                },
                getCityCode: function getCityCode(item) {
                  return item.cityCode;
                },
                getInfoWindow: function getInfoWindow(data, context, recycledInfoWindow) {
                  var innerHTML = MarkerList.utils.template('<div class="info-title"><%- data.storeName %></div>' + '<div class="info-content">' + '<% if(data.relaPhone ){ %>' + '        <p class="info-item phone"><%- data.relaPhone %></p>' + '<% } %>' + '<p class="info-item address"><%- data.address %></p>' + '</div>' + '<a class="info-goHere" href="http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:' + data.latitude + ',' + data.longitude + ';title:' + data.address + ';addr:' + data.address + '&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp"></a>', {
                    data: data
                  });

                  var infowindow = new AMap.InfoWindow({
                    placeSearch: true,
                    asOrigin: true,
                    asDestination: true,
                    content: innerHTML,
                    offset: new AMap.Pixel(0, -30)
                  });
                  return infowindow;
                },
                //构造marker用的options对象, content和title支持模板，也可以是函数，返回marker实例，或者返回options对象
                getMarker: function getMarker(data, context, recycledMarker) {
                  var label = 1;
                  label += context.index;
                  if (recycledMarker) {
                    recycledMarker.setIconLabel(label);
                    return;
                  }

                  return new SimpleMarker({
                    containerClassNames: 'my-marker',
                    iconStyle: vm.defaultIconStyle,
                    iconLabel: label
                  });
                },
                //构造列表元素，与getMarker类似，可以是函数，返回一个dom元素，或者模板 html string
                getListElement: function getListElement(data, context, recycledListElement) {
                  var label = 1;
                  label += context.index;
                  //使用模板创建
                  var innerHTML = MarkerList.utils.template('<span class="poibox-label"><%- label %></span>' + '<div class="poi-info-left">' + '    <h3 class="poi-title">' + '        <%- data.storeName %>' + '    </h3>' + '    <div class="poi-info">' + '        <p class="poi-addr">地址：<%- data.address %></p>' + '<% if(data.relaPhone ){ %>' + '        <p class="poi-addr">电话：<%- data.relaPhone %></p>' + '<% } %>' + '    </div>' + '</div>' + '<div class="clear"></div>', {
                    data: data,
                    label: label
                  });

                  if (recycledListElement) {
                    recycledListElement.innerHTML = innerHTML;
                    return recycledListElement;
                  }

                  return '<li class="poibox">' + innerHTML + '</li>';
                },
                //列表节点上监听的事件
                listElementEvents: ['click', 'mouseenter', 'mouseleave'],
                //marker上监听的事件
                markerEvents: ['click', 'mouseover', 'mouseout'],
                //makeSelectedEvents:false,
                selectedClassNames: 'selected',
                autoSetFitView: true
              });

              //加载地图，调用浏览器定位服务
              var geolocation;
              map.plugin('AMap.Geolocation', function () {
                geolocation = new AMap.Geolocation({
                  enableHighAccuracy: true, //是否使用高精度定位，默认:true
                  timeout: 10000, //超过10秒后停止定位，默认：无穷大
                  buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                  zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                  buttonPosition: 'RB'
                });
                map.addControl(geolocation);
                geolocation.getCurrentPosition();
                AMap.event.addListener(geolocation, 'complete', onComplete); //返回定位信息
                AMap.event.addListener(geolocation, 'error', onError); //返回定位出错信息
              });

              //解析定位结果
              function onComplete(data) {
                console.log("lng", data.position.getLng());
                var positionLists = [];
                var positionList = {
                  longitude: data.position.getLng(),
                  latitude: data.position.getLat()
                };

                vm.lng = data.position.getLng();
                vm.lat = data.position.getLat();
                //地图显示当前城市
                var params = {
                  mapType: 2,
                  longitude: vm.currentAddress.provinceId ? "" : data.position.getLng(),
                  latitude: vm.currentAddress.cityId ? "" : data.position.getLat(),
                  provinceCode: '',
                  cityCode: '',
                  areaCode: '',
                  brandId: '',
                  storeId: vm.storeId || '',
                  goodsId: vm.goodsId || '',
                  provinceId: vm.currentAddress.provinceId || "",
                  cityId: vm.currentAddress.cityId || "",
                  areaId: vm.currentAddress.areaId || ""
                };
                vm.pageDealerStore([params, 1, 20]).then(function (res) {
                  vm.markerList.render(res.result);
                });

                // positionLists.push(positionList);
                // vm.markerList.render(positionLists);
              }
              //解析定位错误信息
              function onError(data) {
                //实例化城市查询类
                var citysearch = new AMap.CitySearch();
                // var city = "重庆"
                //自动获取用户IP，返回当前城市
                citysearch.getLocalCity(function (status, result) {
                  if (status === 'complete' && result.info === 'OK') {
                    if (result && result.city && result.bounds) {
                      vm.lng = result.bounds.eb.lng;
                      vm.lat = result.bounds.eb.lat;
                      //地图显示当前城市
                      var params = {
                        mapType: 2,
                        longitude: vm.currentAddress.provinceId ? "" : result.bounds.eb.lng,
                        latitude: vm.currentAddress.cityId ? "" : result.bounds.eb.lat,
                        provinceCode: '',
                        cityCode: '',
                        areaCode: '',
                        brandId: '',
                        storeId: vm.storeId || '',
                        goodsId: vm.goodsId || '',
                        provinceId: vm.currentAddress.provinceId || "",
                        cityId: vm.currentAddress.cityId || "",
                        areaId: vm.currentAddress.areaId || ""
                      };
                      vm.pageDealerStore([params, 1, 20]).then(function (res) {
                        vm.markerList.render(res.result);
                      });
                    }
                  }
                });
              }
            });

            // //实例化城市查询类
            // var citysearch = new AMap.CitySearch();
            // var city = "重庆"
            // //自动获取用户IP，返回当前城市
            // citysearch.getLocalCity(function(status, result) {
            //   if (status === 'complete' && result.info === 'OK') {
            //     if (result && result.city && result.bounds) {
            //       vm.lng = result.bounds.eb.lng;
            //       vm.lat = result.bounds.eb.lat;
            //       //地图显示当前城市
            //       let params = {
            //         mapType: 2,
            //         longitude: vm.currentAddress.provinceId ? "" : result.bounds.eb.lng,
            //         latitude: vm.currentAddress.cityId ? "" : result.bounds.eb.lat,
            //         provinceCode: '',
            //         cityCode: '',
            //         areaCode: '',
            //         brandId: vm.brandId || '',
            //         storeId: '',
            //         goodsId: '',
            //         provinceId: vm.currentAddress.provinceId || "",
            //         cityId: vm.currentAddress.cityId || "",
            //         areaId: vm.currentAddress.areaId || "",
            //       }
            //       vm.pageDealerStore([params, 1, 20]).then(res => {
            //         vm.markerList.render(res.result);
            //       })
            //     }
            //   }
            // });
            // });
          }
        }
      };
      this.amap = amap;
    },

    //获取实体门店数据
    getPageDealerStore: function getPageDealerStore(lat, lng) {
      var _this2 = this;

      var params = {
        mapType: 2,
        longitude: this.lng || "",
        latitude: this.lat || "",
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        brandId: this.brandId || '',
        storeId: '',
        goodsId: '',
        provinceId: this.currentAddress.provinceId || "",
        cityId: this.currentAddress.cityId || "",
        areaId: this.currentAddress.areaId || ""
      };
      this.pageDealerStore([params, 1, 20]).then(function (res) {
        _this2.markerList.render(res.result);
      });
    },

    //地址看确认
    adressFirm: function adressFirm() {
      if (this.isAddress) {
        this.brandId = '';
        this.brandName = '全部品牌';
        this.Brands.forEach(function (item) {
          item.selected = false;
        });
      }
      this.addressPopup = false;
      this.isAddress = true;
      //this.getAmapContent();
      this.getPageDealerStore();
    },

    //地址出现弹框
    clickProvince: function clickProvince(areaId) {
      this.addressMsgShow = '请选择区域';
      this.addressProvince = '';
      this.cityNameShow = '';
      this.currentAddress.province = '';
      this.currentAddress.provinceId = '';
      this.currentAddress.city = '';
      this.currentAddress.cityId = '';
      this.currentAddress.areaId = '';
      this.currentAddress.area = '';
      this.currentAddress.townId = '';
      this.currentAddress.town = '';
      this.shoWOr = 1;
    },

    // 点击省出现下级
    shooseProvince: function shooseProvince(provinceId, provinceName) {
      //this.clickProvince();
      this.shoWOr = 2;
      this.getCityListShow(provinceId); //获取城市列表
      this.currentAddress.provinceId = provinceId; //保存id
      this.currentAddress.province = provinceName; //保存名字
      this.addressProvince = provinceName; //名字在页面展示
      this.addressMsgShow = provinceName; //选择框展示
    },

    //点击城市出现下级
    shooseCity: function shooseCity(cityId, cityName) {
      var _this3 = this;

      this.getTownMsg(cityId); //获取城镇信息
      //setTimeout(this.getTownMsg(cityId), 1); //获取城镇信息
      //this.addressMsgShow = this.addressProvince + cityName; //选择框展示城市名字
      this.currentAddress.city = cityName; //保存城市名字
      this.cityNameShow = cityName; //展示城市名字
      this.currentAddress.cityId = cityId; //保存城市id
      this.chooseCityId = cityId; //选中城市的id
      this.addressMsgShow = this.addressProvince + '/' + this.cityNameShow;
      this.listAreaMsg(cityId).then(function (res) {
        _this3.areaAddressMsg = res.target;
        if (_this3.areaAddressMsg.length == 0) {
          _this3.addressMsgShow = _this3.addressProvince + '/' + _this3.cityNameShow; //选择框展示城市名字
          _this3.shoWOr = 2; //关闭地址选择框
          return;
        } else if (_this3.areaAddressMsg.length != 0) {
          _this3.shoWOr = 3;
        }
      });
    },

    //点击区域出现下一级
    shooseArea: function shooseArea(areaId, areaName) {
      var _this4 = this;

      this.currentAddress.areaId = areaId; //保存的区域id
      this.chooseAreaId = areaId; //保存的id
      this.currentAddress.area = areaName; //保存地址名称
      this.areaNameShow = areaName; //展示的街道
      this.addressMsgShow = this.addressProvince + '/' + this.cityNameShow + '/' + this.areaNameShow;
      //this.chooseBox = false; //关闭地址框
      this.listAreaMsg(areaId).then(function (res) {
        _this4.getStreetMsgList = res.target;
        if (_this4.getStreetMsgList.length == 0) {
          _this4.shoWOr = 3;
        } else {
          _this4.shoWOr = 4;
        }
      });
    },

    //点击街道出现下一级
    shooseStreet: function shooseStreet(areaId, areaName) {
      var _this5 = this;

      this.currentAddress.townId = areaId; //保存的区域id
      this.chooseStreetId = areaId; //保存街道id
      this.currentAddress.town = areaName; //保存地址名称
      this.streetNameShow = areaName; //展示的街道
      //this.chooseBox = false; //关闭地址框
      this.addressMsgShow = this.addressProvince + '/' + this.cityNameShow + '/' + this.areaNameShow + '/' + this.streetNameShow;
      this.listAreaMsg(areaId).then(function (res) {
        _this5.lastMsg = res.target;
      });
    },

    //获取区域的列表api
    getAreaMsg: function getAreaMsg(areaId) {
      var _this6 = this;

      this.listAreaMsg(areaId).then(function (res) {
        _this6.getStreetMsgList = res.target;
      });
    },

    //获取城镇信息api
    getTownMsg: function getTownMsg(cityId) {
      var _this7 = this;

      this.listAreaMsg(cityId).then(function (res) {
        _this7.areaAddressMsg = res.target;
      });
    },

    //获取城市的列表api
    getCityListShow: function getCityListShow(provinceId) {
      var _this8 = this;

      this.listAreaMsg(provinceId).then(function (result) {
        _this8.cityListShow = result.target;
      });
    },

    //获取省份列表api
    getListAreaMsg: function getListAreaMsg(addressCode) {
      var _this9 = this;

      this.listAreaMsg(addressCode).then(function (result) {
        _this9.arealistMsg = result.target;
      }).catch(function (error) {});
    }
  }),
  mounted: function mounted() {
    this.getAmapContent();
    //获取地域列表
    this.getListAreaMsg(this.addressCode);
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      dialog: true,
      checkedLists: [],
      questionLists: [],
      paperId: "",
      actionUrl: __WEBPACK_IMPORTED_MODULE_2__Constant__["a" /* default */].uploadBaseUrl + "/apps", //提交URL
      imgUrl: __WEBPACK_IMPORTED_MODULE_2__Constant__["a" /* default */].imgBaseUrl,
      answers: [],
      toast: {
        isShow: false,
        messageTip: ""
      },
      mobile: "",
      orderId: "",
      authCode: "",
      codeTitle: "获取验证码",
      time: 120,
      timmer: "",
      isDisabled: false,
      token: "",
      mainTarget: "",
      mainType: "",
      isReadonly: false,
      fitMobile: "",
      fitMan: "",

      randomCodePath: "",
      randomCode: ""
    };
  },
  created: function created() {
    this.userAttrId = __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].storage.session.get("userAttrId");
    this.randomCodePath = __WEBPACK_IMPORTED_MODULE_2__Constant__["a" /* default */].imgBaseUrl + "/random?v=" + Math.random() + "&userAttrId=" + this.userAttrId;
  },
  mounted: function mounted() {
    this.mobile = this.$route.query.mobile || "";
    this.isReadonly = !this.mobile ? false : true;
    this.orderId = this.$route.query.orderId || "";
    this.mainTarget = this.$route.query.mainTarget || "";
    this.mainType = this.$route.query.mainType || "";
    if (this.mainTarget && this.mainType) {
      this.dialog = false;
    }
    this.loadData();
  },

  computed: {
    phone: function phone() {
      var phone = "";
      if (this.mobile) {
        phone = this.mobile.substring(0, 4) + "****" + this.mobile.substring(7, 11);
      }

      return phone;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapActions"])({
    getPaperByCode: "getPaperByCode", //获取问卷内容
    commitPaper: "commitPaper", //保存问卷调查的内容
    commitPaperArea: "commitPaperArea", //保存大区内容
    sendAuthCodeSms: "sendAuthCodeSms", //获取验证码
    checkSmsCode: "checkSmsCode", //手机号验证
    initPriceMain: "initPriceMain" //初始化大区价格
  }), {

    //刷新图片验证码
    refreshImgCode: function refreshImgCode() {
      this.userAttrId = __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].storage.session.get("userAttrId");
      this.randomCodePath = __WEBPACK_IMPORTED_MODULE_2__Constant__["a" /* default */].imgBaseUrl + "/random?v=" + Math.random() + "&userAttrId=" + this.userAttrId;
    },
    changePhone: function changePhone(e, type) {
      var reg = /[^\d|]/g;
      if (!__WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].isNum(e.key)) {
        if (type == 1) {
          this.fitMobile = this.fitMobile.replace(e.key, "");
          this.fitMobile = this.fitMobile.replace(reg, "");
        } else if (type == 2) {
          this.mobile = this.mobile.replace(e.key, "");
          this.mobile = this.mobile.replace(reg, "");
        }
      }
    },
    getAnswers: function getAnswers() {
      var lists = [];
      if (this.questionLists && this.questionLists.length) {
        this.questionLists.forEach(function (item) {
          var obj = {};
          obj.queId = item.queId;
          switch (item.queType) {
            case 1:
              obj.label = "radio";
              obj.optId = "";
              break;
            case 2:
              obj.optIds = [];
              break;
            case 3:
              obj.optText = "";
              break;
            case 4:
              obj.attachs = [];
              break;
          }
          lists.push(obj);
        });
      }
      return lists;
    },
    loadData: function loadData() {
      var _this2 = this;

      var data = {
        paperCode: this.mainTarget && this.mainType ? "priceMainPaper" : "orderServicePaper"
      };
      this.getPaperByCode(data).then(function (res) {
        _this2.questionLists = res.simQuestions;
        _this2.paperId = res.paperId;
        _this2.answers = _this2.getAnswers();
        document.title = res.paperName;
      });
    },
    getAttachs: function getAttachs(index) {
      return this.answers && this.answers.length && this.answers[index] && this.answers[index].attachs;
    },
    submitFn: function submitFn() {
      var _this3 = this;

      if (!this.fitMobile && !this.mainType && !this.mainTarget) {
        this.showTipMessage(true, "安装电话不能为空！");
        return;
      } else if (!this.fitMan && !this.mainType && !this.mainTarget) {
        this.showTipMessage(true, "安装人不能为空！");
        return;
      }
      var dataInfo = {
        paperId: this.paperId,
        simAnswers: ""
      };
      dataInfo.simAnswers = __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].deepCopy(this.answers);
      dataInfo.mobile = this.mobile;
      dataInfo.simAnswers.forEach(function (item) {
        if (item.label) {
          item.optIds = [];
          if (item.optId) {
            item.optIds.push(item.optId);
          }
        }
      });
      dataInfo.orderId = this.orderId || "";
      dataInfo.fitMobile = this.fitMobile;
      dataInfo.fitMan = this.fitMan;
      var data = {
        data: dataInfo,
        token: this.token
      };
      if (this.mainTarget && this.mainType) {
        data.data.mainId = this.$route.query["mainId"] || "";
        this.commitPaperArea(data).then(function (res) {
          if (res.code == 200) {
            if (_this3.mainTarget && _this3.mainType) {
              _this3.initPriceMainFn();
              return;
            }
            _this3.$router.push({
              path: "/"
            });
          } else {
            _this3.showTipMessage(true, "提交失败");
          }
        }).catch(function (error) {
          _this3.showTipMessage(true, error || "提交失败");
        });
        return;
      }
      this.commitPaper(data).then(function (res) {
        if (res.code == 200) {
          if (_this3.mainTarget && _this3.mainType) {
            _this3.initPriceMainFn();
            return;
          }
          _this3.$router.push({
            path: "/"
          });
        } else {
          _this3.showTipMessage(true, "提交失败");
        }
      }).catch(function (error) {
        _this3.showTipMessage(true, error || "提交失败");
      });
    },
    initPriceMainFn: function initPriceMainFn() {
      var _this4 = this;

      var priceMain = {
        mainType: this.mainType,
        mainTarget: this.mainTarget
      };
      this.initPriceMain([priceMain]).then(function (res) {
        _this4.$router.push({
          path: "/"
        });
      });
    },
    change: function change(e, index, id) {
      console.log(index);
      var checkedLists = this.answers[index].optIds;
      console.log(e);
      if (checkedLists && checkedLists.length) {
        if (e.target.checked) {
          checkedLists.push(id);
        } else {
          checkedLists = checkedLists.filter(function (item) {
            return item != id;
          });
        }
      } else {
        checkedLists.push(id);
      }

      var obj = this.answers[index];
      obj.optIds = checkedLists;
      this.$set(this.answers, index, obj);
    },


    //删除图片
    deleteImg: function deleteImg(id, index) {
      var obj = this.answers[index];
      obj.attachs = obj.attachs.filter(function (item) {
        return item.attach_Id != id;
      });

      this.$set(this.answers, index, obj);
    },


    /*提示信息*/
    showTipMessage: function showTipMessage(isShow, msg) {
      var _this5 = this;

      this.toast.isShow = isShow;
      this.toast.messageTip = msg;
      setTimeout(function () {
        _this5.toast.isShow = false;
      }, 1500);
    },


    //图片压缩
    canvasSelImg: function canvasSelImg(event, index) {
      var _this = this;
      var file = event.target.files[0];
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      var str = "JPG/JPEG/PNG/GIF";
      var errorImgMsg = "文件格式只能是:jpg、png、jpeg、gif";
      if (str.indexOf(testmsg.toUpperCase()) < 0) {
        this.showTipMessage(true, errorImgMsg);
        return;
      }

      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        var oReader = new FileReader();
        oReader.onload = function (e) {
          var _this6 = this;

          var image = new Image();
          image.src = e.target.result;
          __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].imgScale(e.target.result, file, 4).then(function (result) {
            __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["c" /* default */].canvasUpload(_this.actionUrl, result, file).then(function (res) {
              event.target.value = "";
              if (!res.returnTargets[0].fileId) {
                _this.showTipMessage(true, "上传失败");
                return;
              }
              _this.showTipMessage(true, "上传成功");
              res.returnTargets[0].fileName = __WEBPACK_IMPORTED_MODULE_2__Constant__["a" /* default */].imgBaseUrl + "/image/" + res.returnTargets[0].fileName;

              var oldData = _this.answers;

              //存储上传的文件
              var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, oldData[index]);
              var lists = [];
              lists.push({
                attachId: res.returnTargets[0].fileId,
                fileUrl: res.returnTargets[0].fileName
              });

              obj.attachs = obj.attachs.concat(lists);
              _this.$set(_this.answers, index, obj);
            }).catch(function (err) {
              event.target.value = "";
              _this6.showTipMessage(true, err || "上传失败");
            });
          });
        };
        oReader.readAsDataURL(file);
      };
    },


    //获取验证码
    getAuthCode: function getAuthCode() {
      var _this7 = this;

      if (this.isDisabled) {
        return;
      }
      if (!this.mobile) {
        this.showTipMessage(true, "请输入手机号！");
        return;
      }

      if (!this.randomCode) {
        this.showTipMessage(true, "请输入图片验证码");
        return;
      }

      var _this = this;

      this.sendAuthCodeSms([this.mobile, this.randomCode]).then(function (res) {
        if (res.success) {
          _this7.timmer = setInterval(function () {
            _this.codeTitle = _this.time + "s后获取";
            _this.isDisabled = true;
            _this.time--;
            if (_this.time == 0) {
              _this.codeTitle = "获取验证码";
              _this.isDisabled = false;
              clearInterval(_this.timmer);
            }
          }, 1000);
        }
      });
    },
    loginCode: function loginCode() {
      var _this8 = this;

      if (!this.mobile) {
        this.showTipMessage(true, "手机号码不能为空！");
        return;
      } else if (!this.authCode) {
        this.showTipMessage(true, "验证码不能为空！");
        return;
      }
      var data = {
        mobile: this.mobile,
        authCode: this.authCode
      };
      this.checkSmsCode([this.mobile, this.authCode]).then(function (res) {
        if (res.success) {
          _this8.dialog = false;
          _this8.token = res.target.token;
        } else {
          _this8.showTipMessage(true, "验证失败");
        }
      }).catch(function (error) {
        _this8.showTipMessage(true, error || "验证失败");
      });
    }
  })
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js_flexible_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js_flexible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_js_flexible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_muse_ui__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_muse_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_muse_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_lazyload__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__service_index__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__service_api__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_utils_index__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_js_common_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_amap__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_amap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters_index__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_weixin_js_sdk__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_sass_common_scss__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_sass_common_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__common_sass_common_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_reset_css__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__static_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_muse_ui_dist_muse_ui_css__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_muse_ui_dist_muse_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_muse_ui_dist_muse_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_sass_mixin_scss__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_sass_mixin_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__common_sass_mixin_scss__);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







 //图片懒加载
 //图片轮播









// import { Toast, Dialog, Radio, RadioGroup } from "vant";

//引入高德地图
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_amap___default.a);
__WEBPACK_IMPORTED_MODULE_15_vue_amap___default.a.initAMapApiLoader({
  key: "4a30ddcd0a6a31f5763053428c0dad35",
  plugin: ["AMap.Autocomplete", "AMap.Geolocation", "AMap.PlaceSearch", "AMap.Geolocation", "AMap.CitySearch", "AMap.Scale", "AMap.OverView", "AMap.ToolBar", "AMap.MapType", "AMap.PolyEditor", "AMap.CircleEditor", "AMap.AdvancedInfoWindow"],
  uiVersion: "1.0" // 版本号
});

// 全局filter注册
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_16__filters_index__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.filter(key, __WEBPACK_IMPORTED_MODULE_16__filters_index__[key]);
});

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.config.productionTip = false;

/*引入css*/




__webpack_require__(146);

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14__common_js_common_js__["a" /* default */]); //引入公用js
/*插件注册*/
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_muse_ui___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11__service_index__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13__common_utils_index__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_lazyload__["a" /* default */], {
  error: "/static/images/defaults/lazy-default.png", //失败后默认图
  loading: "/static/images/defaults/lazy-default.png", //loading过渡图
  try: 3 // 加载重试次数
});

//页面路由
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */])().then(function (routerConfig) {
  var router = new __WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]({
    routes: routerConfig,
    mode: "history"
  });
  router.beforeEach(function (to, from, next) {
    var skipWxAuth = to.meta && to.meta.skipWxAuth;
    if (!skipWxAuth) {
      // 微信分享
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__common_js_common_js__["b" /* initWxShare */])(to.fullPath);
    }

    //设置微信title
    if (to.meta.title) {
      var title = to.meta.title;
      document.title = title;
    } else {
      document.title = "美心门商城";
    }

    console.log(to.meta.title);
    //判断是否是在登陆售后系统之后进入其它板块，true时已经登录过售后系统
    var isCustomerService = __WEBPACK_IMPORTED_MODULE_18__common_utils_util__["a" /* storage */].session.get("customerService");
    var cusToken = __WEBPACK_IMPORTED_MODULE_18__common_utils_util__["a" /* storage */].session.get("cusToken");

    //当前为售后系统时，再次进入页面不需要清空storage，不需要重新登录
    //当在售后登陆之后，进入商城需要重新登陆
    if (!isCustomerService && to.meta.belong == "customerService" && cusToken) {
      __WEBPACK_IMPORTED_MODULE_18__common_utils_util__["a" /* storage */].local.set("token", cusToken);
    } else if (isCustomerService && to.meta.belong != "customerService") {
      //当登录了售后系统之后再进入其他板块需要清空token和用户信息
      __WEBPACK_IMPORTED_MODULE_18__common_utils_util__["a" /* storage */].local.remove("token");
      __WEBPACK_IMPORTED_MODULE_18__common_utils_util__["a" /* storage */].local.remove("USERINFO");
      __WEBPACK_IMPORTED_MODULE_18__common_utils_util__["a" /* storage */].session.set("customerService", false);
    }
    __WEBPACK_IMPORTED_MODULE_18__common_utils_util__["a" /* storage */].local.set("belong", to.meta.belong || "");
    //alert('跳转至：' + to.fullPath + ' ,是否需要登录： ' + !!to.meta.requireAuth + ' ,是否自动登陆：' + !!to.query.autologin);
    if (to.meta.requireAuth || to.query.autologin) {
      if (to.query.autologin) {
        delete to.query.autologin;
      }

      //本地没有userAttrId 或者 userInfo 直接跳转到auth
      //TODO

      //调用api判断是否已登陆
      __WEBPACK_IMPORTED_MODULE_12__service_api__["a" /* default */].loginHanlder.checkLogin([]).then(function (res) {
        console.log("res", res);
        if (res.success && res.target && res.target.success) {
          //alert('已登录，放行');

          //完整路径
          if (to.fullPath.includes("http")) {
            location.href = to.fullPath.startsWith("/") ? to.fullPath.substring(1) : to.fullPath;
          } else {
            next();
          }
        } else {
          var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, to.query, {
            redirect: to.fullPath
          });

          if (to.meta.belong == "questions") {
            next({
              path: "/main/questionLogin",
              query: query
            });
          } else {
            next({
              path: "/main/auth?isQuestionLogin=" + (to.meta.isQuestionLogin || "false"),
              query: query
            });
          }
        }
      });
    } else {
      next();
    }
  });
  new __WEBPACK_IMPORTED_MODULE_2_vue___default.a({
    el: "#app",
    router: router,
    store: __WEBPACK_IMPORTED_MODULE_5__store_index__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
    }
  });
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cmt400Router = [{
  path: "cmt",
  name: "cmt",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(155)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "400服务评价",
    skipWxAuth: true // 跳过微信授权
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (cmt400Router);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var afterSaleCommentsRouter = [{
  path: 'afterSaleComment',
  name: 'afterSaleComment',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(427)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '评价'
  }
}, {
  path: 'asl',
  name: 'asl',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(428)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '评价登录'
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (afterSaleCommentsRouter);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import index from '@views/agency/index'; //经销商主页
// import agencyLogin from '@views/agency/login'; //经销商主页
// import recordList from '@views/agency/recordList'; //全局备案查询列表
// import myRecordList from '@views/agency/myRecordList'; //我的备案列表
// import projectRecordForm from '@views/agency/projectRecordForm'; //工程备案申请表
// import cashDepositForm from '@views/agency/cashDepositForm'; //退备案保证金
// import protectionRecordForm from '@views/agency/protectionRecordForm'; //保护区备案登记表
// import againRecordForm from '@views/agency/againRecordForm'; //工程备案续备案
// import newComPage from '@views/agency/newComPage'; //公示公告、新品发布、管理制度
// import newComContent from '@views/agency/newComContent'; //公示公告、新品发布、管理制度相关详情
// import legalPersonAuth from '@views/agency/legalPersonAuth'; //法人授权
// import legalPersonAuthForm from '@views/agency/legalPersonAuthForm';
// import myJob from '@views/agency/myJob';
// import specialStore from '@views/agency/specialStore';//专卖店首页
var agencyRouter = [{
  path: "index",
  name: "index",
  // component: index,
  component: function component(resolve) {
    return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(433)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "经销商专区",
    requireAuth: false
  }
}, {
  path: "agencyLogin",
  name: "agencyLogin",
  // component: agencyLogin

  component: function component(resolve) {
    return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(436)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "recordList",
  name: "recordList",
  // component: recordList

  component: function component(resolve) {
    return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(454)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "myRecordList",
  name: "myRecordList",
  // component: myRecordList

  component: function component(resolve) {
    return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(442)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "projectRecordForm",
  name: "projectRecordForm",
  // component: projectRecordForm,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(451)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "工程备案申请表",
    requireAuth: false
  }
}, {
  path: "cashDepositForm",
  name: "cashDepositForm",
  // component: cashDepositForm,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(430)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "退备案保证金",
    requireAuth: false
  }
}, {
  path: "protectionRecordForm",
  name: "protectionRecordForm",
  // component: protectionRecordForm,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(452)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "保护区备案登记表",
    requireAuth: false
  }
}, {
  path: "againRecordForm",
  name: "againRecordForm",
  // component: againRecordForm,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(429)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "工程备案续备案",
    requireAuth: false
  }
}, {
  path: "newComPage",
  name: "newComPage",
  // component: newComPage,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(444)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    requireAuth: false
  }
}, {
  path: "newComContent",
  name: "newComContent",
  // component: newComContent,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(443)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "legalPersonAuth",
  name: "legalPersonAuth",
  // component: newComContent,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(434)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "legalPersonAuthForm",
  name: "legalPersonAuthForm",
  // component: newComContent,

  component: function component(resolve) {
    return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(435)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "myJob",
  name: "myJob",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(441)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "specialStore",
  name: "specialStore",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(455)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "specialStoreAdd",
  name: "specialStoreAdd",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(456)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "publicSigns",
  name: "publicSigns",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(453)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "specialStoresSearch",
  name: "specialStoresSearch",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(459)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "mainSpecialStore",
  name: "mainSpecialStore",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(438)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "mainSpecialStoreAdd",
  name: "mainSpecialStoreAdd",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(439)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "mainPublicSigns",
  name: "mainPublicSigns",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(437)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "mainSpecialStoresSearch",
  name: "mainSpecialStoresSearch",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(440)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "dissentList",
  name: "dissentList",

  component: function component(resolve) {
    return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(432)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "noteList",
  name: "noteList",

  component: function component(resolve) {
    return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(445)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "closeRate",
  name: "closeRate",

  component: function component(resolve) {
    return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(431)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "specialStoreCheck",
  name: "specialStoreCheck",

  component: function component(resolve) {
    return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(457)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "specialStoreImage",
  name: "specialStoreImage",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(458)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
},

// 战略采集备案
{
  path: "projectPurchaseList",
  name: "projectPurchaseList",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(449)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
},

// 战略采集备案-公示区
{
  path: "projectPurchasePublicityList",
  name: "projectPurchasePublicityList",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(450)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
},

// 战略采集备案表单
{
  path: "projectPurchaseForm",
  name: "projectPurchaseForm",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(448)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
},

// 工程备案-公海
{
  path: "projectOpenList",
  name: "projectOpenList",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(447)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
},

// 工程备案-公海详情
{
  path: "projectOpenForm",
  name: "projectOpenForm",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(446)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (agencyRouter);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_cart_cart__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_cart_cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_cart_cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_cart_selectaddress__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_cart_selectaddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_cart_selectaddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_cart_writeinvoice__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_cart_writeinvoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_cart_writeinvoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_cart_firmorder__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_cart_firmorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_cart_firmorder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_cart_paysuccess__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_cart_paysuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_cart_paysuccess__);





var cartRouter = [{
  path: 'cart',
  name: 'cart',
  // component: cart,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(101)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '购物车',
    id: '3'
  }
}, {
  path: 'selectaddress',
  name: 'selectaddress',
  // component: selectaddress,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '选择地址',
    requireAuth: true
  }
}, {
  path: 'writeinvoice',
  name: 'writeinvoice',
  // component: writeinvoice,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(105)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '发票',
    requireAuth: true
  }
}, {
  path: 'firmorder',
  name: 'firmorder',
  // component: firmorder,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(102)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '确认订单',
    requireAuth: true
  }
}, {
  path: 'firmpay',
  name: 'firmpay',
  // component: firmorder,
  component: function component(resolve) {
    return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(460)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '确认支付',
    requireAuth: true
  }
}, {
  path: 'paysuccess',
  name: 'paysuccess',
  // component: paysuccess,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(103)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '支付成功',
    requireAuth: true
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (cartRouter);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_classify_classify__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_classify_classify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_classify_classify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_classify_search__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_classify_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_classify_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_classify_goodsDetail__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_classify_goodsDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_classify_goodsDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_classify_goods__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_classify_goods___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_classify_goods__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_classify_evaluate__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_classify_evaluate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_classify_evaluate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_classify_detail__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_classify_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_classify_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_classify_parameter__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_classify_parameter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_classify_parameter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_classify_goodsDiy__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_classify_goodsDiy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_classify_goodsDiy__);









var classifyRouter = [{
  path: "classify",
  name: "classify",
  // component: classify,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(106)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "品牌分类",
    id: "2"
  }
}, {
  path: "search",
  name: "search",
  // component: search
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(113)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "goodsDetail",
  // component: goodsDetail,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(110)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: "",
    name: "goods",
    // component: goods,
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(109)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      id: 0
    }
  }, {
    path: "detail",
    name: "detail",
    // component: detail,
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(107)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      id: 1
    }
  }, {
    path: "parameter",
    name: "parameter",
    // component: parameter,
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      id: 2
    }
  }, {
    path: "evaluate",
    name: "evaluate",
    // component: evaluate,
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(108)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      id: 3
    }
  }, {
    path: "goodsDiy",
    name: "goodsDiy",
    // component: goodsDiy,
    component: function component(resolve) {
      return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      id: -1
    }
  }]
}, {
  path: "diyPage",
  name: "diyPage",
  // component: goodsDiy,
  title: "美心门产品展示",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(461)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    id: -1,
    title: "美心门产品展示"
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (classifyRouter);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var customOrderRouter = [{
  path: 'customorder',
  name: 'customorder',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(464)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '网上订单',
    requireAuth: false
  }
}, {
  path: 'addorder',
  name: 'addorder',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(463)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '订单信息',
    requireAuth: false
  }
}, {
  path: 'addmateriel',
  name: 'addmateriel',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(462)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '料品信息',
    requireAuth: false
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (customOrderRouter);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var customerServiceRouter = [{
	path: 'customerLogin',
	name: 'customerLogin',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(467)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '用户登录',
		belong: 'customerService'
	}
}, {
	path: 'erectorPage',
	name: 'erectorPage',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(471)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '安装',
		belong: 'customerService'
	}
}, {
	path: 'customerPageOne',
	name: 'customerPageOne',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(468)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '用户评价',
		belong: 'customerService'
	}
}, {
	path: 'customerPageTwo',
	name: 'customerPageTwo',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(469)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '用户评价',
		belong: 'customerService'
	}
}, {
	path: 'agencyPage',
	name: 'agencyPage',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(465)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '处理',
		belong: 'customerService'
	}
}, {
	path: 'serviceList',
	name: 'serviceList',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(472)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '美心门',
		belong: 'customerService'
	}
}, {
	path: 'csi',
	name: 'csi',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(470)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '美心门',
		belong: 'customerService'
	}
}, {
	path: 'complainPage',
	name: 'complainPage',
	component: function component(resolve) {
		return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(466)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '投诉',
		belong: 'customerService'
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (customerServiceRouter);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_error_404_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_error_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_error_404_vue__);


var errorRouter = [{
  path: '*', //404
  component: __WEBPACK_IMPORTED_MODULE_0__views_error_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (errorRouter);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var fittingRouter = [{
  path: 'apply',
  name: 'apply',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(473)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '安装队申请',
    belong: 'fitting'

  }
}, {
  path: 'record',
  name: 'record',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(479)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '项目记录',
    belong: 'fitting'

  }
}, {
  path: 'detail',
  name: 'detail',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(474)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '详情',
    belong: 'fitting'

  }
}, {
  path: 'process',
  name: 'process',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(477)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '进度',
    belong: 'fitting'

  }
}, {
  path: 'receive',
  name: 'receive',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(478)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '收货',
    belong: 'fitting'

  }
}, {
  path: 'role',
  name: 'role',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(481)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '选择登录方式',
    requireAuth: false
  }
}, {
  path: 'login',
  name: 'fittingLogin',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(476)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '登录',
    requireAuth: false
  }
}, {
  path: 'register',
  name: 'register',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(480)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '注册',
    requireAuth: false
  }
}, {
  path: 'forgetpsw',
  name: 'forgetpsw',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(475)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: '忘记密码',
    requireAuth: false
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (fittingRouter);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_home_home__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_home_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_home_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_home_brandHome__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_home_brandHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_home_brandHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_allSearch__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_allSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_home_allSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_home_sunhomedetail__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_home_sunhomedetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_home_sunhomedetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_home_sunhomelist__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_home_sunhomelist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_home_sunhomelist__);






var homeRouter = [{
	path: 'home',
	name: 'home',
	// component: home,
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(116)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '美心门商城',
		id: '1'
	}
}, {
	path: 'brandHome',
	name: 'brandHome',
	// component: brandHome
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(115)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	}
}, {
	path: 'allSearch',
	name: 'allSearch',
	// component: allSearch
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(114)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	}
}, {
	path: 'sunhomedetail',
	name: 'sunhomedetail',
	// component: sunhomedetail
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(117)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	}
}, {
	path: 'sunhomelist',
	name: 'sunhomelist',
	// component: sunhomelist,
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(118)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		keepAlive: true
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (homeRouter);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var installStudyRouter = [{
  path: "install-study",
  name: "install-study",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(482)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    keepAlive: true
  }
}, {
  path: "install-study-detail",
  name: "install-study-detail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(483)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (installStudyRouter);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_login_login__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_login_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_login_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_login_auth__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_login_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_login_auth__);



var loginRouter = [{
	path: 'login',
	name: 'login',
	// component: login,
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(120)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '登录'
	}
}, {
	path: 'auth',
	name: 'auth',
	// component: auth,
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(119)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '登录'
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (loginRouter);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_personal_personal__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_personal_personal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_personal_personal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_personal_userinfo__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_personal_userinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_personal_userinfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_personal_editnickname__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_personal_editnickname___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_personal_editnickname__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_personal_myorders__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_personal_myorders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_personal_myorders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_personal_quitsuccess__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_personal_quitsuccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_personal_quitsuccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_personal_orderdetail__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_personal_orderdetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_personal_orderdetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_personal_evaluation__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_personal_evaluation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_personal_evaluation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_personal_myaccount__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_personal_myaccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_personal_myaccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_personal_myredpack__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_personal_myredpack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_personal_myredpack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_personal_mycoupon__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_personal_mycoupon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_personal_mycoupon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_personal_myaddress__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_personal_myaddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_personal_myaddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_personal_invoiceinfo__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_personal_invoiceinfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_personal_invoiceinfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_personal_mycomments__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_personal_mycomments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_personal_mycomments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_personal_mycollection__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_personal_mycollection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_personal_mycollection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_personal_writeaddress__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_personal_writeaddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_personal_writeaddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_personal_publishsunhome__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_personal_publishsunhome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_personal_publishsunhome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_personal_searchbeloworders__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_personal_searchbeloworders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_personal_searchbeloworders__);


















var personalRouter = [{
	path: 'personal',
	name: 'personal',
	// component: personal,
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(132)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '我的',
		id: '4',
		requireAuth: true
	},
	children: []
}, {
	path: 'userinfo',
	name: 'userinfo',
	// component: userinfo, //用户信息编辑
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '个人信息',
		requireAuth: true
	}

}, {
	path: 'editnickname',
	name: 'editnickname',
	// component: editnickname, //编辑用户昵称
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(121)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '修改昵称',
		requireAuth: true
	}
}, {
	path: 'myorders',
	name: 'myorders',
	// component: myorders, //我的订单
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '我的订单',
		requireAuth: true
	}
}, {
	path: 'quitsuccess',
	name: 'quitsuccess',
	// component: quitsuccess, //申请后
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '申请提交',
		requireAuth: true
	}
}, {
	path: 'orderdetail',
	name: 'orderdetail',
	// component: orderdetail, //订单详情
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '订单详情',
		requireAuth: true
	}
}, {
	path: 'evaluation',
	name: 'evaluation',
	// component: evaluation, //评价
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '评价',
		requireAuth: true
	}
}, {
	path: 'myaccount',
	name: 'myaccount',
	// component: myaccount, //我的账户
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '我的账户',
		requireAuth: true
	}
}, {
	path: 'myredpack',
	name: 'myredpack',
	// component: myredpack, //我的红包
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '我的红包',
		requireAuth: true
	}
}, {
	path: 'mycoupon',
	name: 'mycoupon',
	// component: mycoupon, //我的优惠券
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '我的优惠券',
		requireAuth: true
	}
}, {
	path: 'myaddress',
	name: 'myaddress',
	// component: myaddress, //收货地址
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '收货地址',
		requireAuth: true
	}
}, {
	path: 'invoiceinfo',
	name: 'invoiceinfo',
	// component: invoiceinfo, //发票信息
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '发票信息',
		requireAuth: true
	}
}, {
	path: 'mycomments',
	name: 'mycomments',
	// component: mycomments, //我的评论
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '我的评论',
		requireAuth: true
	}
}, {
	path: 'mycollection',
	name: 'mycollection',
	// component: mycollection, //我的收藏
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '我的收藏',
		requireAuth: true
	}
}, {
	path: 'writeaddress',
	name: 'writeaddress',
	// component: writeaddress, //填写地址
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '添加新地址',
		requireAuth: true
	}
}, {
	path: 'publishsunhome',
	name: 'publishsunhome',
	// component: publishsunhome, //填写地址
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '晒家分享',
		requireAuth: true
	}
}, {
	path: 'searchbeloworders',
	name: 'searchbeloworders',
	// component: searchbeloworders, //填写地址
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '搜索线下订单'
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (personalRouter);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_physicalStores_physicalStores__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_physicalStores_physicalStores___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_physicalStores_physicalStores__);


var physicalStoresRouter = [{
	path: 'physicalStores',
	name: 'physicalStores',
	// component: physicalStores,
	component: function component(resolve) {
		return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
	},
	meta: {
		title: '店面搜索'
	}
}];

/* harmony default export */ __webpack_exports__["a"] = (physicalStoresRouter);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var prodIntroRouter = [{
  path: "prod-intro",
  name: "prod-intro",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(484)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    keepAlive: true
  }
}, {
  path: "prod-intro-detail",
  name: "prod-intro-detail",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(485)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (prodIntroRouter);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_questions_index__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_questions_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_questions_index__);


var questionsRouter = [{
  path: "questions",
  name: "questions",
  // component: physicalStores,
  component: function component(resolve) {
    return new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "店面搜索",
    belong: "questions"
  }
}, {
  path: "welcome",
  name: "welcome",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(492)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "欢迎页",
    belong: "questions"
  }
}, {
  path: "questionLogin",
  name: "questionLogin",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(490)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "登录",
    belong: "questions"
  }
}, {
  path: "questionReg",
  name: "questionReg",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(491)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "注册",
    belong: "questions"
  }
}, {
  path: "forgetPwd",
  name: "forgetPwd",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(487)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "忘记密码",
    belong: "questions"
  }
}, {
  path: "direction",
  name: "direction",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(486)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "使用说明",
    isQuestionLogin: true,
    requireAuth: true,
    belong: "questions"
  }
}, {
  path: "wxLogin",
  name: "wxLogin",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(493)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "微信登录",
    belong: "questions"
  }
}, {
  path: "projectList",
  name: "projectList",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(488)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "工程列表",
    keepAlive: true
  }
}, {
  path: "pulishComment",
  name: "pulishComment",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(489)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "评价"
  }
}, {
  path: "400-cmt",
  name: "400-cmt",
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(155)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    title: "评价"
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (questionsRouter);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserAttrId", function() { return updateUserAttrId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initPriceMain", function() { return initPriceMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerLink", function() { return getCustomerLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);





//全局Actions
var updateUserAttrId = function updateUserAttrId(_ref, userAttrId) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* UPDATE_USER_ATTR_ID */], userAttrId);
};

//初始化大区价格
var initPriceMain = function initPriceMain(_ref2, priceMain) {
  var commit = _ref2.commit;

  return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
    fn: 'mallsale.goodsHandler.initPriceMain',
    param: priceMain
  }).then(function (result) {
    if (result && result.success && result.target && result.target.success) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || '获取数据失败');
    }
  }).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

//获取客服链接
var getCustomerLink = function getCustomerLink(_ref3, storeId) {
  var commit = _ref3.commit;

  return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
    fn: 'mallsale.storeHandler.getStoreCustomerService',
    param: [storeId]
  }).then(function (result) {
    if (result && result.success && result.target && result.target.success) {
      var linkType = result.target.target;
      var link = null;
      switch (linkType) {
        case 'QTxWWKm':
          //美心元素
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297261&userId=24628015';
          break;
        case 'oX5WWKm':
          /*return '美心偙朗';*/
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11296769&userId=24628015';
          break;
        case 'ZP1iAXm':
          /*return '美心工艺门';*/
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297221&userId=24628015';
          break;
        case 'KtY2V1m':
          /*return '美心家美';*/
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11296759&userId=24628015';
          break;
        case 'PBnKL1m':
          /*return '美心蒙迪';*/
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297232&userId=24628015';
          break;
        case '917699162':
          //萨瓦尼
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297262&userId=24628015';
          break;
        case '3114195734':
          //美心智远
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11297263&userId=24628015';
          break;
        default:
          /*return '市场部';*/
          link = 'http://p.qiao.baidu.com/cps/chat?siteId=11296598&userId=24628015';
          break;

      }

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* CUSTOMER_SHREF */], "http://p.qiao.baidu.com/cps/chat?siteId=11373955&userId=24698474");
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || '获取数据失败');
    }
  }).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userAttrId", function() { return userAttrId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userInfo", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerLink", function() { return customerLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils_util__ = __webpack_require__(1);

//全局getters
var userAttrId = function userAttrId(state) {
    return state.userAttrId || __WEBPACK_IMPORTED_MODULE_0__common_utils_util__["a" /* storage */].session.get('userAttrId');
};

var userInfo = function userInfo(state) {
    var userInfo = state.userInfo;
    if (userInfo && userInfo.hasOwnProperty('openId')) {
        return userInfo;
    }

    return __WEBPACK_IMPORTED_MODULE_0__common_utils_util__["a" /* storage */].local.get('userInfo');
};

var customerLink = function customerLink(state) {
    return state.customerLink || "";
};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__ = __webpack_require__(1);








/**
 *  STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  actions: {
    //【工程评价】获取订单当前标志：1经销商 2工程师
    getOrderFlag: function getOrderFlag(_ref, data) {
      var commit = _ref.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].commentTokenCallUrl + '/comment/login/getOrderFlag', data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //【经销商、工程师】手机号验证码登录
    loginByComment: function loginByComment(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].commentTokenCallUrl + '/comment/login/loginByComment', data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //【工程评价】获取订单信息
    getCpOrderInfo: function getCpOrderInfo(_ref3, data) {
      var commit = _ref3.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].commentTokenCallUrl + '/comment/api/comment/getCpOrderInfo', data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //【工程评价】添加评价
    addEvalComment: function addEvalComment(_ref4, data) {
      var commit = _ref4.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].commentTokenCallUrl + '/comment/api/comment/addEvalComment', data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //【评价】发送经销商或工程师 验证码
    sendCommentAuthCode: function sendCommentAuthCode(_ref5, data) {
      var commit = _ref5.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].commentTokenCallUrl + '/comment/login/sendCommentAuthCode', data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: {},
  getters: {}
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__ = __webpack_require__(1);








var TASK_INFO = "TASK_INFO";

/**
 * 登陆-注册STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    taskInfo: ""
  },
  actions: {
    pageRecNotes: function pageRecNotes(_ref, data) {
      var commit = _ref.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecord/pageNotes", data, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    addRecNote: function addRecNote(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecord/addNote", data, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 变更状态
    changeRecState: function changeRecState(_ref3, data) {
      var commit = _ref3.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecord/updateRecordState", data, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取法人信息
    getCompanyLegal: function getCompanyLegal(_ref4, data) {
      var commit = _ref4.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/legalAuth/pageCompanyLegal", { pageNo: 1, pageSize: 100 }, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // getUserKey
    getCates: function getCates(_ref5, data) {
      var commit = _ref5.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + "/mxoa/wf/cate/getCates", data, "get").then(function (result) {
        if (result.code = 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取经销商列表
    getPageDealers: function getPageDealers(_ref6, data) {
      var commit = _ref6.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/sm/user/pageDealers", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //工程续备案提交/mxoa/projectRecord/commit
    projectreCommit: function projectreCommit(_ref7, data) {
      var commit = _ref7.commit;

      var url = data.url,
          comData = data.data;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])(url, comData, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //删除工程备案
    removeProject: function removeProject(_ref8, data) {
      var commit = _ref8.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecord/remove", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //删除保护区备案
    removeProtect: function removeProtect(_ref9, data) {
      var commit = _ref9.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/protect/remove", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取流程列表
    getFlowList: function getFlowList(_ref10, data) {
      var commit = _ref10.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/getFlowList", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取流程日志列表
    getFlowLog: function getFlowLog(_ref11, data) {
      var commit = _ref11.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/getFlowLog", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取待办列表
    getPageTask: function getPageTask(_ref12, data) {
      var commit = _ref12.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/pageTask", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取待办数量
    getTaskCount: function getTaskCount(_ref13, data) {
      var commit = _ref13.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/getTaskCount", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取初始化备案产品信息
    getProjectProds: function getProjectProds(_ref14, data) {
      var commit = _ref14.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecord/getProjectProds", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取初始化备案产品信息
    getProjectProdsByArea: function getProjectProdsByArea(_ref15, data) {
      var commit = _ref15.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecord/getProjectProds2", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取用户信息
    getUserInfo: function getUserInfo(_ref16, data) {
      var commit = _ref16.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/sm/user/info", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取部门树结构数据
    getDepartSubs: function getDepartSubs(_ref17, data) {
      var commit = _ref17.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/sm/depart/getDepartSubs", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取部门用户树结构数据
    getDepartUsers: function getDepartUsers(_ref18, data) {
      var commit = _ref18.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/sm/depart/getDepartUsers", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取下一环节
    getNextTache: function getNextTache(_ref19, data) {
      var commit = _ref19.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/getNextTache", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取可以回退的任务
    getCanBackTo: function getCanBackTo(_ref20, data) {
      var commit = _ref20.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/getCanBackTo", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //任务处理
    finishTask: function finishTask(_ref21, data) {
      var commit = _ref21.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/finishTask", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //任务转派/flow/moveTask
    moveTask: function moveTask(_ref22, data) {
      var commit = _ref22.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/moveTask", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //任务回退
    backDirect: function backDirect(_ref23, data) {
      var commit = _ref23.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/backDirect", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //取消备案流程
    cancelProcess: function cancelProcess(_ref24, data) {
      var commit = _ref24.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__service_adapter__["a" /* tokenCall */])("/mxoa/flow/cancelProcess", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //保存选中的tast
    saveTask: function saveTask(_ref25, data) {
      var commit = _ref25.commit;

      commit(TASK_INFO, data);
    },
    clearTask: function clearTask(_ref26) {
      var commit = _ref26.commit;

      commit(TASK_INFO, 1);
    }
  },
  mutations: {
    TASK_INFO: function TASK_INFO(state, data) {
      if (data == 1) {
        state.taskInfo = "";
        __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.remove("taskInfo");
        return;
      }
      state.taskInfo = data;
      __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.set("taskInfo", data);
    }
  },
  getters: {
    taskInfo: function taskInfo(state) {
      return state.taskInfo || __WEBPACK_IMPORTED_MODULE_6__common_utils_util_js__["a" /* storage */].local.get("taskInfo");
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);



var _state, _mutations;








/**
 * 登陆-注册STORE
 */
var PAGENOPRO = "PAGENOPRO";
var LASTPAGEPRO = "LASTPAGEPRO";
var PROJECT_LISTS = "PROJECT_LISTS";

var PURCHASE_PAGENOPRO = "PURCHASE_PAGENOPRO";
var PURCHASE_LASTPAGEPRO = "PURCHASE_LASTPAGEPRO";
var PROJECT_PURCHASE_LISTS = "PROJECT_PURCHASE_LISTS";
var PROJECT_PURCHASE_PUBLICITY_LISTS = "PROJECT_PURCHASE_PUBLICITY_LISTS";
var PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO = "PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO";

var PROTECTION_LISTS = "PROTECTION_LISTS";
var REFUND_RECORD_LISTS = "REFUND_RECORD_LISTS";
var NEW_LISTS = "NEW_LISTS";
var AUTH_LISTS = "AUTH_LISTS";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: (_state = {
    projectLists: [],
    protectionLists: [],

    refundRecordLists: [],
    authLists: [],
    newLists: [],
    pageNoPro: 1,
    lastPagePro: 1,

    projectPurchaseLists: [],
    purchasePageNoPro: 1,
    purchaseLastPagePro: 1

  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, "projectPurchaseLists", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, "purchasePageNoPro", 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, "purchaseLastPagePro", 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, "projectPurchasePublicityLists", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, "projectPurchasePublicityPageNoPro", 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_state, "projectPurchasePublicityLastPagePro", 1), _state),
  actions: {
    // getUserKey
    getUserKey: function getUserKey(_ref, data) {
      var commit = _ref.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sw/getUserKey", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //修改密码
    resetPassword: function resetPassword(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sw/resetPassword", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "修改密码失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 经销商登录
    agencyLogin: function agencyLogin(_ref3, data) {
      var commit = _ref3.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sw/login", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 退出
    agencyLogout: function agencyLogout(_ref4) {
      var commit = _ref4.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sw/logout", {}, "get").then(function (result) {
        if (result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取跟进人员列表
    listDealer: function listDealer(_ref5) {
      var commit = _ref5.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/listDealer", {}, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取经销商
    listDeptMan: function listDeptMan(_ref6, data) {
      var commit = _ref6.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/listDeptMan", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //通过静态值constCode获取字典数据
    constValue: function constValue(_ref7, data) {
      var commit = _ref7.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sm/const/constValue", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取我的下属员工
    getMySubs: function getMySubs(_ref8, data) {
      var commit = _ref8.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sm/user/getMySubs", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取销售部门
    listDepart: function listDepart(_ref9) {
      var commit = _ref9.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/listDepart", {}, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    listDepartByName: function listDepartByName(_ref10, deptName) {
      var commit = _ref10.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/listDepartByName", {
        deptName: deptName
      }, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*********************工程备案********************/

    //分页获取工程备案
    projectRecordPage: function projectRecordPage(_ref11, data) {
      var commit = _ref11.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/page", data).then(function (result) {
        if (result && result.data) {
          commit(PROJECT_LISTS, result.data.list);
          commit(LASTPAGEPRO, result.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    projectListCanAuth: function projectListCanAuth(_ref12, data) {
      var commit = _ref12.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/listCanAuth", data, "get").then(function (result) {
        if (result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //保存工程备案
    projectRecordSave: function projectRecordSave(_ref13, data) {
      var commit = _ref13.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/save", data, "post").then(function (result) {
        if (result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //修改工程备案
    projectRecordUpdate: function projectRecordUpdate(_ref14, data) {
      var commit = _ref14.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/update", data).then(function (result) {
        if (result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取工程备案详情
    getProjectById: function getProjectById(_ref15, data) {
      var commit = _ref15.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/getProjectById", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*********************保护区********************/

    //分页获取保护区备案
    protectRecordPage: function protectRecordPage(_ref16, data) {
      var commit = _ref16.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/protect/page", data).then(function (result) {
        if (result && result.data) {
          commit(PROJECT_LISTS, result.data.list);
          commit(LASTPAGEPRO, result.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //创建保护区备案
    protectCreate: function protectCreate(_ref17, data) {
      var commit = _ref17.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/protect/create", data).then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //修改保护区备案
    protectUpdate: function protectUpdate(_ref18, data) {
      var commit = _ref18.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/protect/update", data).then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //保护区备案详情
    protectDetails: function protectDetails(_ref19, data) {
      var commit = _ref19.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/protect/details", data, "get").then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*********************保证金********************/

    //获取自己可退保证金的工程备案
    listCanRefund: function listCanRefund(_ref20) {
      var commit = _ref20.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/listCanRefund", {}, "get").then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //分页获取自己的退保证金工程
    refundRecordPage: function refundRecordPage(_ref21, data) {
      var commit = _ref21.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/refundRecord/page", data).then(function (result) {
        if (result.code == 200) {
          commit(PROJECT_LISTS, result.data.list);
          commit(LASTPAGEPRO, result.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //创建
    refundRecordSave: function refundRecordSave(_ref22, data) {
      var commit = _ref22.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/refundRecord/save", data).then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //修改
    refundRecordUpdate: function refundRecordUpdate(_ref23, data) {
      var commit = _ref23.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/refundRecord/update", data).then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //详情
    getRefundByRecId: function getRefundByRecId(_ref24, data) {
      var commit = _ref24.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/refundRecord/getByRecId", data, "get").then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /********************* 战略集采备案 ********************/

    // 分页获取战略集采备案
    getPageProjectPurchase: function getPageProjectPurchase(_ref25, data) {
      var commit = _ref25.commit;

      commit(PURCHASE_PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecordPurchase/page", data).then(function (res) {
        if (res.code == 200) {
          commit(PROJECT_PURCHASE_LISTS, res.data.list);
          commit(PURCHASE_LASTPAGEPRO, res.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //保存战略集采备案
    projectPurchaseSave: function projectPurchaseSave(_ref26, data) {
      var commit = _ref26.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecordPurchase/save", data, "post").then(function (result) {
        if (result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //修改战略集采备案
    projectPurchaseUpdate: function projectPurchaseUpdate(_ref27, data) {
      var commit = _ref27.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecordPurchase/update", data).then(function (result) {
        if (result) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取战略集采备案详情
    getProjectPurchaseById: function getProjectPurchaseById(_ref28, data) {
      var commit = _ref28.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecordPurchase/getProjectById", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 分页查询-集采备案公示列表
    getPageProjectPurchasePublicity: function getPageProjectPurchasePublicity(_ref29, data) {
      var commit = _ref29.commit;

      commit(PURCHASE_PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecordPurchase/pageNotice", data).then(function (res) {
        console.log("集采备案公示列表 res:", res);
        if (res.code == 200) {
          commit(PROJECT_PURCHASE_PUBLICITY_LISTS, res.data.list);
          commit(PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO, res.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*工程备案-公海*/

    // 分页获取工程备案-公海列表
    getPageProjectOpen: function getPageProjectOpen(_ref30, data) {
      var commit = _ref30.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecordOpen/page", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 认领公海项目
    claimProject: function claimProject(_ref31, data) {
      var commit = _ref31.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecordOpen/doClaim", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 放弃项目，项目流入公海
    abandonProject: function abandonProject(_ref32, data) {
      var commit = _ref32.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecordOpen/doAbandon", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 获取用户已备案产品总金额
    getUserRecAmount: function getUserRecAmount(_ref33, data) {
      var commit = _ref33.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecordOpen/getUserRecAmount", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 获取部门已备案产品总金额
    getDepartRecAmount: function getDepartRecAmount(_ref34, data) {
      var commit = _ref34.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectRecordOpen/getDepartRecAmount", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*********************续备********************/

    //获取自己可续备的工程备案
    listCanReRecord: function listCanReRecord(_ref35) {
      var commit = _ref35.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/listCanReRecord", {}, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //分页获取工程续备案
    getPageProjectC: function getPageProjectC(_ref36, data) {
      var commit = _ref36.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectre/page", data).then(function (res) {
        if (res.code == 200) {
          commit(PROJECT_LISTS, res.data.list);
          commit(LASTPAGEPRO, res.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //新增续备案
    createProtectionC: function createProtectionC(_ref37, data) {
      var commit = _ref37.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectre/create", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //修改续备案
    updateProtectionC: function updateProtectionC(_ref38, data) {
      var commit = _ref38.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectre/update", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取工程续备详情
    getProjectCdetails: function getProjectCdetails(_ref39, data) {
      var commit = _ref39.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/projectre/details", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*公示公告、新品发布、制度管理*/
    /*分页获取内容*/
    getPageContent: function getPageContent(_ref40, data) {
      var commit = _ref40.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/oa/pageContent", data, "get").then(function (res) {
        if (res.code == 200) {
          commit(NEW_LISTS, res.data.list);
          commit(LASTPAGEPRO, res.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取内容详情
    getPageDetail: function getPageDetail(_ref41, data) {
      var commit = _ref41.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/oa/getContent", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //法人授权
    legalAuthSave: function legalAuthSave(_ref42, data) {
      var commit = _ref42.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/legalAuth/save", data).then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    legalAuthPage: function legalAuthPage(_ref43, data) {
      var commit = _ref43.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])("/mxoa/legalAuth/page", data).then(function (res) {
        if (res.code == 200) {
          commit(AUTH_LISTS, res.data.list);
          commit(LASTPAGEPRO, res.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //详情
    getAuthByRecId: function getAuthByRecId(_ref44, data) {
      var commit = _ref44.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/legalAuth/info", data, "get").then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    legalAuthCommit: function legalAuthCommit(_ref45, data) {
      var commit = _ref45.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/legalAuth/commit", data, "get").then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    legalAuthRemove: function legalAuthRemove(_ref46, data) {
      var commit = _ref46.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/legalAuth/remove", data, "get").then(function (result) {
        if (result.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 专卖店
    pageProShop: function pageProShop(_ref47, data) {
      var commit = _ref47.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/page", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    commitProShop: function commitProShop(_ref48, data) {
      var commit = _ref48.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/commit", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    updateProShop: function updateProShop(_ref49, data) {
      var commit = _ref49.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/update", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    createProShop: function createProShop(_ref50, data) {
      var commit = _ref50.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/save", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getProshop: function getProshop(_ref51, data) {
      var commit = _ref51.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/getProshop", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    selectBrands: function selectBrands(_ref52, data) {
      var commit = _ref52.commit;

      var reData = {
        brandName: ""
      };
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/mall/brand/selectBrands", reData, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getMarkets: function getMarkets(_ref53, data) {
      var commit = _ref53.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/getMarkets", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    pageNotice: function pageNotice(_ref54, data) {
      var commit = _ref54.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/notice/page", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    pageInst: function pageInst(_ref55, data) {
      var commit = _ref55.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/inst/page", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //增加公示异议
    addDissent: function addDissent(_ref56, data) {
      var commit = _ref56.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/notice/addDissent", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取公示异议
    selectDissents: function selectDissents(_ref57, data) {
      var commit = _ref57.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/notice/selectDissents", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //增加-战略集采备案公示异议
    createPurchaseDissents: function createPurchaseDissents(_ref58, data) {
      var commit = _ref58.commit;

      console.log("createPurchaseDissents data:", data);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecordPurchase/createNoticeSuggest", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取-战略集采备案公示异议
    listPurchaseDissents: function listPurchaseDissents(_ref59, data) {
      var commit = _ref59.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecordPurchase/selectDissents", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //入参：
    // {
    //     auitResult: 审核结果，1 通过 0不通过
    //     proshopId： 专卖店ID，
    //     auditDesc： 审核备注
    //   }
    auditProshop: function auditProshop(_ref60, data) {
      var commit = _ref60.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/auditProshop", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getAuditAuth: function getAuditAuth(_ref61, data) {
      var commit = _ref61.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/getAuditAuth", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 保存开店图片
    saveOpenImage: function saveOpenImage(_ref62, data) {
      var commit = _ref62.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/proshop/saveOpenImage", data, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 获取成交率
    getDoneRate: function getDoneRate(_ref63, data) {
      var commit = _ref63.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/projectRecord/getDoneRate", data, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    getRateDepartSubs: function getRateDepartSubs(_ref64, data) {
      var commit = _ref64.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sm/depart/getDepartSubs", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PROJECT_LISTS, function (state, list) {
    if (state.pageNoPro == 1) {
      state.projectLists = [];
    }

    state.projectLists = state.projectLists.concat(list);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, NEW_LISTS, function (state, list) {
    if (state.pageNoPro == 1) {
      state.newLists = [];
    }

    state.newLists = state.newLists.concat(list);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, AUTH_LISTS, function (state, list) {
    if (state.pageNoPro == 1) {
      state.authLists = [];
    }

    state.authLists = state.authLists.concat(list);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PAGENOPRO, function (state, pageNo) {
    state.pageNoPro = pageNo;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, LASTPAGEPRO, function (state, lastPagePro) {
    state.lastPagePro = lastPagePro;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PROJECT_PURCHASE_LISTS, function (state, list) {
    if (state.purchasePageNoPro == 1) {
      state.projectPurchaseLists = [];
    }

    state.projectPurchaseLists = state.projectPurchaseLists.concat(list);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PURCHASE_PAGENOPRO, function (state, pageNo) {
    state.purchasePageNoPro = pageNo;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PURCHASE_LASTPAGEPRO, function (state, lastPagePro) {
    state.purchaseLastPagePro = lastPagePro;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PROJECT_PURCHASE_PUBLICITY_LISTS, function (state, list) {
    if (state.purchasePageNoPro == 1) {
      state.projectPurchaseLists = [];
    }

    state.projectPurchasePublicityLists = state.projectPurchasePublicityLists.concat(list);
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, PROJECT_PURCHASE_PUBLICITY_LASTPAGEPRO, function (state, lastPagePro) {
    state.projectPurchasePublicityLastPagePro = lastPagePro;
  }), _mutations),
  getters: {
    projectLists: function projectLists(state) {
      return state.projectLists;
    },
    pageNoPro: function pageNoPro(state) {
      return state.pageNoPro;
    },
    lastPagePro: function lastPagePro(state) {
      return state.lastPagePro;
    },
    newLists: function newLists(state) {
      return state.newLists;
    },
    authLists: function authLists(state) {
      return state.authLists;
    },

    projectPurchaseLists: function projectPurchaseLists(state) {
      return state.projectPurchaseLists;
    },
    purchasePageNoPro: function purchasePageNoPro(state) {
      return state.purchasePageNoPro;
    },
    purchaseLastPagePro: function purchaseLastPagePro(state) {
      return state.purchaseLastPagePro;
    },

    projectPurchasePublicityLists: function projectPurchasePublicityLists(state) {
      return state.projectPurchasePublicityLists;
    },
    projectPurchasePublicityPageNoPro: function projectPurchasePublicityPageNoPro(state) {
      return state.projectPurchasePublicityPageNoPro;
    },
    projectPurchasePublicityLastPagePro: function projectPurchasePublicityLastPagePro(state) {
      return state.projectPurchasePublicityLastPagePro;
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util__ = __webpack_require__(1);






/**
 * 购物车STORE
 */

var CART_GOOD_NUM = 'CART_GOOD_NUM';

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    cartGoodsNum: 0
  },
  actions: {
    //13.9.获取购物车商品数量
    getCartGoodsNum: function getCartGoodsNum(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.cartHandler.getCartGoodsNum',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          commit(CART_GOOD_NUM, result.target.target);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*14.1.从购物车结算*/
    getOrderSettleMsgFromCart: function getOrderSettleMsgFromCart(_ref2, data) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.settleHandler.getOrderSettleMsgFromCart',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*14.3.提交订单*/
    createOrder: function createOrder(_ref3, data) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.settleHandler.createOrder',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 15.6.提交订单（带订单号）
    createOrderWithOrder: function createOrderWithOrder(_ref4, data) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.settleHandler.createOrderWithOrder',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //15.7. 获取待支付订单信息
    getSettleResult: function getSettleResult(_ref5, data) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.settleHandler.getSettleResult',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.1.获取微信js配置config*/
    getWxJsSdkConfig: function getWxJsSdkConfig(_ref6, data) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.wxHandler.getWxJsSdkConfig',
        param: data
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.2.微信公众号支付*/
    doWxMpPay: function doWxMpPay(_ref7, data) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.payHandler.doWxMpPay',
        param: data
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.2.微信公众号支付*/
    doWxH5Pay: function doWxH5Pay(_ref8, data) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.payHandler.doWxH5Pay',
        param: data
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.2.微信公众号支付*/
    doUnionWapConsumePay: function doUnionWapConsumePay(_ref9, data) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.payHandler.doUnionWapConsumePay',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 13.2.获取发票类型列表
    listInvoiceType: function listInvoiceType(_ref10) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.invoiceHandler.listInvoiceType',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 13.3.获取发票内容列表
    listInvoiceContent: function listInvoiceContent(_ref11) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.invoiceHandler.listInvoiceContent',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 13.4.获取会员单位发票列表
    listMemInvoiceMsg: function listMemInvoiceMsg(_ref12) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.invoiceHandler.listMemInvoiceMsg',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 13.5.保存会员单位发票列表
    saveMemInvoice: function saveMemInvoice(_ref13, data) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.invoiceHandler.saveMemInvoice',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 13.6.删除会员单位发票
    removeMemInvoice: function removeMemInvoice(_ref14, data) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.invoiceHandler.removeMemInvoice',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //21.5.获取订单支付结果
    getOrderPayResult: function getOrderPayResult(_ref15, orderNo) {
      var commit = _ref15.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.payHandler.getOrderPayResult',
        param: orderNo
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, CART_GOOD_NUM, function (state, data) {
    state.cartGoodsNum = data;
  }),
  getters: {
    cartGoodsNum: function cartGoodsNum(state) {
      return state.cartGoodsNum;
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util__ = __webpack_require__(1);



var _mutations;





var SCROLL_HEIGHT = "SCROLL_HEIGHT";
var GOOD_DATA = " GOOD_DATA";
var DIY_GOOD_DATA = " DIY_GOOD_DATA";
var GOOD_SKU = " GOOD_SKU";
var IS_SEL_SKU = " IS_SEL_SKU";
var SKUIMAGES = "SKUIMAGES";
var SELECT_INFO = "SELECT_INFO";
var GOODS_LISTS = "GOODS_LISTS";
var PAGENO = "PAGENO";
var LASTPAGE = "LASTPAGE";
/**
 * 分类 STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    scrollHeight: 0,
    goodData: {},
    diyGoodData: {},
    goodSku: {},
    isSelSku: {},
    skuImages: {},
    selectinfo: {},
    goodsLists: [],
    pageNo: 1,
    lastPage: 1
  },
  actions: {
    //18.2.获取商品SKU信息
    getGoodsSkuMsg: function getGoodsSkuMsg(_ref, id) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.goodsHandler.getGoodsSkuFields",
        param: id
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var banners = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(banners);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //18.3.通过选择属性 获取 商品单品信息
    getGoodsSku: function getGoodsSku(_ref2, id) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.goodsHandler.getGoodsSku",
        param: id
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          commit(GOOD_SKU, result.target.target);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //18.4.获取商品详情
    getGoodsDetail: function getGoodsDetail(_ref3, id) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.goodsHandler.getGoodsDetail",
        param: id
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //商品收藏
    addGoodsFav: function addGoodsFav(_ref4, goodsId) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.goodsFavHandler.addGoodsFav",
        param: [goodsId]
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "收藏失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //18.5.获取商品规格参数
    getGoodsKindValue: function getGoodsKindValue(_ref5, id) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale. goodsHandler.getGoodsKindValue",
        param: id
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //13.2.加入购物车
    addMemCart: function addMemCart(_ref6, data) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.cartHandler.addMemCart",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var res = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //13.3.加入DIY商品到购物车
    addMemCartForDiy: function addMemCartForDiy(_ref7, data) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.cartHandler.addMemCartForDiy",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var res = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //15.2.直接购买-普通商品
    getOrderSettleMsg: function getOrderSettleMsg(_ref8, data) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.settleHandler.getOrderSettleMsg",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var res = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //15.3.直接购买-DIY商品
    getOrderSettleMsgForDiy: function getOrderSettleMsgForDiy(_ref9, data) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.settleHandler.getOrderSettleMsgForDiy",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var banners = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(banners);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //19.1.获取 Diy信息
    getDiyInfo: function getDiyInfo(_ref10, data) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.getDiyInfo",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var banners = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(banners);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //19.2.获取DIY 单品
    getDiySku: function getDiySku(_ref11, data) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.getDiySku",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var banners = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(banners);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取搜索分类标签
    getGoodsPropertieTag: function getGoodsPropertieTag(_ref12) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.goodsHandler.getGoodsPropertieTag",
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //23.2.获取 品牌列表
    getBrands: function getBrands(_ref13) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.brandHandler.getBrands",
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取排序列表
    getGoodsSearchSort: function getGoodsSearchSort(_ref14) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.goodsSearchHandler.getGoodsSearchSort",
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          commit(GOODS_HOTRANK_LISTS, result.target.target);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //17.2. 商品分页查询
    getPageGoods: function getPageGoods(_ref15, goodInfo) {
      var commit = _ref15.commit;

      commit(PAGENO, goodInfo[1]);
      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.goodsSearchHandler.pageGoods",
        param: goodInfo
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          commit(GOODS_LISTS, result.target.target.result);
          commit(LASTPAGE, result.target.target.lastPageNo);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        result.reject(error);
      });
    },

    //11.7.获取商品评价总览
    getGoodsCommMsg: function getGoodsCommMsg(_ref16, goodsId) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.commentHandler.getGoodsCommMsg",
        param: goodsId
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        result.reject(error);
      });
    },

    //24.1.随便获取商城N条广告
    randomAdver: function randomAdver(_ref17, data) {
      var commit = _ref17.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.advertHandler.randomAdver",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        result.reject(error);
      });
    },

    //24.1.随便获取商城N条广告
    randomStoreAdverts: function randomStoreAdverts(_ref18, data) {
      var commit = _ref18.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.storeHandler.randomStoreAdverts",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        result.reject(error);
      });
    },

    //11.8.分页查询商品评价
    pageGoodsCommMsg: function pageGoodsCommMsg(_ref19, goodsId) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.commentHandler.pageGoodsCommMsg",
        param: goodsId
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        result.reject(error);
      });
    },


    //获取优惠券和红包列表
    getListStoreCoupons: function getListStoreCoupons(_ref20, storeId) {
      var commit = _ref20.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.couponHandler.listStoreCoupons",
        param: [storeId]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取信息失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //领取优惠券
    receiveCoupon: function receiveCoupon(_ref21, couponInfo) {
      var commit = _ref21.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.couponHandler.receiveCoupon",
        param: couponInfo
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "领取失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    savescrollHeight: function savescrollHeight(_ref22, data) {
      var commit = _ref22.commit;

      commit(SCROLL_HEIGHT, data);
    },

    //保存要购买的商品信息
    saveGoodsData: function saveGoodsData(_ref23, goodData) {
      var commit = _ref23.commit;

      commit(GOOD_DATA, goodData);
    },

    //DIY信息
    saveDiyData: function saveDiyData(_ref24, diyGoodData) {
      var commit = _ref24.commit;

      commit(DIY_GOOD_DATA, diyGoodData);
    },

    //弹框
    saveIsSelSku: function saveIsSelSku(_ref25, isSelSku) {
      var commit = _ref25.commit;

      commit(IS_SEL_SKU, isSelSku);
    },
    saveSelectSku: function saveSelectSku(_ref26, data) {
      var commit = _ref26.commit;

      commit(SELECT_INFO, data);
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SCROLL_HEIGHT, function (state, data) {
    state.scrollHeight = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, GOOD_DATA, function (state, data) {
    state.goodData = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DIY_GOOD_DATA, function (state, data) {
    state.diyGoodData = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, GOOD_SKU, function (state, data) {
    state.goodData.goodsSkuMsg.sku = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SKUIMAGES, function (state, data) {
    state.goodData.skuImages = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, IS_SEL_SKU, function (state, data) {
    state.isSelSku = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SELECT_INFO, function (state, selectinfo) {
    console.log(selectinfo.fieldId);
    var fieldValue = state.goodData.goodsSkuMsg.fields.find(function (item) {
      return item.fieldId == selectinfo.fieldId;
    });
    fieldValue.values.forEach(function (item) {
      if (item.valueId == selectinfo.valueId) {
        item.isChecked = 1;
      } else {
        item.isChecked = 0;
      }
    });
    //获取商品单品信息
    var values = [];
    state.goodData.goodsSkuMsg.fields.forEach(function (field) {
      field.values.forEach(function (item) {
        if (item.isChecked == 1) {
          if (item.isImage == 1) {
            state.goodData.skuImages = item.showImages;
          }
          var value = {
            fieldId: item.fieldId,
            valueId: item.valueId
          };
          values.push(value);
        }
      });
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, GOODS_LISTS, function (state, goodsList) {
    if (state.pageNo == 1) {
      state.goodsLists = [];
    }

    state.goodsLists = state.goodsLists.concat(goodsList);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, PAGENO, function (state, pageNo) {
    state.pageNo = pageNo;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LASTPAGE, function (state, last) {
    state.lastPage = last;
  }), _mutations),
  getters: {
    scrollHeight: function scrollHeight(state) {
      return state.scrollHeight;
    },
    goodData: function goodData(state) {
      return state.goodData;
    },
    skuImages: function skuImages(state) {
      return state.goodData.skuImages;
    },
    diyGoodData: function diyGoodData(state) {
      return state.diyGoodData;
    },
    goodSku: function goodSku(state) {
      return state.goodSku;
    },
    isSelSku: function isSelSku(state) {
      return state.isSelSku;
    },
    goodsLists: function goodsLists(state) {
      return state.goodsLists;
    },
    pageNo: function pageNo(state) {
      return state.pageNo;
    },
    lastPage: function lastPage(state) {
      return state.lastPage;
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);



var _mutations;






/**
 * 客户订单STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    orderList: [],
    orderMsg: {}, //订单信息
    orderMate: {}, //料品数据
    treeData: {}
  },
  actions: {
    //存储料品树信息
    setTreeData: function setTreeData(_ref, data) {
      var commit = _ref.commit;

      console.log("TREE ===============", data);
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* TREE_DATA */], data);
    },


    //存储订单信息
    setOrderMsg: function setOrderMsg(_ref2, data) {
      var commit = _ref2.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["d" /* ORDER_MSG */], data);
    },


    //存储料品数据
    setOrderMate: function setOrderMate(_ref3, data) {
      var commit = _ref3.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["e" /* ORDER_MATE */], data);
    },


    //获取订单分页数据
    getPageOrder: function getPageOrder(_ref4, data) {
      var commit = _ref4.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/order/info/page', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //保存订单数据
    saveOrder: function saveOrder(_ref5, data) {
      var commit = _ref5.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/order/info/save', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //提交订单
    commitOrder: function commitOrder(_ref6, data) {
      var commit = _ref6.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/order/info/commit', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取订单详情
    getOrderDetail: function getOrderDetail(_ref7, data) {
      var commit = _ref7.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/order/info/getDetail', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //删除订单
    removeOrder: function removeOrder(_ref8, data) {
      var commit = _ref8.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/order/info/remove', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取料品分页数据
    getPageMateriel: function getPageMateriel(_ref9, data) {
      var commit = _ref9.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/materiel/info/pageMateriel', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 料品配置项分页方法
    pageMaterielItemVal: function pageMaterielItemVal(_ref10, data) {
      var commit = _ref10.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/materiel/info/pageMaterielItemVal', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //通过静态值constCode获取字典数据
    getConstValue: function getConstValue(_ref11, data) {
      var commit = _ref11.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/sm/const/constValue', data, 'get').then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取订单流程
    getOrderLogs: function getOrderLogs(_ref12, data) {
      var commit = _ref12.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/order/info/listOrderLogs', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //复制订单
    orderCopy: function orderCopy(_ref13, data) {
      var commit = _ref13.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder/order/info/copy', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取料品树
    getMaterielTree: function getMaterielTree(_ref14, data) {
      var commit = _ref14.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + '/mxorder//materiel/info/materielTree', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["d" /* ORDER_MSG */], function (state, data) {
    state.orderMsg = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["e" /* ORDER_MATE */], function (state, data) {
    state.orderMate = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* TREE_DATA */], function (state, data) {
    state.treeData = data;
  }), _mutations),
  getters: {
    orderMsg: function orderMsg(state) {
      return state.orderMsg || { orderMats: [] };
    },
    orderMate: function orderMate(state) {
      return state.orderMate || {};
    },
    treeData: function treeData(state) {
      return state.treeData || {};
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constant__ = __webpack_require__(5);






/**
 * 客户订单STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  actions: {
    //获取用户售后服务验证码
    getCustomerCode: function getCustomerCode(_ref, data) {
      var commit = _ref.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/mem/sendSmsCode', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //用户验证码登录
    userLoginByCode: function userLoginByCode(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/mem/login', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取order订单信息
    getSaleOrderInfo: function getSaleOrderInfo(_ref3, data) {
      var commit = _ref3.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/getOrderInfo', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //售后列表
    getSalePageOrder: function getSalePageOrder(_ref4, data) {
      var commit = _ref4.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/pageOrder', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //售后投诉列表
    getPageComplaintOrder: function getPageComplaintOrder(_ref5, data) {
      var commit = _ref5.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/pageComplaintOrder ', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //修改客户信息/sale/updateSaleOrder
    updateSaleOrderInfo: function updateSaleOrderInfo(_ref6, data) {
      var commit = _ref6.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/updateSaleOrder', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //售后详情
    getSaleOrderById: function getSaleOrderById(_ref7, data) {
      var commit = _ref7.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/getOrderById', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //安装师傅提交安装结果
    updateOrderResult: function updateOrderResult(_ref8, data) {
      var commit = _ref8.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/updateOrderResult', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //经销商处理投诉结果 
    dealerComplaint: function dealerComplaint(_ref9, data) {
      var commit = _ref9.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/dealerComplaint', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //客户投诉 
    createComplaint: function createComplaint(_ref10, data) {
      var commit = _ref10.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/createComplaint ', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //客户对处理意见的投诉
    updateComplaintScore: function updateComplaintScore(_ref11, data) {
      var commit = _ref11.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/updateComplaintScore ', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: {},
  getters: {}
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util__ = __webpack_require__(1);



var _mutations;





var DIY_GROUPS = "DIY_GROUPS"; //系列
var DIY_FLOWERS = "DIY_FLOWERS"; //花型
var DIY_COLORS = "DIY_COLORS"; //颜色
var DIY_DOORS = "DIY_DOORS"; //门体
var DIY_FITTINGS = "DIY_FITTINGS"; // 配件
var DIY_SHOW_IMAGES = "DIY_SHOW_IMAGES"; //diy展示的图片
var GOOD_DETAIL = "GOOD_DETAIL"; //diy详情
var ADD_SPEC_PRICE = "ADD_SPEC_PRICE";

/**
 * 分类 STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    diyGroups: {}, //系列
    diyFlowers: {}, //花型
    diyColors: {}, //颜色
    diyDoors: {}, //门体
    diyFittings: [], // 配件
    diyShowImages: [], //diy展示的图片
    diyTotalPrice: 0, // 选中的价格
    finalSelect: {
      doorInstMsg: {},
      specs: [],
      fittings: []
    },
    goodsDetails: [] //diy详情
  },
  actions: {
    // 获取diy信息 (无参数）
    getDiyInfos: function getDiyInfos(_ref, diyInfo) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.getDiyInfo",
        param: diyInfo
      }).then(function (result) {
        console.log("result", result);
        if (result && result.success && result.target && result.target.success) {
          var list = result.target.target;
          commit("DIY_GROUPS", { list: list.groups || {} });
          commit("DIY_DOORS", { list: list.doors || {} });
          commit("DIY_FITTINGS", { list: list.fittings || [] });
          commit("DIY_COLORS", { list: list.colors || {} });
          commit("DIY_FLOWERS", { list: list.flowers || {} });
          commit("DIY_SHOW_IMAGES");
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(list);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 根据系列获取diy信息
    getDoorInfo: function getDoorInfo(_ref2, diyInfo) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.getDoorInfo",
        param: diyInfo
      }).then(function (result) {
        console.log("result", result);
        if (result && result.success && result.target && result.target.success) {
          var list = result.target.target;
          commit("DIY_DOORS", { list: list.doors || {} });
          commit("DIY_FITTINGS", { list: list.fittings || [] });
          commit("DIY_COLORS", { list: list.colors || {} });
          commit("DIY_FLOWERS", { list: list.flowers || {} });
          commit("DIY_SHOW_IMAGES");
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(list);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 刷新门体，规格，配件
    getDoorInstInfo: function getDoorInstInfo(_ref3, diyInfo) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.getDoorInstInfo",
        param: diyInfo
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var list = result.target.target;
          commit("DIY_DOORS", { list: list.doors || {} });
          commit("DIY_FITTINGS", { list: list.fittings || [] });
          commit("DIY_SHOW_IMAGES");
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(list);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 获取门体规格
    getSpecInfo: function getSpecInfo(_ref4, diyInfo) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.getSpecInfo",
        param: diyInfo
      }).then(function (result) {
        console.log("result", result);
        if (result && result.success && result.target && result.target.success) {
          var list = result.target.target;
          commit("DIY_FITTINGS", { list: list.fittings || [] });
          commit("DIY_SHOW_IMAGES");
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(list);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //加入diy到购物车
    addMemCartDiyPage: function addMemCartDiyPage(_ref5, data) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.addMemCart",
        param: data
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "添加购物车失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //直接购买diy（商品diy入口）
    getOrderSettleMsgDiyPage: function getOrderSettleMsgDiyPage(_ref6, goodsInfo) {
      var commit = _ref6.commit;

      console.log("goodsInfo", goodsInfo);
      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.settleHandler.getOrderSettleMsgForDiy",
        param: goodsInfo
      }).then(function (result) {
        console.log("result>>>", result);
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    // 获取diy详情
    getDiyDetail: function getDiyDetail(_ref7) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.diyHandler.getDiyDetail",
        param: [0]
      }).then(function (result) {
        console.log("result", result);
        if (result && result.success && result.target && result.target.success) {
          console.log(result.target.target);
          commit("GOOD_DETAIL", result.target.target);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    handleSelectChange: function handleSelectChange(_ref8, _ref9) {
      var commit = _ref8.commit;
      var diyName = _ref9.diyName,
          item = _ref9.item,
          index = _ref9.index;

      switch (diyName) {
        case "GROUPS":
          commit("DIY_GROUPS", { index: index });
          break;
        case "DOORS":
          commit("DIY_DOORS", { item: item });
          commit("DIY_SHOW_IMAGES");
          break;
        case "COLORS":
          commit("DIY_COLORS", { item: item });
          commit("DIY_SHOW_IMAGES");
          break;
        case "FLOWERS":
          commit("DIY_FLOWERS", { item: item });
          commit("DIY_SHOW_IMAGES");
          break;
        case "FITTINGS":
          commit("DIY_FITTINGS", { item: item, index: index });
          commit("DIY_SHOW_IMAGES");
          break;
        default:
          break;
      }
    },
    handleAddSpecPrice: function handleAddSpecPrice(_ref10, specPrice) {
      var commit = _ref10.commit;

      commit("ADD_SPEC_PRICE", specPrice);
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DIY_GROUPS, function (state, _ref11) {
    var list = _ref11.list,
        _ref11$index = _ref11.index,
        index = _ref11$index === undefined ? "auto" : _ref11$index;

    list = list && list.diyList && list.diyList.length > 0 ? list : state.diyGroups;
    list.diyList && list.diyList.forEach(function (item, i) {
      if (index === "auto") {
        if (!item.checked) {
          item.checked = "0";
        }
      } else {
        if (i == index) {
          item.checked = "1";
        } else {
          item.checked = "0";
        }
      }
    });
    state.diyGroups = list;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DIY_FLOWERS, function (state, _ref12) {
    var list = _ref12.list,
        _ref12$item = _ref12.item,
        item = _ref12$item === undefined ? "auto" : _ref12$item;

    if (item !== "auto") {
      list = state.diyFlowers;
      list.diyList.forEach(function (it) {
        if (it.flowerId == item.flowerId) {
          if (it.checked === "1") {
            it.checked = "0";
          } else {
            it.checked = "1";
          }
        } else {
          it.checked = "0";
        }
      });
      // const diyDoors = state.diyDoors;
      // diyDoors.diyList.forEach((itemDoor) => {
      //   if (itemDoor.flowerId == item.flowerId) {
      //     itemDoor.checked = "1";
      //   } else {
      //     itemDoor.checked = "0";
      //   }
      // });
      // state.diyDoors = diyDoors;
    }
    state.diyFlowers = list;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DIY_COLORS, function (state, _ref13) {
    var list = _ref13.list,
        _ref13$item = _ref13.item,
        item = _ref13$item === undefined ? "auto" : _ref13$item;

    if (item !== "auto") {
      list = state.diyColors;
      list.diyList.forEach(function (it) {
        if (it.colorId == item.colorId) {
          if (it.checked === "1") {
            it.checked = "0";
          } else {
            it.checked = "1";
          }
        } else {
          it.checked = "0";
        }
      });
      // const diyDoors = state.diyDoors;
      // diyDoors.diyList.forEach((itemDoor) => {
      //   if (itemDoor.colorId == item.colorId) {
      //     itemDoor.checked = "1";
      //   } else {
      //     itemDoor.checked = "0";
      //   }
      // });
      // state.diyDoors = diyDoors;
    }
    state.diyColors = list;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DIY_FITTINGS, function (state, _ref14) {
    var list = _ref14.list,
        item = _ref14.item,
        _ref14$index = _ref14.index,
        index = _ref14$index === undefined ? "auto" : _ref14$index;

    if (index != "auto") {
      list = state.diyFittings;
      list.forEach(function (itemS) {
        if (item.diyName === itemS.diyName) {
          itemS.diyList.forEach(function (itemX, idx) {
            if (idx == index) {
              if (itemX.checked === "1") {
                itemX.checked = "0";
              } else {
                itemX.checked = "1";
              }
            } else {
              itemX.checked = "0";
            }
          });
        }
      });
    }
    state.diyFittings = list;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DIY_DOORS, function (state, _ref15) {
    var list = _ref15.list,
        _ref15$item = _ref15.item,
        item = _ref15$item === undefined ? "auto" : _ref15$item;

    if (item !== "auto") {
      list = state.diyDoors;
      list.diyList.forEach(function (it) {
        if (it.doorInstId == item.doorInstId) {
          it.checked = "1";
        } else {
          it.checked = "0";
        }
      });
      // console.log("list", list);
      // const diyFlowers = state.diyFlowers;
      // diyFlowers.diyList.forEach((itemF) => {
      //   if (itemF.flowerId == item.flowerId) {
      //     itemF.checked = "1";
      //   } else {
      //     itemF.checked = "0";
      //   }
      // });
      // const diyColors = state.diyColors;
      // diyColors.diyList.forEach((itemC) => {
      //   if (itemC.colorId == item.colorId) {
      //     itemC.checked = "1";
      //   } else {
      //     itemC.checked = "0";
      //   }
      // });
      // state.diyFlowers = diyFlowers;
      // state.diyColors = diyColors;
    }

    state.diyDoors = list;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DIY_SHOW_IMAGES, function (state) {
    var diyDoors = state.diyDoors || {};
    var diyFittings = state.diyFittings || [];
    var images = [];
    var finalSelect = {
      doorInstMsg: {},
      specs: [],
      fittings: []
    };
    diyDoors.diyList && diyDoors.diyList.forEach(function (itemDoor) {
      itemDoor.imageIndex = 9;
      if (itemDoor.checked === "1") {
        images.push(itemDoor);
        finalSelect.doorInstMsg = itemDoor;
      }
    });
    diyFittings.forEach(function (item) {
      item.diyList.forEach(function (itemFit) {
        itemFit.imageIndex = 10;
        if (itemFit.checked === "1") {
          images.push(itemFit);
          finalSelect.fittings.push(itemFit);
        }
      });
    });
    var lastImages = images.map(function (item) {
      var madeClass = "";
      if (item.mxoffset || item.myoffset) {
        var mxoffset = Number(item.mxoffset);
        var myoffset = Number(item.myoffset);
        var arr = [];
        arr.push("z-index:" + item.imageIndex);
        if (mxoffset < 0) {
          arr.push("right:" + -mxoffset + "px");
        } else {
          arr.push("left:" + mxoffset + "px");
        }
        if (myoffset < 0) {
          arr.push("top:" + -myoffset + "px");
        } else {
          arr.push("bottom:" + myoffset + "px");
        }
        madeClass = arr.join(";");
      }
      item.madeClass = madeClass;
      return item;
    });
    state.diyShowImages = lastImages;
    state.finalSelect = finalSelect;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, GOOD_DETAIL, function (state, detail) {
    state.goodsDetails = detail;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, ADD_SPEC_PRICE, function (state, specPrice) {
    var diyPriceSelected = [];
    var diyFittings = state.diyFittings || [];
    diyFittings.forEach(function (item) {
      item.diyList.forEach(function (itemFit) {
        itemFit.imageIndex = 10;
        if (itemFit.checked === "1") {
          diyPriceSelected.push(itemFit);
        }
      });
    });
    var diyTotalPrice = 0;
    diyPriceSelected.forEach(function (item) {
      diyTotalPrice += Number(item.price);
    });
    console.log("specPrice", specPrice);
    state.diyTotalPrice = diyTotalPrice + specPrice;
  }), _mutations),
  getters: {
    diyGroups: function diyGroups(state) {
      return state.diyGroups;
    },
    diyFlowers: function diyFlowers(state) {
      return state.diyFlowers;
    },
    diyColors: function diyColors(state) {
      return state.diyColors;
    },
    diyDoors: function diyDoors(state) {
      return state.diyDoors;
    },
    diyShowImages: function diyShowImages(state) {
      return state.diyShowImages;
    },
    diyTotalPrice: function diyTotalPrice(state) {
      return state.diyTotalPrice;
    },
    finalSelect: function finalSelect(state) {
      return state.finalSelect;
    },
    diyFittings: function diyFittings(state) {
      return state.diyFittings;
    },
    goodsDetails: function goodsDetails(state) {
      return state.goodsDetails;
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constant__ = __webpack_require__(5);






/**
 * 客户订单STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  actions: {

    //账号密码注册
    saleRegister: function saleRegister(_ref, data) {
      var commit = _ref.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sw/saleRegister', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //账号密码登录
    saleLogin: function saleLogin(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sw/saleLogin', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //安装队申请
    addTeam: function addTeam(_ref3, data) {
      var commit = _ref3.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/team/addTeam', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //分页查询安装队 物流订单信息
    pagelogisticsOrder: function pagelogisticsOrder(_ref4, data) {
      var commit = _ref4.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/saleInstall/pagelogisticsOrder', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //物流详细订单
    getLogisticsOrder: function getLogisticsOrder(_ref5, data) {
      var commit = _ref5.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/saleInstall/getLogisticsOrder', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //物流进度
    addTeamProcess: function addTeamProcess(_ref6, data) {
      var commit = _ref6.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/saleInstall/addTeamProcess', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //确认收货
    receiveOrder: function receiveOrder(_ref7, data) {
      var commit = _ref7.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/saleInstall/receiveOrder', data, 'post').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取售后订单信息 操作日志 
    selectOrderLogs: function selectOrderLogs(_ref8, data) {
      var commit = _ref8.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_5__Constant__["a" /* default */].tokenCallUrl + '/mxoa/sale/selectOrderLogs', data, 'get').then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res && res.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: {},
  getters: {}
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_util__ = __webpack_require__(1);



var _actions, _mutations;





/**
 * 主页STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    searchKeywordList: [], //随机获取关键词列表
    lastSearchList: [], //最近搜索列表
    shareGoodsLists: [],
    pageNo: 1,
    lastPage: 1
  },
  actions: (_actions = {

    /*获取首页幻灯*/
    getHomeSlide: function getHomeSlide(_ref) {
      var commit = _ref.commit;
      var appType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.floorHandler.getHomeSlide',
        param: [appType]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*获取品牌分类*/
    getBrandCates: function getBrandCates(_ref2, data) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.navBarHandler.getBrandCates',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var _data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(_data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*获取广告banner*/
    getAdBanners: function getAdBanners(_ref3) {
      var commit = _ref3.commit;
      var appType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeSlide',
        param: [appType]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*获取系列推荐商品*/
    getRecomGoods: function getRecomGoods(_ref4) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeRankingList',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*获取VR 展示广告*/
    getVrBanner: function getVrBanner(_ref5) {
      var commit = _ref5.commit;
      var appType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeSlide',
        param: [appType]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*获取精品推荐商品*/
    getBoutiqueGoods: function getBoutiqueGoods(_ref6) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.floorHandler.getHomeRankingList',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*获取最新消息发布*/
    getNewMessages: function getNewMessages(_ref7) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        //TODO
        fn: 'mallsale.floorHandler.getHomeRankingList',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*获取商品楼层*/
    getHomeFloorInfos: function getHomeFloorInfos(_ref8) {
      var commit = _ref8.commit;
      var appType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: 'mallsale.floorHandler.getHomeFloorInfos',
        param: [appType]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          var data = result.target.target;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getHomeFloorInfos', function getHomeFloorInfos(_ref9) {
    var commit = _ref9.commit;
    var appType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.floorHandler.getHomeFloorInfos',
      param: [appType]
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        var data = result.target.target;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      console.log("错误信息:", error);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getStoreBaseInfo', function getStoreBaseInfo(_ref10, storeId) {
    var commit = _ref10.commit;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.storeHandler.getStoreBaseInfo',
      param: [storeId]
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        var data = result.target.target;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      console.log("错误信息:", error);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getStoreBanner', function getStoreBanner(_ref11, storeId) {
    var commit = _ref11.commit;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.storeHandler.getStoreBanner',
      param: storeId
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        var data = result.target.target;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      console.log("错误信息:", error);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getStorePromotions', function getStorePromotions(_ref12, storeId) {
    var commit = _ref12.commit;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.storeHandler.getStorePromotions',
      param: storeId
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        var data = result.target.target;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      console.log("错误信息:", error);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getStoreFloorInfo', function getStoreFloorInfo(_ref13, storeId) {
    var commit = _ref13.commit;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.storeHandler.getStoreFloorInfo',
      param: storeId
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        var data = result.target.target;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getHotSearch', function getHotSearch(_ref14) {
    var commit = _ref14.commit;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.searchHandler.getHotSearch',
      param: []
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        var data = result.target.target;
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["f" /* SEARCH_KEYWORD_LIST */], data);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getMainShareGoods', function getMainShareGoods(_ref15) {
    var commit = _ref15.commit;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.shareHandler.getMainShareGoods',
      param: []
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'pageShareGoods', function pageShareGoods(_ref16, data) {
    var commit = _ref16.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["g" /* PAGENO */], data[1]);
    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.shareHandler.pageShareGoods',
      param: data
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["h" /* SHARE_GOODS_LISTS */], result.target.target.result);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["i" /* LASTPAGE */], result.target.target.lastPageNo);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'getShareInfoContent', function getShareInfoContent(_ref17, shareId) {
    var commit = _ref17.commit;

    return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
      fn: 'mallsale.shareHandler.getShareInfoContent',
      param: shareId
    }).then(function (result) {
      if (result && result.success && result.target && result.target.success) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].getResultErrMsg(result));
      }
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'addLastSearch', function addLastSearch(_ref18, keyword) {
    var commit = _ref18.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["j" /* LASTTEST_SEARCH_LIST */], keyword);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, 'clearLastSearch', function clearLastSearch(_ref19) {
    var commit = _ref19.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["k" /* CLEAR_LASTTEST_SEARCH_LIST */]);
  }), _actions),
  /*8.2.分页查询会员订单*/
  /*  pageMemOrder({ commit }, data) {
      return http.jsonCall({
        fn: 'mallsale.memOrderHandler.pageMemOrder',
        param: data
      }).then(result => {
        if (result && result.success && result.target && result.target.success) {
          return Promise.resolve(result.target.target.result);
        } else {
          return Promise.reject((result && (result.message || result.target.message)) || "获取数据失败");
        }
      }).catch(error => {
        console.log("错误信息:", error);
        return Promise.reject(error);
      })
    },
  */
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["f" /* SEARCH_KEYWORD_LIST */], function (state, data) {
    state.searchKeywordList = data;
    __WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].storage.local.set('searchKeywordList', data);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["j" /* LASTTEST_SEARCH_LIST */], function (state, keyword) {
    state.lastSearchList = __WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].storage.local.get('lastSearchList') || [];
    if (state.lastSearchList && state.lastSearchList.length) {
      state.lastSearchList = state.lastSearchList.filter(function (item) {
        return item != keyword;
      });
    }
    if (state.lastSearchList && state.lastSearchList.length > 5) {
      state.lastSearchList.pop();
    }
    state.lastSearchList.splice(0, 0, keyword);
    __WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].storage.local.set('lastSearchList', state.lastSearchList);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["k" /* CLEAR_LASTTEST_SEARCH_LIST */], function (state) {
    state.lastSearchList = [];
    __WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].storage.local.set('lastSearchList', []);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["h" /* SHARE_GOODS_LISTS */], function (state, data) {
    if (state.pageNo == 1) {
      state.shareGoodsLists = [];
    }
    state.shareGoodsLists = state.shareGoodsLists.concat(data);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["g" /* PAGENO */], function (state, data) {
    state.pageNo = data;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["i" /* LASTPAGE */], function (state, data) {
    state.lastPage = data;
  }), _mutations),
  getters: {
    searchKeywordList: function searchKeywordList(state) {
      if (!state.searchKeywordList || !state.searchKeywordList.length) {
        return __WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].storage.local.get('searchKeywordList');
      }
      return state.searchKeywordList;
    },
    lastSearchList: function lastSearchList(state) {
      if (!state.lastSearchList || !state.lastSearchList.length) {
        return __WEBPACK_IMPORTED_MODULE_4__common_utils_util__["c" /* default */].storage.local.get('lastSearchList');
      }
      return state.lastSearchList;
    },
    shareGoodsLists: function shareGoodsLists(state) {
      return state.shareGoodsLists;
    },
    pageNo: function pageNo(state) {
      return state.pageNo;
    },
    lastPage: function lastPage(state) {
      return state.lastPage;
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);



var _mutations;








/**
 * 安装指导-STORE
 */
var PAGENOPRO = "PAGENOPRO";
var LASTPAGEPRO = "LASTPAGEPRO";
var INSTALL_STUDY_LISTS = "INSTALL_STUDY_LISTS";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    installStudyList: [],
    pageNoPro: 1,
    lastPagePro: 1
  },
  actions: {
    //分页获取安装指导列表
    pageInstallStudy: function pageInstallStudy(_ref, data) {
      var commit = _ref.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/study/page", data).then(function (result) {
        if (result && result.data) {
          commit(INSTALL_STUDY_LISTS, result.data.list);
          commit(LASTPAGEPRO, result.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取安装指导详情
    getInstallStudyDetail: function getInstallStudyDetail(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/study/getContent", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, INSTALL_STUDY_LISTS, function (state, list) {
    if (state.pageNoPro == 1) {
      state.installStudyList = [];
    }

    state.installStudyList = state.installStudyList.concat(list);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, PAGENOPRO, function (state, pageNo) {
    state.pageNoPro = pageNo;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LASTPAGEPRO, function (state, lastPagePro) {
    state.lastPagePro = lastPagePro;
  }), _mutations),
  getters: {
    installStudyList: function installStudyList(state) {
      return state.installStudyList;
    },
    pageNoPro: function pageNoPro(state) {
      return state.pageNoPro;
    },
    lastPagePro: function lastPagePro(state) {
      return state.lastPagePro;
    }
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);









/**
 * 登陆-注册STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    isLogined: false //判断是否登录
    // userInfo:null,
  },
  actions: {
    //获取验证码
    sendAuthCodeSms: function sendAuthCodeSms(_ref, params) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.sendAuthCodeSms",
        param: params
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //获取验证码
    checkSmsCode: function checkSmsCode(_ref2, phoneNum) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.checkSmsCode",
        param: phoneNum
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //登录
    quickLogin: function quickLogin(_ref3, data) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.quickLogin",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //登录
    quickLoginWithCode: function quickLoginWithCode(_ref4, data) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.quickLoginWithCode",
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //执行登录
    doLogin: function doLogin(_ref5, _ref6) {
      var commit = _ref5.commit;
      var openId = _ref6.openId,
          clientType = _ref6.clientType,
          authToken = _ref6.authToken;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["b" /* restCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].loginReqUrl, {
        p0: openId,
        p1: clientType,
        p2: authToken
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["l" /* USER_INFO */], result.target.target);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //13.11.用户登录后，修改购物车数据
    updateMemCartForUserLogin: function updateMemCartForUserLogin(_ref7) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.cartHandler.updateMemCartForUserLogin",
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //退出登录
    logout: function logout(_ref8) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.logout",
        param: []
      }).then(function (result) {
        if (result && result.success) {
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["m" /* IS_LOGINDE */], false);
          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["l" /* USER_INFO */], "");
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //执行退出登录
    doLogout: function doLogout(_ref9) {
      var commit = _ref9.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["b" /* restCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].logoutBaseUrl, {
        // p0:openId,
        // p1:clientType,
        // p2:authToken
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //5.2.生成微信网页授URL-用户同意授权获取code
    connectOauth2Authorize: function connectOauth2Authorize(_ref10, data) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.connectOauth2Authorize",
        param: data
      }).then(function (result) {
        console.log(result);
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //2、调用后台执行微信登录
    doWxMpLogin: function doWxMpLogin(_ref11, data) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.doWxMpLogin",
        param: data
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //登录
    memLogin: function memLogin(_ref12, memLoginInfo) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.login",
        param: memLoginInfo
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //保存登录信息
    saveWxLogin: function saveWxLogin(_ref13, isLogined) {
      var commit = _ref13.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["m" /* IS_LOGINDE */], isLogined);
    },

    //保存用户信息
    saveUserInfo: function saveUserInfo(_ref14, userInfo) {
      var commit = _ref14.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["l" /* USER_INFO */], userInfo);
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["m" /* IS_LOGINDE */], function (state, isLogined) {
    state.isLogined = isLogined;
    __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.set("isLogined", isLogined);
  }),
  getters: {
    isLogined: function isLogined(state) {
      if (!state.isLogined) {
        return __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__["a" /* storage */].local.get("isLogined");
      }
      return state.isLogined;
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util__ = __webpack_require__(1);





/**
 * 个人中心STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {},
  actions: {
    /*8.1.获取会员订单数*/
    getMemOrderCount: function getMemOrderCount(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.memOrderHandler.getMemOrderCount',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.2.分页查询会员订单*/
    pageMemOrder: function pageMemOrder(_ref2, data) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.memOrderHandler.pageMemOrder',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*  8.3.获取会员订单详情*/
    getMemOrderDetail: function getMemOrderDetail(_ref3, data) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.memOrderHandler.getMemOrderDetail',
        param: [data]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.4.取消订单*/
    cancelMemOrder: function cancelMemOrder(_ref4, data) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.memOrderHandler.cancelMemOrder',
        param: [data]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.5.申请退单*/
    applyBackOrder: function applyBackOrder(_ref5, data) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.memOrderHandler.applyBackOrder',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*8.6.分页查询会员发票信息*/
    pageMemOrderInvoice: function pageMemOrderInvoice(_ref6, data) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.invoiceHandler.pageMemOrderInvoice',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        console.log("错误信息:", error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*5.9.新增收货地址*/
    addAddress: function addAddress(_ref7, memAddr) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.addressHandler.addAddress',
        param: [memAddr]
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "新增失败！");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*5.10.修改收货地址*/
    editAddress: function editAddress(_ref8, memAddr) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.addressHandler.editAddress',
        param: memAddr
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "修改失败！");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*5.11.设置默认收货地址*/
    doSetDefaultAddress: function doSetDefaultAddress(_ref9, addressIdMsg) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.addressHandler.doSetDefaultAddress',
        param: addressIdMsg
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "设置为默认地址失败！");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*5.12.获取收货地址详情 */
    getAddress: function getAddress(_ref10, addressId) {
      var commit = _ref10.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.addressHandler.getAddress',
        param: [addressId]
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取信息失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*5.13.删除收货地址*/
    removeAddress: function removeAddress(_ref11, addressId) {
      var commit = _ref11.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: ' mallmem.addressHandler.removeAddress',
        param: [addressId]
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "删除失败！");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*5.14.列出收货地址*/
    listAddress: function listAddress(_ref12) {
      var commit = _ref12.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.addressHandler.listAddress',
        param: []
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取信息失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*7.7.获取指定区域ID的所有下级区域*/
    listAreaMsg: function listAreaMsg(_ref13, upAreaId) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.addressHandler.listAreaMsg',
        param: [upAreaId]
      }).then(function (result) {
        if (result && result.success && result.target || result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*10.1.获取订单还未评价的商品*/
    getNotCommentGoods: function getNotCommentGoods(_ref14, stOrderId) {
      var commit = _ref14.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.commentHandler.getNotCommentGoods',
        param: [stOrderId]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*10.2.增加商品评价mallsale.commentHandler.addGoodsComment*/
    addGoodsComment: function addGoodsComment(_ref15, CommentData) {
      var commit = _ref15.commit;

      console.log("CommentData", CommentData);
      //debugger;
      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.commentHandler.addGoodsComment',
        param: CommentData
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*  10.3.修改商品评价*/
    modGoodsComment: function modGoodsComment(_ref16, CommentData) {
      var commit = _ref16.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.commentHandler.modGoodsComment',
        param: CommentData
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "修改失败！");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*10.4.删除商品评价mallsale.commentHandler.delGoodsComment*/
    delGoodsComment: function delGoodsComment(_ref17, commId) {
      var commit = _ref17.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.commentHandler.delGoodsComment',
        param: [commId]
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "删除失败！");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*10.5.分页查询商品评价mallsale.commentHandler.pageGoodsComment*/
    pageGoodsComment: function pageGoodsComment(_ref18, data) {
      var commit = _ref18.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.commentHandler.pageGoodsComment',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*10.6.获取商品评价详情*/
    getGoodsComment: function getGoodsComment(_ref19, commId) {
      var commit = _ref19.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.commentHandler.getGoodsComment',
        param: [commId]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*6.1.设置出生日期*/
    doSetBirthDay: function doSetBirthDay(_ref20, birthday) {
      var commit = _ref20.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.memInfoHandler.doSetBirthDay',
        param: [birthday]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*6.2.设置会员头像*/
    doSetMemImage: function doSetMemImage(_ref21, memImageId) {
      var commit = _ref21.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.memInfoHandler.doSetMemImage',
        param: [memImageId]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*6.3.设置昵称*/
    doSetNickName: function doSetNickName(_ref22, memImageId) {
      var commit = _ref22.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.memInfoHandler.doSetNickName',
        param: [memImageId]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*6.4.设置性别*/
    doSetSex: function doSetSex(_ref23, sex) {
      var commit = _ref23.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.memInfoHandler.doSetSex',
        param: [sex]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*6.5.获取会员账户信息*/
    getMemAccountMsg: function getMemAccountMsg(_ref24) {
      var commit = _ref24.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.accountHandler.getMemAccountMsg',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target || result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*10.1.分页查询会员商品收藏*/
    pageGoodsFav: function pageGoodsFav(_ref25, data) {
      var commit = _ref25.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.goodsFavHandler.pageGoodsFav',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*7.1.批量删除会员商品收藏*/
    delGoodsFavBatch: function delGoodsFavBatch(_ref26, data) {
      var commit = _ref26.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.goodsFavHandler.delGoodsFavBatch',
        param: [data]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*10.2.删除会员商品收藏  */
    delGoodsFav: function delGoodsFav(_ref27, favId) {
      var commit = _ref27.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.goodsFavHandler.delGoodsFav',
        param: [favId]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*6.3.获取会员详细信息*/
    getMemDetailInfo: function getMemDetailInfo(_ref28) {
      var commit = _ref28.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallmem.memInfoHandler.getMemDetailInfo',
        param: []
      }).then(function (result) {
        if (result && result.success && result.target || result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*12.3.分页查询会员红包mallsale.couponHandler.pageMemRedpacket*/
    pageMemRedpacket: function pageMemRedpacket(_ref29, data) {
      var commit = _ref29.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.couponHandler.pageMemRedpacket',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*分页查询我的优惠券mallsale.couponHandler.pageMemCoupon*/
    pageMemCoupon: function pageMemCoupon(_ref30, data) {
      var commit = _ref30.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.couponHandler.pageMemCoupon',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*删除我的[优惠或者是红包]mallsale.couponHandler.delMemCoupon*/
    delMemCoupon: function delMemCoupon(_ref31, data) {
      var commit = _ref31.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.couponHandler.delMemCoupon',
        param: [data]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*15.4.再次购买*/
    getOrderSettleMsgForOrder: function getOrderSettleMsgForOrder(_ref32, data) {
      var commit = _ref32.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: ' mallsale.settleHandler.getOrderSettleMsgForOrder',
        param: [data]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*22.6.获取分享订单商品列表*/
    listOrderGoodsMsgByOrderId: function listOrderGoodsMsgByOrderId(_ref33, data) {
      var commit = _ref33.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: ' mallsale.shareHandler.listOrderGoodsMsgByOrderId',
        param: [data]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*22.7.提交晒家分享数据*/
    submitShareData: function submitShareData(_ref34, data) {
      var commit = _ref34.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: ' mallsale.shareHandler.submitShareData',
        param: data
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    /*线下订单查询*/
    queryOrder: function queryOrder(_ref35, projectCode) {
      var commit = _ref35.commit;

      return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
        fn: 'mallsale.memOrderHandler.queryOrder',
        param: [projectCode]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: {},
  getters: {}
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util__ = __webpack_require__(1);





/**
 * 实体店 STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
	state: {},
	actions: {
		//分页获取实体门店信息
		pageDealerStore: function pageDealerStore(_ref, data) {
			var commit = _ref.commit;

			return __WEBPACK_IMPORTED_MODULE_2__service_http__["a" /* default */].post({
				fn: 'mallsale.dealerHandler.pageDealerStore',
				param: data
			}).then(function (result) {
				if (result && result.success && result.target && result.target.success) {
					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
				} else {
					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || '获取信息失败');
				}
			}).catch(function (error) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
			});
		}
	},
	mutations: {},
	getters: {}
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);



var _mutations;








/**
 * 产品说明书-STORE
 */
var PAGENOPRO = "PAGENOPRO";
var LASTPAGEPRO = "LASTPAGEPRO";
var PROD_INTRO_LISTS = "PROD_INTRO_LISTS";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    prodIntroList: [],
    pageNoPro: 1,
    lastPagePro: 1
  },
  actions: {
    //分页获取产品说明书列表
    pageProdIntro: function pageProdIntro(_ref, data) {
      var commit = _ref.commit;

      commit(PAGENOPRO, data.pageNo);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/intro/page", data).then(function (result) {
        if (result && result.data) {
          commit(PROD_INTRO_LISTS, result.data.list);
          commit(LASTPAGEPRO, result.data.lastPage);
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取产品说明书详情
    getProdIntroDetail: function getProdIntroDetail(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/intro/getContent", data, "get").then(function (result) {
        if (result && result.data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, PROD_INTRO_LISTS, function (state, list) {
    if (state.pageNoPro == 1) {
      state.prodIntroList = [];
    }

    state.prodIntroList = state.prodIntroList.concat(list);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, PAGENOPRO, function (state, pageNo) {
    state.pageNoPro = pageNo;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LASTPAGEPRO, function (state, lastPagePro) {
    state.lastPagePro = lastPagePro;
  }), _mutations),
  getters: {
    prodIntroList: function prodIntroList(state) {
      return state.prodIntroList;
    },
    pageNoPro: function pageNoPro(state) {
      return state.pageNoPro;
    },
    lastPagePro: function lastPagePro(state) {
      return state.lastPagePro;
    }
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_http__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_adapter__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_util__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constant__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_util_js__ = __webpack_require__(1);









/**
 * 实体店 STORE
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loginType: "" //当前登录方式 PWD|MOBILE
  },
  actions: {
    updateLoginType: function updateLoginType(state, val) {
      state.loginType = val;
    },

    //获取问卷调查内容
    getPaperByCode: function getPaperByCode(_ref, data) {
      var commit = _ref.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/oa/simPaper/getPaperByCode", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //保存售后问卷调查的内容
    commitPaper: function commitPaper(_ref2, data) {
      var commit = _ref2.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/oa/simPaper/commitPaper", data, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //保存大区问卷调查的内容
    commitPaperArea: function commitPaperArea(_ref3, data) {
      var commit = _ref3.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/oa/simPaper/commit", data.data, "post").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取验证码mxoa/sm/sendAuthCode
    sendAuthCode: function sendAuthCode(_ref4, data) {
      var commit = _ref4.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sm/sendAuthCode", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //提交手机号验证mxoa/sm/checkAuthCode
    checkAuthCode: function checkAuthCode(_ref5, data) {
      var commit = _ref5.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].tokenCallUrl + "/mxoa/sm/checkAuthCode", data, "get").then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //校验是否可以注册
    checkRegisterable: function checkRegisterable(_ref6, phoneNum) {
      var commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.checkRegisterable",
        param: [phoneNum]
      }).then(function (result) {
        if (result && result.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && result.message || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    memSendAuthCodeSms: function memSendAuthCodeSms(_ref7, mobileInfo) {
      var commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.sendAuthCodeSms",
        param: mobileInfo
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //忘记密码
    doSetLoginPwdByMobile: function doSetLoginPwdByMobile(_ref8, setInfo) {
      var commit = _ref8.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.doSetLoginPwdByMobile",
        param: setInfo
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //注册
    memRegister: function memRegister(_ref9, memRegisterInfo) {
      var commit = _ref9.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.saleMemRegister",
        param: memRegisterInfo
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //获取登录/注册tooken
    getLoginToken: function getLoginToken(_ref10, data) {
      var commit = _ref10.commit;

      var url = __WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].authBaseUrl;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["b" /* restCall */])(url, data).then(function (res) {
        if (res && res.success && res.target && res.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && (res.message || res.target && res.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //登陆USR SESSION
    loginUsrSession: function loginUsrSession(_ref11, _ref12) {
      var commit = _ref11.commit;
      var openid = _ref12.openid,
          islogend = _ref12.islogend,
          regnode = _ref12.regnode,
          memdata = _ref12.memdata,
          userAttrId = _ref12.userAttrId;

      var data = {
        openid: openid,
        islogend: islogend,
        memdata: memdata,
        userAttrId: userAttrId
      };
      if (regnode) {
        axios.post("/api/login", data);
      }
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* SET_USER */], data);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
    },


    /*6.3.登录成功获取会员详细信息*/
    getLoginMemDetailInfo: function getLoginMemDetailInfo(_ref13) {
      var commit = _ref13.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memInfoHandler.getMemDetailInfo",
        param: []
      }).then(function (result) {
        if (result && result.success && result.target || result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //注销SESSION
    logoutUsrSession: function logoutUsrSession(_ref14, distroynode) {
      var commit = _ref14.commit;

      if (distroynode) {
        axios.post("/api/logout");
      }
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* SET_USER */], null);
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(true);
    },


    //登录token（用于保存登录状态）
    loginToken: function loginToken(_ref15, data) {
      var commit = _ref15.commit;

      var url = __WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].loginReqUrl;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["b" /* restCall */])(url, data).then(function (res) {
        if (res && res.success && res.target && res.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res && (res.message || res.target && res.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //18.3.通过选择属性 获取 商品单品信息
    // getGoodsSku({ commit },id) {
    //   return http.post({
    //     fn: 'mallsale.goodsHandler.getGoodsSku',
    //     param: id
    //   }).then(result => {
    //     if (result && result.success && result.target && result.target.success) {
    //       commit( GOOD_SKU, result.target.target);
    //       return Promise.resolve( result.target.target);
    //     } else {
    //       return Promise.reject(util.getResultErrMsg(result));
    //     }
    //   }).catch(error => {
    //     console.log("错误信息:", error);
    //     return Promise.reject(error);
    //   })
    // },

    /*===================================使用说明=========================================*/
    // 18.1.获取使用说明
    getElContract: function getElContract(_ref16) {
      var commit = _ref16.commit;

      var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref17$updated = _ref17.updated,
          updated = _ref17$updated === undefined ? true : _ref17$updated,
          _ref17$params = _ref17.params,
          params = _ref17$params === undefined ? {} : _ref17$params;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.siteHandler.getAfterSalesService",
        param: []
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    // 提交问卷调查
    commitQuestionPaper: function commitQuestionPaper(_ref18, param) {
      var commit = _ref18.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallsale.sitePaperHandler.commitPaper",
        param: [param]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target && result.target.message) || "提交失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //分页】分页查询项目信息，关键字keyword（cpOrderId）不能为空
    pageProjects: function pageProjects(_ref19, data) {
      var commit = _ref19.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].commentTokenCallUrl + "/comment/api/comment/pageProjects", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //【U9】查询 订单 操作日志 信息, 入参data: CP订单号
    selectUjiuLogs: function selectUjiuLogs(_ref20, data) {
      var commit = _ref20.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].commentTokenCallUrl + "/comment/api/comment/selectUjiuLogs", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //【评价】添加评价
    addComment: function addComment(_ref21, data) {
      var commit = _ref21.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].commentTokenCallUrl + "/comment/api/comment/addComment", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },
    loginByCode: function loginByCode(_ref22, data) {
      var commit = _ref22.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].commentTokenCallUrl + "/comment/login/loginByCode", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    /*===================================  end  ==========================================*/
    // 获取400投诉内容
    get400Complaint: function get400Complaint(_ref23, data) {
      var commit = _ref23.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].commentTokenCallUrl + "/comment/api/iface/getComplaint", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "获取数据失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },

    //400投诉处理评价-添加评价
    add400Comment: function add400Comment(_ref24, data) {
      var commit = _ref24.commit;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__service_adapter__["a" /* tokenCall */])(__WEBPACK_IMPORTED_MODULE_6__Constant__["a" /* default */].commentTokenCallUrl + "/comment/api/iface/createComment", data).then(function (res) {
        if (res.code == 200) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res.data);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(res || "操作失败");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //微信登录部分
    //生成网页授权URL（网站应用微信登录）
    connectQrconnect: function connectQrconnect(_ref25, redirectUrl) {
      var commit = _ref25.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.connectQrconnect",
        param: [redirectUrl]
      }).then(function (result) {
        if (result && result.success && result.target) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target);
        } else {
          if (result.message) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result.message);
          }
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    },


    //调用后台执行微信登录
    doWxAppLogin: function doWxAppLogin(_ref26, wxCode) {
      var commit = _ref26.commit;

      return __WEBPACK_IMPORTED_MODULE_3__service_http__["a" /* default */].post({
        fn: "mallmem.memLoginHandler.doWxAppLogin",
        param: [wxCode]
      }).then(function (result) {
        if (result && result.success && result.target && result.target.success) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(result.target.target);
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(result && (result.message || result.target.message) || "登录失败！");
        }
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* SET_USER */], function (state, user) {
    state.authUser = user;
  }),
  getters: {
    loginType: function loginType(state) {
      return state.loginType;
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_util__ = __webpack_require__(1);


var _types$UPDATE_USER_AT;





//全局mutations
/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_USER_AT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER_AT, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* UPDATE_USER_ATTR_ID */], function (state, userAttrId) {
    state.userAttrId = userAttrId;
    __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["a" /* storage */].session.set('userAttrId', state.userAttrId);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER_AT, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* USER_INFO */], function (state, userInfo) {
    state.userInfo = userInfo || {};
    __WEBPACK_IMPORTED_MODULE_3__common_utils_util__["a" /* storage */].local.set('userInfo', state.userInfo);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER_AT, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["o" /* CUSTOMER_SHREF */], function (state, link) {
    state.customerLink = link || '';
}), _types$UPDATE_USER_AT);

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/u276.350c47b.jpeg";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_meixin2_3x.17a213b.png";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(374),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(416),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "grid-tip tip"
  }, [_vm._v("\n      快来取个有逼格的名字吧~\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "edit"
  }, [_c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("昵称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickName),
      expression: "nickName"
    }],
    staticClass: "right",
    attrs: {
      "placeholder": "请输入昵称"
    },
    domProps: {
      "value": (_vm.nickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "editButton"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "保存",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  })], 1)]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "昵称不能为空  *__*"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.successMsg) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "修改成功!"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap",
    staticClass: "detail-wrap",
    style: (_vm.txtStyle),
    on: {
      "touchstart": _vm._touchStart,
      "touchmove": _vm._touchMove,
      "touchend": _vm._touchEnd
    }
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content"
  }, [(_vm.GoodsDetail.length < 1 && !_vm.load) ? _c('empty', {
    attrs: {
      "emptytext": "对不起，暂时没有找到结果"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.GoodsDetail), function(goodItem, index) {
    return (goodItem.infoType == 1) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(goodItem.infos)
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.height > 0),
      expression: "height>0"
    }],
    staticClass: "tripartite-box",
    style: (_vm.txtStyle)
  }, [_c('span', {
    staticClass: "wxauth-title"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.tip) + "\n\t\t\t")])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "flex-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pay-result"
  }, [_c('p', [_vm._v("订单号：" + _vm._s(_vm.payResult && _vm.payResult.orderNo))]), _vm._v(" "), _c('p', [_vm._v("支付方式："), _c('label', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.payResult && _vm.payResult.payTypeName))])]), _vm._v(" "), _c('p', [_vm._v("订单金额："), _c('label', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.payResult && _vm.payResult.payAmount))])])]), _vm._v(" "), _c('div', {
    staticClass: "fullbtn-box"
  }, [(_vm.payResult.orderFlag == 2) ? _c('mu-raised-button', {
    staticClass: "full gray",
    attrs: {
      "fullWidth": "",
      "label": "查看订单详情"
    },
    on: {
      "click": _vm.gotoOrderDetail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payResult.orderFlag == 1) ? _c('mu-raised-button', {
    staticClass: "full gray",
    attrs: {
      "fullWidth": "",
      "label": "查看订单"
    },
    on: {
      "click": _vm.gotoOrder
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "fullbtn-box"
  }, [_c('mu-raised-button', {
    staticClass: "full",
    attrs: {
      "label": "继续逛逛",
      "fullWidth": ""
    },
    on: {
      "click": _vm.goScanmore
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-result-box"
  }, [_c('p', [_vm._v("订单支付成功！")])])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-delete"
  }, [_c('div', {
    staticClass: "move",
    style: (_vm.txtStyle),
    on: {
      "touchstart": _vm._touchStart,
      "touchmove": _vm._touchMove,
      "touchend": _vm._touchEnd
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "deleteIcon",
    style: (_vm.zIndex),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteItem(_vm.index)
      }
    }
  }, [_c('span', [_vm._v("删除")])])])
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap",
    staticClass: "parameter-wrap",
    style: (_vm.txtStyle),
    on: {
      "touchstart": _vm._touchStart,
      "touchmove": _vm._touchMove,
      "touchend": _vm._touchEnd
    }
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "content"
  }, [(_vm.GoodsKindValue.length < 1 && !_vm.load) ? _c('empty', {
    attrs: {
      "emptytext": "对不起，暂时没有找到结果"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.GoodsKindValue), function(item) {
    return _c('div', {
      staticClass: "parameter-box"
    }, [_c('h3', {
      staticClass: "header"
    }, [_vm._v(_vm._s(item.groupName))]), _vm._v(" "), _vm._l((item.values), function(sub) {
      return _c('div', {
        staticClass: "parameter-item"
      }, [_c('label', {
        staticClass: "label"
      }, [_vm._v(_vm._s(sub.fieldName))]), _vm._v(" "), _c('span', {
        staticClass: "content"
      }, [_vm._v(_vm._s(sub.fieldValue))])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.height > 0),
      expression: "height>0"
    }],
    staticClass: "tripartite-box",
    style: (_vm.txtStyle)
  }, [_c('span', {
    staticClass: "wxauth-title"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.tip) + "\n\t\t\t")])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap writeinvoice-wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "invoice-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        发票类型：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "invoice-type-box"
  }, _vm._l((_vm.invoiceTypeList), function(typeItem) {
    return _c('mu-chip', {
      key: typeItem.value,
      staticClass: "demo-chip",
      class: [_vm.invoiceData.invoiceType == typeItem.value ? 'primary' : ''],
      on: {
        "click": function($event) {
          _vm.invoiceData.invoiceType = typeItem.value;
          _vm.invoiceData.invoiceTypeName = typeItem.name
        }
      }
    }, [_vm._v(_vm._s(typeItem.name))])
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "invoice-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        发票抬头：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "invoice-title-box"
  }, [_c('div', {
    staticClass: "radio-box"
  }, [_c('mu-radio', {
    staticClass: "list-radio",
    class: ['person' == _vm.invoiceTitle ? 'primary' : ''],
    attrs: {
      "nativeValue": "person",
      "label": "个人"
    },
    on: {
      "change": function($event) {
        _vm.invoiceData.invoiceHead = '个人';
        _vm.invoiceData.uniformCode = ''
      }
    },
    model: {
      value: (_vm.invoiceTitle),
      callback: function($$v) {
        _vm.invoiceTitle = $$v
      },
      expression: "invoiceTitle"
    }
  }), _vm._v(" "), _c('mu-radio', {
    staticClass: "list-radio",
    class: ['company' == _vm.invoiceTitle ? 'primary' : ''],
    attrs: {
      "nativeValue": "company",
      "label": "单位"
    },
    model: {
      value: (_vm.invoiceTitle),
      callback: function($$v) {
        _vm.invoiceTitle = $$v
      },
      expression: "invoiceTitle"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceTitle == 'company' && _vm.memInvoiceMsgList.length > 0),
      expression: "invoiceTitle=='company' && memInvoiceMsgList.length > 0"
    }],
    staticClass: "company-list"
  }, _vm._l((_vm.memInvoiceMsgList), function(item, index) {
    return _c('div', {
      staticClass: "company-item"
    }, [_c('p', {
      staticClass: "ellipsis floatL",
      on: {
        "click": function($event) {
          return _vm.selcompanycheckbox(index)
        }
      }
    }, [_vm._v(_vm._s(item.invoiceHead))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isEditState),
        expression: "isEditState"
      }],
      staticClass: "edit-company fr"
    }, [_c('label', {
      staticClass: "primary",
      on: {
        "click": function($event) {
          return _vm.write('modify', index)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('label', {
      staticClass: "primary",
      on: {
        "click": function($event) {
          return _vm.write('delete', index)
        }
      }
    }, [_vm._v("删除")])]), _vm._v(" "), _c('mu-radio', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isEditState),
        expression: "!isEditState"
      }],
      staticClass: "list-radio fr",
      class: [item.invoiceHead == _vm.invoiceData.invoiceHead ? 'primary' : ''],
      attrs: {
        "nativeValue": item.invoiceHead
      },
      on: {
        "change": function($event) {
          _vm.invoiceData.invoiceHead = item.invoiceHead;
          _vm.invoiceData.uniformCode = item.uniformCode
        }
      },
      model: {
        value: (_vm.selectedCompanyid),
        callback: function($$v) {
          _vm.selectedCompanyid = $$v
        },
        expression: "selectedCompanyid"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.invoiceTitle == 'company' && _vm.memInvoiceMsgList.length <= 0) || (_vm.isAddState)),
      expression: "(invoiceTitle == 'company'  && memInvoiceMsgList.length <= 0) || (isAddState)"
    }],
    staticClass: "write-company"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addInfo.invoiceHead),
      expression: "addInfo.invoiceHead"
    }],
    attrs: {
      "type": "text",
      "placeholder": "新增单位发票抬头"
    },
    domProps: {
      "value": (_vm.addInfo.invoiceHead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addInfo, "invoiceHead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addInfo.uniformCode),
      expression: "addInfo.uniformCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入纳税人识别号"
    },
    domProps: {
      "value": (_vm.addInfo.uniformCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addInfo, "uniformCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceTitle == 'company'),
      expression: "invoiceTitle=='company'"
    }],
    staticClass: "operate"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memInvoiceMsgList.length > 0 && !_vm.isEditState && !_vm.isAddState),
      expression: "memInvoiceMsgList.length > 0 && !isEditState && !isAddState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('edit', null)
      }
    }
  }, [_vm._v("编辑单位")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memInvoiceMsgList.length > 0 && !_vm.isEditState && !_vm.isAddState),
      expression: "memInvoiceMsgList.length > 0 && !isEditState && !isAddState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('add', null)
      }
    }
  }, [_vm._v("新增单位")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditState && !_vm.isAddState),
      expression: "isEditState && !isAddState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('finish', null)
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAddState && !_vm.isEditState),
      expression: "isAddState && !isEditState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('quit', null)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.invoiceTitle == 'company' && _vm.memInvoiceMsgList.length <= 0 || _vm.isAddState) && !_vm.isEditState),
      expression: "(invoiceTitle == 'company' && memInvoiceMsgList.length <= 0 ||isAddState) && !isEditState"
    }],
    staticClass: "blue",
    on: {
      "click": function($event) {
        return _vm.write('save', null)
      }
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "invoice-box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        发票内容：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "invoice-content-box"
  }, [_c('div', {
    staticClass: "radio-box"
  }, _vm._l((_vm.invoiceContentList), function(item) {
    return _c('mu-radio', {
      key: item.value,
      staticClass: "list-radio",
      class: [item.value == _vm.invoiceData.invoiceContent ? 'primary' : ''],
      attrs: {
        "nativeValue": item.name,
        "label": item.name
      },
      on: {
        "change": function($event) {
          _vm.invoiceData.invoiceContent = item.value;
          _vm.invoiceData.invoiceContentName = item.name
        }
      },
      model: {
        value: (_vm.invoiceData.invoiceContentName),
        callback: function($$v) {
          _vm.$set(_vm.invoiceData, "invoiceContentName", $$v)
        },
        expression: "invoiceData.invoiceContentName"
      }
    })
  }), 1)])])])]) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确 定",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.submit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.deleteDialog,
      "title": "删除单位",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("\n    确定删除这个单位吗？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.deleteHead
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.editDialog,
      "bodyClass": "dialogBody input-dialog",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "write-company"
  }, [_c('p', [_vm._v("单位发票抬头")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selCompany.invoiceHead),
      expression: "selCompany.invoiceHead"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入发票抬头"
    },
    domProps: {
      "value": (_vm.selCompany.invoiceHead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selCompany, "invoiceHead", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("纳税人识别号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selCompany.uniformCode),
      expression: "selCompany.uniformCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入纳税人识别号"
    },
    domProps: {
      "value": (_vm.selCompany.uniformCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selCompany, "uniformCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.saveEdit
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap search-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索商品",
      "autofocus": true
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "change": function($event) {
        _vm.loading = false
      },
      "focus": function($event) {
        return _vm.focusinput()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        return _vm.filter()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "search-condition"
  }, [_c('mu-flat-button', {
    class: {
      primary: _vm.seo
    },
    attrs: {
      "label": "综合"
    },
    on: {
      "click": _vm.seoRanking
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "sales",
    class: {
      activeAsc: _vm.asc == 'asc',
      activeDesc: _vm.asc == 'desc'
    },
    attrs: {
      "label": "销量"
    },
    on: {
      "click": function($event) {
        return _vm.select()
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "multiple",
    attrs: {
      "label": "筛选"
    },
    on: {
      "click": function($event) {
        _vm.rightPopup = true
      }
    }
  })], 1), _vm._v(" "), (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "listBox",
    staticClass: "box flex-item"
  }, [_c('div', {
    staticClass: "banner-img",
    on: {
      "click": function($event) {
        return _vm.linkFn(_vm.adver.linkType, _vm.adver.linkTarget)
      }
    }
  }, [_c('imgs', {
    attrs: {
      "height": 240,
      "imagePath": _vm.adver && _vm.adver.imagePath && _vm.adver.imagePath.imagePath
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-lists"
  }, [_vm._l((_vm.goodsList), function(gooditem) {
    return _c('div', {
      staticClass: "product-list square",
      on: {
        "click": function($event) {
          return _vm.scanDetail(gooditem.storeId, gooditem.goodsId, gooditem.skuId)
        }
      }
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('imgs', {
      attrs: {
        "width": 522,
        "height": 522,
        "imagePath": gooditem && gooditem.imagePath && gooditem.imagePath.imagePath,
        "titleText": gooditem.goodsName,
        "orginalCost": gooditem.unitPrice,
        "moneyText": gooditem.goodsPrice > 0 ?
          gooditem.goodsPrice :
          gooditem.priceDesc || ''
      }
    }, [_c('template', {
      slot: "money"
    }, [_vm._v("\n                " + _vm._s(gooditem.goodsPrice > 0 ?
      gooditem.goodsPrice :
      gooditem.priceDesc) + "\n              ")]), _vm._v(" "), _c('template', {
      slot: "orginalCost"
    }, [_vm._v(_vm._s(gooditem.unitPrice))])], 2)], 1)])
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  })], 2), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.load) || (_vm.total == 0 && !_vm.load)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("\n        没有更多商品啦~\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.isColligate) ? _c('div', {
    staticClass: "colligate-select"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('div', {
    staticClass: "radio-item",
    class: {
      active: _vm.asc == 'asc'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sale('asc')
      }
    }
  }, [_vm._v("\n          销量从低到高\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "radio-item",
    class: {
      active: _vm.asc == 'desc'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sale('desc')
      }
    }
  }, [_vm._v("\n          销量从高到低\n        ")])])]) : _vm._e(), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "right",
      "popupClass": "filter-popup",
      "open": _vm.rightPopup
    },
    on: {
      "close": function($event) {
        _vm.rightPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-column"
  }, [_c('div', {
    staticClass: "filter-header"
  }, [_c('span', {
    staticClass: "arrow",
    on: {
      "click": function($event) {
        _vm.rightPopup = false
      }
    }
  }), _vm._v(" "), _c('samp', {}, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, _vm._l((_vm.GoodsPropertieTags), function(tag, index) {
    return _c('div', {
      ref: "toggleWrap",
      refInFor: true,
      staticClass: "item"
    }, [_c('p', {
      staticClass: "filter-list-header",
      on: {
        "click": function($event) {
          return _vm.toggleNexted(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tag.linkName) + "\n              "), (index >= _vm.eq) ? _c('samp', {
      staticClass: "arrow",
      class: {
        upArrow: index == _vm.nextId
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item",
      class: {
        spread: index < _vm.eq || index == _vm.nextId
      }
    }, _vm._l((tag.subs), function(subtag) {
      return _c('span', {
        staticClass: "label",
        class: {
          active: _vm.checkedTag &&
            _vm.checkedTag[index] &&
            _vm.checkedTag[index].linkInfo &&
            _vm.checkedTag[index].linkInfo.linkTarget == subtag.linkTarget,
        },
        on: {
          "click": function($event) {
            return _vm.selectTag(index, subtag)
          }
        }
      }, [_vm._v("\n                " + _vm._s(subtag.linkName) + "\n              ")])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('mu-raised-button', {
    staticClass: "reset-button",
    attrs: {
      "label": "重置",
      "primary": ""
    },
    on: {
      "click": _vm.reset
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submit-button",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.filter
    }
  })], 1)])]), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap search-all-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索商品关键词"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        return _vm.searchGoods(_vm.searchKey)
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [(_vm.lastSearchList && _vm.lastSearchList.length) ? _c('div', {
    staticClass: "last-search"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v("最近搜索")]), _vm._v(" "), _c('span', {
    staticClass: "floatR button",
    on: {
      "click": function($event) {
        _vm.isDialog = true
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-label"
  }, _vm._l((_vm.lastSearchList), function(item, index) {
    return _c('mu-flat-button', {
      key: index,
      staticClass: "label",
      attrs: {
        "label": item
      },
      on: {
        "click": function($event) {
          return _vm.searchGoods(item)
        }
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.searchKeywordList && _vm.searchKeywordList.length) ? _c('div', {
    staticClass: "hot-search"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v("热门搜索")]), _vm._v(" "), _c('span', {
    staticClass: "floatR button",
    on: {
      "click": _vm.batchKeyword
    }
  }, [_vm._v("换一批")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-label"
  }, _vm._l((_vm.searchKeywordList), function(item, index) {
    return _c('mu-flat-button', {
      key: index,
      staticClass: "label",
      attrs: {
        "label": item
      },
      on: {
        "click": function($event) {
          return _vm.searchGoods(item)
        }
      }
    })
  }), 1)]) : _vm._e()]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDialog,
      "title": "提示"
    },
    on: {
      "close": function($event) {
        _vm.isDialog = false
      }
    }
  }, [_vm._v("\n\t    是否清空搜索内容\n\t    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": function($event) {
        _vm.isDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.clearSearch
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-link-wrap verticalM"
  }, [_c('img', {
    staticClass: "verticalM-box",
    attrs: {
      "src": "/static/images/home_logo_top_3x.png"
    },
    on: {
      "click": _vm.goHome
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "verticalM-box"
  }, [_vm._v("美心·美家·美生活")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "verticalM-box"
  }, [_c('a', {
    attrs: {
      "href": "tel:400-832-2777"
    }
  }, [_vm._v("400-832-2777")])])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGoodsCommentList.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_evaluation_3x.png",
      "emptytext": "您还没有商品评价",
      "btnurl": "/main/home",
      "btntext": "去逛一逛"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "flex-column flex-item orders-list"
  }, [_vm._l((_vm.getGoodsCommentList), function(getGoodsMsg) {
    return (_vm.getGoodsCommentList.length != 0) ? _c('div', {
      staticClass: "orders-list-item"
    }, [_c('mu-list', {
      staticStyle: {
        "border-bottom": "1px solid #f5f7f9"
      }
    }, _vm._l((_vm.getGoodsCommentList), function(goodsShow, goodsIndex) {
      return _c('myOrdersItem', {
        key: goodsIndex,
        attrs: {
          "width": 150,
          "height": 150,
          "cartitem": goodsShow,
          "isRightTriggle": 'true'
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "comment-box"
    }, [_c('p', {
      staticClass: "comment"
    }, [_vm._v(_vm._s(getGoodsMsg.commDesc))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(getGoodsMsg.commTime))]), _vm._v(" "), (0) ? _c('div', {
      staticClass: "reply"
    }, [_c('p', {
      staticClass: "triangle"
    }), _vm._v(" "), _c('p', [(getGoodsMsg.commentReplys.length == 0) ? _c('label', {
      staticClass: "orange"
    }, [_vm._v("商家回复：")]) : _vm._e(), _vm._v("\n            " + _vm._s(getGoodsMsg.commentReplys && getGoodsMsg.commentReplys.replyDesc) + "\n            ")]), (getGoodsMsg.commentReplys.length != 0) ? _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(getGoodsMsg.commentReplys && getGoodsMsg.commentReplys.replyTime))]) : _vm._e(), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [_c('p', {
      staticClass: "edit-address fr",
      on: {
        "click": function($event) {
          return _vm.editAddress(getGoodsMsg.commId)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('p', {
      staticClass: "delete-address fr",
      on: {
        "click": function($event) {
          return _vm.deleteAddress(getGoodsMsg.commId)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])])], 1) : _vm._e()
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.total == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多评价啦~")]) : _vm._e()], 2), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDelete,
      "title": "删除评论",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDelete = false
      }
    }
  }, [_vm._v("\n    确定删除这个评论？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDelete = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.closedeleteAddress
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap cart-wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('emptyCart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartInfoList.length == 0 && !_vm.load),
      expression: "cartInfoList.length == 0 && !load"
    }],
    attrs: {
      "imgpath": "/static/images/empty_shopping_cart_3x.png",
      "emptytext": "购物车空啦",
      "btntext": "逛一逛",
      "btnurl": "/main/home"
    }
  }), _vm._v(" "), (_vm.cartInfoList.length > 0 && !_vm.load) ? _c('div', {
    staticClass: "grid-tip"
  }, [_vm._v("\n    购物车(" + _vm._s(_vm.totalGoodsNum) + ")\n    "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEdit),
      expression: "!isEdit"
    }],
    staticClass: "fr",
    on: {
      "click": function($event) {
        _vm.isEdit = true
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticClass: "fr",
    on: {
      "click": function($event) {
        _vm.isEdit = false
      }
    }
  }, [_vm._v("完成")])]) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "flex-item cart-box"
  }, [_c('div', {
    staticClass: "cart-list"
  }, _vm._l((_vm.cartInfoList), function(storeItem, storeIndex) {
    return _c('div', {
      staticClass: "cart-item"
    }, [_c('div', {
      staticClass: "brandTitle"
    }, [_c('mu-checkbox', {
      staticClass: "list-radio floatL",
      attrs: {
        "name": "group"
      },
      on: {
        "change": function($event) {
          return _vm.storeAll($event, storeIndex)
        }
      },
      model: {
        value: (storeItem.Selected),
        callback: function($$v) {
          _vm.$set(storeItem, "Selected", $$v)
        },
        expression: "storeItem.Selected"
      }
    }), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          return _vm.gotoBrandHome(storeItem.storeId)
        }
      }
    }, [_c('imgs', {
      staticClass: "logo floatL",
      attrs: {
        "width": 120,
        "imagePath": storeItem &&
          storeItem.storeLogoPath &&
          storeItem.storeLogoPath.imagePath
      }
    }), _vm._v(" "), _c('p', [_c('label', [_vm._v("品牌：")]), _vm._v(_vm._s(storeItem && storeItem.storeName))]), _vm._v(" "), _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "getcoupon",
      on: {
        "click": function($event) {
          _vm.couponPopup = true;
          _vm.getListStoreCoupon(storeItem.storeId);
        }
      }
    }, [_vm._v("领券")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1), _vm._v(" "), _vm._l((storeItem.cartGoodses), function(goodsItem, goodsIndex) {
      return [(goodsItem.sourceType == 2) ? _c('div', {
        staticClass: "cartTitle"
      }, [_c('mu-list', [_c('touchDelete', {
        key: goodsIndex,
        attrs: {
          "index": goodsItem.instSkuId
        },
        on: {
          "deleteItem": _vm.deleteItem
        }
      }, [_c('mu-list-item', {
        attrs: {
          "title": goodsItem.goodsName
        }
      }, [_c('mu-checkbox', {
        staticClass: "list-radio",
        attrs: {
          "name": "group"
        },
        on: {
          "change": function($event) {
            return _vm.changeSelect($event, storeIndex, goodsIndex)
          }
        },
        model: {
          value: (goodsItem.cartSelected),
          callback: function($$v) {
            _vm.$set(goodsItem, "cartSelected", $$v)
          },
          expression: "goodsItem.cartSelected"
        }
      }), _vm._v(" "), (!_vm.isEdit) ? _c('div', {
        staticClass: "listItem"
      }, [_c('p', {
        staticClass: "price"
      }, [_vm._v("￥" + _vm._s(goodsItem.salePrice))]), _vm._v(" "), _c('p', {
        staticClass: "count"
      }, [_vm._v("x" + _vm._s(goodsItem.goodsNum))]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', {
        staticClass: "listItem edit"
      }, [_c('span', {
        staticClass: "reduce-btn",
        on: {
          "click": function($event) {
            return _vm.changeNum(
              'add',
              goodsItem.instSkuId,
              goodsItem.goodsNum
            )
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input"
      }, [_vm._v(_vm._s(goodsItem.goodsNum))]), _vm._v(" "), _c('span', {
        staticClass: "add-btn",
        on: {
          "click": function($event) {
            return _vm.changeNum(
              'reduce',
              goodsItem.instSkuId,
              goodsItem.goodsNum
            )
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (goodsItem.sourceType == 2 && !_vm.isEdit) ? _c('div', {
        staticClass: "dashLine dashLineparent"
      }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
        goodsItem.sourceType == 2 &&
        goodsItem.subCartGoods &&
        goodsItem.subCartGoods.length > 0
      ) ? _c('mu-list', {
        class: [_vm.isEdit ? 'isedit' : '']
      }, _vm._l((goodsItem.subCartGoods), function(subItem, subIndex) {
        return _c('touchDelete', {
          key: subIndex,
          attrs: {
            "index": subItem.instSkuId
          },
          on: {
            "deleteItem": _vm.deleteItem
          }
        }, [(
          (subIndex > 0 && subItem.sourceType == 1) ||
          subItem.sourceType == 2
        ) ? _c('hr') : _vm._e(), _vm._v(" "), _c('mu-list-item', {
          attrs: {
            "title": subItem.goodsName
          }
        }, [(goodsItem.sourceType == 1 || _vm.isEdit) ? _c('mu-checkbox', {
          staticClass: "list-radio",
          attrs: {
            "name": "group"
          },
          on: {
            "change": function($event) {
              return _vm.changeSelect($event, storeIndex, subIndex)
            }
          },
          model: {
            value: (goodsItem.cartSelected),
            callback: function($$v) {
              _vm.$set(goodsItem, "cartSelected", $$v)
            },
            expression: "goodsItem.cartSelected"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "leftAvataDiv",
          attrs: {
            "slot": "leftAvatar"
          },
          on: {
            "click": function($event) {
              return _vm.gotoDetail(
                storeItem.storeId,
                subItem.goodsId,
                subItem.skuId
              )
            }
          },
          slot: "leftAvatar"
        }, [_c('imgs', {
          attrs: {
            "width": 200,
            "height": 200,
            "imagePath": subItem.imagePath.imagePath
          }
        })], 1), _vm._v(" "), (!_vm.isEdit) ? _c('div', {
          staticClass: "listItem"
        }, [_c('p', {
          staticClass: "price"
        }, [_vm._v("\n                    ￥" + _vm._s(goodsItem.salePrice)), _c('label', [_vm._v("￥" + _vm._s(goodsItem.unitPrice))])]), _vm._v(" "), _c('p', {
          staticClass: "count"
        }, [_vm._v("x" + _vm._s(goodsItem.goodsNum))]), _vm._v(" "), _c('div', {
          staticClass: "clearfix"
        })]) : _vm._e(), _vm._v(" "), (goodsItem.sourceType == 2 && !_vm.isEdit) ? _c('div', [(subIndex != goodsItem.subCartGoods.length - 1) ? _c('div', {
          staticClass: "dashLine dashLineall"
        }) : _vm._e(), _vm._v(" "), (subIndex == goodsItem.subCartGoods.length - 1) ? _c('div', {
          staticClass: "dashLine dashLinetop"
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "pointp"
        })]) : _vm._e()], 1)], 1)
      }), 1) : _vm._e(), _vm._v(" "), (goodsItem.sourceType == 1) ? _c('mu-list', {
        class: [_vm.isEdit ? 'isedit' : '']
      }, [_c('touchDelete', {
        attrs: {
          "index": goodsItem.instSkuId
        },
        on: {
          "deleteItem": _vm.deleteItem
        }
      }, [(
        (goodsIndex > 0 && goodsItem.sourceType == 1) ||
        goodsItem.sourceType == 2
      ) ? _c('hr') : _vm._e(), _vm._v(" "), _c('mu-list-item', {
        attrs: {
          "title": goodsItem.goodsName
        }
      }, [(goodsItem.sourceType == 1 || _vm.isEdit) ? _c('mu-checkbox', {
        staticClass: "list-radio",
        attrs: {
          "name": "group"
        },
        on: {
          "change": function($event) {
            return _vm.changeSelect($event, storeIndex, goodsIndex)
          }
        },
        model: {
          value: (goodsItem.cartSelected),
          callback: function($$v) {
            _vm.$set(goodsItem, "cartSelected", $$v)
          },
          expression: "goodsItem.cartSelected"
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "leftAvataDiv",
        attrs: {
          "slot": "leftAvatar"
        },
        on: {
          "click": function($event) {
            return _vm.gotoDetail(
              storeItem.storeId,
              goodsItem.goodsId,
              goodsItem.skuId
            )
          }
        },
        slot: "leftAvatar"
      }, [_c('imgs', {
        attrs: {
          "width": 200,
          "height": 200,
          "imagePath": goodsItem.imagePath.imagePath
        }
      })], 1), _vm._v(" "), (_vm.isEdit) ? _c('div', {
        staticClass: "listItem edit"
      }, [_c('span', {
        staticClass: "reduce-btn",
        on: {
          "click": function($event) {
            return _vm.changeNum(
              'add',
              goodsItem.instSkuId,
              goodsItem.goodsNum
            )
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "input"
      }, [_vm._v(_vm._s(goodsItem.goodsNum))]), _vm._v(" "), _c('span', {
        staticClass: "add-btn",
        on: {
          "click": function($event) {
            return _vm.changeNum(
              'reduce',
              goodsItem.instSkuId,
              goodsItem.goodsNum
            )
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('div', {
        staticClass: "listItem"
      }, [_c('p', {
        staticClass: "price"
      }, [_vm._v("\n                    ￥" + _vm._s(goodsItem.salePrice)), _c('label', [_vm._v("￥" + _vm._s(goodsItem.unitPrice))])]), _vm._v(" "), _c('p', {
        staticClass: "count"
      }, [_vm._v("x" + _vm._s(goodsItem.goodsNum))]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e()], 1)], 1)], 1) : _vm._e()]
    })], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.cartInfoList.length > 0 && !_vm.isEdit && !_vm.load) ? _c('div', {
    staticClass: "cartBottom"
  }, [_c('mu-checkbox', {
    staticClass: "list-radio",
    attrs: {
      "name": "group",
      "id": "all",
      "label": "全选"
    },
    on: {
      "change": function($event) {
        return _vm.handleCheckAllChange($event)
      }
    },
    model: {
      value: (_vm.all),
      callback: function($$v) {
        _vm.all = $$v
      },
      expression: "all"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "count ellipsis pdl"
  }, [_vm._v("\n      合计："), _c('span', [_vm._v("￥" + _vm._s(_vm.totalGoodsPrice))]), _c('span', [_vm._v("(不含运费)")])]), _vm._v(" "), _c('div', {
    staticClass: "go",
    class: [_vm.totalGoodsPrice <= 0 ? 'disabledbtn' : 'primarybtn'],
    on: {
      "click": _vm.goOrderPay
    }
  }, [_vm._v("\n      去结算\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.cartInfoList.length > 0 && _vm.isEdit && !_vm.load) ? _c('div', {
    staticClass: "cartBottom"
  }, [_c('mu-checkbox', {
    staticClass: "list-radio",
    attrs: {
      "name": "group",
      "id": "all",
      "label": "全选"
    },
    on: {
      "change": function($event) {
        return _vm.handleCheckAllChange($event)
      }
    },
    model: {
      value: (_vm.all),
      callback: function($$v) {
        _vm.all = $$v
      },
      expression: "all"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "go",
    class: [_vm.totalGoodsPrice < 0 ? 'disabledbtn' : 'primarybtn'],
    on: {
      "click": function($event) {
        _vm.isDeletes = true
      }
    }
  }, [_vm._v("\n      删除\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "go",
    class: [_vm.totalGoodsPrice < 0 ? 'disabledbtn' : 'orangebtn'],
    on: {
      "click": _vm.addCollect
    }
  }, [_vm._v("\n      加入收藏夹\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('menus'), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "custom-popup-bottom flex-column",
      "open": _vm.headimgPopup
    },
    on: {
      "close": function($event) {
        _vm.headimgPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.headimgPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-img"
  }, [_c('imgs', {
    attrs: {
      "imagePath": __webpack_require__(367)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-desc"
  }, [_c('p', {
    staticClass: "price"
  }, [_c('samp', [_vm._v("¥")]), _vm._v("6502")]), _vm._v(" "), _c('p', {
    staticClass: "desc overflowT2"
  }, [_vm._v("\n            Mexin美心家美实木复合 简欧免漆室内套装卧室门简欧免漆室内套装卧室门\n            木门包安装 N856\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "goods-label"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("颜色")]), _vm._v(" "), _c('div', {
    staticClass: "label-list"
  }, _vm._l((5), function(i) {
    return _c('span', {
      staticClass: "label",
      class: {
        active: _vm.id == i
      },
      on: {
        "click": function($event) {
          _vm.id = i
        }
      }
    }, [_vm._v("实色浪漫白")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "goods-number"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticClass: "reduce-btn",
    on: {
      "click": function($event) {
        return _vm.goodsNum('reduce')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsNumber),
      expression: "goodsNumber"
    }],
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.goodsNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goodsNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        return _vm.goodsNum('add')
      }
    }
  }), _vm._v(" "), _c('samp', [_vm._v("件")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    }
  })], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDelete,
      "title": "删除商品",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDelete = false
      }
    }
  }, [_vm._v("\n    确定删除这个商品？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDelete = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.removeCart
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDeletes,
      "title": "删除商品",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDeletes = false
      }
    }
  }, [_vm._v("\n    您确定删除已勾选的商品？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDeletes = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.removeCarts
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "coupon-receive-popup-bottom flex-column",
      "open": _vm.couponPopup
    },
    on: {
      "close": function($event) {
        _vm.couponPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-list-item title"
  }, [_vm._v("\n              领券\n            ")]), _vm._v(" "), _c('emptyCart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.couponsList.length == 0),
      expression: "couponsList.length == 0"
    }],
    attrs: {
      "emptytext": "当前店铺没有优惠券了~"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "coupon-list-item"
  }, _vm._l((_vm.couponsList), function(couponItem) {
    return _c('tr', [_c('td', [(couponItem.couponCate != 3) ? _c('div', {
      class: {
        coupon: couponItem.couponType == 1,
        redpackage: couponItem.couponType == 2,
      }
    }, [_vm._v("\n                    ￥" + _vm._s(couponItem.couponAmount) + "\n                  ")]) : _vm._e(), _vm._v(" "), (couponItem.couponCate == 3) ? _c('div', {
      class: {
        coupon: couponItem.couponType == 1,
        redpackage: couponItem.couponType == 2,
      }
    }, [_vm._v("\n                    " + _vm._s(_vm._f("discount")(couponItem.couponDiscount))), _c('samp', [_vm._v("折")])]) : _vm._e()]), _vm._v(" "), _c('td', [(couponItem.couponType == 1) ? _c('p', [_vm._v("\n                    " + _vm._s(couponItem.useAmount == 0 ?
      "不限制" :
      "满" + couponItem.useAmount + "可用") + "\n                  ")]) : _vm._e(), _vm._v(" "), (couponItem.couponType == 2) ? _c('p', [_vm._v("\n                    剩余" + _vm._s((parseInt(couponItem.sendNum) - parseInt(couponItem.recivedNum))) + "个红包\n                  ")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(couponItem.effectiveTime) + " -\n                    " + _vm._s(couponItem.overdueTime))])]), _vm._v(" "), _c('td', [(couponItem.isGet == 1) ? _c('button', {
      staticClass: "gray finish",
      attrs: {
        "type": "default",
        "disabled": ""
      }
    }, [_vm._v("\n                    已领取\n                  ")]) : _vm._e(), _vm._v(" "), (couponItem.isGet == 0) ? _c('button', {
      staticClass: "gray",
      attrs: {
        "type": "default"
      },
      on: {
        "click": function($event) {
          return _vm.getCoupon(
            couponItem.couponId,
            couponItem.couponType,
            couponItem.isGet
          )
        }
      }
    }, [_vm._v("\n                    领取\n                  ")]) : _vm._e()])])
  }), 0)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  })], 1)]), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.invoiceList.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_invoice_3x.png",
      "btnurl": "/main/home",
      "emptytext": "您还没有发票信息",
      "btntext": "去逛一逛"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceList.length != 0 && !_vm.loadShow),
      expression: "invoiceList.length!=0 && !loadShow"
    }],
    staticClass: "flex-column flex-item orders-list detail"
  }, [_vm._l((_vm.invoiceList), function(invoiceListShow) {
    return _c('div', {
      staticClass: "orders-list-item"
    }, [_c('div', {
      staticClass: "orders-list-item-title invoiceinfo-title"
    }, [_vm._v("\n        订单号：\n        "), _c('label', [_vm._v(_vm._s(invoiceListShow.orderId))]), _c('span', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(invoiceListShow.orderTime))])]), _vm._v(" "), _c('mu-list', {
      staticStyle: {
        "border-bottom": "1px solid #e5e5e5"
      }
    }, _vm._l((invoiceListShow.goodsOrderMsgs), function(goodsShow, invoiceIndex) {
      return _c('myOrdersItem', {
        key: invoiceIndex,
        attrs: {
          "width": 150,
          "height": 150,
          "cartitem": goodsShow,
          "isRightTriggle": 'true'
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "orders-list-item-state"
    }, [_c('p', [_vm._v("发票信息")]), _vm._v(" "), _c('div', {
      staticClass: "state"
    }, [_vm._v("\n          发票类型："), _c('span', {
      staticClass: "black"
    }, [_vm._v(_vm._s(invoiceListShow.invoiceData && invoiceListShow.invoiceData.invoiceTypeName || '无'))]), _vm._v(" "), _c('br'), _vm._v(" 发票内容：\n          "), _c('span', {
      staticClass: "black"
    }, [_vm._v(_vm._s(invoiceListShow.invoiceData && invoiceListShow.invoiceData.invoiceContentName || '无'))]), _vm._v(" "), _c('br'), _vm._v(" 发票抬头：\n          "), _c('span', {
      staticClass: "black"
    }, [_vm._v(_vm._s(invoiceListShow.invoiceData && invoiceListShow.invoiceData.invoiceHead || '无'))])])])], 1)
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.total == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多信息啦~")]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap"
  }, [_c('div', {
    staticClass: "flex-column myaccount"
  }, [_c('div', {
    staticClass: "mytabs two"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      'active': _vm.activeTab == 'tab1'
    },
    on: {
      "click": function($event) {
        return _vm.tabHeaderOne(0)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": "0",
      "circle": "",
      "secondary": "",
      "badgeClass": "none-badge"
    }
  }, [_c('p', [_vm._v("未使用")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      'active': _vm.activeTab == 'tab2'
    },
    on: {
      "click": function($event) {
        return _vm.tabHeaderTwo(2)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": "0",
      "circle": "",
      "secondary": "",
      "badgeClass": "none-badge"
    }
  }, [_c('p', [_vm._v("已失效")])])], 1)]), _vm._v(" "), (_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.memCouponMsg.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_coupon_3x.png",
      "emptytext": "您还没有相关优惠券"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memCouponMsg.length != 0 && !_vm.loadShow),
      expression: " memCouponMsg.length != 0  && !loadShow"
    }],
    staticClass: "flex-item coupon-list"
  }, [_vm._l((_vm.memCouponMsg), function(memCouponMsgList, ceffectiveIndex) {
    return _c('mu-list', {
      key: ceffectiveIndex,
      staticClass: "acount-list coupon",
      class: {
        'out-date': _vm.activeTab == 'tab2'
      }
    }, [_c('mu-list-item', [_c('div', {
      staticClass: "acount-list-left"
    }, [(memCouponMsgList.couponCate != 3) ? _c('p', {
      staticClass: "money"
    }, [_vm._v("￥\n              "), _c('label', [_vm._v(_vm._s(memCouponMsgList.couponAmount))])]) : _vm._e(), _vm._v(" "), (memCouponMsgList.couponCate == 3) ? _c('p', {
      staticClass: "money"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("discount")(memCouponMsgList.couponDiscount)))]), _vm._v("折\n            ")]) : _vm._e(), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTab == 'tab2'),
        expression: "activeTab =='tab2'"
      }],
      attrs: {
        "src": "/static/images/coupon_out_of_date_3x.png"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "limit"
    }, [_vm._v(_vm._s(memCouponMsgList.useableAmount == 0 ? '不限制' : '满' + memCouponMsgList.useableAmount + '可用'))])]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis gray mgt"
    }, [_c('label', [_vm._v("限品类：")]), _vm._v(_vm._s(memCouponMsgList.userTypeName))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis gray"
    }, [_c('label', [_vm._v("有效期：")]), _vm._v(_vm._s(memCouponMsgList.effectiveTime) + "-" + _vm._s(memCouponMsgList.expireTime))]), _vm._v(" "), _c('div', {
      staticClass: "account-operate"
    }, [_c('p', {
      staticClass: "scan-detail gray",
      on: {
        "click": function($event) {
          return _vm.scandetail(ceffectiveIndex)
        }
      }
    }, [_vm._v("详细")]), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [_c('mu-raised-button', {
      staticClass: "account-btn account-btn-gray",
      attrs: {
        "label": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.deleteitem(memCouponMsgList.couponInstId)
        }
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      staticClass: "account-btn account-btn-primary",
      attrs: {
        "label": "去使用"
      },
      on: {
        "click": function($event) {
          return _vm.gouse(memCouponMsgList.storeId, memCouponMsgList.useType)
        }
      }
    })], 1)])]), _vm._v(" "), (_vm.check(ceffectiveIndex)) ? _c('div', {
      staticClass: "detail-box"
    }, [_c('p', {
      staticClass: "gray"
    }, [_c('label', [_vm._v("券名称：")]), _vm._v(_vm._s(memCouponMsgList.couponName))]), _vm._v(" "), _c('p', {
      staticClass: "gray"
    }, [_c('label', [_vm._v("券编号：")]), _vm._v(_vm._s(memCouponMsgList.couponInstId))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.total == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多优惠券啦~")]) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.toast1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "删除成功!"
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.delCoupon,
      "title": "删除优惠券",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.delCoupon = false
      }
    }
  }, [_vm._v("\n    您确定要删除这张优惠券么?\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.delCoupon = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.getDelMemCoupon(_vm.temp)
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap flex-column"
  }, [_vm._l((_vm.notCommentGoodsListMsg), function(notCommentMsg, index) {
    return (this.commId == null) ? _c('div', {
      staticClass: "flex-item"
    }, [_c('div', {
      staticClass: "orders-list detail"
    }, [_c('div', {
      staticClass: "orders-list-item",
      staticStyle: {
        "margin": "0rem"
      }
    }, [_c('mu-list', {
      staticStyle: {
        "border-bottom": "0"
      }
    }, _vm._l((_vm.notCommentGoodsListMsg), function(shopList, commentIndex) {
      return _c('myOrdersItem', {
        key: commentIndex,
        attrs: {
          "cartitem": shopList,
          "isRightTriggle": 'true'
        }
      }, [_vm._v("111\n            ")])
    }), 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "star-content"
    }, _vm._l((notCommentMsg.commentStars), function(starShow, starIndex) {
      return _c('div', {
        staticClass: "star-box"
      }, [_c('p', {
        staticClass: "text"
      }, [_vm._v(_vm._s(starShow.starTypeName))]), _vm._v(" "), _vm._l((5), function(starAdd) {
        return _c('div', {
          staticClass: "star",
          class: {
            'red': starAdd <= starShow.starScore
          },
          on: {
            "click": function($event) {
              return _vm.starAddBtn(starAdd, index, starIndex)
            }
          }
        })
      })], 2)
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "tag-content"
    }, [_c('p', {
      staticClass: "text-title"
    }, [_vm._v("买家印象")]), _vm._v(" "), _c('div', {
      staticClass: "tag-box"
    }, _vm._l((notCommentMsg.commentTags), function(tag, tagIndex) {
      return _c('mu-chip', {
        key: tagIndex,
        staticClass: "demo-chip",
        class: {
          'primary': 1 == tag.selected
        },
        on: {
          "click": function($event) {
            return _vm.selectTag(tagIndex, index)
          }
        }
      }, [_vm._v(_vm._s(tag.tagName))])
    }), 1)]), _vm._v(" "), _c('div', {
      staticClass: "text-content"
    }, [_c('p', {
      staticClass: "text-title"
    }, [_vm._v("评价")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (notCommentMsg.commDesc),
        expression: "notCommentMsg.commDesc"
      }],
      attrs: {
        "maxlength": "200",
        "placeholder": "商品是否给力？快分享您的购物心得吧~"
      },
      domProps: {
        "value": (notCommentMsg.commDesc)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(notCommentMsg, "commDesc", $event.target.value)
        }, function($event) {
          return _vm.notcommentInput(index)
        }]
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-count"
    }, [_vm._v(_vm._s(_vm.remnant) + "/200字")])])])]) : _vm._e()
  }), _vm._v(" "), (this.commId != null) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "orders-list detail"
  }, [_c('div', {
    staticClass: "orders-list-item",
    staticStyle: {
      "margin": "0rem"
    }
  }, [_c('mu-list', {
    staticStyle: {
      "border-bottom": "0"
    }
  }, [_c('myOrdersItem', {
    key: _vm.getGoodsCommentEditShow.commId,
    attrs: {
      "cartitem": _vm.getGoodsCommentEditShow,
      "isRightTriggle": 'true'
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "star-content"
  }, _vm._l((_vm.getGoodsCommentEditShow.commentStars), function(starShow, starEditIndex) {
    return _c('div', {
      staticClass: "star-box"
    }, [_c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(starShow.starTypeName))]), _vm._v(" "), _vm._l((5), function(starEdit) {
      return _c('div', {
        staticClass: "star",
        class: {
          'red': starEdit <= starShow.starScore
        },
        on: {
          "click": function($event) {
            return _vm.starEditBtn(starEdit, starEditIndex)
          }
        }
      })
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tag-content"
  }, [_c('p', {
    staticClass: "text-title"
  }, [_vm._v("买家印象")]), _vm._v(" "), _c('div', {
    staticClass: "tag-box"
  }, _vm._l((_vm.getGoodsCommentEditShow.commentTags), function(tag, tagEditIndex) {
    return _c('mu-chip', {
      key: tagEditIndex,
      staticClass: "demo-chip",
      class: {
        'primary': 1 == tag.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectEditTag(tagEditIndex)
        }
      }
    }, [_vm._v(_vm._s(tag.tagName))])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('p', {
    staticClass: "text-title"
  }, [_vm._v("评价")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getGoodsCommentEditShow.commDesc),
      expression: "getGoodsCommentEditShow.commDesc"
    }],
    attrs: {
      "maxlength": "200",
      "placeholder": "商品是否给力？快分享您的购物心得吧~"
    },
    domProps: {
      "value": (_vm.getGoodsCommentEditShow.commDesc)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getGoodsCommentEditShow, "commDesc", $event.target.value)
      }, _vm.commentInput]
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-count"
  }, [_vm._v(_vm._s(_vm.remnant) + "/200字")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "保存",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.goEvaluation
    }
  })], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.evaluation,
      "bodyClass": "dialogBody successBody",
      "actionsContainerClass": "dialogActionsContainer fullContainer"
    },
    on: {
      "close": _vm.closeEvaluation
    }
  }, [_c('p', {
    staticClass: "success-text"
  }, [_c('img', {
    staticClass: "user-hear",
    attrs: {
      "src": "/static/images/personal/operation_success_3x.png"
    }
  }), _vm._v("评价提交成功！")]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.closeEvaluation
    },
    slot: "actions"
  })], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap sunhome-wrap personal-wrap flex-column"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadShow) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', [_c('div', {
    staticClass: "orders-list detail"
  }, [_c('div', {
    staticClass: "orders-list-item"
  }, [_c('div', {
    staticClass: "grid-tip"
  }, [_c('p', {
    staticClass: "wid60 fl ellipsis"
  }, [_vm._v("订单号:"), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.orderId))])])]), _vm._v(" "), _c('div', {
    staticClass: "goods-content"
  }, [_c('div', {
    staticClass: "banner-recommend"
  }, [_c('swiper', {
    ref: "mySwiper2",
    attrs: {
      "options": _vm.comSwiperOption
    }
  }, _vm._l((_vm.memOrderDetailMsg), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.viewGoodsDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('imgs', {
      attrs: {
        "width": 250,
        "height": 250,
        "imagePath": item.imagePath && item.imagePath.imagePath
      }
    })], 1)])])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commDesc),
      expression: "commDesc"
    }],
    attrs: {
      "maxlength": "200",
      "placeholder": "输入分享内容…"
    },
    domProps: {
      "value": (_vm.commDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-content"
  }, [_vm._l((_vm.file), function(item) {
    return _c('div', {
      staticClass: "img-item"
    }, [_c('div', {
      staticClass: "filter"
    }), _vm._v(" "), _c('div', {
      staticClass: "verticalM"
    }, [_c('img', {
      staticClass: "verticalM-box",
      attrs: {
        "src": item.fileName
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deletefile(item.fileId)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "img-item add"
  }, [_c('input', {
    ref: "albumImg",
    staticClass: "file-button",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "value": ""
    },
    on: {
      "change": function($event) {
        return _vm.selimg()
      }
    }
  })])], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "提交",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  })], 1)]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "input-box flex-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "serarch-input flex-item",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索线上订单",
      "autofocus": true
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "change": function($event) {
        return _vm.searchOrder()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-btn blue",
    on: {
      "click": function($event) {
        return _vm.jumpSearchBelowOrders()
      }
    }
  }, [_vm._v("线下订单")])]), _vm._v(" "), _c('div', {
    staticClass: "mytabs"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 1
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(1)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.allMemOrderCount),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.allMemOrderCount == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("全部")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 2
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(2)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.waitPayNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.waitPayNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("待支付")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 3
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(3)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.payedNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.payedNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("支付完成")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 4
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(4)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.productNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.productNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("生产中")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 5
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(5)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.shippedNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.shippedNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("已发货")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 6
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(6)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.installedNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.installedNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("安装完成")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 7
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(7)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.commentedNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.commentedNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("已评价")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 8
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(8)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.canceledNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.canceledNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("已取消")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      active: _vm.activeTab == 'tab' + 9
    },
    on: {
      "click": function($event) {
        return _vm.stateClick(9)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.countNumber.backedNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [
        _vm.countNumber.backedNum == 0 || _vm.loadorderCount ?
        'none-badge' :
        'custom-badge' ]
    }
  }, [_c('p', [_vm._v("已退单")])])], 1)]), _vm._v(" "), (_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageMemOrderList.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_orders_3x.png",
      "emptytext": "您还没有相关订单",
      "btntext": "去逛一逛",
      "btnurl": "/main/home"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageMemOrderList.length != 0 && !_vm.loadShow),
      expression: "pageMemOrderList.length != 0 && !loadShow"
    }],
    staticClass: "orders-list flex-item tab1"
  }, [_vm._l((_vm.pageMemOrderList), function(orderDetail) {
    return _c('div', {
      staticClass: "orders-list-item"
    }, [_c('div', {
      staticClass: "orders-list-item-title",
      on: {
        "click": function($event) {
          return _vm.gotoOrderDetail(
            orderDetail.stOrderId,
            orderDetail.orderState,
            orderDetail.commonFinished
          )
        }
      }
    }, [_vm._v("\n        订单号：" + _vm._s(orderDetail.stOrderId) + "\n        "), _c('p', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(orderDetail.storeName))]), _vm._v(" "), _c('img', {
      staticClass: "fr",
      attrs: {
        "src": "/static/images/mexin_logo_3x.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "orders-list-item-state"
    }, [_c('div', {
      staticClass: "state",
      on: {
        "click": function($event) {
          return _vm.gotoOrderDetail(
            orderDetail.stOrderId,
            orderDetail.orderState,
            orderDetail.commonFinished
          )
        }
      }
    }, [_vm._v("\n          状态："), _c('span', {
      staticClass: "blue"
    }, [_vm._v(_vm._s(orderDetail.orderStateName))]), _vm._v(" "), _c('br'), _vm._v("\n          总价：\n          "), _c('span', {
      staticClass: "primary"
    }, [_vm._v("￥" + _vm._s(orderDetail.finalPrice))])]), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [(orderDetail.orderState == 0) ? _c('mu-raised-button', {
      staticClass: "orders-button",
      attrs: {
        "label": "立即支付",
        "primary": ""
      },
      on: {
        "click": function($event) {
          return _vm.gotoOrderDetail(
            orderDetail.stOrderId,
            orderDetail.orderState,
            orderDetail.commonFinished
          )
        }
      }
    }) : _vm._e(), _vm._v(" "), (orderDetail.orderState == 0) ? _c('mu-raised-button', {
      staticClass: "orders-button mu-raised-button-grad",
      attrs: {
        "label": "取消订单"
      },
      on: {
        "click": function($event) {
          return _vm.cancelOrder(orderDetail.orderState, orderDetail.stOrderId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (
      orderDetail.orderState == 1 ||
      orderDetail.orderState == 3 ||
      orderDetail.orderState == 4 ||
      orderDetail.orderState == 12 ||
      orderDetail.orderState == 13
    ) ? _c('mu-raised-button', {
      staticClass: "orders-button mu-raised-button-grad",
      attrs: {
        "label": "申请退单"
      },
      on: {
        "click": function($event) {
          return _vm.cancelOrder(orderDetail.orderState, orderDetail.stOrderId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (orderDetail.orderState == 9) ? _c('mu-raised-button', {
      staticClass: "orders-button",
      attrs: {
        "label": "晒家分享"
      },
      on: {
        "click": function($event) {
          return _vm.shareJump(orderDetail.stOrderId, orderDetail.orderId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (
      orderDetail.orderState == 9 &&
      orderDetail.commonFinished == false
    ) ? _c('mu-raised-button', {
      staticClass: "orders-button",
      attrs: {
        "label": "去评价",
        "primary": ""
      },
      on: {
        "click": function($event) {
          return _vm.evaluateJump(orderDetail.stOrderId, orderDetail.orderId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (orderDetail.orderState == 2 || orderDetail.orderState == 10) ? _c('mu-raised-button', {
      staticClass: "orders-button mu-raised-button-grad",
      attrs: {
        "label": "立即购买"
      },
      on: {
        "click": function($event) {
          return _vm.buyNow(orderDetail.stOrderId, orderDetail.orderId)
        }
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('mu-list', {
      on: {
        "click": function($event) {
          return _vm.gotoOrderDetail(
            orderDetail.stOrderId,
            orderDetail.orderState,
            orderDetail.commonFinished
          )
        }
      }
    }, [(
      orderDetail &&
      orderDetail.goodsOrderMsgs &&
      orderDetail.goodsOrderMsgs.length > 0
    ) ? _c('div', _vm._l((orderDetail.goodsOrderMsgs), function(listShop, shopIndex) {
      return _c('myOrdersItem', {
        key: shopIndex,
        attrs: {
          "width": 150,
          "height": 150,
          "cartitem": listShop
        }
      })
    }), 1) : _vm._e()])], 1)
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), (
    (_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.total == 0 && !_vm.loadShow)
  ) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("\n      没有更多订单啦~\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.quitOrder,
      "title": "取消订单",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": _vm.closeQuitOrder
    }
  }, [_vm._v("\n    您确定要取消这个订单么?\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": _vm.closeQuitOrder
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.doQuitOrder(1)
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.chargeBack,
      "title": "申请退单",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": _vm.closeChargeBack
    }
  }, [_vm._v("\n    您确定要申请退单么?\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": _vm.closeChargeBack
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.doChargeBack()
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.contactService,
      "title": "申请退单请联系客服",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer fullContainer"
    },
    on: {
      "close": function($event) {
        _vm.contactService = false
      }
    }
  }, [_vm._v("\n    400-832-2777\n    "), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": function($event) {
        return _vm.phoneCall('400-832-2777')
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap firmorder-wrap flex-column"
  }, [_c('mu-infinite-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay.loading),
      expression: "pay.loading"
    }],
    staticClass: "load maskloading",
    attrs: {
      "loading": _vm.pay.loading,
      "loadingText": _vm.pay.message
    }
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    staticClass: "flex-item firmorderWrapper"
  }, [_c('div', {
    staticClass: "firmorder-content"
  }, [(_vm.addressInfo.length > 0) ? _c('div', {
    staticClass: "order-box addr"
  }, [_c('div', {
    staticClass: "border-img top"
  }), _vm._v(" "), _c('div', {
    staticClass: "addr-info",
    on: {
      "click": _vm.openaddr
    }
  }, [_c('p', {
    staticClass: "addr-title"
  }, [_vm._v("收货人信息")]), _vm._v(" "), _c('p', [_vm._v("\n            收货人：" + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].consignee) + "\n            "), _c('label', {
    staticClass: "fr"
  }, [_vm._v(_vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].mobile))])]), _vm._v(" "), _c('p', [_vm._v("\n            收货地址：" + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].province) + "\n            " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].city) + "\n            " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].area) + "\n            " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].address) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "border-img bottom"
  })]) : _c('div', {
    staticClass: "order-box addr"
  }, [_c('div', {
    staticClass: "border-img top"
  }), _vm._v(" "), _c('div', {
    staticClass: "none-addr-info"
  }, [_c('p', [_vm._v("您还没有收货地址，赶快添加吧！")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "+ 新建地址"
    },
    on: {
      "click": _vm.addaddr
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "border-img bottom"
  })]), _vm._v(" "), _vm._l((_vm.OrderSettleMsg.storeOrderSettleMsgs), function(storeItem, storeIndex) {
    return [_c('div', {
      staticClass: "order-box"
    }, [_c('div', {
      staticClass: "brandTitle"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.gotoBrandHome(storeItem.settleGoodsMsg.storeId)
        }
      }
    }, [_c('imgs', {
      staticClass: "logo floatL",
      attrs: {
        "width": 120,
        "imagePath": storeItem &&
          storeItem.settleGoodsMsg &&
          storeItem.settleGoodsMsg.storeLogoPath &&
          storeItem.settleGoodsMsg.storeLogoPath.imagePath
      }
    }), _vm._v(" "), _c('p', [_c('label', [_vm._v("品牌：" + _vm._s(storeItem.settleGoodsMsg.storeName))])]), _vm._v(" "), _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    })], 1), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.settleDatas[storeIndex].dealerCode),
        expression: "settleDatas[storeIndex].dealerCode"
      }],
      attrs: {
        "placeholder": "经销商编码"
      },
      domProps: {
        "value": (_vm.settleDatas[storeIndex].dealerCode)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.settleDatas[storeIndex], "dealerCode", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('mu-list', _vm._l((storeItem.settleGoodsMsg
      .cartGoodses), function(goodItem, goodIndex) {
      return _c('myOrdersItem', {
        key: goodIndex,
        attrs: {
          "cartitem": goodItem
        }
      })
    }), 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "order-box"
    }, [(storeItem.couponMsgs.length > 0) ? _c('p', {
      staticClass: "order-box-item",
      on: {
        "click": function($event) {
          _vm.couponPopup = true;
          _vm.currentCoupon = storeIndex;
        }
      }
    }, [_vm._v("\n            优惠券：\n            "), _c('label', {
      staticClass: "fr black"
    }, [(_vm.settleDatas[storeIndex].couponInstId == 0) ? [_vm._v("不使用优惠券")] : _vm._e(), _vm._v(" "), (
      _vm.settleDatas[storeIndex].couponInstId != 0 &&
      _vm.couponAmounts[storeIndex].couponCate == 3
    ) ? [_vm._v(_vm._s(_vm._f("discount")(_vm.couponAmounts[storeIndex].couponDiscount)) + "折优惠券")] : _vm._e(), _vm._v(" "), (
      _vm.settleDatas[storeIndex].couponInstId != 0 &&
      _vm.couponAmounts[storeIndex].couponCate != 3
    ) ? [_vm._v(_vm._s(_vm.couponAmounts[storeIndex]) + "元优惠券")] : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    })], 2)]) : _c('p', {
      staticClass: "order-box-item"
    }, [_vm._v("\n            优惠券：\n            "), _c('label', {
      staticClass: "fr not-available"
    }, [_vm._v("无可用")])]), _vm._v(" "), (storeItem.redpacketMsgs.length > 0) ? _c('p', {
      staticClass: "order-box-item",
      on: {
        "click": function($event) {
          _vm.redpackagePopup = true;
          _vm.currentCoupon = storeIndex;
        }
      }
    }, [_vm._v("\n            红包：\n            "), _c('label', {
      staticClass: "fr black"
    }, [(_vm.settleDatas[storeIndex].redpacketInstId == 0) ? [_vm._v("不使用红包")] : _vm._e(), _vm._v(" "), (_vm.settleDatas[storeIndex].redpacketInstId != 0) ? [_vm._v(_vm._s(_vm.redpacketAmounts[storeIndex]) + "元红包")] : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    })], 2)]) : _c('p', {
      staticClass: "order-box-item"
    }, [_vm._v("\n            红包："), _c('label', {
      staticClass: "fr not-available"
    }, [_vm._v("无可用")])])]), _vm._v(" "), _c('div', {
      staticClass: "order-box"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.settleDatas[storeIndex].remark),
        expression: "settleDatas[storeIndex].remark"
      }],
      staticClass: "order-box-item",
      attrs: {
        "placeholder": "选填：给商家留言 （50字以内）"
      },
      domProps: {
        "value": (_vm.settleDatas[storeIndex].remark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.settleDatas[storeIndex], "remark", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "order-box mgb"
    }, [_c('p', {
      staticClass: "order-box-item"
    }, [_vm._v("\n             \n            "), _c('label', {
      staticClass: "fr"
    }, [_vm._v("合计："), _c('span', {
      staticClass: "primary"
    }, [_vm._v("￥" + _vm._s(storeItem.finalPrice))])])])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "order-box mgb"
  }, [_c('p', {
    staticClass: "order-box-item",
    on: {
      "click": _vm.openinvoice
    }
  }, [_vm._v("\n          发票信息：\n          "), _c('label', {
    staticClass: "fr black"
  }, [_vm._v(_vm._s(_vm.invoinceInfo)), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "order-box mgb"
  }, [_c('p', {
    staticClass: "order-box-item"
  }, [_vm._v("\n          商品金额：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("￥" + _vm._s(_vm.OrderSettleMsg.totalGoodsPrice))])]), _vm._v(" "), _c('p', {
    staticClass: "order-box-item"
  }, [_vm._v("\n          运费：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("+￥" + _vm._s(_vm.OrderSettleMsg.postPrice))])]), _vm._v(" "), _c('p', {
    staticClass: "order-box-item"
  }, [_vm._v("\n          优惠券：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("-￥" + _vm._s(_vm.OrderSettleMsg.discountPrice))])]), _vm._v(" "), _c('p', {
    staticClass: "order-box-item textright"
  }, [_vm._v("\n          实付款：\n          "), _c('label', {
    staticClass: "fr primary"
  }, [_vm._v("￥" + _vm._s(_vm.OrderSettleMsg.finalPrice))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "fullbtn-box"
  }, [_c('mu-raised-button', {
    staticClass: "full",
    attrs: {
      "label": "创建订单",
      "fullWidth": ""
    },
    on: {
      "click": _vm.onCreatOrder
    }
  })], 1)]), _vm._v(" "), (_vm.scrolled > 200 && _vm.addressInfo.length > 0 && !_vm.load) ? _c('p', {
    staticClass: "delivery-addr"
  }, [_vm._v("\n    配送至：" + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].province) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].city) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].area) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].address) + "\n    （\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].consignee) + "\n    " + _vm._s(_vm.addressInfo &&
    _vm.addressInfo[_vm.selectAddressIndex] &&
    _vm.addressInfo[_vm.selectAddressIndex].mobile) + "\n    收）\n  ")]) : _vm._e(), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "coupon-popup-bottom flex-column",
      "open": _vm.couponPopup
    },
    on: {
      "close": function($event) {
        _vm.couponPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  }), _vm._v(" "), (_vm.currentCoupon >= 0) ? _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-list-item title"
  }, [_vm._v("\n              选择优惠券\n            ")]), _vm._v(" "), _vm._l((_vm.OrderSettleMsg
    .storeOrderSettleMsgs[_vm.currentCoupon].couponMsgs), function(couponItem, couponIndex) {
    return _c('div', {
      staticClass: "coupon-list-item",
      on: {
        "click": function($event) {
          return _vm.selCoupon('1', couponItem.couponInstId)
        }
      }
    }, [(couponItem.couponInstId == 0) ? [_vm._v("\n                " + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), (couponItem.couponInstId != 0) ? [(couponItem.couponCate != 3) ? [_vm._v("省" + _vm._s(couponItem.couponAmount) + "元")] : _vm._e(), _vm._v(" "), (couponItem.couponCate == 3) ? [_vm._v(_vm._s(_vm._f("discount")(couponItem.couponDiscount))), _c('samp', [_vm._v("折")])] : _vm._e(), _vm._v("\n                ：满" + _vm._s(couponItem.useableAmount) + "可用，" + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), _c('mu-radio', {
      staticClass: "list-radio fr",
      attrs: {
        "name": "group",
        "nativeValue": '' + couponItem.couponInstId
      },
      on: {
        "change": function($event) {
          return _vm.selCoupon('1', couponItem.couponInstId)
        }
      },
      model: {
        value: (_vm.settleDatas[_vm.currentCoupon].couponInstId),
        callback: function($$v) {
          _vm.$set(_vm.settleDatas[_vm.currentCoupon], "couponInstId", $$v)
        },
        expression: "settleDatas[currentCoupon].couponInstId"
      }
    })], 2)
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "coupon-popup-bottom flex-column",
      "open": _vm.redpackagePopup
    },
    on: {
      "close": function($event) {
        _vm.redpackagePopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.redpackagePopup = false
      }
    }
  }), _vm._v(" "), (_vm.currentCoupon >= 0) ? _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-list-item title"
  }, [_vm._v("\n              选择红包\n            ")]), _vm._v(" "), _vm._l((_vm.OrderSettleMsg
    .storeOrderSettleMsgs[_vm.currentCoupon].redpacketMsgs), function(couponItem, couponIndex) {
    return _c('div', {
      staticClass: "coupon-list-item",
      on: {
        "click": function($event) {
          return _vm.selCoupon('2', couponItem.couponInstId)
        }
      }
    }, [(couponItem.couponInstId == 0) ? [_vm._v("\n                " + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), (couponItem.couponInstId != 0) ? [_vm._v("\n                省" + _vm._s(couponItem.couponAmount) + "元：满" + _vm._s(couponItem.useableAmount) + "可用，" + _vm._s(couponItem.couponName) + "\n              ")] : _vm._e(), _vm._v(" "), _c('mu-radio', {
      staticClass: "list-radio fr",
      attrs: {
        "name": "group",
        "nativeValue": '' + couponItem.couponInstId
      },
      on: {
        "change": function($event) {
          return _vm.selCoupon('2', couponItem.couponInstId)
        }
      },
      model: {
        value: (_vm.settleDatas[_vm.currentCoupon].redpacketInstId),
        callback: function($$v) {
          _vm.$set(_vm.settleDatas[_vm.currentCoupon], "redpacketInstId", $$v)
        },
        expression: "settleDatas[currentCoupon].redpacketInstId"
      }
    })], 2)
  })], 2)]) : _vm._e()])])]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isShowFirmBox,
      "title": "请确认微信支付是否已完成",
      "titleClass": "payTitle dialogTitle",
      "bodyClass": "dialogBody payBody",
      "actionsContainerClass": "payActionsContainer"
    }
  }, [_c('div', {
    on: {
      "click": _vm.finishPay
    }
  }, [_vm._v("已完成支付")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    on: {
      "click": function($event) {
        return _vm.callH5WxPay(_vm.createOrderData.orderId)
      }
    },
    slot: "actions"
  }, [_vm._v("\n      支付遇到问题，重新支付\n    ")])]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap sunhomedetail-wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "flex-item"
  }, [(_vm.ShareInfoContent.shareImages.length > 0) ? _c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper1",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.ShareInfoContent.shareImages), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('v-image', {
      attrs: {
        "width": 720,
        "imagePath": item.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "evaluate-detail"
  }, [_c('div', {
    staticClass: "evaluate-item"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('span', {
    staticClass: "head"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/head_default_3x.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.ShareInfoContent.shareBy))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v(_vm._s(_vm.ShareInfoContent.shareTime))])]), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
    staticClass: "evaluate-content"
  }, [_vm._v(_vm._s(_vm.ShareInfoContent.shareContent))])])]), _vm._v(" "), (_vm.ShareInfoContent.shareGoods != null && _vm.ShareInfoContent.shareGoods.length > 0) ? _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("商品信息")]), _vm._v(" "), _vm._l((_vm.ShareInfoContent.shareGoods), function(item) {
    return _c('div', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.viewGoodsDetail(item)
        }
      }
    }, [_c('span', [_c('label', {
      staticClass: "goodsTitle ellipsis"
    }, [_vm._v(_vm._s(item.goodsName))]), _c('label', {
      staticClass: "red"
    }, [_vm._v("￥" + _vm._s(item.goodsPrice))]), _c('label', {
      staticClass: "scandetail"
    }, [_vm._v("查看详情")])])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": _vm.loadingTip
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listMemDetailInfo.openId != null && !_vm.loadShow) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "grid-tip"
  }, [_vm._v("\n      基本信息\n    ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "user-order-title headimg",
    on: {
      "click": function($event) {
        return _vm.open('headimg')
      }
    }
  }, [_c('p', [_vm._v("头像\n          "), _c('span', {
    staticClass: "right"
  }, [_c('imgs', {
    staticClass: "user-hear",
    attrs: {
      "imagePath": _vm.listMemDetailInfo.avatarImage && _vm.listMemDetailInfo.avatarImage.imagePath
    }
  })], 1)]), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title",
    on: {
      "click": function($event) {
        return _vm.editNickname(_vm.listMemDetailInfo.nickName)
      }
    }
  }, [_c('p', [_vm._v("昵称"), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.listMemDetailInfo.nickName))])]), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title",
    on: {
      "click": function($event) {
        return _vm.open('sex')
      }
    }
  }, [(_vm.listMemDetailInfo.sex == 1) ? _c('p', [_vm._v("性别"), _c('span', {
    staticClass: "right"
  }, [_vm._v("男")])]) : _vm._e(), _vm._v(" "), (_vm.listMemDetailInfo.sex == 2) ? _c('p', [_vm._v("性别"), _c('span', {
    staticClass: "right"
  }, [_vm._v("女")])]) : _vm._e(), _vm._v(" "), (_vm.listMemDetailInfo.sex == 0) ? _c('p', [_vm._v("性别"), _c('span', {
    staticClass: "right"
  }, [_vm._v("保密")])]) : _vm._e(), _vm._v(" "), (_vm.listMemDetailInfo.sex == null) ? _c('p', [_vm._v("性别")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_vm._v("生日"), _c('span', {
    staticClass: "right"
  }, [_c('mu-date-picker', {
    staticClass: "boxDate",
    attrs: {
      "hintText": "选择生日",
      "maxDate": _vm.nowTime
    },
    on: {
      "change": _vm.birthDayChange
    },
    model: {
      value: (_vm.valBirthDay),
      callback: function($$v) {
        _vm.valBirthDay = $$v
      },
      expression: "valBirthDay"
    }
  })], 1)]), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })])]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "uploadFrame",
      "id": "uploadFrame"
    }
  }), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "demo-popup-bottom select",
      "open": _vm.headimgPopup
    },
    on: {
      "close": function($event) {
        return _vm.close('headimg')
      }
    }
  }, [_c('mu-content-block', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "popupitem"
  }, [_c('label', {
    attrs: {
      "for": "cameraImg"
    }
  }, [_vm._v("相机")]), _vm._v(" "), _c('input', {
    ref: "cameraImg",
    staticClass: "file-upload-button",
    attrs: {
      "id": "cameraImg",
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": function($event) {
        return _vm.selimg(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popupitem"
  }, [_c('label', {
    attrs: {
      "for": "albumImg"
    }
  }, [_vm._v("从相册选择")]), _vm._v(" "), _c('input', {
    ref: "albumImg",
    staticClass: "file-upload-button",
    attrs: {
      "id": "albumImg",
      "type": "file",
      "accept": "image/*",
      "value": ""
    },
    on: {
      "change": function($event) {
        return _vm.selimg(2)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popupitem",
    on: {
      "click": function($event) {
        return _vm.close('headimg')
      }
    }
  }, [_vm._v("取消")])])], 1), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "demo-popup-bottom select",
      "open": _vm.sexPopup
    },
    on: {
      "close": function($event) {
        return _vm.close('sex')
      }
    }
  }, [_c('mu-content-block', {
    staticClass: "wrap"
  }, [_vm._l((_vm.sex), function(item, index) {
    return _c('div', {
      staticClass: "popupitem",
      on: {
        "click": function($event) {
          return _vm.selsex(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('div', {
    staticClass: "popupitem",
    on: {
      "click": function($event) {
        return _vm.close('sex')
      }
    }
  }, [_vm._v("取消")])], 2)], 1), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "demo-popup-bottom select",
      "open": _vm.brithPopup
    },
    on: {
      "close": function($event) {
        return _vm.close('brith')
      }
    }
  }, [_c('mu-content-block', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "popupitem",
    on: {
      "click": function($event) {
        return _vm.close('brith')
      }
    }
  }, [_vm._v("取消")])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.successMsg) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "修改成功!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap addr-wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "seladdress-list"
  }, [_c('div', {
    staticClass: "address-item"
  }, [_c('table', _vm._l((_vm.addressInfo), function(address, index) {
    return _c('tr', [_c('td', [_c('mu-radio', {
      staticClass: "list-radio floatL",
      class: [address.addressId == _vm.selectAddressId ? 'primary' : ''],
      attrs: {
        "name": "group",
        "nativeValue": address.addressId
      },
      on: {
        "change": function($event) {
          return _vm.selectAddr(address.addressId)
        }
      },
      model: {
        value: (_vm.selectAddressId),
        callback: function($$v) {
          _vm.selectAddressId = $$v
        },
        expression: "selectAddressId"
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "user-box",
      on: {
        "click": function($event) {
          return _vm.selectAddr(address.addressId)
        }
      }
    }, [_c('p', {
      staticClass: "address"
    }, [(address.isDefault == '1') ? _c('label', {
      staticClass: "orange"
    }, [_vm._v("[默认地址]")]) : _vm._e(), _vm._v(_vm._s(address.province) + "  " + _vm._s(address.city) + "  " + _vm._s(address.area) + "  " + _vm._s(address.address))]), _vm._v(" "), _c('p', {
      staticClass: "user"
    }, [_c('label', [_vm._v(_vm._s(address.consignee))]), _c('label', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(address.mobile))])])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "operate",
      on: {
        "click": function($event) {
          return _vm.editAddress(address.addressId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/icon_edit.png"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "addaddr",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("\n\t\t\t新增收货地址\n\t\t\t"), _c('img', {
    staticClass: "fr",
    attrs: {
      "src": "/static/images/ic_add_address_3x.png"
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-this.currentAddress"
  }, [_c('ul', {
    staticClass: "edit editaddress"
  }, [_c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("收货人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.consignee),
      expression: "currentAddress.consignee"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "type": "text",
      "placeholder": "姓名",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.currentAddress.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("联系电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.mobile),
      expression: "currentAddress.mobile"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "手机号码",
      "type": "number",
      "minlength": "11",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.currentAddress.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title",
    on: {
      "click": function($event) {
        _vm.bottomPopup = true
      }
    }
  }, [_c('p', [_c('label', [_vm._v("所在地区")]), _vm._v(" "), _c('input', {
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "请选择省市区县",
      "readonly": "",
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.addressMsgShow
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("详细地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.address),
      expression: "currentAddress.address"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "详细地址需填写楼栋楼层或房间号信息"
    },
    domProps: {
      "value": (_vm.currentAddress.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("邮政编码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddress.postCode),
      expression: "currentAddress.postCode"
    }],
    staticClass: "right ellipsis",
    attrs: {
      "placeholder": "选填，若您不清楚邮递区号，请填000000",
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.currentAddress.postCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddress, "postCode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "demo-popup-bottom popup-bottom physical-popup",
      "open": _vm.bottomPopup
    },
    on: {
      "close": function($event) {
        _vm.bottomPopup = false
      }
    }
  }, [_c('h3', [_vm._v("所在地区"), _c('span', {
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  })]), _vm._v(" "), _c('mu-content-block', [(_vm.chooseBox) ? _c('div', {
    staticClass: "chooseList forbid-sel-text",
    class: {
      'chooseTwo': _vm.shoWOr == 2,
      'chooseOne': _vm.shoWOr == 1
    }
  }, [_c('div', {
    staticClass: "pShow"
  }, [(_vm.shoWOr <= 1) ? _c('samp', {
    staticClass: "sampOne",
    on: {
      "click": function($event) {
        return _vm.clickProvince(1)
      }
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 2) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.addressProvince))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 3) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityNameShow))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('samp', {
    staticClass: "sampTwo"
  }, [_vm._v("请选择")]) : _vm._e()]), _vm._v(" "), (_vm.shoWOr == 1) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.arealistMsg), function(provinceShow) {
    return _c('span', {
      on: {
        "click": function($event) {
          return _vm.shooseProvince(provinceShow.areaId, provinceShow.areaName)
        }
      }
    }, [_vm._v(_vm._s(provinceShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.cityListShow), function(cityShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseCityId == cityShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseCity(cityShow.areaId, cityShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(cityShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 3) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.areaAddressMsg), function(areaListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseAreaId == areaListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseArea(areaListShow.areaId, areaListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(areaListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 4) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.getStreetMsgList), function(streetListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseStreetId == streetListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseStreet(streetListShow.areaId, streetListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(streetListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确认",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  })], 1)])]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "editButton"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "保存",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1)]), _vm._v(" "), (_vm.errorShow == 1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "请核对您输入的信息!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toast2) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.messageShow
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap home-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    class: {
      fixed: _vm.scrolled > 0
    }
  }, [_c('input', {
    staticClass: "serarch-input",
    attrs: {
      "readonly": "",
      "type": "text",
      "name": "",
      "placeholder": "搜索商品"
    },
    on: {
      "click": _vm.searchGood
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "homeWrapper",
    staticClass: "flex-item homeWrapper"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper1",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.slides), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.linkType, item.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "width": 720,
        "imagePath": item.imagePath && item.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-brand"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.linkFn('fitting', '')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/icon_sgtd.jpg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("诚邀合伙人")])]), _vm._v(" "), _vm._l((_vm.brandCates), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "brand-item square",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.cates.linkType, item.cates.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": item.cates &&
          item.cates.imagePath &&
          item.cates.imagePath.imagePath,
        "width": 120,
        "height": 120,
        "imgStyle": {
          margin: '0 auto'
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cates.linkName))])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.linkFn('oa', '')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("办公门户")])]), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.$router.push('/main/diyPage')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("DIY")])]), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.$router.push('/main/install-study')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("安装指导")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "recommend"
  }, [_c('h2', [_vm._v("精品推荐")]), _vm._v(" "), _c('div', {
    staticClass: "banner-recommend"
  }, [_c('swiper', {
    ref: "mySwiper2",
    attrs: {
      "options": _vm.comSwiperOption
    }
  }, _vm._l((_vm.boutiques), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.viewGoodsDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('v-image', {
      attrs: {
        "width": 250,
        "height": 250,
        "imagePath": item.imagePath && item.imagePath.imagePath
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "title ellipsis"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('p', {
      staticClass: "money"
    }, [(item.goodsPrice > 0) ? _c('samp', [_vm._v("¥")]) : _vm._e(), _vm._v("\n                " + _vm._s(item.goodsPrice > 0 ? item.goodsPrice : item.goodDesc) + "\n                "), (item.unitPrice > 0) ? _c('span', [_vm._v("¥ " + _vm._s(item.unitPrice))]) : _vm._e()])])])
  }), 1)], 1)]), _vm._v(" "), _vm._l((_vm.floors), function(item, index) {
    return _c('div', {
      staticClass: "brand-product"
    }, [(item.itemType == 99) ? _c('a', {
      staticClass: "banner-product",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.floorInfo.linkType, item.floorInfo.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "width": 720,
        "imagePath": item.floorInfo &&
          item.floorInfo.imagePath &&
          item.floorInfo.imagePath.imagePath,
        "eventparam": item
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.floorInfo.goods && item.floorInfo.goods.length) ? _c('a', {
      staticClass: "header",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.floorInfo.linkType, item.floorInfo.storeId)
        }
      }
    }, [_c('span', {
      staticClass: "floatL brandName"
    }, [_vm._v("\n          " + _vm._s(item.floorName) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "floatR arrow"
    }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "product"
    }, _vm._l((item.floorInfo.goods), function(goods, index) {
      return _c('div', {
        staticClass: "product-item square"
      }, [_c('v-image', {
        attrs: {
          "width": 250,
          "height": 250,
          "titleText": goods.goodsName,
          "imagePath": goods.imagePath && goods.imagePath.imagePath,
          "moneyText": goods.goodsPrice > 0 ? goods.goodsPrice : goods.priceDesc || '',
          "orginalCost": goods.unitPrice,
          "eventparam": goods
        },
        on: {
          "eventclick": _vm.viewGoodsDetail
        }
      }, [_c('template', {
        slot: "money"
      }, [_vm._v("\n              " + _vm._s(goods.goodsPrice > 0 ? goods.goodsPrice : goods.priceDesc) + "\n            ")]), _vm._v(" "), _c('template', {
        slot: "orginalCost"
      }, [_vm._v(_vm._s(goods.unitPrice))])], 2)], 1)
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-product bottom"
  }, [(_vm.ShareGoods.length > 0) ? _c('a', {
    staticClass: "header",
    on: {
      "click": _vm.gotosunhomeList
    }
  }, [_c('span', {
    staticClass: "floatL brandName"
  }, [_vm._v("晒家分享")]), _vm._v(" "), _c('span', {
    staticClass: "floatR arrow"
  }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ShareGoods), function(item) {
    return _c('div', {
      staticClass: "floatL left-advertise"
    }, [_c('div', {
      staticClass: "img",
      on: {
        "click": function($event) {
          return _vm.gotoSunhomeDetail(item.shareId)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "titleText": item.shareContent,
        "imagePath": item && item.imagePath && item.imagePath.imagePath
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "userName ellipsis"
    }, [_vm._v("来自 " + _vm._s(item.shareBy) + " 的评价")]), _vm._v(" "), _c('p', {
      staticClass: "style-box"
    }, [_c('span', {
      staticClass: "style ellipsis"
    }, [_vm._l((item.tags), function(sub) {
      return [_vm._v("\n                " + _vm._s(sub.linkName) + " \n              ")]
    })], 2), _vm._v(" "), (item.totalPrice > 0) ? _c('span', {
      staticClass: "price ellipsis"
    }, [_vm._v("\n              " + _vm._s(item.totalPrice) + "元\n            ")]) : _vm._e()])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)], 2), _vm._v(" "), _c('menus')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "brand-item square",
    attrs: {
      "href": "tel:023-62797973"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/project-icon.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("工厂直供")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "square",
    staticStyle: {
      "width": "100%",
      "font-size": "0",
      "border-radius": "0.333333rem",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/oaLogo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "square",
    staticStyle: {
      "width": "100%",
      "font-size": "0",
      "border-radius": "0.333333rem",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/diyLogo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "square",
    staticStyle: {
      "width": "100%",
      "font-size": "0",
      "border-radius": "0.333333rem",
      "overflow": "hidden",
      "background-color": "yellow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/install-study.png"
    }
  })])
}]}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "wrap login-wrap flex-column"
  }, [_c('mu-appbar', {
    staticClass: "custom-appbar",
    attrs: {
      "title": "登录",
      "titleClass": "custom-appbar-title"
    }
  }, [_c('img', {
    attrs: {
      "slot": "left",
      "src": "/static/images/login_back_3x.png"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('form', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('label', [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "small-input",
    attrs: {
      "type": "text",
      "minlength": "11",
      "maxlength": "11",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "blur": _vm.checkMobile,
      "change": _vm.checkMobile,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('label', [_vm._v("图片验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.randomCode),
      expression: "randomCode"
    }],
    staticClass: "small-input",
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.randomCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.randomCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "img-code-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.randomCodePath
    },
    on: {
      "click": _vm.refreshImgCode
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('label', [_vm._v("短信验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authCode),
      expression: "authCode"
    }],
    staticClass: "small-input",
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.authCode)
    },
    on: {
      "blur": _vm.checkAuthCode,
      "change": _vm.checkAuthCode,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "getyz-btn",
    attrs: {
      "label": _vm.getauthCodeTip,
      "disabled": _vm.isGetauthCode
    },
    on: {
      "click": _vm.getValidateCode,
      "change": function($event) {}
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "el-input-error"
  }, [_vm._v(_vm._s(_vm.tip))]), _vm._v(" "), _c('div', {}, [(_vm.isFormValid()) ? _c('mu-raised-button', {
    attrs: {
      "label": "登录",
      "fullWidth": ""
    },
    on: {
      "click": _vm.login
    }
  }) : _c('mu-raised-button', {
    attrs: {
      "label": "登录",
      "fullWidth": "",
      "disabled": ""
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tripartite-box"
  }, [_c('span', {
    staticClass: "wxauth-title"
  }, [_vm._v("\n\t\t\t\t\t美心商城手机版\n\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isWxBrowser()) ? _c('img', {
    attrs: {
      "src": "/static/images/login_wechat_3x.png"
    },
    on: {
      "click": _vm.loginForWx
    }
  }) : _c('img', {
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "src": "/static/images/mexin_logo_3x.png"
    },
    on: {
      "click": _vm.tQHandler
    }
  }), _vm._v(" "), _c('p', [_vm._v("登录即代表您已同意美心隐私政策")])])]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [(!_vm.mainTarget || !_vm.mainType) ? _c('div', {
    staticClass: "flex-row content-box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("安装人")]), _vm._v(" "), _c('div', {
    staticClass: "input-box flex-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fitMan),
      expression: "fitMan"
    }],
    attrs: {
      "type": "",
      "maxlength": "11",
      "name": ""
    },
    domProps: {
      "value": (_vm.fitMan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fitMan = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.mainTarget || !_vm.mainType) ? _c('div', {
    staticClass: "flex-row content-box"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("安装电话")]), _vm._v(" "), _c('div', {
    staticClass: "input-box flex-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fitMobile),
      expression: "fitMobile"
    }],
    attrs: {
      "type": "",
      "maxlength": "11",
      "name": ""
    },
    domProps: {
      "value": (_vm.fitMobile)
    },
    on: {
      "keyup": function($event) {
        return _vm.changePhone($event, 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fitMobile = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.questionLists), function(item, index) {
    return _c('div', {
      staticClass: "question-item"
    }, [(item.queType == 3) ? _c('div', {
      staticClass: "flex-row content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box flex-item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answers && _vm.answers[index] && _vm.answers[index].optText),
        expression: "answers && answers[index] && answers[index].optText"
      }],
      attrs: {
        "type": "",
        "name": ""
      },
      domProps: {
        "value": (_vm.answers && _vm.answers[index] && _vm.answers[index].optText)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers && _vm.answers[index] && _vm.answers[index], "optText", $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (item.queType == 5) ? _c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answers && _vm.answers[index] && _vm.answers[index].optText),
        expression: "answers && answers[index] && answers[index].optText"
      }],
      domProps: {
        "value": (_vm.answers && _vm.answers[index] && _vm.answers[index].optText)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers && _vm.answers[index] && _vm.answers[index], "optText", $event.target.value)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (item.queType == 2) ? _c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box"
    }, _vm._l((item.options), function(option) {
      return _c('label', {
        key: option.optId,
        staticClass: "check-box"
      }, [_c('input', {
        staticClass: "optInput",
        attrs: {
          "type": "checkbox",
          "name": index
        },
        on: {
          "change": function($event) {
            return _vm.change($event, index, option.optId)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "optLabel"
      }, [_vm._v(_vm._s(option.optDesc))]), _vm._v(" "), (option.optImagePath) ? _c('img', {
        staticClass: "optImg",
        attrs: {
          "src": _vm.imgUrl + '/' + option.optImagePath
        }
      }) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (item.queType == 1) ? _c('div', {
      staticClass: "content-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "input-box"
    }, _vm._l((item.options), function(option) {
      return _c('label', {
        key: option.optId,
        staticClass: "check-box"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.answers && _vm.answers[index] && _vm.answers[index].optId),
          expression: "answers && answers[index] && answers[index].optId"
        }],
        staticClass: "optInput",
        attrs: {
          "type": "radio",
          "name": index
        },
        domProps: {
          "value": option.optId,
          "checked": _vm._q(_vm.answers && _vm.answers[index] && _vm.answers[index].optId, option.optId)
        },
        on: {
          "change": function($event) {
            return _vm.$set(_vm.answers && _vm.answers[index] && _vm.answers[index], "optId", option.optId)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "optLabel"
      }, [_vm._v(_vm._s(option.optDesc))]), _vm._v(" "), (option.optImagePath) ? _c('img', {
        staticClass: "optImg",
        attrs: {
          "src": _vm.imgUrl + '/' + option.optImagePath
        }
      }) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (item.queType == 4) ? _c('div', {
      staticClass: "img-box content-box"
    }, [_c('div', {
      staticClass: "flex-row"
    }, [_c('label', {
      staticClass: "flex-item"
    }, [_vm._v(_vm._s(item.queDesc))]), _vm._v(" "), (item.queImagePath) ? _c('img', {
      attrs: {
        "src": _vm.imgUrl + '/' + item.queImagePath
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img-item add"
    }, [_vm._v("\n            添加照片\n            "), _c('input', {
      ref: "img1",
      refInFor: true,
      staticClass: "file-button",
      attrs: {
        "type": "file",
        "multiple": "",
        "accept": "image/gif,image/jpeg,image/jpg,image/png",
        "value": ""
      },
      on: {
        "change": function($event) {
          return _vm.canvasSelImg($event, index)
        }
      }
    })])]), _vm._v(" "), _vm._l((_vm.getAttachs(index)), function(item) {
      return _c('div', {
        staticClass: "image-list"
      }, [_c('div', {
        staticClass: "verticalM image-box"
      }, [_c('img', {
        staticClass: "verticalM-box",
        attrs: {
          "src": item.fileUrl
        }
      })]), _vm._v(" "), _c('label', {
        staticClass: "delete",
        on: {
          "click": function($event) {
            return _vm.deleteImg(item.attach_Id, index)
          }
        }
      })])
    })], 2) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.mainTarget && _vm.mainType) ? _c('div', {
    staticClass: "flex-item btn",
    on: {
      "click": _vm.initPriceMainFn
    }
  }, [_vm._v("\n      去商城\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-item btn submitBtn",
    on: {
      "click": _vm.submitFn
    }
  }, [_vm._v("提交")])]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "登录",
      "dialogClass": "authCodeDialog"
    }
  }, [_c('div', {
    staticClass: "flex-row auth-info"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("图片验证码")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.randomCode),
      expression: "randomCode"
    }],
    attrs: {
      "maxlength": "4",
      "type": "",
      "name": "randomCode"
    },
    domProps: {
      "value": (_vm.randomCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.randomCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBtn",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('span', {
    staticClass: "img-code-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.randomCodePath
    },
    on: {
      "click": _vm.refreshImgCode
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row auth-info"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "maxlength": "11",
      "type": "",
      "name": "",
      "readonly": _vm.isReadonly
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "keyup": function($event) {
        return _vm.changePhone($event, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "codeBtn",
    class: {
      disabled: _vm.isDisabled
    },
    on: {
      "click": _vm.getAuthCode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.codeTitle) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row auth-info"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("短信验证码")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authCode),
      expression: "authCode"
    }],
    attrs: {
      "type": "",
      "name": "",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.authCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.authCode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row buttons"
  }, [_c('a', {
    staticClass: "flex-item button",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("去商城")]), _vm._v(" "), _c('div', {
    staticClass: "flex-item button loginBtn",
    on: {
      "click": _vm.loginCode
    }
  }, [_vm._v("登录")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-wrap"
  }, [_c('div', {
    staticClass: "empty-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgpath
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.emptytext))]), _vm._v(" "), (_vm.btntext) ? _c('mu-raised-button', {
    attrs: {
      "label": _vm.btntext
    },
    on: {
      "click": function($event) {
        return _vm.doUrl(_vm.btnurl)
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap brand-home-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('v-image', {
    attrs: {
      "imagePath": _vm.shopDetail.imagePath && _vm.shopDetail.imagePath.imagePath,
      "height": 42
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    class: {
      fixed: _vm.isFixed
    }
  }, [_c('input', {
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": _vm.shopDetail.storeName
    },
    on: {
      "change": function($event) {},
      "click": _vm.jumpSearch
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "homeWrapper",
    staticClass: "flex-item homeWrapper"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.bannerDeatilList), function(swiperShow, swiperIndex) {
    return _c('swiper-slide', {
      key: swiperIndex
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.goPage(swiperShow.linkType, swiperShow.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": swiperShow.imagePath && swiperShow.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), (_vm.couponsList && _vm.couponsList.length) ? _c('div', {
    staticClass: "coupon"
  }, [_c('div', {
    staticClass: "coupon-recommend",
    style: ('background: url(' +
      _vm.backgroundImage +
      ') no-repeat;background-size: 100% 100%;')
  }, [_c('swiper', {
    ref: "mySwiper2",
    attrs: {
      "options": _vm.comSwiperOption
    }
  }, _vm._l((_vm.couponsList), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "coupon-item"
    }, [_c('div', {
      staticClass: "coupon-content",
      on: {
        "click": function($event) {
          return _vm.receiveCouponFn(item.couponId, item.couponType, item.isGet)
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left",
      class: {
        couponColor: item.couponType == 1,
        redpacketColor: item.couponType == 2,
        finishColor: item.isGet == 1,
      }
    }, [(item.couponCate != 3) ? _c('p', {
      staticClass: "amount"
    }, [_c('samp', [_vm._v("¥")]), _vm._v("\n                  " + _vm._s(item.couponAmount) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.couponCate == 3) ? _c('p', {
      staticClass: "amount"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("discount")(item.couponDiscount)) + "\n                  "), _c('samp', [_vm._v("折")])]) : _vm._e(), _vm._v(" "), (item.couponType == 1) ? _c('p', {
      staticClass: "limit"
    }, [_vm._v("\n                  " + _vm._s(item.useAmount == 0 ?
      "不限制" :
      "满" + item.useAmount + "可用") + "\n                ")]) : _vm._e(), _vm._v(" "), (item.couponType == 2) ? _c('p', {
      staticClass: "limit"
    }, [_vm._v("\n                  " + _vm._s("剩余" +
      (parseInt(item.sendNum) - parseInt(item.recivedNum)) +
      "个红包") + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right verticalM",
      class: {
        coupons: item.couponType == 1,
        redpacket: item.couponType == 2,
        finish: item.isGet == 1,
      }
    }, [(item.isGet != 1) ? _c('span', {
      staticClass: "verticalM-box"
    }, [_vm._v("\n                  立\n                  "), _c('br'), _vm._v("\n                  即\n                  "), _c('br'), _vm._v("\n                  领\n                  "), _c('br'), _vm._v("\n                  取\n                ")]) : _vm._e(), _vm._v(" "), (item.isGet == 1) ? _c('span', {
      staticClass: "verticalM-box"
    }, [_vm._v("\n                  已\n                  "), _c('br'), _vm._v("\n                  领\n                  "), _c('br'), _vm._v("\n                  取\n                ")]) : _vm._e()])])])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "grid-three"
  }, _vm._l((_vm.promotionsShopList33), function(promotionShop3, promotion3Index) {
    return _c('mu-flexbox-item', {
      key: promotion3Index,
      staticClass: "flex-demo",
      on: {
        "click": function($event) {
          return _vm.goPage(
            promotionShop3.cates.linkType,
            promotionShop3.cates.linkTarget
          )
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShop3.imagePath && promotionShop3.imagePath.imagePath
      }
    })], 1)
  }), 1), _vm._v(" "), _vm._l((_vm.promotionsShopList44), function(promotionShop44, promotion44Index) {
    return _c('mu-flexbox', {
      key: promotion44Index,
      staticClass: "grid-one",
      on: {
        "click": function($event) {
          return _vm.goPage(
            promotionShop44.cates.linkType,
            promotionShop44.cates.linkTarget
          )
        }
      }
    }, [_c('mu-flexbox-item', {
      staticClass: "flex-demo"
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShop44.imagePath && promotionShop44.imagePath.imagePath
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "banner bannerTwo"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.promotionsShopListBanner), function(promotionShopBanner, promotionBannerIndex) {
    return _c('swiper-slide', {
      key: promotionBannerIndex
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.goPage(
            promotionShopBanner.linkType,
            promotionShopBanner.linkTarget
          )
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShopBanner.imagePath &&
          promotionShopBanner.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _vm._l((_vm.promotionsShopList66), function(promotionShop66, promotion66Index) {
    return _c('mu-flexbox', {
      key: promotion66Index,
      staticClass: "grid-one grid-one-bannerM"
    }, [_c('mu-flexbox-item', {
      staticClass: "flex-demo"
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShop66.imagePath && promotionShop66.imagePath.imagePath
      }
    })], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.floorMsg), function(shopSetList, setIndex) {
    return (_vm.floorMsg[0].floorInfo.goods.length != 0) ? _c('div', {
      staticClass: "brand-product"
    }, [_c('a', {
      staticClass: "header",
      on: {
        "click": function($event) {
          return _vm.goPage(shopSetList.floorInfo.linkType, shopSetList.floorInfo.cateId)
        }
      }
    }, [_c('span', {
      staticClass: "floatL brandName"
    }, [_vm._v("\n          " + _vm._s(shopSetList.floorInfo && shopSetList.floorInfo.cateName) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "floatR arrow"
    }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "product"
    }, _vm._l((shopSetList.floorInfo.goods), function(shopShow, shopIndex) {
      return _c('div', {
        staticClass: "product-item square"
      }, [_c('v-image', {
        attrs: {
          "width": 250,
          "height": 250,
          "titleText": shopShow.goodsName,
          "imagePath": shopShow.imagePath && shopShow.imagePath.imagePath,
          "moneyText": shopShow.goodsPrice > 0 ?
            shopShow.goodsPrice :
            shopShow.priceDesc || '',
          "orginalCost": shopShow.unitPrice
        },
        on: {
          "eventclick": function($event) {
            return _vm.viewGoodsDetail(shopShow)
          }
        }
      }, [_c('template', {
        slot: "money"
      }, [_vm._v("\n              " + _vm._s(shopShow.goodsPrice > 0 ?
        shopShow.goodsPrice :
        shopShow.priceDesc) + "\n            ")]), _vm._v(" "), _c('template', {
        slot: "orginalCost"
      }, [_vm._v(_vm._s(shopShow.unitPrice))])], 2)], 1)
    }), 0), _vm._v(" "), _vm._l((shopSetList), function(floorBox) {
      return (shopSetList.itemType == 99) ? _c('div', {
        staticClass: "banner-product"
      }, [_c('v-image', {
        attrs: {
          "imagePath": floorBox.floorInfo &&
            floorBox.floorInfo.imagePath &&
            floorBox.floorInfo.imagePath.imagePath,
          "eventparam": _vm.item
        },
        on: {
          "eventclick": _vm.viewAdDetail
        }
      })], 1) : _vm._e()
    })], 2) : _vm._e()
  })], 2), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('imgs', {
    staticClass: "user-hear",
    attrs: {
      "imagePath": _vm.listMemDetailInfo.avatarImage && _vm.listMemDetailInfo.avatarImage.imagePath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info-text",
    attrs: {
      "tag": "div"
    },
    on: {
      "click": _vm.openUserInfo
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.listMemDetailInfo.nickName))]), _vm._v(" "), _c('mu-chip', {
    staticClass: "demo-chip",
    attrs: {
      "disable": true
    }
  }, [_vm._v("\n          " + _vm._s(_vm.listMemDetailInfo.mobile) + "\n        ")])], 1), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-grid"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('p', {
    staticClass: "red",
    on: {
      "click": _vm.openMyCoupon
    }
  }, [_c('span', {
    staticClass: "user-grid-money"
  }, [_vm._v(_vm._s(_vm.listMemAccountMsg.couponNum || 0))]), _vm._v("张")]), _vm._v(" "), _c('p', [_vm._v("我的优惠券")])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('p', {
    staticClass: "red",
    on: {
      "click": _vm.openMyRedpack
    }
  }, [_c('span', {
    staticClass: "user-grid-money"
  }, [_vm._v(_vm._s(_vm.listMemAccountMsg.redpacketNum || 0))]), _vm._v("个")]), _vm._v(" "), _c('p', [_vm._v("我的红包")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "user-order"
  }, [_c('div', {
    staticClass: "user-order-title",
    on: {
      "click": function($event) {
        return _vm.openMyOrders(1)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-grid"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": _vm.listMemOrderCount.waitPayNum,
      "circle": "",
      "secondary": "",
      "badgeClass": [_vm.listMemOrderCount.waitPayNum == 0 || _vm.loading ? 'none-badge' : 'custom-badge']
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.openMyOrders(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/orders_unpaid_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("待支付")])])])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": _vm.listMemOrderCount.payedNum,
      "circle": "",
      "secondary": "",
      "badgeClass": [_vm.listMemOrderCount.payedNum == 0 || _vm.loading ? 'none-badge' : 'custom-badge']
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.openMyOrders(3)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/orders_unrecieved_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("支付成功")])])])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": _vm.listMemOrderCount.productNum,
      "circle": "",
      "secondary": "",
      "badgeClass": [_vm.listMemOrderCount.productNum == 0 || _vm.loading ? 'none-badge' : 'custom-badge']
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.openMyOrders(4)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/orders_unestimate_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("生产中")])])])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": _vm.listMemOrderCount.shippedNum,
      "circle": "",
      "secondary": "",
      "badgeClass": [_vm.listMemOrderCount.shippedNum == 0 || _vm.loading ? 'none-badge' : 'custom-badge']
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.openMyOrders(5)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/orders_uncollected_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("已发货")])])])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user-order"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "order-grid"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('div', {
    on: {
      "click": _vm.openMyCollection
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/personal_collect_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的收藏")])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('div', {
    on: {
      "click": _vm.openMyComments
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/personal_estimate_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("我的评价")])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('div', {
    on: {
      "click": _vm.openInvoiceInfo
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/personal_invoice_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("发票信息")])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }, [_c('div', {
    on: {
      "click": _vm.openAddress
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/personal/personal_shipping_address_3x.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("收货地址")])])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tripartite-box",
    on: {
      "click": _vm.loginOut
    }
  }, [_c('span', {
    staticClass: "wxauth-title"
  }, [_vm._v("\n        退出登录\n      ")])]), _vm._v(" "), _c('menus'), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("我的订单"), _c('span', {
    staticClass: "right"
  }, [_vm._v("查看全部订单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-order-title"
  }, [_c('p', [_vm._v("必备工具")])])
}]}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap"
  })
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listAddressMsg.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_address_3x.png",
      "emptytext": "您还没有添加收货地址",
      "btntext": "去添加",
      "btnurl": "/main/writeaddress"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listAddressMsg.length != 0 && !_vm.loadShow) ? _c('div', {
    staticClass: "flex-column address-list"
  }, [_c('div', {
    staticClass: "flex-item"
  }, _vm._l((_vm.listAddressMsg), function(listAddressShow, addressIndex) {
    return _c('div', {
      staticClass: "address-item"
    }, [_c('p', {
      staticClass: "address"
    }, [_vm._v(_vm._s(listAddressShow.province) + "  " + _vm._s(listAddressShow.city) + "  " + _vm._s(listAddressShow.area) + "  " + _vm._s(listAddressShow.address))]), _vm._v(" "), _c('p', {
      staticClass: "user"
    }, [_c('label', [_vm._v(_vm._s(listAddressShow.consignee))]), _vm._v(" "), _c('label', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(listAddressShow.mobile))])]), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [_c('mu-radio', {
      staticClass: "list-radio",
      class: [listAddressShow.isDefault == 1 ? 'primary' : ''],
      attrs: {
        "name": "group",
        "label": listAddressShow.isDefault == 1 ? '默认地址' : '设为默认',
        "nativeValue": listAddressShow.addressId
      },
      on: {
        "change": function($event) {
          return _vm.changeCheck(listAddressShow.addressId, listAddressShow.isDefault)
        }
      },
      model: {
        value: (_vm.defaultAddress),
        callback: function($$v) {
          _vm.defaultAddress = $$v
        },
        expression: "defaultAddress"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "edit-address fr",
      on: {
        "click": function($event) {
          return _vm.editAddress(listAddressShow.addressId, listAddressShow.memId)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('p', {
      staticClass: "delete-address fr",
      on: {
        "click": function($event) {
          return _vm.deleteAddress(listAddressShow.addressId)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "添加新地址",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.addAddress()
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDelete,
      "title": "删除地址",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDelete = false
      }
    }
  }, [_vm._v("\n    确定删除这个地址？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDelete = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": function($event) {
        return _vm.closedeleteAddress()
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "设置成功!"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toast2) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "删除成功!"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "wrap goods-detail-wrap flex-column"
  }, [(_vm.currentIndex >= 0) ? _c('div', {
    ref: "menuWrapper",
    staticClass: "menu-wrapper"
  }, [_c('ul', {
    ref: "menuList"
  }, _vm._l((_vm.menuData), function(item, index) {
    return _c('li', {
      staticClass: "menu-item verticalM",
      class: {
        active: _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(index)
        }
      }
    }, [_c('span', {
      staticClass: "menu-text verticallM-box"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "dishesWrapper",
    staticClass: "flex-item goods-wrapper",
    attrs: {
      "id": "dishesWrapper"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "small-button server",
    staticStyle: {
      "min-width": "15% !important"
    },
    attrs: {
      "label": "客服"
    },
    on: {
      "click": _vm.openCustomServer
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "small-button collect",
    staticStyle: {
      "min-width": "15% !important"
    },
    attrs: {
      "label": "收藏"
    },
    on: {
      "click": _vm.addGoodFav
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "small-button cart",
    staticStyle: {
      "min-width": "15% !important"
    },
    attrs: {
      "content": "11",
      "label": "购物车"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [(_vm.cartGoodsNum > 0) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.cartGoodsNum))]) : _vm._e()]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "big-button add-cart",
    class: {
      disabledbtn: _vm.btnDisabled
    },
    staticStyle: {
      "min-width": "27.5% !important"
    },
    attrs: {
      "label": "加入购物车",
      "primary": "",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": _vm.joinCart
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "big-button buyNow",
    class: {
      disabledbtn: _vm.btnDisabled
    },
    staticStyle: {
      "min-width": "27.5% !important"
    },
    attrs: {
      "label": "立即购买",
      "primary": "",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": _vm.buyNow
    }
  })], 1), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "custom-popup-bottom flex-column",
      "open": _vm.bottomPopup
    },
    on: {
      "close": function($event) {
        _vm.bottomPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-img"
  }, [_c('imgs', {
    attrs: {
      "imagePath": _vm.skuImages &&
        _vm.skuImages.length &&
        _vm.skuImages[0].imagePath &&
        _vm.skuImages[0].imagePath.imagePath
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-desc"
  }, [_c('p', {
    staticClass: "price"
  }, [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s((_vm.goodsSkuMsg &&
      _vm.goodsSkuMsg.sku &&
      _vm.goodsSkuMsg.sku.goodsPrice) ||
    0.0) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "desc overflowT2"
  }, [_vm._v("\n            " + _vm._s((_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuName) ||
    "") + "\n          ")])])]), _vm._v(" "), _vm._l(((_vm.goodsSkuMsg && _vm.goodsSkuMsg.fields)), function(item) {
    return _c('div', {
      staticClass: "goods-label"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.fieldName))]), _vm._v(" "), _c('div', {
      staticClass: "label-list"
    }, _vm._l((item.values), function(value) {
      return _c('span', {
        staticClass: "label",
        class: {
          active: value.isChecked == 1
        },
        on: {
          "click": function($event) {
            return _vm.selectSku(item.fieldId, value.valueId)
          }
        }
      }, [_vm._v(_vm._s(value.valueName))])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-number"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('reduce')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsNum),
      expression: "goodsNum"
    }],
    domProps: {
      "value": (_vm.goodsNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goodsNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reduce-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('add')
      }
    }
  }), _vm._v(" "), _c('samp', [_vm._v("件")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.submit
    }
  })], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.showDialog,
      "title": "DIY清单",
      "dialogClass": "custom-class diy-dialog"
    },
    on: {
      "close": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "diy-list"
  }, _vm._l((_vm.selectDIYinfo), function(diyItem, index) {
    return _c('li', {
      staticClass: "ellipsis",
      class: {
        right: index % 2 != 0
      }
    }, [_c('label', [_vm._v(_vm._s(diyItem.fieldName) + "：")]), _c('span', [_vm._v(_vm._s(diyItem.valueName))])])
  }), 0), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.submitDIY
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-wrap",
    on: {
      "click": _vm.onImgClick
    }
  }, [(!_vm.onlyImage) ? _c('div', {
    staticClass: "img verticalM"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imgPath),
      expression: "imgPath"
    }],
    staticClass: "verticalM-box",
    class: {
      floatL: _vm.isLeftRight
    },
    style: (_vm.imgStyle)
  })]) : _vm._e(), _vm._v(" "), (!_vm.onlyImage) ? _c('div', {
    staticClass: "detail",
    class: {
      floatL: _vm.isLeftRight
    }
  }, [(_vm.titleText) ? _c('div', {
    staticClass: "title ellipsis",
    attrs: {
      "title": _vm.titleText == true ? '' : _vm.titleText
    }
  }, [_vm._t("title", function() {
    return [_vm._v(_vm._s(_vm.titleText))]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.moneyText) ? _c('div', {
    staticClass: "money"
  }, [_c('span', {
    staticClass: "nowCost ellipsis",
    class: {
      width: _vm.orginalCost > 0
    }
  }, [(_vm.moneyText > 0) ? _c('samp', [_vm._v("¥")]) : _vm._e(), _vm._v(" "), _vm._t("money", function() {
    return [_vm._v(_vm._s(_vm.moneyText))]
  })], 2), _vm._v(" "), (_vm.orginalCost && _vm.orginalCost > 0) ? _c('span', {
    staticClass: "orginalCost"
  }, [_c('samp', [_vm._v("¥")]), _vm._v(" "), _c('samp', [_vm._t("orginalCost", function() {
    return [_vm._v(_vm._s(_vm.orginalCost))]
  })], 2)]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.onlyImage) ? _c('div', {
    class: {
      clearfix: _vm.isLeftRight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.onlyImage) ? _vm._t("image", function() {
    return [_c('img', {
      style: (_vm.imgStyle),
      attrs: {
        "src": _vm.imagePath
      }
    })]
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "input-box flex-row"
  }, [_c('div', {
    staticClass: "search-box flex-item flex-row"
  }, [_c('span', [_vm._v("CP -")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumObj.orderNumFour),
      expression: "orderNumObj.orderNumFour"
    }],
    staticClass: "flex-item",
    attrs: {
      "placeholder": "数字",
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.orderNumObj.orderNumFour)
    },
    on: {
      "keyup": function($event) {
        return _vm.checkNum($event, 'orderNumFour')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderNumObj, "orderNumFour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumObj.orderNumFive),
      expression: "orderNumObj.orderNumFive"
    }],
    staticClass: "flex-item",
    attrs: {
      "placeholder": "数字",
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.orderNumObj.orderNumFive)
    },
    on: {
      "keyup": function($event) {
        return _vm.checkNum($event, 'orderNumFour')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orderNumObj, "orderNumFive", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "search-btn blue",
    on: {
      "click": function($event) {
        return _vm.searchOrder()
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "search-tips"
  }, [_vm._v("\n     请在上方线框空白处填写CP订单号，进行快速自助查询，美心祝您购物愉快。全国服务热线：400-832-2777\n   ")]), _vm._v(" "), (_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "orderDetail flex-item"
  }, [(_vm.isEmpty) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_orders_3x.png",
      "emptytext": "暂无记录"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderContent.length > 0) ? _c('div', [_c('div', {
    staticClass: "title flex-row"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_vm._v("查询结果")]), _vm._v(" "), _c('div', {
    staticClass: "title-tip"
  }, [_vm._v("\n           本数据由\n           "), _c('a', [_vm._v("重庆美心集团")]), _vm._v("\n           提供\n         ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-row order-title"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_vm._v("\n           订单：CP-" + _vm._s(_vm.orderNumObj.orderNumFour) + "-" + _vm._s(_vm.orderNumObj.orderNumFive) + "\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "order-title-tip"
  }, [_vm._v("我的订单列表")])]), _vm._v(" "), _c('ul', {
    staticClass: "orderLists"
  }, [_c('li', {
    staticClass: "timeImg"
  }), _vm._v(" "), _vm._l((_vm.orderContent), function(item) {
    return _c('li', {
      staticClass: "order-item flex-item"
    }, [_vm._v("\n           " + _vm._s(item.recTime) + "  " + _vm._s(item.recDesc) + "\n         ")])
  })], 2)]) : _vm._e()], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(368)
    }
  })])
}]}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap",
    staticClass: "goods-wrap",
    style: (_vm.txtStyle),
    on: {
      "touchstart": _vm._touchStart,
      "touchmove": _vm._touchMove,
      "touchend": _vm._touchEnd
    }
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "content"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.skuImages), function(img, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('imgs', {
      attrs: {
        "width": 700,
        "imagePath": img && img.imagePath && img.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-custom",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-content"
  }, [_c('div', {
    staticClass: "goods-box"
  }, [_c('span', {
    staticClass: "goodsName"
  }, [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuName || ""))]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "diy-button",
    attrs: {
      "label": "DIY",
      "primary": ""
    },
    on: {
      "click": _vm.gotoDIY
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "price-box"
  }, [_c('span', {
    staticClass: "price floatL"
  }, [_vm._v("\n            优惠价\n            "), (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.unitPrice > 0) ? _c('samp', [_vm._v("¥")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && (_vm.goodsSkuMsg.sku.goodsPrice > 0 ? _vm.goodsSkuMsg.sku.goodsPrice : _vm.goodsSkuMsg.sku.priceDesc)))])]), _vm._v(" "), (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.unitPrice > 0) ? _c('span', {
    staticClass: "price old-price floatR"
  }, [_vm._v("\n            原价 "), _c('dd', [_vm._v("￥" + _vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.unitPrice || 0.00))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips saleNum"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v("销量：" + _vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.saleNum || 0) + "件")]), _vm._v(" "), _c('span', {
    staticClass: "floatR"
  }, [_vm._v("库存：" + _vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.stockNum || 0) + "件")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuDesc || ""))])]), _vm._v(" "), (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.coupons && _vm.goodsSkuMsg.sku.coupons.length > 0) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "button coupon-box",
    on: {
      "click": function($event) {
        _vm.couponPopup = true
      }
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.bottomPopup = true
      }
    }
  }, [_c('span', [_c('samp', [_vm._v("已选")]), _vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuFields || ""))])]), _vm._v(" "), _c('div', {
    staticClass: "store-map"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('samp', [_vm._v("门店")]), _vm._v(" "), _c('div', {
    staticClass: "verticalM-box address"
  }, [_c('span', {
    staticClass: "ellipsis",
    on: {
      "click": function($event) {
        _vm.addressPopup = true;
        _vm.isAddress = true
      }
    },
    model: {
      value: (_vm.addressMsgShow),
      callback: function($$v) {
        _vm.addressMsgShow = $$v
      },
      expression: "addressMsgShow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.addressMsgShow) + "\n            ")])])]), _vm._v(" "), (_vm.amap) ? _c('div', {
    staticClass: "map-box map"
  }, [_c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo",
      "center": _vm.amap.center,
      "map-manager": _vm.amap.amapManager,
      "zoom": _vm.amap.zoom,
      "events": _vm.amap.events
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.gotoEvalute
    }
  }, [_c('span', [_c('samp', [_vm._v("评价")]), (_vm.GoodsComm.favRate) ? _c('label', [_vm._v("好评率" + _vm._s(_vm.GoodsComm.favRate) + "%")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "floatR show-evalute"
  }, [_vm._v("查看全部评价")])]), _vm._v(" "), _c('div', {
    staticClass: "evaluate-detail"
  }, [_c('div', {
    staticClass: "evaluate-label"
  }, _vm._l((_vm.GoodsComm.commentTags), function(tag) {
    return _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(tag.name)), _c('samp', [_vm._v(_vm._s(tag.nums))])])
  }), 0), _vm._v(" "), (_vm.GoodsCommList.length < 1) ? _c('p', {
    staticClass: "none-conment"
  }, [_vm._v("对不起，暂时没有找到结果")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.GoodsCommList), function(item) {
    return _c('div', {
      staticClass: "evaluate-item"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('span', {
      staticClass: "head"
    }, [_c('imgs', {
      attrs: {
        "imagePath": item.header && item.header.imagePath
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.memName))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_c('span', {
      staticClass: "floatL"
    }, [_vm._v(_vm._s(item.commTime))])]), _c('div', {
      staticClass: "floatR"
    }, _vm._l((5), function(i) {
      return _c('span', {
        staticClass: "star",
        class: {
          active: i <= Math.floor(item.starScore)
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
      staticClass: "evaluate-content"
    }, [_vm._v(_vm._s(item.commDesc))]), _vm._v(" "), (item.replyDesc) ? _c('div', {
      staticClass: "merchant-reply"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('span', {
      staticClass: "floatL"
    }, [_vm._v("美心商城回复:")]), _vm._v(" "), _c('span', {
      staticClass: "floatR time"
    }, [_vm._v(_vm._s(item.replyTime))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "evaluate-content"
    }, [_vm._v(_vm._s(item.replyDesc))])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tripartite-box",
    style: (_vm.txtStyle)
  }, [_c('span', {
    staticClass: "wxauth-title"
  }, [_vm._v("\n          " + _vm._s(_vm.tip) + "\n        ")])])], 2), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "custom-popup-bottom flex-column",
      "open": _vm.bottomPopup
    },
    on: {
      "close": function($event) {
        _vm.bottomPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-img"
  }, [_c('imgs', {
    attrs: {
      "width": 200,
      "imagePath": _vm.skuImages && _vm.skuImages[0] && _vm.skuImages[0].imagePath && _vm.skuImages[0].imagePath.imagePath
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-desc"
  }, [_c('p', {
    staticClass: "price"
  }, [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.goodsPrice || 0.00))]), _vm._v(" "), _c('p', {
    staticClass: "desc overflowT2"
  }, [_vm._v(_vm._s(_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuName || ""))])])]), _vm._v(" "), _vm._l(((_vm.goodsSkuMsg && _vm.goodsSkuMsg.fields)), function(item) {
    return _c('div', {
      staticClass: "goods-label"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.fieldName))]), _vm._v(" "), _c('div', {
      staticClass: "label-list"
    }, _vm._l((item.values), function(value) {
      return _c('span', {
        staticClass: "label",
        class: {
          active: value.isChecked == 1
        },
        on: {
          "click": function($event) {
            return _vm.selectSku(item.fieldId, value.valueId)
          }
        }
      }, [_vm._v(_vm._s(value.valueName))])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-number"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('reduce')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsNum),
      expression: "goodsNum"
    }],
    domProps: {
      "value": (_vm.goodsNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goodsNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reduce-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('add')
      }
    }
  }), _vm._v(" "), _c('samp', [_vm._v("件")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "coupon-receive-popup-bottom flex-column",
      "open": _vm.couponPopup
    },
    on: {
      "close": function($event) {
        _vm.couponPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon-list"
  }, [_c('div', {
    staticClass: "coupon-list-item title"
  }, [_vm._v("\n                领券\n              ")]), _vm._v(" "), _c('emptyCart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.coupons && _vm.goodsSkuMsg.sku.coupons.length <= 0),
      expression: "goodsSkuMsg && goodsSkuMsg.sku && goodsSkuMsg.sku.coupons && goodsSkuMsg.sku.coupons.length<=0"
    }],
    attrs: {
      "emptytext": "当前店铺没有优惠券了~"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "coupon-list-item"
  }, _vm._l((_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.coupons && _vm.goodsSkuMsg.sku.coupons), function(couponItem) {
    return _c('tr', [_c('td', [(couponItem.couponCate != 3) ? _c('div', {
      class: {
        coupon: couponItem.couponType == 1,
        redpackage: couponItem.couponType == 2
      }
    }, [_vm._v("￥" + _vm._s(couponItem.couponAmount))]) : _vm._e(), _vm._v(" "), (couponItem.couponCate == 3) ? _c('div', {
      class: {
        coupon: couponItem.couponType == 1,
        redpackage: couponItem.couponType == 2
      }
    }, [_vm._v(_vm._s(_vm._f("discount")(couponItem.couponDiscount))), _c('samp', [_vm._v("折")])]) : _vm._e()]), _vm._v(" "), _c('td', [(couponItem.couponType == 1) ? _c('p', [_vm._v(_vm._s(couponItem.useAmount == 0 ? '不限制' : '满' + couponItem.useAmount + '可用'))]) : _vm._e(), _vm._v(" "), (couponItem.couponType == 2) ? _c('p', [_vm._v("剩余" + _vm._s((parseInt(couponItem.sendNum) - parseInt(couponItem.recivedNum))) + "个红包")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(couponItem.effectiveTime) + " - " + _vm._s(couponItem.overdueTime))])]), _vm._v(" "), _c('td', [(couponItem.isGet == 1) ? _c('button', {
      staticClass: "gray finish",
      attrs: {
        "type": "default",
        "disabled": ""
      }
    }, [_vm._v("已领取")]) : _vm._e(), _vm._v(" "), (couponItem.isGet == 0) ? _c('button', {
      staticClass: "gray",
      attrs: {
        "type": "default"
      },
      on: {
        "click": function($event) {
          return _vm.getCoupon(couponItem.couponId, couponItem.couponType, couponItem.isGet)
        }
      }
    }, [_vm._v("领取")]) : _vm._e()])])
  }), 0)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.couponPopup = false
      }
    }
  })], 1)]), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "popup-bottom physical-popup",
      "open": _vm.addressPopup
    },
    on: {
      "close": function($event) {
        _vm.addressPopup = false
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.isAddress ? '所在地区' : '选择品牌')), _c('span', {
    on: {
      "click": function($event) {
        _vm.addressPopup = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-content"
  }, [(_vm.isAddress) ? _c('div', {
    staticClass: "chooseList forbid-sel-text",
    class: {
      'chooseTwo': _vm.shoWOr == 2,
      'chooseOne': _vm.shoWOr == 1
    }
  }, [_c('div', {
    staticClass: "pShow"
  }, [(_vm.shoWOr <= 1) ? _c('samp', {
    staticClass: "sampOne",
    on: {
      "click": function($event) {
        return _vm.clickProvince(1)
      }
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 2) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.addressProvince))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 3) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityNameShow))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('samp', {
    staticClass: "sampTwo"
  }, [_vm._v("请选择")]) : _vm._e()]), _vm._v(" "), (_vm.shoWOr == 1) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.arealistMsg), function(provinceShow) {
    return _c('span', {
      on: {
        "click": function($event) {
          return _vm.shooseProvince(provinceShow.areaId, provinceShow.areaName)
        }
      }
    }, [_vm._v(_vm._s(provinceShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.cityListShow), function(cityShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseCityId == cityShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseCity(cityShow.areaId, cityShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(cityShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 3) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.areaAddressMsg), function(areaListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseAreaId == areaListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseArea(areaListShow.areaId, areaListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(areaListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 4) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.getStreetMsgList), function(streetListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseStreetId == streetListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseStreet(streetListShow.areaId, streetListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(streetListShow.areaName))])
  }), 0) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确认",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.adressFirm
    }
  })], 1)])]), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-title"
  }, [_c('span', [_c('samp', [_vm._v("领券优惠")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "item redpackage"
  }, [_c('span', [_vm._v("红包")])]), _vm._v(" "), _c('label', [_vm._v("领取红包")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "item coupon"
  }, [_c('span', [_vm._v("优惠券")])]), _vm._v(" "), _c('label', [_vm._v("领取优惠券")])])
}]}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap physical-stores-wrap flex-column"
  }, [_c('div', {
    staticClass: "head verticalM"
  }, [_c('div', {
    staticClass: "verticalM-box address"
  }, [_c('span', {
    staticClass: "ellipsis",
    on: {
      "click": function($event) {
        _vm.addressPopup = true;
        _vm.isAddress = true
      }
    },
    model: {
      value: (_vm.addressMsgShow),
      callback: function($$v) {
        _vm.addressMsgShow = $$v
      },
      expression: "addressMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.addressMsgShow))])]), _vm._v(" "), _c('div', {
    staticClass: "verticalM-box brand"
  }, [_c('span', {
    staticClass: "ellipsis",
    on: {
      "click": function($event) {
        _vm.addressPopup = true;
        _vm.isAddress = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.brandName))])])]), _vm._v(" "), (_vm.amap) ? _c('div', {
    staticClass: "flex-item map"
  }, [_c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo",
      "center": _vm.amap.center,
      "map-manager": _vm.amap.amapManager,
      "zoom": _vm.amap.zoom,
      "events": _vm.amap.events
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "popup-bottom physical-popup",
      "open": _vm.addressPopup
    },
    on: {
      "close": function($event) {
        _vm.addressPopup = false
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.isAddress ? '所在地区' : '选择品牌')), _c('span', {
    on: {
      "click": function($event) {
        _vm.addressPopup = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popup-content"
  }, [(_vm.isAddress) ? _c('div', {
    staticClass: "chooseList forbid-sel-text",
    class: {
      'chooseTwo': _vm.shoWOr == 2,
      'chooseOne': _vm.shoWOr == 1
    }
  }, [_c('div', {
    staticClass: "pShow"
  }, [(_vm.shoWOr <= 1) ? _c('samp', {
    staticClass: "sampOne",
    on: {
      "click": function($event) {
        return _vm.clickProvince(1)
      }
    }
  }, [_vm._v("请选择")]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 2) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.addressProvince))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr >= 3) ? _c('samp', {
    on: {
      "click": function($event) {
        return _vm.clickProvince(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.cityNameShow))]) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('samp', {
    staticClass: "sampTwo"
  }, [_vm._v("请选择")]) : _vm._e()]), _vm._v(" "), (_vm.shoWOr == 1) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.arealistMsg), function(provinceShow) {
    return _c('span', {
      on: {
        "click": function($event) {
          return _vm.shooseProvince(provinceShow.areaId, provinceShow.areaName)
        }
      }
    }, [_vm._v(_vm._s(provinceShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 2) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.cityListShow), function(cityShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseCityId == cityShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseCity(cityShow.areaId, cityShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(cityShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 3) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.areaAddressMsg), function(areaListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseAreaId == areaListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseArea(areaListShow.areaId, areaListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(areaListShow.areaName))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.shoWOr == 4) ? _c('div', {
    staticClass: "chooseProvince"
  }, _vm._l((_vm.getStreetMsgList), function(streetListShow) {
    return _c('span', {
      class: {
        'chooseCityStyle': _vm.chooseStreetId == streetListShow.areaId
      },
      on: {
        "click": function($event) {
          return _vm.shooseStreet(streetListShow.areaId, streetListShow.areaName)
        }
      }
    }, [_vm._v(" " + _vm._s(streetListShow.areaName))])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isAddress) ? _c('div', _vm._l((_vm.Brands), function(brand, index) {
    return _c('mu-checkbox', {
      key: brand.linkTarget,
      staticClass: "demo-checkbox",
      attrs: {
        "name": "group",
        "labelLeft": true,
        "nativeValue": brand.linkTarget,
        "label": brand.linkName
      },
      on: {
        "change": function($event) {
          return _vm.selBrand($event, index)
        }
      },
      model: {
        value: (brand.selected),
        callback: function($$v) {
          _vm.$set(brand, "selected", $$v)
        },
        expression: "brand.selected"
      }
    })
  }), 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottom-btn-box"
  }, [_c('div', {
    staticClass: "bottom-full-button"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确认",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.adressFirm
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap"
  }, [_c('div', {
    staticClass: "flex-column myaccount"
  }, [_c('div', {
    staticClass: "mytabs two"
  }, [_c('div', {
    staticClass: "tab",
    class: {
      'active': _vm.activeTab == 'tab1'
    },
    on: {
      "click": function($event) {
        return _vm.tabHeaderOne(0)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": "0",
      "circle": "",
      "secondary": "",
      "badgeClass": "none-badge"
    }
  }, [_c('p', [_vm._v("未使用")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab",
    class: {
      'active': _vm.activeTab == 'tab2'
    },
    on: {
      "click": function($event) {
        return _vm.tabHeaderTwo(2)
      }
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": "0",
      "circle": "",
      "secondary": "",
      "badgeClass": "none-badge"
    }
  }, [_c('p', [_vm._v("已失效")])])], 1)]), _vm._v(" "), (_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.memCouponMsg.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_red_packet_3x.png",
      "emptytext": "您还没有相关红包"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.memCouponMsg.length != 0 && !_vm.loadShow),
      expression: "memCouponMsg.length != 0  && !loadShow"
    }],
    staticClass: "flex-item tab1"
  }, [_vm._l((_vm.memCouponMsg), function(memCouponMsgList, ceffectiveIndex) {
    return _c('mu-list', {
      key: memCouponMsgList.couponId,
      staticClass: "acount-list",
      class: {
        'out-date': _vm.activeTab == 'tab2'
      }
    }, [_c('mu-list-item', [_c('div', {
      staticClass: "acount-list-left"
    }, [(memCouponMsgList.couponCate != 3) ? _c('p', {
      staticClass: "money"
    }, [_vm._v("￥\n              "), _c('label', [_vm._v(_vm._s(memCouponMsgList.couponAmount))])]) : _vm._e(), _vm._v(" "), (memCouponMsgList.couponCate == 3) ? _c('p', {
      staticClass: "money"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("discount")(memCouponMsgList.couponDiscount)))]), _vm._v("折\n            ")]) : _vm._e(), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTab == 'tab2'),
        expression: "activeTab =='tab2'"
      }],
      attrs: {
        "src": "/static/images/coupon_out_of_date_3x.png"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "limit"
    }, [_vm._v(_vm._s(memCouponMsgList.useableAmount == 0 ? '不限制' : '满' + memCouponMsgList.useableAmount + '可用'))])]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis gray mgt"
    }, [_c('label', [_vm._v("限品类：")]), _vm._v(_vm._s(memCouponMsgList.userTypeName))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis gray"
    }, [_c('label', [_vm._v("有效期：")]), _vm._v(_vm._s(memCouponMsgList.effectiveTime) + "-" + _vm._s(memCouponMsgList.expireTime))]), _vm._v(" "), _c('div', {
      staticClass: "account-operate"
    }, [_c('p', {
      staticClass: "scan-detail gray",
      on: {
        "click": function($event) {
          return _vm.scandetail(ceffectiveIndex)
        }
      }
    }, [_vm._v("详细")]), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [_c('mu-raised-button', {
      staticClass: "account-btn account-btn-gray",
      attrs: {
        "label": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.deleteitem(memCouponMsgList.couponInstId)
        }
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      staticClass: "account-btn account-btn-primary",
      attrs: {
        "label": "去使用"
      },
      on: {
        "click": function($event) {
          return _vm.gouse(memCouponMsgList.storeId, memCouponMsgList.useType)
        }
      }
    })], 1)])]), _vm._v(" "), (_vm.check(ceffectiveIndex)) ? _c('div', {
      staticClass: "detail-box"
    }, [_c('p', {
      staticClass: "gray"
    }, [_c('label', [_vm._v("券名称：")]), _vm._v(_vm._s(memCouponMsgList.couponName))]), _vm._v(" "), _c('p', {
      staticClass: "gray"
    }, [_c('label', [_vm._v("券编号：")]), _vm._v(_vm._s(memCouponMsgList.couponInstId))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.total == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多红包啦~")]) : _vm._e()], 2)], 1), _vm._v(" "), (_vm.toast1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "删除成功!"
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.delCoupon,
      "title": "删除优惠券",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.delCoupon = false
      }
    }
  }, [_vm._v("\n    您确定要删除这张优惠券么?\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.delCoupon = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.getDelMemCoupon(_vm.temp)
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "goods-diy-wrap"
  }, [_c('div', {
    staticClass: "image"
  }, _vm._l((_vm.diyImages), function(item, index) {
    return _c('div', {
      staticClass: "img-box",
      style: ({
        'z-index': item.imageIndex
      })
    }, [_c('img', {
      attrs: {
        "src": _vm.imagePath(item.sku && item.sku.diyImage && item.sku.diyImage.imagePath),
        "alt": ""
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "select-type"
  }, _vm._l((_vm.selectDIYinfo), function(item) {
    return _c('div', {
      staticClass: "typeItem"
    }, [_c('label', [_vm._v(_vm._s(item.fieldName) + "：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.valueName))])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "mx-mall-type"
  }, [_vm._l(((_vm.diyPropertys && _vm.diyPropertys.items)), function(diyProperty, index) {
    return [_vm._l(((diyProperty.itemInfo && diyProperty.itemInfo.fields)), function(item, i) {
      return _c('li', {
        staticClass: "type-list",
        class: {
          active: _vm.typeId == i + 'field'
        }
      }, [(diyProperty.itemType == 1) ? [_c('div', {
        staticClass: "head",
        on: {
          "click": function($event) {
            _vm.typeId = i + 'field'
          }
        }
      }, [_vm._v(_vm._s(item.fieldName))]), _vm._v(" "), _c('div', {
        staticClass: "type-box"
      }, _vm._l((item.values), function(info) {
        return _c('div', {
          staticClass: "img-box",
          class: {
            active: info.isChecked == 1
          },
          on: {
            "click": function($event) {
              return _vm.selectDiyGood(index, diyProperty.goodsId, item.fieldId, info.valueId, diyProperty.imageIndex)
            }
          }
        }, [(info.imagePath) ? _c('imgs', {
          attrs: {
            "imagePath": info.imagePath && info.imagePath.imagePath
          }
        }) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(info.valueName))])], 1)
      }), 0)] : _vm._e()], 2)
    }), _vm._v(" "), _c('li', {
      staticClass: "type-list",
      class: {
        active: _vm.typeId == index
      }
    }, [(diyProperty.itemType == 2) ? [_c('div', {
      staticClass: "head",
      on: {
        "click": function($event) {
          _vm.typeId = index
        }
      }
    }, [_vm._v(_vm._s(diyProperty.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "type-box"
    }, _vm._l((diyProperty.itemInfo), function(info) {
      return _c('div', {
        staticClass: "img-box",
        class: {
          active: info.isChecked == 1
        },
        on: {
          "click": function($event) {
            return _vm.selectDiyProperty(index, info.skuId)
          }
        }
      }, [_c('imgs', {
        attrs: {
          "imagePath": info.diyImage && info.diyImage.imagePath
        }
      })], 1)
    }), 0)] : _vm._e()], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "number-box"
  }, [_c('div', {
    staticClass: "floatL"
  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
    staticClass: "floatR"
  }, [_c('div', {
    staticClass: "goods-number"
  }, [_c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('reduce')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsNum),
      expression: "goodsNum"
    }],
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.goodsNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goodsNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reduce-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('add')
      }
    }
  }), _vm._v(" "), _c('samp', [_vm._v("套")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "utilPrice"
  }, [_c('div', {
    staticClass: "floatL"
  }, [_c('label', [_vm._v("优惠价")]), _vm._v(" "), _c('span', [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s(_vm.skuInfo && _vm.skuInfo.goodsPrice.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "floatR"
  }, [_vm._v("售价 "), _c('span', [_vm._v("¥" + _vm._s(_vm.skuInfo && _vm.skuInfo.unitPrice.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "totalPrice"
  }, [_c('div', {
    staticClass: "floatL"
  }, [_c('label', [_vm._v("总价")]), _vm._v(" "), _c('span', [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s(_vm.totalPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "floatR"
  }, [_vm._v("共 "), _c('span', [_vm._v(_vm._s(_vm.goodsNum))]), _vm._v(" 套")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "quitsuccess"
  }, [_vm._v("\n      您的申请已经提交，系统正在处理，稍后您可以在订单详情页查看结果。感谢您对美心的支持！\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "editButton"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "确定",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "正在跳转···"
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap search-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索商品",
      "id": "input"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "focus": function($event) {
        return _vm.focusinput()
      },
      "blur": function($event) {
        return _vm.blurinput()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        return _vm.filter()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('span', {
    staticClass: "search-btn multiple",
    on: {
      "click": function($event) {
        _vm.rightPopup = true
      }
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "listBox",
    staticClass: "box flex-item"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_vm._l((_vm.goodsList), function(item) {
    return _c('div', {
      staticClass: "left-advertise square"
    }, [_c('div', {
      staticClass: "img",
      on: {
        "click": function($event) {
          return _vm.gotoSunhomeDetail(item.shareId)
        }
      }
    }, [_c('imgs', {
      attrs: {
        "titleText": item.shareContent,
        "imagePath": item && item.imagePath && item.imagePath.imagePath
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "userName ellipsis"
    }, [_vm._v("来自 " + _vm._s(item.shareBy) + " 的评价")]), _vm._v(" "), _c('p', {
      staticClass: "style-box flex-row"
    }, [_c('span', {
      staticClass: "style ellipsis flex-item"
    }, [_vm._l((item.tags), function(sub) {
      return [_vm._v(_vm._s(sub.linkName) + " ")]
    })], 2), _vm._v(" "), (item.totalPrice > 0) ? _c('span', {
      staticClass: "price ellipsis"
    }, [_vm._v(_vm._s(item.totalPrice) + "元")]) : _vm._e()])], 1)])
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  })], 2), _vm._v(" "), ((_vm.lastPageNo == _vm.pageNo && !_vm.load) || (_vm.total == 0 && !_vm.load)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多商品啦~")]) : _vm._e()]), _vm._v(" "), (_vm.isColligate) ? _c('div', {
    staticClass: "colligate-select"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('div', {
    staticClass: "radio-item",
    class: {
      active: _vm.asc == 'asc'
    },
    on: {
      "click": function($event) {
        return _vm.sale('asc')
      }
    }
  }, [_vm._v("销量从低到高")]), _vm._v(" "), _c('div', {
    staticClass: "radio-item",
    class: {
      active: _vm.asc == 'desc'
    },
    on: {
      "click": function($event) {
        return _vm.sale('desc')
      }
    }
  }, [_vm._v("销量从高到低")])])]) : _vm._e(), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "right",
      "popupClass": "filter-popup",
      "open": _vm.rightPopup
    },
    on: {
      "close": function($event) {
        _vm.rightPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-column"
  }, [_c('div', {
    staticClass: "filter-header"
  }, [_c('span', {
    staticClass: "arrow",
    on: {
      "click": function($event) {
        _vm.rightPopup = false
      }
    }
  }), _vm._v(" "), _c('samp', {}, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, _vm._l((_vm.GoodsPropertieTags), function(tag, index) {
    return _c('div', {
      ref: "toggleWrap",
      refInFor: true,
      staticClass: "item"
    }, [_c('p', {
      staticClass: "filter-list-header",
      on: {
        "click": function($event) {
          return _vm.toggleNexted(index)
        }
      }
    }, [_vm._v(_vm._s(tag.linkName)), (index >= _vm.eq) ? _c('samp', {
      staticClass: "arrow",
      class: {
        upArrow: index == _vm.nextId
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "list-item",
      class: {
        spread: index < _vm.eq || index == _vm.nextId
      }
    }, _vm._l((tag.subs), function(subtag) {
      return _c('span', {
        staticClass: "label",
        class: {
          active: _vm.checkedTag && _vm.checkedTag[index] && _vm.checkedTag[index].linkInfo && _vm.checkedTag[index].linkInfo.linkTarget == subtag.linkTarget
        },
        on: {
          "click": function($event) {
            return _vm.selectTag(index, subtag)
          }
        }
      }, [_vm._v(_vm._s(subtag.linkName))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('mu-raised-button', {
    staticClass: "reset-button",
    attrs: {
      "label": "重置",
      "primary": ""
    },
    on: {
      "click": _vm.reset
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submit-button",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.filter
    }
  })], 1)])]), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrap"
  }, [_c('mu-bottom-nav', {
    attrs: {
      "value": _vm.bottomNav
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('mu-bottom-nav-item', {
    staticClass: "home",
    attrs: {
      "value": "1",
      "title": "首页",
      "icon": "home"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    staticClass: "sort",
    attrs: {
      "value": "2",
      "title": "分类",
      "icon": "list"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    staticClass: "cart",
    attrs: {
      "value": "3",
      "title": "购物车",
      "icon": "shopcart"
    }
  }, [_c('mu-badge', {
    attrs: {
      "content": String(_vm.cartGoodsNum),
      "circle": "",
      "secondary": "",
      "badgeClass": [_vm.cartGoodsNum == 0 ? 'none-badge' : 'custom-badge']
    }
  })], 1), _vm._v(" "), _c('mu-bottom-nav-item', {
    staticClass: "mine",
    attrs: {
      "value": "4",
      "title": "我的",
      "icon": "my"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-content"
  }, [_c('div', {
    staticClass: "no-content-img"
  }), _vm._v(" "), _c('p', {
    staticClass: "no-content-text"
  }, [_vm._v("哎呀，页面未找到！")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-btn",
    attrs: {
      "to": '/'
    }
  }, [_vm._v("返回首页")])], 1)
},staticRenderFns: []}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap flex-column"
  }, [_c('mu-infinite-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pay.loading),
      expression: "pay.loading"
    }],
    staticClass: "load maskloading",
    attrs: {
      "loading": _vm.pay.loading,
      "loadingText": _vm.pay.message
    }
  }), _vm._v(" "), (_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadShow) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', [_c('div', {
    staticClass: "orders-list detail"
  }, [(_vm.orderStateType != 0 && _vm.orderStateType != 2 && _vm.orderStateType != 10 && _vm.orderStateType != 11) ? _c('div', {
    staticClass: "time-line four"
  }, _vm._l((_vm.memOrderDetailMsg.orderOperMsgs), function(orderType, typeIndex) {
    return (typeIndex != 0 && typeIndex != 5) ? _c('div', {
      staticClass: "time-line-item",
      class: {
        'nowStyle': orderType.operIndex == 2,
        'finishStyle': orderType.operIndex == 1
      }
    }, [_c('p', {
      staticClass: "state"
    }, [_vm._v(_vm._s(orderType.operName))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), (orderType.operIndex != 3) ? _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(orderType.operTime))]) : _vm._e()]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), (_vm.orderStateType == 10 || _vm.orderStateType == 11) ? _c('div', {
    staticClass: "time-line three"
  }, _vm._l((_vm.memOrderDetailMsg.orderOperMsgs), function(orderType, typeIndex) {
    return _c('div', {
      staticClass: "time-line-item",
      class: {
        'nowStyle': orderType.operIndex == 2,
        'finishStyle': orderType.operIndex == 1
      }
    }, [_c('p', {
      staticClass: "state"
    }, [_vm._v(_vm._s(orderType.operName))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), (orderType.operIndex != 3) ? _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(orderType.operTime))]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item"
  }, [_c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              订单状态："), _c('span', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderStateName))]), _vm._v(" "), (_vm.memOrderDetailMsg.orderStateName == '等待支付') ? _c('samp', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("支付剩余:" + _vm._s(_vm.memOrderDetailMsg.remainPayTime))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" 订单号：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.stOrderId))]), _vm._v(" "), _c('br'), _vm._v(" 下单时间：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderTime))])]), _vm._v(" "), (_vm.orderStateType == 0) ? _c('div', {
    staticClass: "operate"
  }, [_c('mu-raised-button', {
    staticClass: "orders-button mu-raised-button-grad",
    attrs: {
      "label": "取消订单"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder(_vm.orderStateType, _vm.memOrderDetailMsg.stOrderId)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.orderStateType == 1 || _vm.orderStateType == 3 || _vm.orderStateType == 4 || _vm.orderStateType == 12 || _vm.orderStateType == 13) ? _c('div', {
    staticClass: "operate"
  }, [_c('mu-raised-button', {
    staticClass: "orders-button mu-raised-button-grad fr",
    attrs: {
      "label": "申请退单"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder(_vm.orderStateType, _vm.memOrderDetailMsg.stOrderId)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.orderStateType == 2 || _vm.orderStateType == 10) ? _c('div', {
    staticClass: "operate"
  }, [_c('mu-raised-button', {
    staticClass: "orders-button mu-raised-button-grad fr",
    attrs: {
      "label": "立即购买"
    },
    on: {
      "click": function($event) {
        return _vm.buyNow()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.orderStateType == 9 && _vm.commonFinished == false) ? _c('div', {
    staticClass: "operate"
  }, [_vm._v("=\"去评价\" class=\"orders-button fr\" primary @click=\"evaluateJump()\" />\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('mu-list', _vm._l((_vm.memOrderDetailMsg.goodsOrderMsgs), function(listShop, shopIndex) {
    return _c('myOrdersItem', {
      key: shopIndex,
      attrs: {
        "width": 150,
        "height": 150,
        "cartitem": listShop
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              收货人："), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderAddrMsg && _vm.memOrderDetailMsg.orderAddrMsg.consignee))]), _vm._v(" "), _c('br'), _vm._v(" 联系电话：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.orderAddrMsg && _vm.memOrderDetailMsg.orderAddrMsg.mobile))]), _vm._v(" "), _c('br'), _vm._v(" 收货地址：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(" " + _vm._s(_vm.memOrderDetailMsg.orderAddrMsg && _vm.memOrderDetailMsg.orderAddrMsg.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              支付方式：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(" " + _vm._s(_vm.memOrderDetailMsg.payTypeName))])])]), _vm._v(" "), (_vm.memOrderDetailMsg.invoiceDat && _vm.memOrderDetailMsg.invoiceData.doInvoice == '1') ? _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state"
  }, [_vm._v("\n              发票类型："), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.invoiceData && _vm.memOrderDetailMsg.invoiceData.invoiceTypeName))]), _vm._v(" "), _c('br'), _vm._v(" 发票内容：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.invoiceData && _vm.memOrderDetailMsg.invoiceData.invoiceContentName))]), _vm._v(" "), _c('br'), _vm._v(" 发票抬头：\n              "), _c('span', {
    staticClass: "black"
  }, [_vm._v(_vm._s(_vm.memOrderDetailMsg.invoiceData && _vm.memOrderDetailMsg.invoiceData.invoiceHead))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "orders-list-item-state"
  }, [_c('div', {
    staticClass: "state money"
  }, [_vm._v("\n              商品总额："), _c('span', {
    staticClass: "primary"
  }, [_vm._v("￥  " + _vm._s(_vm.memOrderDetailMsg.totalPrice))]), _vm._v(" "), _c('br'), _vm._v(" 运费：\n              "), _c('span', {
    staticClass: "primary"
  }, [_vm._v("￥" + _vm._s(_vm.memOrderDetailMsg.postPrice))]), _vm._v(" "), _c('br'), _vm._v(" 使用优惠券：\n              "), _c('span', {
    staticClass: "primary"
  }, [_vm._v("-￥" + _vm._s(_vm.memOrderDetailMsg.discountPrice))]), _vm._v(" "), _c('br'), _vm._v(" 使用红包:\n              "), _c('span', {
    staticClass: "primary"
  }, [_vm._v("-￥" + _vm._s(_vm.memOrderDetailMsg.redpacketPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "orderSum"
  }, [_vm._v("\n              实付金额："), _c('span', {
    staticClass: "primary"
  }, [_vm._v("￥" + _vm._s(_vm.memOrderDetailMsg.finalPrice))])])])], 1), _vm._v(" "), (_vm.orderStateType == 0) ? _c('div', {
    staticClass: "fullbtn-box"
  }, [_c('mu-raised-button', {
    staticClass: "full wx",
    attrs: {
      "label": "微信支付",
      "fullWidth": ""
    },
    on: {
      "click": _vm.submitOrder
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "full Union",
    attrs: {
      "label": "银联支付",
      "fullWidth": ""
    },
    on: {
      "click": _vm.submitUnionOrder
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.quitOrder,
      "title": "取消订单",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.quitOrder = false
      }
    }
  }, [_vm._v("\n      您确定要取消这个订单么?\n      "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.quitOrder = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.doQuitOrder(1)
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.chargeBack,
      "title": "申请退单",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.chargeBack = false
      }
    }
  }, [_vm._v("\n      您确定要申请退单么?\n      "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.chargeBack = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "是"
    },
    on: {
      "click": function($event) {
        return _vm.doChargeBack()
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.contactService,
      "title": "申请退单请联系客服",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer fullContainer"
    },
    on: {
      "close": function($event) {
        _vm.contactService = false
      }
    }
  }, [_vm._v("\n      400-832-2777\n      "), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": function($event) {
        return _vm.phoneCall('400-832-2777')
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast.isShow) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-box"
  }, [_c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-box"
  }, [_c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.cartitem.sourceType == '1' || _vm.cartitem.sourceType == null || _vm.cartitem.sourceType == 0) ? _c('mu-list-item', {
    key: _vm.cartitem.id,
    staticClass: "list-box",
    class: [_vm.isRightTriggle ? 'hasright' : ''],
    attrs: {
      "title": _vm.cartitem.goodsName
    },
    on: {
      "click": function($event) {
        return _vm.clickItem(_vm.cartitem.goodsId, _vm.cartitem.skuId || 0)
      }
    }
  }, [_c('mu-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckBox),
      expression: "isCheckBox"
    }],
    staticClass: "list-radio",
    attrs: {
      "name": "group",
      "nativeValue": _vm.cartitem.favId
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('imgs', {
    attrs: {
      "slot": "leftAvatar",
      "width": _vm.width,
      "height": _vm.height,
      "imagePath": _vm.cartitem.imagePath && _vm.cartitem.imagePath.imagePath
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "listItem"
  }, [_c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.cartitem.salePrice || _vm.cartitem.orderGoodsPrice || _vm.cartitem.goodsPrice) + "\n        "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartitem.goodsNum),
      expression: "cartitem.goodsNum"
    }],
    staticClass: "count"
  }, [_vm._v("x" + _vm._s(_vm.cartitem.goodsNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.isRightTriggle) ? _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.cartitem.sourceType == '2') ? [_c('mu-list-item', {
    key: _vm.cartitem.id,
    staticClass: "list-box diy-title",
    class: [_vm.isRightTriggle ? 'hasright' : ''],
    attrs: {
      "title": _vm.cartitem.goodsName
    }
  }, [_c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('div', {
    staticClass: "listItem"
  }, [_c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.cartitem.salePrice || _vm.cartitem.orderGoodsPrice) + "\n          "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartitem.goodsNum),
      expression: "cartitem.goodsNum"
    }],
    staticClass: "count"
  }, [_vm._v("x" + _vm._s(_vm.cartitem.goodsNum))])])])]), _vm._v(" "), _vm._l(((_vm.cartitem.subCartGoods || _vm.cartitem.subGoodsOrderMsgs)), function(sub, subindex) {
    return [_c('mu-list-item', {
      key: sub.id,
      staticClass: "list-box diy-list",
      class: [_vm.isRightTriggle ? 'hasright' : ''],
      attrs: {
        "title": sub.goodsName
      },
      on: {
        "click": function($event) {
          return _vm.clickItem(sub.goodsId, sub.skuId || 0)
        }
      }
    }, [(_vm.cartitem.subCartGoods) ? _c('div', {
      staticClass: "point",
      class: [subindex == (_vm.cartitem.subCartGoods.length - 1) ? 'last' : '']
    }) : _vm._e(), _vm._v(" "), (_vm.cartitem.subGoodsOrderMsgs) ? _c('div', {
      staticClass: "point",
      class: [subindex == (_vm.cartitem.subGoodsOrderMsgs.length - 1) ? 'last' : '']
    }) : _vm._e(), _vm._v(" "), _c('imgs', {
      attrs: {
        "slot": "leftAvatar",
        "imagePath": sub.imagePath && sub.imagePath.imagePath
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('div', {
      staticClass: "listItem"
    }, [_c('p', {
      staticClass: "price"
    }, [_vm._v("￥" + _vm._s(sub.salePrice || sub.orderGoodsPrice) + "\n            "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (sub.goodsNum),
        expression: "sub.goodsNum"
      }],
      staticClass: "count"
    }, [_vm._v("x" + _vm._s(sub.goodsNum))])])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }), _vm._v(" "), (_vm.isRightTriggle) ? _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    }) : _vm._e()], 1)]
  })] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "evaluate-wrap"
  }, [(_vm.GoodsComm.favRate) ? _c('div', {
    staticClass: "evaluate-label"
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("好评度"), _c('span', [_vm._v(_vm._s(_vm.GoodsComm.favRate) + "%")])]), _vm._v(" "), _vm._l((_vm.GoodsComm.commentTags), function(tag) {
    return _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(tag.name))])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "evaluate-detail"
  }, [(_vm.GoodsCommList.length < 1) ? _c('empty', {
    attrs: {
      "emptytext": "对不起，暂时没有找到结果"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.GoodsCommList), function(item) {
    return _c('div', {
      staticClass: "evaluate-item"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('span', {
      staticClass: "head"
    }, [_c('imgs', {
      attrs: {
        "imagePath": item.header && item.header.imagePath
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.memName))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_c('span', {
      staticClass: "floatL"
    }, [_vm._v(_vm._s(item.commTime))])]), _c('div', {
      staticClass: "floatR"
    }, _vm._l((5), function(i) {
      return _c('span', {
        staticClass: "star",
        class: {
          active: i <= Math.floor(item.starScore)
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
      staticClass: "evaluate-content"
    }, [_vm._v(_vm._s(item.commDesc))]), _vm._v(" "), (item.replyDesc) ? _c('div', {
      staticClass: "merchant-reply"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('span', {
      staticClass: "floatL"
    }, [_vm._v("美心商城回复：")]), _vm._v(" "), _c('span', {
      staticClass: "floatR time"
    }, [_vm._v(_vm._s(item.replyTime))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "evaluate-content"
    }, [_vm._v(_vm._s(item.replyDesc))])]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap collection-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listPageGoodsFav.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_collection_3x.png",
      "emptytext": "您还没有收藏商品",
      "btntext": "去逛一逛",
      "btnurl": "/main/home"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listPageGoodsFav.length != 0 && !_vm.loadShow),
      expression: "listPageGoodsFav.length!=0 && !loadShow"
    }],
    staticClass: "flex-column"
  }, [_c('div', {
    staticClass: "grid-tip"
  }, [_vm._v("\n      你收藏了\n      "), _c('label', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.size) + " ")]), _vm._v("个商品\n      "), (!_vm.editstate) ? _c('label', {
    staticClass: "fr blue",
    on: {
      "click": function($event) {
        _vm.editstate = true
      }
    }
  }, [_vm._v("编辑")]) : _c('label', {
    staticClass: "fr blue",
    on: {
      "click": function($event) {
        _vm.editstate = false
      }
    }
  }, [_vm._v("完成")])]), _vm._v(" "), _c('div', {
    staticClass: "collection-list flex-item",
    class: [_vm.editstate ? 'edit-state' : ' ']
  }, [_c('mu-list', _vm._l((_vm.listPageGoodsFav), function(pageGoodsShow, indexNumber) {
    return _c('myOrdersItem', {
      key: indexNumber,
      attrs: {
        "width": 150,
        "height": 150,
        "cartitem": pageGoodsShow,
        "selvalue": _vm.checkboxsel,
        "isCheckBox": 'true',
        "isRightTriggle": 'true'
      },
      on: {
        "on-result-change": _vm.onResultChange
      }
    })
  }), 1), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.size == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多商品啦~")]) : _vm._e()], 1), _vm._v(" "), (_vm.editstate) ? _c('div', {
    staticClass: "cartBottom"
  }, [_c('mu-checkbox', {
    staticClass: "list-radio",
    attrs: {
      "name": "group",
      "id": "all",
      "label": "全选"
    },
    on: {
      "change": function($event) {
        return _vm.selectAll($event)
      }
    },
    model: {
      value: (_vm.allChecked),
      callback: function($$v) {
        _vm.allChecked = $$v
      },
      expression: "allChecked"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "go",
    class: [_vm.checkboxsel.length == 0 ? 'disabledbtn' : 'primarybtn'],
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v("取消收藏")])], 1) : _vm._e()]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDelete,
      "title": "取消收藏",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDelete = false;
      }
    }
  }, [_vm._v("\n    确定对选中的" + _vm._s(_vm.checkboxsel.length) + "个产品取消收藏？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDelete = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": function($event) {
        return _vm.closedeleteAddress()
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast1) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "当前还没有选中商品"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toast2) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "删除成功!"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap classify-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyWord),
      expression: "keyWord"
    }],
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索商品"
    },
    domProps: {
      "value": (_vm.keyWord)
    },
    on: {
      "click": _vm.searchgoods,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyWord = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "flex-item tab-content"
  }, [_c('div', {
    ref: "tabBar",
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-item verticalM",
    class: {
      active: _vm.tabIndex == 'essence'
    },
    on: {
      "click": function($event) {
        _vm.tabIndex = 'essence';
        _vm.isTabIndex = false
      }
    }
  }, [_c('span', {
    staticClass: "verticalM-box"
  }, [_vm._v("为您推荐")])]), _vm._v(" "), _vm._l((_vm.brandCates), function(brandItem, index) {
    return _c('div', {
      staticClass: "tab-item verticalM",
      class: {
        active: _vm.tabIndex == index
      },
      on: {
        "click": function($event) {
          return _vm.selTab(index)
        }
      }
    }, [_c('span', {
      staticClass: "verticalM-box"
    }, [_vm._v(_vm._s(brandItem.cates.linkName))])])
  })], 2), _vm._v(" "), _c('div', {
    ref: "brandContent",
    staticClass: "brand-content"
  }, [(_vm.tabIndex != 'essence') ? _c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('imgs', {
    attrs: {
      "imagePath": _vm.brandCates[_vm.tabIndex] && _vm.brandCates[_vm.tabIndex].cates.imagePath.imagePath
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabIndex == 'essence') ? _c('div', {
    staticClass: "recommend-content"
  }, [(_vm.adverstore) ? _c('div', {
    staticClass: "banner",
    on: {
      "click": function($event) {
        return _vm.linkFn(_vm.adverstore.linkType, _vm.adverstore.linkTarget)
      }
    }
  }, [_c('imgs', {
    attrs: {
      "width": 500,
      "imagePath": _vm.adverstore && _vm.adverstore.imagePath && _vm.adverstore.imagePath.imagePath
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('span', [_vm._v("精品推荐")])]), _vm._v(" "), _vm._l((_vm.boutiques), function(item, index) {
    return _c('div', {
      staticClass: "product-item square",
      on: {
        "click": function($event) {
          return _vm.scanDetail(item.storeId, item.goodsId, item.skuId)
        }
      }
    }, [_c('imgs', {
      attrs: {
        "width": 270,
        "height": 270,
        "imagePath": item.imagePath && item.imagePath.imagePath,
        "titleText": item.goodsName
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tabIndex != 'essence') ? _c('div', {
    staticClass: "product-content"
  }, [(_vm.adverbrand) ? _c('div', {
    staticClass: "banner",
    on: {
      "click": function($event) {
        return _vm.linkFn(_vm.adverbrand.linkType, _vm.adverbrand.linkTarget)
      }
    }
  }, [_c('imgs', {
    attrs: {
      "width": 500,
      "imagePath": _vm.adverbrand && _vm.adverbrand.imagePath && _vm.adverbrand.imagePath.imagePath
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(((_vm.brandCates[_vm.tabIndex] && _vm.brandCates[_vm.tabIndex].goodsList)), function(goodItem, goodIndex) {
    return _c('div', {
      staticClass: "product-item square",
      on: {
        "click": function($event) {
          return _vm.scanDetail(_vm.brandCates[_vm.tabIndex].cates.linkTarget, goodItem.goodsId, goodItem.skuId)
        }
      }
    }, [_c('imgs', {
      attrs: {
        "width": 270,
        "height": 270,
        "imagePath": goodItem && goodItem.imagePath && goodItem.imagePath.imagePath,
        "titleText": goodItem.goodsName
      }
    })], 1)
  })], 2) : _vm._e()])]), _vm._v(" "), _c('menus')], 1)
},staticRenderFns: []}

/***/ }),
/* 422 */,
/* 423 */
/***/ (function(module, exports) {

module.exports = axios;

/***/ })
],[206]);


// WEBPACK FOOTER //
// static/js/app.ee47d6d417026905afcc.js